<template>
    <div class="container-fluid">
        <!-- 헤더 섹션 -->
        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex flex-wrap align-items-center justify-content-between">
                    <div>
                        <h4 class="mb-3">로켓배송 AI상품등록</h4>
                        <p class="mb-0">상품별 등록 현황 및 관리</p>
                    </div>
                    <div class="rr-head-btns d-flex flex-wrap">
                        <b-button v-if="showTalhwanGuideVideo" variant="outline-secondary" class="mr-2"
                            @click="$bvModal.show('talhwanGuideVideoModal')">
                            <i class="las la-play-circle mr-1"></i> 탈환의깃발 안내 영상
                        </b-button>
                        <b-button variant="secondary" class="mr-2" @click="toggleSettings">
                            <i class="las la-cog mr-1"></i> 기본설정
                        </b-button>
                        <b-button variant="primary" class="mr-2" @click="addProduct">
                            <i class="las la-plus mr-1"></i> 상품 추가
                        </b-button>
                        <b-dropdown :text="getWorkTypeText(selectedWorkType)" variant="outline-primary" class="mr-2">
                            <b-dropdown-item @click="selectWorkType('all')" :active="selectedWorkType === 'all'">전체 작업</b-dropdown-item>
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item @click="selectWorkType('seo')"
                                :active="selectedWorkType === 'seo'">SEO설정</b-dropdown-item>
                            <b-dropdown-item @click="selectWorkType('pricing')"
                                :active="selectedWorkType === 'pricing'">가격설정</b-dropdown-item>
                            <b-dropdown-item @click="selectWorkType('mainImage')"
                                :active="selectedWorkType === 'mainImage'">대표이미지</b-dropdown-item>
                            <b-dropdown-item @click="selectWorkType('additionalImage')"
                                :active="selectedWorkType === 'additionalImage'">추가이미지</b-dropdown-item>
                            <b-dropdown-item @click="selectWorkType('detailImage')"
                                :active="selectedWorkType === 'detailImage'">상세이미지</b-dropdown-item>
                            <b-dropdown-item @click="selectWorkType('sizeChart')"
                                :active="selectedWorkType === 'sizeChart'">사이즈표</b-dropdown-item>
                            <b-dropdown-item @click="selectWorkType('koreanLabel')"
                                :active="selectedWorkType === 'koreanLabel'">한글표시사항</b-dropdown-item>
                            <b-dropdown-item @click="selectWorkType('quotation')"
                                :active="selectedWorkType === 'quotation'">견적서</b-dropdown-item>
                        </b-dropdown>
                        <b-button variant="success" class="mr-2" @click="startProcessing"
                            :disabled="!hasSelectedProducts || isAddingProduct">
                            <span class="d-flex align-items-center">
                                작업 개시
                                <b-spinner small class="ml-2" v-if="isProcessing"></b-spinner>
                            </span>
                        </b-button>
                        <b-button variant="danger" class="mr-2" @click="submitProductsToCoupang({ byClick: true })"
                            :disabled="isAddingProduct">
                            <span class="d-flex align-items-center">
                                등록 전송
                                <b-spinner small class="ml-2" v-if="isVerifying"></b-spinner>
                            </span>
                        </b-button>
                        <!-- 접수 미확인 건 일괄 — 서플라이어허브 등록 상태 목록만 다시 본다(전송 없음) -->
                        <b-button v-if="confirmPendingCount > 0" variant="outline-warning" class="ml-2"
                            @click="recheckHubConfirm(products, { manual: true })" :disabled="hubRecheck.inFlight">
                            <span class="d-flex align-items-center">
                                접수 다시 확인 ({{ confirmPendingCount }})
                                <b-spinner small class="ml-2" v-if="hubRecheck.inFlight"></b-spinner>
                            </span>
                        </b-button>
                    </div>
                </div>
            </div>

            <div class="col-lg-12">
                <div v-if="showspinner1" class="d-flex justify-content-center">
                    <div><img style="max-width:10%;" :src="require('../../../assets/images/small/loading.gif')">{{
                        loadingtext }}</div>
                </div>
            </div>

            <!-- 세련된 초기화 로딩 오버레이 (상품 추가 시 SEO+Pricing 자동 실행) -->
            <div v-if="isInitialProcessing" class="initial-processing-overlay">
                <div class="processing-card">
                    <div class="processing-spinner">
                        <div class="spinner-ring"></div>
                        <div class="spinner-ring"></div>
                        <div class="spinner-ring"></div>
                        <div class="spinner-dot"></div>
                    </div>
                    <div v-if="queueProcessing" class="mb-2" style="font-size: 0.9rem; color: #6c757d;">
                        상품 {{ queueProgress.current }}/{{ queueProgress.total }}
                    </div>
                    <h4 class="processing-title">{{ initialProcessingTitle }}</h4>
                    <p class="processing-message">{{ initialProcessingMessage }}</p>
                    <div class="processing-progress">
                        <div class="progress-bar" :style="{ width: initialProcessingProgress + '%' }"></div>
                    </div>
                    <div class="processing-steps">
                        <div class="step" :class="{ active: initialProcessingStep >= 1, completed: initialProcessingStep > 1 }">
                            <span class="step-icon">1</span>
                            <span class="step-text">상품 저장</span>
                        </div>
                        <div class="step" :class="{ active: initialProcessingStep >= 2, completed: initialProcessingStep > 2 }">
                            <span class="step-icon">2</span>
                            <span class="step-text">SEO 최적화</span>
                        </div>
                        <div class="step" :class="{ active: initialProcessingStep >= 3, completed: initialProcessingStep > 3 }">
                            <span class="step-icon">3</span>
                            <span class="step-text">가격 설정</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 기본세팅 컴포넌트 -->
            <div class="col-lg-12 mb-3">
                <RocketSettingsPanel v-model="showSettings" :default-settings="defaultSettings"
                    @settings-saved="handleSettingsSaved" />
            </div>

            <!-- 검색 필터 -->
            <div class="col-lg-12">
                <card>
                    <div class="p-2">
                        <form>
                            <div class="row align-items-center">
                                <div class="col-md-3">
                                    <div class="d-flex align-items-center w-100">
                                        <div class="custom-control custom-radio custom-control-inline mb-0 ml-4">
                                            <input type="radio" id="customRadio7" name="customRadio-2"
                                                class="custom-control-input" v-model="selectdate" value="today"
                                                @change="changedate()">
                                            <label class="custom-control-label" for="customRadio7">오늘</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline mb-0">
                                            <input type="radio" id="customRadio8" name="customRadio-2"
                                                class="custom-control-input" v-model="selectdate" value="week"
                                                @change="changedate()">
                                            <label class="custom-control-label" for="customRadio8">7일</label>
                                        </div>
                                        <div class="custom-control custom-radio custom-control-inline mb-0">
                                            <input type="radio" id="customRadio9" name="customRadio-2"
                                                class="custom-control-input" v-model="selectdate" value="month"
                                                @change="changedate()">
                                            <label class="custom-control-label" for="customRadio9">1개월</label>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-8">
                                    <div class="d-flex align-items-center w-100">
                                        <select class="custom-select w-50" style="width:80px; height:38px"
                                            v-model="selectoption">
                                            <option>등록일</option>
                                        </select>
                                        <b-form-datepicker id="example-datepicker1" size="sm" v-model="startdate"
                                            class="mx-2 w-100" style="width:130px"></b-form-datepicker>
                                        <span>~</span>
                                        <b-form-datepicker id="example-datepicker2" size="sm" v-model="enddate"
                                            class="mx-2 w-100" style="width:130px"></b-form-datepicker>
                                    </div>
                                </div>
                                <div class="col-md-1">
                                    <button type="button" class="btn btn-primary" @click="search">
                                        검색
                                        <b-spinner small v-if="showspinner" class="ml-1"></b-spinner>
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </card>
            </div>

            <div class="col-lg-12">
                <!-- 상품 리스트 테이블 -->
                <b-alert :show="rocketProductsHiddenTotal > 0" variant="warning" class="mb-2">
                    목록을 다 받지 못했어요 (보이는 {{ products.length }}건 / 전체 {{ rocketProductsHiddenTotal }}건) — 잠시 뒤 다시 검색해 주세요
                </b-alert>
                <div class="table-responsive">
                    <CDataTable
                        storage-key="AIRocketReg.1" :headers="headers" :items="products" :items-per-page="10" :pagination="true"
                        :show-select="true" v-model="selectedItems" hover sorter :itemKey="'registrationId'">
                        <!-- 등록번호 -->
                        <template v-slot:registrationId="{ item }">
                            <div class="text-center" @click="editProduct(item)">
                                {{ item.registrationId }}
                            </div>
                        </template>

                        <!-- 상품 이미지 -->
                        <template v-slot:productImage="{ item }">
                            <div class="d-flex align-items-center justify-content-center" @click="editProduct(item)">
                                <!-- 옛 문서는 1688 원본 주소(cbu01.alicdn.com)라 남의 Referer 로 막히거나 못 받으면 깨진 아이콘 + 중국어 alt 가 남았다(10-19 사진)
                                     → Referer 끄고, 그래도 못 받으면 같은 크기 빈 틀(줄 높이 그대로) -->
                                <div v-if="brokenImages[item.registrationId] || !item.productImage" class="rr-thumb-empty rounded avatar-50">그림 없음</div>
                                <img v-else :src="item.productImage" class="img-fluid rounded avatar-50" referrerpolicy="no-referrer"
                                    :alt="item.productName" @error="$set(brokenImages, item.registrationId, true)">
                            </div>
                        </template>

                        <!-- 상품명 -->
                        <template v-slot:productName="{ item }">
                            <div @click="editProduct(item)">
                                <div class="mb-1">
                                    <!-- SEO 설정이 완료된 경우 SEO 상품명 사용 -->
                                    <span v-if="item.seoStatus === 'completed' && item.seo && item.seo.productName">
                                        {{ item.seo.productName }}
                                    </span>
                                    <span v-else>
                                        {{ item.productName }}
                                    </span>
                                </div>
                                <div class="d-flex align-items-center">
                                    <b-badge variant="primary" class="cursor-pointer" @click="toggleOptions(item)">
                                        옵션 {{ item.options.length }}개
                                    </b-badge>
                                    <div class="ml-2">
                                        <b-badge variant="light">
                                            {{ item.productFeature }}
                                        </b-badge>
                                    </div>
                                    <div class="ml-2">
                                        <b-badge variant="success">
                                            {{ item.targetKeyword }}
                                        </b-badge>
                                    </div>
                                </div>
                            </div>
                        </template>

                        <template v-slot:구매링크="{ item }">
                            <div class="text-center">
                                <a :href="item.구매링크" target="_blank">
                                    <b-icon icon="link" scale="2" variant="primary"></b-icon>
                                </a>
                            </div>
                        </template>

                        <!-- SEO설정 -->
                        <template v-slot:seoStatus="{ item }">
                            <div class="text-center" @click="editProduct(item)">
                                <b-badge :variant="getStatusVariant(getWorkStatus(item, 'seoStatus'))"
                                    class="rocket-badge-pill"
                                    :class="{ 'pulsating': getWorkStatus(item, 'seoStatus') === 'processing' }">
                                    {{ getStatusText(item.seoStatus) }}
                                    <b-spinner small v-if="getWorkStatus(item, 'seoStatus') === 'processing'"
                                        class="ml-1"></b-spinner>
                                </b-badge>
                            </div>
                        </template>

                        <!-- 가격설정 -->
                        <template v-slot:pricingStatus="{ item }">
                            <div class="text-center" @click="editProduct(item)">
                                <b-badge :variant="getStatusVariant(getWorkStatus(item, 'pricingStatus'))"
                                    class="rocket-badge-pill"
                                    :class="{ 'pulsating': getWorkStatus(item, 'pricingStatus') === 'processing' }">
                                    {{ getStatusText(item.pricingStatus) }}
                                    <b-spinner small v-if="getWorkStatus(item, 'pricingStatus') === 'processing'"
                                        class="ml-1"></b-spinner>
                                </b-badge>
                            </div>
                        </template>

                        <!-- 대표이미지 상태 -->
                        <template v-slot:mainImageStatus="{ item }">
                            <div class="text-center" @click="editProduct(item)">
                                <b-badge :variant="getStatusVariant(getWorkStatus(item, 'mainImageStatus'))"
                                    class="rocket-badge-pill"
                                    :class="{ 'pulsating': getWorkStatus(item, 'mainImageStatus') === 'processing' }">
                                    {{ getStatusText(item.mainImageStatus) }}<span v-if="stepCountText(item, 'mainImage')"> {{ stepCountText(item, 'mainImage') }}</span>
                                    <b-spinner small v-if="getWorkStatus(item, 'mainImageStatus') === 'processing'"
                                        class="ml-1"></b-spinner>
                                </b-badge>
                            </div>
                        </template>

                        <!-- 추가이미지 상태 -->
                        <template v-slot:additionalImageStatus="{ item }">
                            <div class="text-center" @click="editProduct(item)">
                                <b-badge :variant="getStatusVariant(getWorkStatus(item, 'additionalImageStatus'))"
                                    class="rocket-badge-pill"
                                    :class="{ 'pulsating': getWorkStatus(item, 'additionalImageStatus') === 'processing' }">
                                    {{ getStatusText(item.additionalImageStatus) }}
                                    <b-spinner small
                                        v-if="getWorkStatus(item, 'additionalImageStatus') === 'processing'"
                                        class="ml-1"></b-spinner>
                                </b-badge>
                            </div>
                        </template>

                        <!-- 상세이미지 상태 -->
                        <template v-slot:detailImageStatus="{ item }">
                            <div class="text-center" @click="editProduct(item)">
                                <b-badge :variant="getStatusVariant(getWorkStatus(item, 'detailImageStatus'))"
                                    class="rocket-badge-pill"
                                    :class="{ 'pulsating': getWorkStatus(item, 'detailImageStatus') === 'processing' }">
                                    {{ getStatusText(item.detailImageStatus) }}
                                    <b-spinner small v-if="getWorkStatus(item, 'detailImageStatus') === 'processing'"
                                        class="ml-1"></b-spinner>
                                </b-badge>
                                <!-- 이미지 문구를 원문과 다르게 고친 상품 — 상세 이미지 단계에서 확인 -->
                                <div v-if="item.detailClaimWarning && item.detailClaimWarning.items && item.detailClaimWarning.items.length"
                                    class="detail-claim-flag mt-1" v-b-tooltip.hover.top :title="item.detailClaimWarning.message">
                                    <i class="las la-exclamation-triangle"></i> 문구 {{ item.detailClaimWarning.items.length }}곳 고침
                                </div>
                            </div>
                        </template>

                        <template v-slot:sizeChartStatus="{ item }">
                            <div class="text-center" @click="editProduct(item)">
                                <b-badge
                                    :variant="getStatusVariant(getWorkStatus(item, 'sizeChartStatus', isSizeChartRequired(item)))"
                                    class="rocket-badge-pill"
                                    :class="{ 'pulsating': getWorkStatus(item, 'sizeChartStatus') === 'processing' }">
                                    {{ getStatusText(isSizeChartRequired(item) ? item.sizeChartStatus : 'disabled') }}
                                    <b-spinner small v-if="getWorkStatus(item, 'sizeChartStatus') === 'processing'"
                                        class="ml-1"></b-spinner>
                                </b-badge>
                            </div>
                        </template>

                        <!-- 한글표시사항 -->
                        <template v-slot:koreanLabelStatus="{ item }">
                            <div class="text-center" @click="editProduct(item)">
                                <b-badge :variant="getStatusVariant(getWorkStatus(item, 'koreanLabelStatus'))"
                                    class="rocket-badge-pill"
                                    :class="{ 'pulsating': getWorkStatus(item, 'koreanLabelStatus') === 'processing' }">
                                    {{ getStatusText(item.koreanLabelStatus) }}<span v-if="stepCountText(item, 'koreanLabel')"> {{ stepCountText(item, 'koreanLabel') }}</span>
                                    <b-spinner small v-if="getWorkStatus(item, 'koreanLabelStatus') === 'processing'"
                                        class="ml-1"></b-spinner>
                                </b-badge>
                            </div>
                        </template>

                        <!-- 견적서세부정보 -->
                        <template v-slot:quotationStatus="{ item }">
                            <div class="text-center" @click="editProduct(item)">
                                <b-badge :variant="getStatusVariant(getWorkStatus(item, 'quotationStatus'))"
                                    class="rocket-badge-pill"
                                    :class="{ 'pulsating': getWorkStatus(item, 'quotationStatus') === 'processing' }">
                                    {{ getStatusText(item.quotationStatus) }}
                                    <b-spinner small v-if="getWorkStatus(item, 'quotationStatus') === 'processing'"
                                        class="ml-1"></b-spinner>
                                </b-badge>
                            </div>
                        </template>

                        <!-- 등록 상태 -->
                        <template v-slot:verified="{ item }">
                            <div class="text-center">
                                <b-badge :variant="getVerificationStatusVariant(item)" class="rocket-badge-pill"
                                    v-b-tooltip.hover.top :title="getVerificationStatusTooltip(item)">
                                    {{ getRegistrationStatusText(item) }}
                                </b-badge>
                                <!-- 접수 미확인 — 허브 등록 상태 목록만 다시 본다(전송 없음) -->
                                <a v-if="isConfirmPending(item)" href="javascript:void(0)" class="d-block small mt-1"
                                    :class="{ 'text-muted': hubRecheck.inFlight }"
                                    @click.stop="!hubRecheck.inFlight && recheckHubConfirm([item], { manual: true })">
                                    접수 다시 확인
                                </a>
                            </div>
                        </template>

                        <!-- 관리 버튼 -->
                        <template v-slot:actions="{ item }">
                            <div class="d-flex align-items-center justify-content-center">
                                <!-- <a class="badge bg-info mr-2" data-toggle="tooltip" v-b-tooltip.top title="초기화"
                                    href="javascript:void(0)" @click="resetProduct(item)">
                                    <i class="ri-refresh-line mr-0"></i>
                                </a> -->
                                <!-- 쿠팡에 보낸 건은 지울 수 없다. 누르기 전에 알 수 있게 비활성으로 보여준다 -->
                                <span v-if="isSentToCoupang(item)" class="badge bg-secondary mr-2 rocket-delete-disabled"
                                    data-toggle="tooltip" v-b-tooltip.top
                                    title="쿠팡에 이미 전송된 상품이라 삭제할 수 없습니다">
                                    <i class="ri-delete-bin-line mr-0"></i>
                                </span>
                                <a v-else class="badge bg-warning mr-2" data-toggle="tooltip" v-b-tooltip.top title="삭제"
                                    href="javascript:void(0)" @click="deleteProduct(item)">
                                    <i class="ri-delete-bin-line mr-0"></i>
                                </a>
                            </div>
                        </template>
                    </CDataTable>
                </div>
            </div>
        </div>

        <!-- 상품 추가 모달 -->
        <b-modal id="addProductModal" title="로켓배송 상품 추가" @ok="handleAddProduct" ok-title="추가" cancel-title="취소">
            <b-form @submit.prevent="triggerAddProduct">
                <b-form-group label="1688 상품 링크" label-for="link-input" :invalid-feedback="linkError"
                    :valid-feedback="validLinkFeedback" :state="linkValidation">
                    <b-form-input id="link-input" autocomplete="off" v-model="newProduct.link"
                        placeholder="1688 상품 링크를 입력해주세요" :state="linkValidation" trim
                        @keydown.enter="triggerAddProduct"></b-form-input>
                </b-form-group>

                <b-form-group label="선택된 카테고리" label-for="category-info">
                    <b-form-textarea id="category-info" v-model="newProduct.categoryPathString" readonly rows="2"
                        class="bg-light"></b-form-textarea>
                    <small class="form-text text-muted">
                        <span v-if="newProduct.categoryPathString">선택된 카테고리: {{ newProduct.categoryPathString }}</span>
                        <span v-else class="text-warning">카테고리를 선택하려면 취소 후 다시 시도해주세요.</span>
                    </small>
                </b-form-group>

                <b-form-group label="상품특징" label-for="product-feature-input">
                    <b-form-input id="product-feature-input" autocomplete="off" v-model="newProduct.productFeature"
                        placeholder="상품특징을 입력해주세요" trim
                        @keydown.enter="triggerAddProduct"></b-form-input>
                    <small class="form-text text-muted">상품의 주요특징을 입력해주세요. (예. 인조가죽)</small>
                </b-form-group>

                <b-form-group label="타겟 키워드" label-for="keyword-input">
                    <b-form-input id="keyword-input" autocomplete="off" v-model="newProduct.keyword"
                        placeholder="타겟 키워드를 입력해주세요" trim
                        @keydown.enter="triggerAddProduct"></b-form-input>
                    <small class="form-text text-muted">주요 타겟 키워드를 입력해주세요. (예. 크로스백)</small>
                </b-form-group>
            </b-form>
        </b-modal>

        <!-- 상품 대기열 모달 -->
        <b-modal id="productQueueModal" title="상품 대기열" size="xl" hide-footer scrollable>
            <div>
                <CDataTable
                    storage-key="AIRocketReg.2"
                    v-if="productQueue.length > 0"
                    :headers="queueHeaders"
                    :items="productQueue"
                    item-key="_queueId"
                    v-model="queueSelectedItems"
                    :show-select="true"
                    :items-per-page="10"
                    :is-per-page="false"
                    :is-column="false"
                    :is-radio="false"
                >
                    <template v-slot:link="{ item }">
                        <b-form-input
                            v-model="item.link"
                            placeholder="1688 상품 링크"
                            size="sm"
                            trim
                        ></b-form-input>
                    </template>
                    <template v-slot:productFeature="{ item }">
                        <b-form-input
                            v-model="item.productFeature"
                            placeholder="상품 특징"
                            size="sm"
                            trim
                        ></b-form-input>
                    </template>
                    <template v-slot:keyword="{ item }">
                        <b-form-input
                            v-model="item.keyword"
                            placeholder="타겟 키워드"
                            size="sm"
                            trim
                        ></b-form-input>
                    </template>
                    <template v-slot:lastError="{ item }">
                        <!-- 실패해도 대기열에서 빼지 않는다. 대신 여기서 보이게 해서 사람이 지울지 정한다. -->
                        <div v-if="item.lastError" style="font-size: 0.75rem; color: #d9534f; word-break: break-all;">
                            <span class="badge bg-danger mr-1">{{ item.failCount || 1 }}번 실패</span>{{ item.lastError }}
                        </div>
                        <span v-else class="text-muted">-</span>
                    </template>
                    <template v-slot:actions="{ item }">
                        <div class="d-flex">
                            <a class="badge bg-primary mr-1" style="cursor:pointer" @click="duplicateQueueItem(item)" title="복사">
                                <i class="ri-file-copy-line mr-0"></i>
                            </a>
                            <a class="badge bg-danger" style="cursor:pointer" @click="removeQueueItem(item)" title="삭제">
                                <i class="ri-delete-bin-line mr-0"></i>
                            </a>
                        </div>
                    </template>
                </CDataTable>
                <div v-if="productQueue.length === 0" class="text-center text-muted py-4">
                    대기열이 비어있습니다. [+ 상품 추가] 버튼으로 상품을 추가하세요.
                </div>
            </div>

            <!-- 진행 범위 선택 -->
            <div class="mb-3 px-3 py-2 rounded" style="background: #f8f9fa; border: 1px solid #e0e0e0;">
                <div class="mb-1" style="font-size: 0.8rem; color: #555; font-weight: 600;">어디까지 진행할까요?</div>
                <div v-for="step in queueSteps" :key="step.level"
                    class="d-flex align-items-center px-2 rounded"
                    :style="[queueStepLevel === step.level ? 'background: #e8f0fe;' : 'cursor: pointer;', 'padding: 4px 8px;']"
                    @click="queueStepLevel = step.level"
                >
                    <b-form-radio
                        :checked="queueStepLevel === step.level"
                        :value="true"
                        class="mr-2"
                        style="pointer-events: none;"
                    ></b-form-radio>
                    <span style="font-size: 0.82rem; font-weight: 600; min-width: 70px;" :style="queueStepLevel === step.level ? 'color: #1a73e8;' : 'color: #333;'">{{ step.label }}</span>
                    <span style="font-size: 0.75rem; color: #888; margin-left: 4px;">{{ step.description }}</span>
                </div>
            </div>

            <div class="d-flex justify-content-between">
                <div>
                    <b-button variant="outline-primary" @click="addQueueItem" class="mr-2" :disabled="queueAddLoading">
                        <b-spinner small class="mr-1" v-if="queueAddLoading"></b-spinner>
                        <i class="las la-plus mr-1" v-else></i>
                        {{ queueAddLoading ? '카테고리 불러오는 중...' : '상품 추가' }}
                    </b-button>
                    <b-button
                        v-if="queueSelectedItems.length > 0"
                        variant="outline-danger"
                        @click="removeSelectedQueueItems"
                    >
                        <i class="las la-trash mr-1"></i> 선택 삭제 ({{ queueSelectedItems.length }})
                    </b-button>
                </div>
                <b-button
                    variant="primary"
                    :disabled="productQueue.length === 0 || queueProcessing"
                    @click="checkLoginBeforeQueue().then(ok => ok && startQueueProcessing())"
                >
                    <span v-if="queueProcessing">
                        <b-spinner small class="mr-1"></b-spinner>
                        {{ queueProgress.current }}/{{ queueProgress.total }} 처리 중...
                    </span>
                    <span v-else-if="queueSelectedItems.length > 0">
                        선택 시작 ({{ queueSelectedItems.length }}건)
                    </span>
                    <span v-else>
                        전체 시작 ({{ productQueue.length }}건)
                    </span>
                </b-button>
            </div>
        </b-modal>

        <!-- 옵션 정보 모달 -->
        <RocketOptionsModal v-model="showOptionsModal" :selected-product="selectedProduct"
            @option-deleted="handleOptionDeleted" @open-wizard="handleOpenWizard" />

        <!-- 작업 마법사 모달 -->
        <ProductWizardModal v-if="selectedProduct" ref="productWizard" :default-settings="defaultSettings"
            @auto-save="updateProduct" @update-option-image="updateOptionImage" @closed="handleWizardClosed" />

        <!-- 카테고리 선택 모달 -->
        <CategorySelectModal ref="categorySelect" @selected="handleCategorySelected" @responded="handleCategoryResponded" />

        <!-- 탈환의깃발 안내 영상 모달 -->
        <b-modal id="talhwanGuideVideoModal" title="탈환의깃발 안내 영상" size="lg" hide-footer centered
            @hidden="pauseTalhwanGuideVideo">
            <video ref="talhwanGuideVideo" class="talhwan-guide-video" :src="talhwanGuideVideoUrl"
                controls preload="none" playsinline></video>
        </b-modal>
    </div>
</template>

<script>
import CDataTable from '@/components/common/CDataTable';
import { EXT_NO_ANSWER } from '@/utils/extInstallSteps';
import axios from 'axios';
import ProductWizardModal from '../../../components/AIRocket/ProductWizardModal.vue';
import CategorySelectModal from '../../../components/AIRocket/CategorySelectModal.vue';
import RocketSettingsPanel from '../../../components/AIRocket/RocketSettingsPanel.vue';
import RocketOptionsModal from '../../../components/AIRocket/RocketOptionsModal.vue';
import { mapState, mapActions, mapMutations } from 'vuex';
import workflowService from '../../../services/workflowService';
import bundleOptionService from '../../../services/works/bundleOptionService';
import pricingPolicy from '../../../services/works/pricingPolicy';
import { getWorkDetail, formatWorkDetail, formatStepCount, onWorkProgress, resetProduct as resetWorkProgress } from '../../../services/works/workProgress';
import { workOutcome } from '../../../services/works/workOutcome';
import { detailImageErrorText } from '../../../services/works/detailImageZero';
import { seoErrorText, koreanLabelErrorText } from '../../../services/works/seoErrorKeep';
import detailImageService from '../../../services/works/detailImageService';
import { buildClaimWarning } from '../../../services/works/detailClaimGuard';
import { checkDetailImageEditInput, hasDetailImageEdit, detailImageList, applyDetailImageEdit, combinedDetailHtml, detailEditUpdateFields, detailUploadFailText } from '../../../utils/detailImageEdit';
import { fixOriginForSubmit } from '../../../services/works/submitOriginFix';
import { coupangDocForSend } from '../../../services/works/packageEstimate';
import { detailImageUrls, detailSizeReason, measureImage } from '../../../services/works/detailImageMin';
import apiService from '../../../services/apiService';
import { resolveKeepSkuIds, dropSoldOutSkus, KEEP_NONE_MESSAGE, STOCK_NONE_MESSAGE } from '../../../utils/keepSkus';
import { listRangeIncludingToday } from '../../../utils/listRange';
import { isLightDoc, assertNotLight, LIGHT_SAVE_ERROR } from '../../../utils/rocketRegLight';
import { markSentUnconfirmed } from '../../../utils/sentUnconfirmed';
import { needsHubRecheck, quotationIdOf, needsServerRecheck, applyServerRecheck, pickAutoRecheck, AUTO_SERVER_RECHECK_MAX, SERVER_SAVE_FAILED, hubStartMs, applyHubResult, HUB_PAGE_SIZE, HUB_MAX_PAGES } from '../../../utils/hubRecheck';
import { logServiceError, ERROR_TYPES } from '../../../services/works/errorLoggingService';
import { cliDaemonUrl, CLI_DAEMON_ENABLED } from '@/config/cliDaemon';
import { shouldBeat, stallLimitMs } from '@/utils/cliHeartbeat';
import rocketRegDraftMixin from '../../../mixins/rocketRegDraftMixin';
import confirmInPageMixin from '@/mixins/confirmInPageMixin';
import { workProgress, workProgressText } from '@/utils/workProgress';

// 로컬 에이전트(데몬)와 이 화면을 잇는 실행 채널. 정본 docs/mcp-rocket-plan.md §5
// 규약: subscribe(SSE) → tools 선언 → 명령 수신 → result 보고
// 탈환의깃발 안내 영상 (S3 logis-import-image 버킷 공개 URL)
const TALHWAN_GUIDE_VIDEO_URL = 'https://logis-import-image.s3.ap-northeast-2.amazonaws.com/guide-videos/talhwan-flag-v2.mp4';

// 데몬 없는 빌드(로컬 기본)면 비워 두고 아래 부르는 곳이 CLI_DAEMON_ENABLED 로 건너뛴다
const CLI_PAGE_BASE = CLI_DAEMON_ENABLED ? cliDaemonUrl('/api/cli/page') : '';
const CLI_PAGE_SCREEN = 'rocketReg';
// 여기 적은 것만 실제로 실행할 수 있다. 실행 못 하는 걸 적으면 명령이 조용히 타임아웃난다.
// «접수 미확인» 허브 재확인(읽기만) — 자동은 5분마다 살피되 상품마다 마지막 확인 뒤 10분이 지난 것만, 조회가 실패하면 30분 쉰다.
// 전송이 끝나면 30초 뒤 한 번. 확장 응답은 60초까지 기다린다(등록 심사 상태 화면과 같은 상한)
const HUB_AUTO_TICK_MS = 5 * 60 * 1000;
const HUB_AUTO_MIN_GAP_MS = 10 * 60 * 1000;
const HUB_AUTO_BACKOFF_MS = 30 * 60 * 1000;
const HUB_SOON_MS = 30 * 1000;
const HUB_RESPONSE_TIMEOUT_MS = 60 * 1000;
const HUB_SERVER_RECHECK_CHUNK = 50;   // 서버 재확인 한 번에 보낼 등록ID 수 — 도구 상한(tool-exec/rocket-submit.js SUBMIT_MAX_PRODUCTS)과 같다
const CLI_PAGE_TOOLS = ['rocket.sourcing.runWork', 'rocket.sourcing.setDetailImages', 'rocket.sourcing.setBundle', 'rocket.sourcing.setPrice', 'rocket.sourcing.submitRegistration', 'rocket.sourcing.startQueue', 'common.sourcing.categorySearch', 'common.sourcing.findCategoryId', 'rocket.sourcing.checkSetup',
    // 2026-10-01 개명 전 이름 — 개명 전 서버가 보낸 작업도 받는다. 다음 배포에서 뺀다(tool-catalog/aliases.js 와 같이)
    'rocket.runWork', 'rocket.setBundle', 'rocket.setPrice', 'rocket.submitRegistration', 'rocket.startQueue', 'rocket.checkSetup', 'sourcing.categorySearch', 'sourcing.findCategory'];
// 세팅 점검이 확장에 서플라이어허브 탭 유무를 묻고 기다리는 시간. 옛 확장은 답을 안 한다 → 모름(unknown)
const CLI_PAGE_TAB_CHECK_MS = 3000;
// 이 화면의 쿠플러스 로그인이 풀렸을 때. 서버는 상품 정보 대신 「로그인실패」를 돌려준다 — 상품번호 탓이 아니다.
const LOGIN_EXPIRED_MESSAGE = '쿠플러스 로그인이 풀렸어요 — 이 화면을 새로고침하고 다시 로그인한 뒤 작업개시를 다시 눌러주세요.';
const CLI_PAGE_RETRY_MIN_MS = 5000;
const CLI_PAGE_RETRY_MAX_MS = 60000;
// 진행보고가 올 때마다 저쪽 타임아웃 시계가 다시 걸린다. 긴 작업은 말이 없으면 죽는다.
const CLI_PAGE_HEARTBEAT_MS = 30000;

// ── 카테고리 수집(common.sourcing.categorySearch) ────────────────────────────────
// 쿠팡 카테고리 페이지는 브라우저 밖에서는 못 읽는다(챌린지). 확장이 브라우저 안에서 읽고
// 이 화면이 그 사이를 잇는다. 짧은 시간에 여러 번 읽으면 403 이 떨어지고 한 시간 넘게
// 안 풀린다 — 그동안 셀러가 자기 크롬에서 쿠팡 검색을 못 한다. 그래서 여기서 먼저 막는다.
const CATEGORY_SEARCH_MAX_PAGES = 5;
const CATEGORY_SEARCH_SORTERS = ['saleCountDesc', 'coupangRanking', 'salePriceAsc', 'salePriceDesc', 'latestAsc'];
const CATEGORY_SEARCH_TICK_MS = 1000;
// 첫 응답이 없다 = 확장이 없거나 이 기능이 없는 옛 버전이다. 도중에 끊긴 것과 구분해서 알린다.
const CATEGORY_SEARCH_FIRST_MS = 30 * 1000;
// 한 페이지마다 1초 이상 쉬므로 응답 간격이 이만큼 벌어지면 멈춘 것으로 본다.
const CATEGORY_SEARCH_IDLE_MS = 3 * 60 * 1000;

// ── 카테고리 찾기(common.sourcing.findCategoryId) ─────────────────────────────────
// 쿠팡 홈의 카테고리 메뉴를 통째로 한 번 긁어 로컬 에이전트에 넘긴다. 거기서 캐시하므로
// 이름으로 찾는 일은 쿠팡을 아예 안 부른다 — 이 화면이 불리는 건 목록을 새로 받을 때뿐이다.
// 기다리는 규칙(첫 응답 / 응답 끊김)은 위 카테고리 수집과 같은 값을 쓴다.

// 대기열 처리는 확장 응답을 타고 이어져서 끝을 약속해 주지 않는다.
// queueProcessing 이 내려가는 것이 유일한 완료 신호라 그걸 지켜본다.
const QUEUE_WAIT_TICK_MS = 2000;
// 진행 숫자가 안 바뀌어도 이만큼 지나면 한 번은 보고한다 (2초 × 10 = 20초).
const QUEUE_WAIT_REPORT_TICKS = 10;
// 작업개시(runWork) 중 세부 진행(작업 이름·옵션 n/N)을 다시 읽는 간격. 바뀌었을 때만 보고한다.
const RUN_WORK_DETAIL_TICK_MS = 5000;
// 상품추가가 이만큼 한 건도 안 늘면 멈춘 것으로 본다. 작업개시 구간(숫자가 다 찬 뒤)에는 적용하지 않는다.
const QUEUE_WAIT_STALL_MS = 30 * 60 * 1000;
// 다른 탭이 이어받았을 때 이 탭이 지금 건을 마치고 멈추길 기다리는 최대 시간(작업개시 한 건이 10~15분까지 간다)
const QUEUE_TAKEOVER_STOP_WAIT_MS = 20 * 60 * 1000;
// 탭 사이 대기열 표식 — 돌고 있는 탭이 이 간격으로 갱신하고, 이보다 오래 안 바뀐 표식은 죽은 탭 것으로 본다.
// 숨은 탭은 타이머가 1분 간격까지 늦어지므로 기준을 넉넉히 둔다.
const QUEUE_RUN_KEY = 'couplus.aiRocketReg.queueRun';
const QUEUE_RUN_BEAT_MS = 15 * 1000;
const QUEUE_RUN_STALE_MS = 3 * 60 * 1000;
// 대기열 항목 묶음 수량 상한 — 서버 대기열 도구(tool-exec/rocket-local.js 묶음 수량 max)와 같은 값(#1825)
const QUEUE_BUNDLE_QUANTITY_MAX = 1000;

// 등록전송도 같은 이유로 끝을 약속해 주지 않는다 — submitProductsToCoupang 는 확장에 요청만 던지고
// 돌아오고, 실제 완료는 확장 응답을 타고 processNextVerification 이 이어간다.
// isVerifying 이 내려가는 것이 유일한 완료 신호다.
// 한 건이 몇 분 걸린다(문서 생성 → 페이지 이동 → 단계별 검증). 아무것도 안 움직이는 시간이
// 이만큼이면 멈춘 것으로 본다 — 확장이 "Supplier Hub에 로그인하세요" alert 을 띄우고
// 멈춰 선 경우가 대표적이다(background.js verifyRocketReg).
const SUBMIT_WAIT_STALL_MS = 15 * 60 * 1000;
// 대기열 작업개시가 「끝났다」고 말하려면 이 작업이 전부 완료여야 한다 — 대기열 등록전송(4단계)이 고르는 기준과 같다
const AUTO_WORK_TASKS = ['seo', 'mainImage', 'additionalImage', 'detailImage', 'koreanLabel', 'quotation'];

// 어디까지 끝났는지 / 다음에 무엇을 하면 되는지. 부르는 쪽이 이걸 읽고 다음 단계를 고른다.
const QUEUE_STEP_DONE = {
    1: '상품 추가까지 끝났습니다. SEO·가격·이미지 작업은 아직 하지 않았습니다.',
    2: '상품 추가와 SEO·가격까지 끝났습니다. 이미지 등 나머지 작업은 아직 하지 않았습니다.',
    3: '상품 추가부터 작업 개시까지 끝났습니다. 쿠팡 등록 전송은 하지 않았습니다.',
    4: '상품 추가부터 쿠팡 등록 전송까지 끝났습니다. 더 진행할 단계가 없습니다.'
};
const QUEUE_STEP_NEXT = {
    1: 'rocket.sourcing.runWork 로 작업을 이어가세요. SEO·가격도 아직이라 tasks 를 비우고 전체를 돌리면 됩니다.',
    2: "rocket.sourcing.runWork 로 남은 작업을 이어가세요. tasks 에 'seo' 나 'pricing' 을 다시 넣으면 중복입니다.",
    3: 'rocket.sourcing.runWork 는 이미 끝났으니 다시 부르지 마세요. 다음은 rocket.sourcing.submitRegistration 입니다.',
    4: '더 부를 것이 없습니다. 결과는 rocket.sourcing.listRegistrations 의 등록상태에서 확인하세요.'
};

export default {
    name: 'RocketProductRegistration',
    mixins: [rocketRegDraftMixin, confirmInPageMixin],
    components: {
        CDataTable,
        ProductWizardModal,
        CategorySelectModal,
        RocketSettingsPanel,
        RocketOptionsModal
    },
    data() {
        return {
            // 월요일 공개 예정 — 공개할 때 true 로 켠다
            showTalhwanGuideVideo: true,
            // 목록 그림을 못 받은 등록번호 → 빈 틀(깨진 아이콘 대신)
            brokenImages: {},
            talhwanGuideVideoUrl: TALHWAN_GUIDE_VIDEO_URL,
            // 기본 상태 변수
            selectedItems: [],
            showSettings: false,
            showspinner1: false,
            showspinner: false,
            loadingtext: '',
            isProcessing: false,
            isVerifying: false,
            // «접수 미확인» 허브 재확인(읽기만) — 한 번에 하나. 자동은 HUB_AUTO_* 간격, 실패하면 HUB_AUTO_BACKOFF_MS 쉼
            hubRecheck: { inFlight: false, timer: null, soonTimer: null, nextAutoAt: 0, loadingPending: false },

            // 검증 관련 필드 추가
            pendingVerifications: new Map(),
            verificationQueue: [],

            // 기본 설정
            defaultSettings: {
                brand: '',
                manufacturer: '',
                importer: '',
                transactionType: '기타 도소매업자',
                importStatus: '수입대상아님',
                asInfo: '',
                exchangeRate: 350,
                marginRate: 40,
                coupangMarginRate: 40,
                roundUnit: 100,
                msrpMultiplier: 1.3,
                enableBundling: false,
                bundlingType: 'marginAmount',
                minMarginAmount: 3000,
                minCoupangMarginAmount: 3000,
                totalSKUsInBox: 1,          // 박스 내 SKU 수량
                enableUnexposedAttributes: true,  // 비노출속성 자동 생성 (기본값: true)
                imageSettings: {
                    useTopImage: false,
                    topImageUrl: '',
                    useBottomImage: false,
                    bottomImageUrl: '',
                    translateImages: true,
                    addCopyright: true,
                    translationPromptStyle: `- 온라인 쇼핑객들에게 인기 있는 현대적이고 트렌디한 한국어 표현을 사용하세요 (예: 득템, 인생템, 꿀템)
- 번역에 이모티콘이나 이모지를 사용하지 마세요
- 제품의 시각적 스타일과 타겟 고객에 맞는 마케팅 카피를 작성하세요
- 직역보다는 감정적 연결에 집중하세요
- 제품 사양의 경우 핵심 요소만 간단히 표현하세요
- 가능한 한 짧은 단어와 줄임말을 사용하세요`
                }
            },

            // 테이블 헤더 설정
            headers: [
                {
                    text: '등록번호',
                    value: 'registrationId',
                    align: 'center',
                    sortable: true,
                    width: 120,
                    isSlot: true
                },
                {
                    text: '상품이미지',
                    value: 'productImage',
                    align: 'center',
                    sortable: false,
                    width: 100,
                    isSlot: true
                },
                {
                    text: '상품명',
                    value: 'productName',
                    align: 'left',
                    sortable: true,
                    width: 200,
                    isSlot: true
                },
                {
                    text: '구매링크',
                    value: '구매링크',
                    align: 'left',
                    sortable: true,
                    // 50 이면 머리 글이 한 자씩 세로로 꺾였다(10-19 1440 사진) — 이웃 칸(SEO설정 등)과 같은 폭
                    width: 100,
                    isSlot: true
                },
                {
                    text: 'SEO설정',
                    value: 'seoStatus',
                    align: 'center',
                    sortable: true,
                    width: 100,
                    isSlot: true
                },
                {
                    text: '가격설정',
                    value: 'pricingStatus',
                    align: 'center',
                    sortable: true,
                    width: 100,
                    isSlot: true
                },
                {
                    text: '대표이미지',
                    value: 'mainImageStatus',
                    align: 'center',
                    sortable: true,
                    width: 100,
                    isSlot: true
                },
                {
                    text: '추가이미지',
                    value: 'additionalImageStatus',
                    align: 'center',
                    sortable: true,
                    width: 100,
                    isSlot: true
                },
                {
                    text: '상세이미지',
                    value: 'detailImageStatus',
                    align: 'center',
                    sortable: true,
                    width: 100,
                    isSlot: true
                },
                {
                    text: '사이즈표',
                    value: 'sizeChartStatus',
                    align: 'center',
                    sortable: true,
                    width: 100,
                    isSlot: true
                },
                {
                    text: '한글표시사항',
                    value: 'koreanLabelStatus',
                    align: 'center',
                    sortable: true,
                    width: 100,
                    isSlot: true
                },
                {
                    text: '견적서',
                    value: 'quotationStatus',
                    align: 'center',
                    sortable: true,
                    width: 120,
                    isSlot: true
                },
                {
                    text: '등록상태',
                    value: 'verified',
                    align: 'center',
                    sortable: true,
                    width: 100,
                    isSlot: true
                },
                {
                    text: '관리',
                    value: 'actions',
                    align: 'center',
                    sortable: false,
                    width: 120,
                    isSlot: true
                }
            ],

            // 옵션 관련 상태
            showOptionsModal: false,

            // 상품 추가 관련 상태
            linkError: '',
            validLinkFeedback: '',
            newProduct: {
                link: '',
                keyword: '',
                brand: ''
            },

            // 로컬 에이전트 실행 채널 (정본 docs/mcp-rocket-plan.md §5)
            // 화면이 열려 있는 동안만 붙어 있는 연결이다. 에이전트가 시킨 일을 이 화면이 대신 실행한다.
            cliPage: {
                source: null,        // EventSource (Vue 가 관찰하지 않는 객체)
                subId: null,
                // 같은 탭이 다시 붙을 때 「내가 그 탭이다」 증명 — 마지막 연결의 subId 와 그 hello 의 resumeKey
                resume: null,
                connected: false,
                retryDelay: CLI_PAGE_RETRY_MIN_MS,
                retryTimer: null,
                stopped: false,
                // 다른 탭이 같은 화면을 열어 명령권을 가져간 상태. 밀려난 탭은 그 작업의
                // 주인이 아니므로 "진행 중" 을 보내면 안 된다 — 보낼 때마다 시계가 다시 걸린다.
                superseded: false,
                loggedOffline: false,
                seenJobs: new Set(),  // 같은 job 이 hello + job 두 경로로 와도 한 번만 실행한다
                beatTimers: new Map(), // jobId → setInterval 핸들
                lastProgressAt: new Map(), // jobId → 마지막 진척(onProgress) 시각 — 진척 없이 오래 가면 박동을 멈춘다
                stallMs: new Map(), // jobId → 그 진척이 알린 일감 한도(상품 하나 작업 한도 합) — 30분보다 길면 그만큼 기다린다
                rejoinTried: new Set(), // 진행 보고가 409 로 거절돼 한 번 다시 붙어 본 jobId
                // 완료를 지켜보는 대기 인터벌. 화면 수명에 묶어 두지 않으면 화면이 사라진 뒤에도
                // 계속 돌면서 보고를 보내고, 그 보고가 저쪽 타임아웃 시계를 영영 다시 건다.
                waitTimers: new Map(), // setInterval 핸들 → reject
                // 카테고리 수집이 도는 중인지. 동시에 두 번 읽으면 쿠팡이 403 을 내고
                // 한 시간 넘게 안 풀어준다 — 큐는 하나만 둔다.
                categoryBusy: false,
                // 카테고리 찾기도 같은 쿠팡 세션을 쓴다 — 카테고리 수집과 큐를 나눠 갖지 않는다.
                findCategoryBusy: false,
                // 첫 등록상품 목록 로드가 끝났는지. 끝나기 전에 작업이 오면 실제 상품도
                // 「화면 목록에 없는 상품」으로 거절된다 — 끝나면 데몬에 준비됨을 알린다.
                listReady: false
            },

            // 대기열 모달 관련
            productQueue: [],
            queueSelectedItems: [],
            queueAddMode: false,
            queueProcessing: false,
            queueProgress: { current: 0, total: 0 },
            // 상품추가가 끝난 뒤 작업개시 구간의 진행(k/N·상품명). 없으면 null — 도구 진행 보고용
            queueWorkProgress: null,
            // 옵션별 작업 장수(workProgress)가 바뀔 때마다 올린다 — 목록 칸 「처리중 12/50」을 다시 그리는 신호
            workProgressTick: 0,
            queueStepLevel: 2, // 1=상품추가, 2=SEO+가격, 3=작업개시, 4=등록전송
            queueSteps: [
                { level: 1, label: '상품추가', description: '상품만 테이블에 추가합니다. 옵션·가격을 직접 확인한 뒤 다음 단계를 진행할 수 있습니다.' },
                { level: 2, label: 'SEO+가격', description: 'SEO·가격설정까지 자동 진행합니다. 번들링·옵션정리 후 작업개시하면 한글표시사항·견적서에 반영됩니다.' },
                { level: 3, label: '작업개시', description: '이미지 편집, 한글라벨, 상세페이지, 견적서까지 전체 작업을 실행합니다.' },
                { level: 4, label: '등록전송', description: '모든 작업 완료 후 쿠팡에 자동 등록까지 진행합니다.' }
            ],
            queueHeaders: [
                { text: '카테고리', value: 'categoryPathString', width: 200 },
                { text: '1688 링크', value: 'link', isSlot: true, width: 250 },
                { text: '특징', value: 'productFeature', isSlot: true, width: 150 },
                { text: '키워드', value: 'keyword', isSlot: true, width: 150 },
                { text: '실패', value: 'lastError', isSlot: true, width: 220 },
                { text: '', value: 'actions', isSlot: true, sortable: false, width: 80 }
            ],

            // 검색 관련 상태
            selectdate: 'today',
            startdate: this.getTodaywith(),
            enddate: this.getTodaywith(),
            selectoption: '등록일',
            selectedWorkType: 'all', // 기본값으로 전체 작업 선택
            extensionRequestId: null,
            extensionResponseData: null,
            extensionRequestPending: false,
            pendingProductData: null,
            resetPendingProduct: null, // 초기화 중인 상품 (초기화 모드 구분용)
            createdProductId: null,          // 생성된 상품 ID
            pendingOptionCount: 0,           // 처리 예정 옵션 수
            completedOptionCount: 0,         // 처리 완료된 옵션 수
            savedRocketRegInfo: null,
            delay: 500,

            // 소싱 자동 등록 큐
            sourcingQueue: [],
            isSourcingProcessing: false,
            sourcingAutoMode: false,
            sourcingProgress: { current: 0, total: 0 },
            queueAutoMode: false,
            // 대기열 모달의 [+ 상품 추가] 버튼 로딩 상태 (카테고리 조회 중)
            queueAddLoading: false,

            // 상품추가 모드: false=자동설정(SEO+가격), true=바로추가(테이블에만)
            skipInitialProcessing: false,

            // 초기화 처리 관련 (상품 추가 시 자동 SEO+Pricing)
            isInitialProcessing: false,
            initialProcessingTitle: '상품 초기화 중...',
            initialProcessingMessage: '상품 정보를 분석하고 있습니다.',
            initialProcessingProgress: 0,
            initialProcessingStep: 0,
        };
    },

    mounted() {
        // 기본 설정 로드
        this.loadDefaultSettings();
        this.loadIntegratedRate();
        // search 는 실패해도 던지지 않는다(토스트만). 끝나면 목록 준비됨 — 연결돼 있으면 데몬에 알린다
        this.search().finally(() => {
            this.cliPage.listReady = true;
            if (this.cliPage.connected) this.cliPageDeclareTools();
            this.autoRecheckHubConfirm();   // 화면을 열 때 «접수 미확인» 건을 허브에서 한 번 확인(읽기만)
        });
        this.hubRecheck.timer = setInterval(() => this.autoRecheckHubConfirm(), HUB_AUTO_TICK_MS);

        window.addEventListener('message', this.handleExtensionMessage);

        // 상품 분리 완료 이벤트 리스너 추가
        window.addEventListener('product-split-completed', this.handleProductSplitCompleted);

        // AI소싱에서 전송된 상품 처리
        console.log('[AIRocketReg] mounted — sourcingItems:', this.$store.state.sourcingItems?.length, '건', (this.$store.state.sourcingItems || []).map(i => i.offerId));

        // CLI 파이프라인에서 추가된 상품 자동 로드
        this.loadCliRegistrationQueue();

        // 로컬 에이전트 실행 채널 연결 (데몬이 없으면 아무 일도 일어나지 않는다)
        this.cliPageConnect();

        // 옵션별 작업 장수가 바뀌면 목록 칸을 다시 그린다
        this._offWorkProgress = onWorkProgress(() => { this.workProgressTick++; });

    },
    beforeDestroy() {
        // 크롬 확장 프로그램 메시지 리스너 제거
        window.removeEventListener('message', this.handleExtensionMessage);

        // 상품 분리 완료 이벤트 리스너 제거
        window.removeEventListener('product-split-completed', this.handleProductSplitCompleted);

        // 로컬 에이전트 실행 채널 정리 (화면을 떠나면 명령을 받지 않는다)
        this.cliPageDisconnect();
        this.$store.commit('workEnd', 'rocketReg');

        if (this._offWorkProgress) this._offWorkProgress();
        clearInterval(this.hubRecheck.timer);
        clearTimeout(this.hubRecheck.soonTimer);

        // 대기열 도중에 화면을 떠나면 자동 버림 제외를 되돌린다
        if (this.queueProcessing) this.keepTabAlive(false);
    },
    watch: {
        // 바쁨 문(판 #308) — 등록·대기열이 도는 동안 화면 새로고침·CLI 업데이트를 미루게 알린다
        rocketRegWorking(v) {
            this.$store.commit(v ? 'workStart' : 'workEnd', 'rocketReg');
        },
        // 기존 watch 항목들...

        // 대기열이 끝나면(어느 길로든) 탭 사이 표식을 걷는다 — 남겨 두면 다른 탭이 몇 분 동안 시작하지 못한다
        queueProcessing(on) {
            if (!on) this.markQueueRun(false);
            // 도는 동안 이 탭을 크롬 자동 버림(Memory Saver)에서 뺀다 — 버려지면 작업개시가 수십 분 멈춘다(#1917)
            this.keepTabAlive(!!on);
        },

        // 등록전송이 끝나면(성공·실패·중단 모두) 체크를 푼다 — 남겨 두면 다음 전송(버튼·자동)이
        // 같은 행을 또 보낸다(2026-10-16 PR261016-3043EA). 완료 처리(processNextVerification)가 다 읽은 뒤라 안전하다.
        isVerifying(now, before) {
            if (before && !now) {
                this.selectedItems = [];
                this.scheduleHubRecheckSoon();   // 방금 보낸 건을 허브에서 확인(읽기만) — 쿠팡 반영을 잠깐 기다린 뒤
            }
        },

        // 기본정보 저장·계정 전환 뒤 store settings 가 바뀌면 화면 defaultSettings 도 새 값으로
        '$store.state.settings'() {
            this.loadDefaultSettings();
        },

        // rocketProducts의 변경을 감시
        '$store.state.rocketProducts': {
            handler(newProducts) {
                // 선택된 상품 ID를 유지하면서 최신 데이터로 업데이트
                this.selectedItems = this.selectedItems.map(item => {
                    const updatedProduct = newProducts.find(p => p.registrationId === item.registrationId);
                    return updatedProduct || item; // 찾지 못하면 기존 항목 유지
                });
            },
            deep: true // 깊은 감시 (중첩 객체 변경 감지)
        },

        // 저장 중 서버에 반영되지 못한 옵션이 있을 때만 값이 들어온다.
        // 드물게 생기는 상황이라, 뜰 때는 사용자가 알고 다시 저장할 수 있게 알린다.
        '$store.state.featureSaveWarning'(warning) {
            if (!warning) return;
            // 알 수 없는 작업이면 getWorkTypeText 가 '작업 선택' 을 돌려주므로 그때는 작업명을 뺀다
            const workName = this.getWorkTypeText(warning.feature);
            const prefix = workName === '작업 선택' ? '' : workName + ' ';
            this.$bvToast.toast(`${prefix}작업 결과 중 ${warning.count}개 옵션이 저장되지 않았습니다. 목록을 새로고침한 뒤 다시 시도해주세요.`, {
                title: '저장되지 않은 항목이 있습니다',
                variant: 'warning',
                solid: true,
                autoHideDelay: 8000,
                toaster: 'b-toaster-bottom-right'
            });
        },

        // 자동 상품명에서 어린이용 낱말(어린이·아동·키즈·유아)이나 근거 없는 개수(9개입·4구)를 뺐을 때
        '$store.state.seoWordWarning'(warning) {
            if (!warning) return;
            // userKept = 사람이 저장한 옵션명이라 빼지 않고 둔 것(판 #737) — «뺐습니다» 제목이면 거꾸로 읽힌다
            const onlyKept = String(warning.type || '').split(',').every(t => t === 'userKept');
            this.$bvToast.toast(`${warning.registrationId}: ${warning.message}`, {
                title: onlyKept ? '사람이 저장한 옵션명은 그대로 뒀습니다 — 확인해 주세요' : '자동 상품명에서 일부 낱말을 뺐습니다',
                variant: 'warning',
                solid: true,
                autoHideDelay: 10000,
                toaster: 'b-toaster-bottom-right'
            });
        }
    },
    computed: {
        // 바쁨 문(판 #308) — 단건 등록(isProcessing)이나 대기열(queueProcessing)이 도는 중
        rocketRegWorking() {
            return this.isProcessing || this.queueProcessing;
        },
        confirmPendingCount() {
            return (this.products || []).filter(p => needsHubRecheck(p)).length;
        },
        // Vuex 상태 매핑
        ...mapState({
            products: state => state.rocketProducts,
            rocketProductsHiddenTotal: state => state.rocketProductsHiddenTotal,
            vuexSelectedProduct: state => state.selectedRocketProduct,
            processing: state => state.processing,
            progressMessage: state => state.progressMessage
        }),

        // 선택된 상품
        selectedProduct: {
            get() {
                return this.vuexSelectedProduct;
            },
            set(value) {
                this.SET_SELECTED_ROCKET_PRODUCT(value);
            }
        },

        // 링크 유효성 검사
        linkValidation() {
            if (!this.newProduct.link) return null;
            return this.newProduct.link.includes('detail.1688.com');
        },

        // 선택된 상품이 있는지 확인
        hasSelectedProducts() {
            return this.selectedItems.length > 0;
        },

        // 상품 추가 중인지 확인
        isAddingProduct() {
            return this.showspinner1 && this.loadingtext && (
                this.loadingtext.includes('상품 추가') ||
                this.loadingtext.includes('상품을 추가') ||
                this.loadingtext.includes('상품 등록') ||
                this.loadingtext.includes('상품을 등록')
            );
        },

        // 작업 상태 필드 목록
        workStatusFields() {
            return [
                'seoStatus',
                'pricingStatus',
                'mainImageStatus',
                'additionalImageStatus',
                'detailImageStatus',
                'sizeChartStatus',
                'koreanLabelStatus',
                'quotationStatus'
            ];
        },
    },

    methods: {
        // Vuex 액션과 뮤테이션 매핑
        ...mapActions([
            'searchRocketProducts',
            'updateRocketProduct',
            'updateOptionImage',
            'processMainImageForAllOptions',
            'testRequestExtension'
        ]),

        ...mapMutations([
            'SET_SELECTED_ROCKET_PRODUCT',
            'SET_SELECTED_OPTION',
            'SET_SELECTED_WORK_TYPE'
        ]),

        /**
 * 선택된 작업 타입에 따라 드롭다운 표시 텍스트 반환
 * @param {string} workType - 선택된 작업 타입
 * @returns {string} 표시할 텍스트
 */
        getWorkTypeText(workType) {
            const workTypeNames = {
                'all': '전체 작업',
                'seo': 'SEO설정',
                'pricing': '가격설정',
                'mainImage': '대표이미지',
                'additionalImage': '추가이미지',
                'detailImage': '상세이미지',
                'sizeChart': '사이즈표',
                'koreanLabel': '한글표시사항',
                'quotation': '견적서'
            };

            return workTypeNames[workType] || '작업 선택';
        },
        selectWorkType(type) {
            this.selectedWorkType = type;
        },

        /**
         * 상품명 표시를 위한 우선순위 규칙에 따라 표시할 상품명 반환
         * 우선순위: SEO 상품명 > 영문 상품명(productNameTrans) > 원본 상품명(productName)
         * @param {Object} product - 상품 객체
         * @returns {string} - 표시할 상품명
         */
        getDisplayProductName(product) {
            if (!product) return '';

            // 1. SEO 처리된 상품명이 있으면 가장 높은 우선순위
            if (product.seoStatus === 'completed' && product.seo && product.seo.productName) {
                return product.seo.productName;
            }

            // 2. 영문 상품명 (productNameTrans)
            if (product.productNameTrans) {
                return product.productNameTrans;
            }

            // 3. 원본 상품명
            return product.productName || '';
        },

        // 설정 토글
        pauseTalhwanGuideVideo() {
            const video = this.$refs.talhwanGuideVideo;
            if (video) video.pause();
        },
        toggleSettings() {
            this.showSettings = !this.showSettings;
        },

        // 기본 설정 로드
        loadDefaultSettings() {
            if (this.$store.state.settings[0]?.defaultSettings) {
                this.defaultSettings = this.$store.state.settings[0].defaultSettings;
            }
        },

        // 서버의 통합통관환율을 받아 가격 계산(pricingPolicy)에 넣는다.
        // 기본세팅 useIntegratedRate 가 켜진 계정에서만 쓰이지만, 스위치를 켜는 순간 바로 계산되도록 늘 받아 둔다.
        async loadIntegratedRate() {
            try {
                const res = await axios.post('/api/getExchangeRate', {});
                const d = res.data && res.data.data;
                if (d && d.integratedRateFound && Number(d.integratedRate) > 0) {
                    pricingPolicy.setIntegratedRate(d.integratedRate);
                } else {
                    console.error('[AIRocketReg] 통합통관환율이 서버에 없습니다:', res.data);
                    pricingPolicy.setIntegratedRate(null);
                }
            } catch (e) {
                console.error('[AIRocketReg] 통합통관환율 조회 실패:', e);
                pricingPolicy.setIntegratedRate(null);
            }
            return pricingPolicy.getIntegratedRate();
        },

        // 기본세팅을 쿠패스 통합통관 환율로 켜고 저장한다. 켠 환율을 돌려준다.
        // 환율을 못 받으면 켜지 않고 던진다 — 켜 놓고 적용환율로 조용히 계산되는 것보다 낫다.
        async enableIntegratedRateDefault() {
            const rate = await this.loadIntegratedRate();
            if (!rate) {
                throw new Error('쿠패스 통합통관 환율을 받지 못해 기본세팅을 바꾸지 않았습니다. 쿠플러스 로그인·서버 상태를 확인해주세요.');
            }
            const res = await axios.post('/api/savesetting', { 'defaultSettings.useIntegratedRate': true });
            if (!res.data || !res.data.success) {
                throw new Error(`기본세팅 저장에 실패했습니다: ${(res.data && res.data.message) || '응답 없음'}`);
            }
            this.$store.commit('settingsupdate', [res.data.data]);
            this.loadDefaultSettings();
            return rate;
        },

        // 설정 저장 처리
        handleSettingsSaved(settings) {
            this.defaultSettings = settings;
        },

        handleOpenWizard() {
            console.log('open-wizard 이벤트 수신');
            // ProductWizardModal 열기
            if (this.$refs.productWizard) {
                this.$refs.productWizard.open();
            }
        },

        // 검색 관련 메서드
        async search() {
            console.log(this.$store.state.user.rocketRegSlot)
            // 대기열이 도는 사이 자정을 넘겼으면 저장 직후 조회가 어제 기간으로 목록을 덮어 오늘 만든 상품이 빠진다 — 매 조회마다 오늘까지 늘린다
            if (this.queueProcessing) this.ensureListRangeIncludesToday();
            this.showspinner = true;
            try {
                // 시작 날짜는 해당일 00:00:00으로 설정
                const start = this.gettimestamp(this.startdate);

                // 종료 날짜는 해당일 23:59:59.999로 설정 (하루의 마지막 시점)
                const end = this.gettimestamp(this.enddate) + (1000 * 60 * 60 * 24) - 1;

                console.log('검색 날짜 범위:',
                    '시작: ' + new Date(start).toLocaleString() + ' (' + start + ')',
                    '종료: ' + new Date(end).toLocaleString() + ' (' + end + ')');
                // Vuex 액션 호출
                await this.searchRocketProducts({ start, end });
                this._lastSearchError = '';
            } catch (e) {
                console.error('등록상품 불러오기 실패', e);
                // 이 함수는 실패해도 토스트만 띄우고 던지지 않는다 — 부르는 쪽(cliPageStartQueue)은
                // 목록이 안 채워진 것을 성공으로 읽는다. 실패 사실을 남겨서 응답에 실을 수 있게 한다.
                this._lastSearchError = (e && e.message) || '등록상품을 불러오지 못했습니다.';
                // 서버가 사유를 말해준 경우(권한 등)에는 그 문구를 그대로 보여준다.
                this.$bvToast.toast(e && e.serverRejected ? e.message : '등록상품을 불러오지 못했습니다. 잠시 후 다시 시도해주세요.', {
                    title: '알림',
                    variant: 'warning',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
            } finally {
                this.showspinner = false;
            }
        },

        // 날짜 포맷 관련 메서드
        getdate(timestamp) {
            var date = new Date(timestamp);
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + "-" + month + "-" + day;
        },

        changedate() {
            if (this.selectdate == 'today') {
                this.startdate = this.getTodaywith();
                this.enddate = this.getTodaywith();
            } else if (this.selectdate == 'week') {
                const now = new Date(this.getTodaywith());
                const target = now - 1000 * 60 * 60 * 24 * 7;
                this.startdate = this.getdate(target);
                this.enddate = this.getTodaywith();
            } else if (this.selectdate == 'month') {
                const now = new Date(this.getTodaywith());
                const target = now - 1000 * 60 * 60 * 24 * 30;
                this.startdate = this.getdate(target);
                this.enddate = this.getTodaywith();
            }
        },

        getTodaywith() {
            var date = new Date();
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + "-" + month + "-" + day;
        },

        gettimestamp(date) {
            // 날짜 문자열(YYYY-MM-DD)을 타임스탬프로 변환
            // 시간대 문제 해결: 한국 시간 기준으로 해당 날짜의 00:00:00 시간으로 설정
            console.log('gettimestamp input date:', date);

            // 입력 날짜를 파싱하여 한국시간으로 자정(00:00:00)으로 설정
            const parts = date.split('-');
            const year = parseInt(parts[0]);
            const month = parseInt(parts[1]) - 1; // 월은 0-11로 표현
            const day = parseInt(parts[2]);

            // 한국 시간대(GMT+9)로 자정(00:00:00) 설정
            const koreaDate = new Date(year, month, day, 0, 0, 0);
            const timestamp = koreaDate.getTime();

            console.log('gettimestamp result:', timestamp, '=', new Date(timestamp).toLocaleString());
            return timestamp;
        },

        // 상품 추가 관련 메서드
        async addProduct() {
            try {
                // 1. 현재 날짜가 오늘인지 확인
                const today = this.getTodaywith();
                const isAlreadySearchedToday = this.startdate === today && this.enddate === today;

                // 오늘 날짜로 검색되어 있지 않은 경우에만 검색 실행
                if (!isAlreadySearchedToday) {
                    console.log('오늘 날짜로 검색 실행');
                    this.startdate = today;
                    this.enddate = today;
                    await this.search();
                } else {
                    console.log('이미 오늘 날짜로 검색되어 있음, 추가 검색 스킵');
                }

                // 2. 오늘 등록된 상품 수 확인 (분리된 상품 제외)
                // 분리된 상품은 등록번호 뒤에 _1, _2 등이 붙으므로 이를 제외
                const originalProducts = this.products.filter(product => {
                    return !product.registrationId.includes('_');
                });
                const todayProductCount = originalProducts.length;
                console.log(`오늘 등록된 상품 수 (분리된 상품 제외): ${todayProductCount}`);

                // 3. 슬롯 제한과 비교
                // 값이 없으면 0 칸(등록 불가) — 서버·도구(tool-exec/lib.js rocketRegSlotLimit)와 같은 기준.
                // 기본값을 두면 한도를 받지 않은 계정이 한도가 있는 것처럼 열린다.
                const slotValue = this.$store.state.user.rocketRegSlot;
                const maxSlot = Number(slotValue) || 0;   // 없음·null·빈값·숫자 아님 → 0
                console.log(`최대 슬롯 수: ${maxSlot}`);

                if (!Number.isFinite(maxSlot) || maxSlot <= 0) {
                    this.$bvToast.toast('오늘 추가 가능한 상품 한도가 없습니다. 이용 중인 요금제나 한도를 확인해주세요.', {
                        title: '상품 추가 불가',
                        variant: 'warning',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                    return; // 함수 종료
                }

                if (todayProductCount >= maxSlot) {
                    // 한도 초과 알림
                    this.$bvToast.toast(`오늘 추가 가능한 상품 수(${maxSlot}개)를 초과했습니다. 내일 다시 시도해주세요.`, {
                        title: '한도 초과',
                        variant: 'warning',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                    return; // 함수 종료
                }

                // 4. 기본정보 세팅 확인
                if (!this.defaultSettings.brand || !this.defaultSettings.manufacturer || !this.defaultSettings.asInfo) {
                    this.$bvToast.toast('기본 등록 정보를 먼저 설정해주세요.', {
                        title: '알림',
                        variant: 'warning',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                    this.showSettings = true; // 기본세팅 패널 자동 열기
                    return;
                }

                // 5. 대기열 모달 열기 — 열기 전에 CLI 대기열과 맞춘다.
                //    안 맞추면 CLI 에서 이미 뺀 항목이 목록에 남아 "전체 시작" 이 그걸 또 돌린다.
                await this.loadCliRegistrationQueue();
                this.$bvModal.show('productQueueModal');
            } catch (error) {
                console.error('상품 추가 전 검증 중 오류:', error);
                this.$bvToast.toast(`상품 추가 전 검증 중 오류가 발생했습니다: ${error.message}`, {
                    title: '오류',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
            }
        },

        // 상품 바로추가 (SEO+가격설정 건너뜀, 이후 작업개시로 일괄 처리)
        addProductQuick() {
            this.skipInitialProcessing = true;
            this.addProduct();
        },

        // CLI 파이프라인에서 추가된 상품 대기열 로드 (CLI 파일이 정본)
        //
        // 넣기만 하고 뺀 적이 없어서 유령이 생겼다. CLI 쪽에서 rocket.sourcing.removeQueueItems 로
        // 항목을 빼도 화면이 들고 있는 사본에는 그대로 남아, 대기열을 시작할 때마다 이미 뺀
        // 항목이 다시 돌고 같은 이유로 또 실패했다(화면을 새로고침해야만 사라졌다).
        // ⇒ **CLI 에서 온 행(_fromCli)의 정본은 CLI 파일이다.** 파일에서 빠졌으면 화면에서도 뺀다.
        // 화면에서 직접 추가한 행(_fromCli 없음)은 파일에 없는 것이 정상이므로 건드리지 않는다.
        async loadCliRegistrationQueue() {
            try {
                // 처리 중에는 손대지 않는다. 지금 돌고 있는 행이 발밑에서 사라진다.
                if (this.queueProcessing) return;
                if (!CLI_DAEMON_ENABLED) return;   // 데몬 없는 빌드 — CLI 대기열이 없다

                const company = this.cliQueueCompany();
                const res = await axios.post(cliDaemonUrl('/api/cli/registration/consume'), { companyid: company });
                const items = res.data?.items || [];
                // 어느 회사 대기열에서 읽었는지 항목마다 기억한다 — 읽은 뒤 쿠플러스 계정을 바꿔도 삭제·실패 기록은 그 회사 파일로 간다
                if (!this._cliQueueCompanyById) this._cliQueueCompanyById = {};
                items.forEach(item => { if (item && item._queueId) this._cliQueueCompanyById[item._queueId] = company; });

                // 파일에서 빠진 CLI 항목을 화면에서도 뺀다. 파일이 비어도(clearQueue) 여기까지 와야 한다.
                const fileIds = new Set(items.map(item => item && item._queueId).filter(Boolean));
                const stale = this.productQueue.filter(q => q._fromCli && !fileIds.has(q._queueId));
                if (stale.length) {
                    console.log(`[AIRocketReg] CLI 대기열에서 빠진 ${stale.length}건을 화면에서도 제거`);
                    const staleIds = new Set(stale.map(q => q._queueId));
                    this.productQueue = this.productQueue.filter(q => !staleIds.has(q._queueId));
                    this.queueSelectedItems = this.queueSelectedItems.filter(q => !staleIds.has(q._queueId));
                }

                // 이미 로드된 항목은 중복 추가 방지 (_queueId 기준)
                const existingIds = new Set(this.productQueue.map(q => q._queueId));
                const newItems = items.filter(item => !existingIds.has(item._queueId));
                if (newItems.length === 0) return;

                console.log(`[AIRocketReg] CLI 대기열에서 ${newItems.length}건 로드`);

                newItems.forEach(item => {
                    this.productQueue.push({
                        _queueId: item._queueId || Date.now() + '_' + Math.random().toString(36).substr(2, 5),
                        // CLI 파일에서 온 행이라는 표식. 파일에서 빠지면 이 행도 같이 빠진다.
                        _fromCli: true,
                        categoryCode: item.categoryCode || '',
                        categoryPath: item.categoryPath || '',
                        categoryPathString: item.categoryPathString || item.categoryPath || '',
                        link: item.link || (item.offerId ? `https://detail.1688.com/offer/${item.offerId}.html` : ''),
                        productFeature: item.productFeature || '',
                        keyword: item.keyword || '',
                        stepLevel: this.normalizeQueueStepLevel(item.stepLevel),
                        // 소싱에서 정한 묶음 수량. 없으면 null — 지금처럼 사용자 설정을 따른다.
                        bundleQuantity: this.normalizeQueueBundleQuantity(item.bundleQuantity),
                        // 소싱에서 정한 목표 판매가(원). 없으면 null — 지금처럼 마진율로 계산한다.
                        targetSellingPrice: this.normalizeQueueSellingPrice(item.targetSellingPrice),
                        // 소싱에서 계산한 매입원가(원, CLI rocket.sourcing.calculateMargin). 없으면 null — CNY × 환율로 본다.
                        purchaseCost: this.normalizeQueuePurchaseCost(item.purchaseCost),
                        // 소싱에서 확정한 공급가(원). 있으면 등록 단계는 재계산하지 않고 그대로 쓴다.
                        supplyPrice: this.normalizeQueuePurchaseCost(item.supplyPrice),
                        // 소싱에서 남기기로 한 옵션(1688 skuId). 없으면 null — 지금처럼 옵션을 전부 만든다.
                        keepSkuIds: this.normalizeQueueKeepSkuIds(item.keepSkuIds),
                        // 소싱에서 뺀 옵션([{skuId, reason}]). 있으면 그 옵션은 상품에 만들지 않는다(판 #443 ①). 사유는 대기열 파일에 그대로 남는다.
                        excludedSkus: Array.isArray(item.excludedSkus) ? item.excludedSkus : null,
                        // 소싱(04)에서 고른 쿠팡 벤치 옵션ID. 없으면 null — 상품에 싣지 않는다(탈환 09 기록용).
                        benchmarkVendorItemId: /^\d{5,20}$/.test(String(item.benchmarkVendorItemId || '')) ? String(item.benchmarkVendorItemId) : null,
                        // 지난 회차의 실패는 파일에 남아 있다. 여기서 안 들고 오면 화면을 새로 열 때마다
                        // 실패 이력이 초기화돼서, 몇 번을 실패했는지 아무도 모른 채 계속 다시 시도한다.
                        // 옛 항목에는 이 필드들이 없다 — 그때는 실패한 적 없는 것으로 본다.
                        failCount: Number(item.failCount) || 0,
                        lastError: item.lastError || '',
                        lastFailedAt: item.lastFailedAt || ''
                    });
                });

                // 어디까지 진행할지는 **항목마다** 그 행에 실려 있고(queueItemStepLevel) 실행도
                // 항목마다 갈린다. 예전에는 여기서 가장 낮은 단계 하나로 화면 전역 queueStepLevel 을
                // 덮어써서, 2단계로 넣은 항목과 4단계로 넣은 항목이 똑같이 2단계로 돌았다 —
                // 도구가 항목마다 받아 저장한 값이 실제로는 버려지고 있었다.
                const levels = newItems.map(item => this.normalizeQueueStepLevel(item.stepLevel)).filter(level => level !== null);
                if (levels.length && levels.some(l => l !== levels[0])) {
                    console.log('[AIRocketReg] 대기열 항목마다 진행 단계가 다릅니다. 항목별로 그 단계까지만 진행합니다:', levels);
                }

                this.$bvToast.toast(`CLI에서 추가된 상품 ${newItems.length}건이 대기열에 로드되었습니다.`, {
                    title: '파이프라인 상품 로드',
                    variant: 'info',
                    solid: true,
                    autoHideDelay: 5000,
                    toaster: 'b-toaster-bottom-right'
                });
            } catch (e) {
                if (e.code !== 'ECONNREFUSED') {
                    console.error('[AIRocketReg] CLI 대기열 로드 실패:', e.message);
                }
            }
        },

        // 대기열 항목이 가져온 진행 단계 값 검사 (1=상품추가 2=SEO+가격 3=작업개시 4=등록전송)
        // 알 수 없는 값이면 null 을 돌려 기존 기본 동작을 그대로 쓴다.
        normalizeQueueStepLevel(value) {
            if (value === undefined || value === null || value === '') return null;
            const level = Number(value);
            if (!Number.isInteger(level) || level < 1 || level > 4) {
                console.error('[AIRocketReg] 알 수 없는 진행 단계 값이라 무시합니다:', value);
                return null;
            }
            return level;
        },

        // 대기열 항목이 가져온 소싱 묶음 수량 검사 (정수 1~QUEUE_BUNDLE_QUANTITY_MAX). 알 수 없는 값이면 null — 묶음을 싣지 않는다.
        normalizeQueueBundleQuantity(value) {
            if (value === undefined || value === null || value === '') return null;
            const quantity = Number(value);
            if (!Number.isInteger(quantity) || quantity < 1 || quantity > QUEUE_BUNDLE_QUANTITY_MAX) {
                console.error('[AIRocketReg] 알 수 없는 묶음 수량이라 무시합니다:', value);
                return null;
            }
            return quantity;
        },

        // 대기열 항목이 가져온 소싱 목표 판매가 검사 (정수 5,200~10,000,000원). 알 수 없는 값이면 null — 판매가를 고정하지 않는다.
        normalizeQueueSellingPrice(value) {
            if (value === undefined || value === null || value === '') return null;
            const price = Number(value);
            if (!Number.isInteger(price) || price < 5200 || price > 10000000) {
                console.error('[AIRocketReg] 알 수 없는 목표 판매가라 무시합니다:', value);
                return null;
            }
            return price;
        },

        // 대기열 항목이 가져온 소싱 매입원가·공급가 검사 (정수 1~10,000,000원). 알 수 없는 값이면 null.
        normalizeQueuePurchaseCost(value) {
            if (value === undefined || value === null || value === '') return null;
            const cost = Number(value);
            if (!Number.isInteger(cost) || cost < 1 || cost > 10000000) {
                console.error('[AIRocketReg] 알 수 없는 매입원가라 무시합니다:', value);
                return null;
            }
            return cost;
        },

        // 대기열 항목이 가져온 남길 옵션 목록 검사 (1688 skuId 숫자 문자열, 1~50개). 알 수 없으면 null — 옵션을 거르지 않는다.
        normalizeQueueKeepSkuIds(value) {
            if (value === undefined || value === null) return null;
            const ids = Array.isArray(value) ? value.map(v => String(v).trim()) : [];
            if (!ids.length || ids.length > 50 || ids.some(id => !/^\d+$/.test(id))) {
                console.error('[AIRocketReg] 알 수 없는 남길 옵션 목록이라 무시합니다:', value);
                return null;
            }
            return ids;
        },

        // 대기열 항목이 가져온 뺀 옵션([{skuId, reason}]) → skuId 목록. 없으면 null. 알 수 없는 꼴이면 상품을 만들지 않는다 —
        // 무시하면 뺀 옵션이 그 상품에 그대로 만들어진다(판 #443 ①).
        normalizeQueueExcludedSkuIds(value) {
            if (value === undefined || value === null) return null;
            const ids = Array.isArray(value) ? value.map(e => String(e && e.skuId != null ? e.skuId : '').trim()) : [];
            if (!ids.length || ids.some(id => !/^\d+$/.test(id))) {
                throw new Error(`뺀 옵션 목록(excludedSkus)을 읽지 못해 상품을 만들지 않았습니다: ${JSON.stringify(value).slice(0, 120)}`);
            }
            return ids;
        },

        // 이 항목이 어디까지 갈지. 항목이 단계를 안 가져왔으면(null) 화면에서 고른 기본값을 따른다.
        queueItemStepLevel(item) {
            const level = this.normalizeQueueStepLevel(item && item.stepLevel);
            const own = level === null ? this.queueStepLevel : level;
            // 에이전트가 시킨 회차는 상한(maxStepLevel)까지만 — 등록 전송은 전용 도구로만 나간다. 사람이 누른 회차엔 상한이 없다.
            return this._cliMaxStepLevel ? Math.min(own, this._cliMaxStepLevel) : own;
        },

        // ───────────────────────────────────────────────────────────────
        // 로컬 에이전트 실행 채널 (정본 docs/mcp-rocket-plan.md §5)
        //
        // 화면 안에만 있는 것(쿠팡 세션·확장 브리지·워크플로우 서비스)은 데몬이 흉내낼 수
        // 없다. 그래서 에이전트가 시킨 일을 **열려 있는 이 화면**이 대신 실행하고 결과를
        // 돌려준다. 데몬이 안 떠 있는 사용자(대부분)에게는 아무 일도 일어나지 않아야 한다.
        // ───────────────────────────────────────────────────────────────

        // SSE 구독을 연다. 끊기면 백오프를 두고 다시 붙는다.
        cliPageConnect() {
            if (this.cliPage.stopped) return;
            if (!CLI_DAEMON_ENABLED) return;   // 데몬 없는 빌드 — cliDaemon.js 가 한 번 알린다
            if (typeof window === 'undefined' || typeof window.EventSource !== 'function') return;
            if (this.cliPage.source) return;

            let source;
            try {
                // 로그인한 회사를 같이 알린다 — 에이전트가 다른 계정 화면에 명령을 보내지 않게(없으면 데몬은 「모름」으로 본다)
                const companyid = (this.$store.state.user && this.$store.state.user.companyid) || '';
                const companyQuery = companyid ? `&companyid=${encodeURIComponent(companyid)}` : '';
                // awaitReady=1 — 이 화면은 첫 목록 로드 뒤 준비됨(ready)을 따로 알린다. 데몬은 그 전에는 화면을 열어 기다리는 작업을 내려보내지 않는다
                // 실행 중인 작업이 있으면 재연결 증명과 그 작업 id 를 같이 보낸다 — 데몬이 이 탭의 진행 보고를 계속 받게
                const held = [...this.cliPage.beatTimers.keys()];
                const resume = this.cliPage.resume;
                const resumeQuery = resume && held.length
                    ? `&resumeSub=${encodeURIComponent(resume.subId)}&resumeKey=${encodeURIComponent(resume.key)}&heldJobs=${encodeURIComponent(held.join(','))}`
                    : '';
                source = new EventSource(`${CLI_PAGE_BASE}/subscribe?screen=${CLI_PAGE_SCREEN}${companyQuery}&awaitReady=1${resumeQuery}`);
            } catch (e) {
                console.error('[AIRocketReg] 로컬 에이전트 연결 시도 실패:', e.message);
                this.cliPageScheduleReconnect();
                return;
            }
            this.cliPage.source = source;

            source.addEventListener('hello', (evt) => {
                const data = this.cliPageParse(evt);
                if (!data) return;
                this.cliPage.subId = data.subId;
                this.cliPage.resume = data.resumeKey ? { subId: data.subId, key: data.resumeKey } : null;
                this.cliPage.connected = true;
                // 방금 붙은 연결이 가장 최근이라 이 화면이 다시 명령을 받는다.
                this.cliPage.superseded = false;
                this.cliPage.retryDelay = CLI_PAGE_RETRY_MIN_MS;
                this.cliPage.loggedOffline = false;
                console.log(`[AIRocketReg] 로컬 에이전트 연결됨 (#${data.subId})`);

                // 구독이 있어야 도구 선언이 받아들여진다. 반드시 hello 이후에 보낸다.
                this.cliPageDeclareTools();

                // 끊긴 사이 시작도 못 한 것들. 곧바로 job 이벤트로도 다시 오므로 seenJobs 로 중복을 막는다.
                (data.pendingJobs || []).forEach(job => this.cliPageHandleJob(job));

                // 내가 시작했다고 보고한 뒤 새로고침으로 잃은 것들.
                // **자동 재실행하지 않는다** — 등록전송이 두 번 나갈 수 있다. 알리기만 한다.
                this.cliPageNotifyOrphaned(data.orphanedJobs || []);
            });

            source.addEventListener('job', (evt) => {
                const job = this.cliPageParse(evt);
                if (job) this.cliPageHandleJob(job);
            });

            source.addEventListener('superseded', (evt) => {
                const data = this.cliPageParse(evt);
                console.log('[AIRocketReg] 다른 탭에서 로켓등록 화면이 열렸습니다. 이 탭은 더 이상 명령을 받지 않습니다.', data && data.reason);
                // 명령권을 넘겼으면 진행 보고도 넘긴다. 안 그러면 이 탭이 20초마다 계속
                // "아직 하고 있다"고 말해서 저쪽 시계가 영영 다시 걸린다.
                this.cliPage.superseded = true;
                // 이 탭의 대기열은 다음 상품 사이(안전한 자리)에서 멈춘다 — 그대로 두면 새 탭이 같은 대기열을 또 돌려
                // 같은 상품이 두 번 만들어진다(PR261016-98F029). 저장 중인 건은 끝까지 마친다.
                // 에이전트가 시킨 회차만 멈춘다 — 사람이 누른 회차는 끝까지 돌고, 새 탭은 탭 사이 표식을 보고 시작하지 않는다.
                if (this.queueProcessing && this._queueStartedByAgent) this.stopQueueForTakeover();
                this.cliPageStandDown('로켓등록 화면이 다른 탭에서 새로 열려 이 탭에서는 진행 상태를 더 지켜볼 수 없습니다. 새로 연 화면에서 결과를 확인해주세요.');
            });

            source.addEventListener('promoted', () => {
                console.log('[AIRocketReg] 이 탭이 명령을 받는 화면이 되었습니다.');
                this.cliPage.superseded = false;
            });

            source.onerror = () => {
                // 데몬이 없거나 끊긴 상태. 화면에는 아무것도 띄우지 않는다.
                if (this.cliPage.connected) {
                    console.log('[AIRocketReg] 로컬 에이전트 연결이 끊겼습니다. 다시 연결을 시도합니다.');
                } else if (!this.cliPage.loggedOffline) {
                    this.cliPage.loggedOffline = true;
                    console.log('[AIRocketReg] 로컬 에이전트가 실행 중이 아닙니다. 백그라운드에서 연결을 계속 시도합니다.');
                }
                this.cliPageCloseSource();
                this.cliPageScheduleReconnect();
            };
        },

        cliPageParse(evt) {
            try {
                return JSON.parse(evt.data);
            } catch (e) {
                console.error('[AIRocketReg] 로컬 에이전트 메시지 해석 실패:', e.message, evt && evt.data);
                return null;
            }
        },

        cliPageCloseSource() {
            this.cliPage.connected = false;
            this.cliPage.subId = null;
            if (this.cliPage.source) {
                try { this.cliPage.source.close(); } catch (e) { console.error('[AIRocketReg] 연결 정리 실패:', e.message); }
                this.cliPage.source = null;
            }
        },

        cliPageScheduleReconnect() {
            if (this.cliPage.stopped || this.cliPage.retryTimer) return;
            const delay = this.cliPage.retryDelay;
            this.cliPage.retryTimer = setTimeout(() => {
                this.cliPage.retryTimer = null;
                this.cliPageConnect();
            }, delay);
            this.cliPage.retryDelay = Math.min(delay * 2, CLI_PAGE_RETRY_MAX_MS);
        },

        cliPageDisconnect() {
            this.cliPage.stopped = true;
            if (this.cliPage.retryTimer) {
                clearTimeout(this.cliPage.retryTimer);
                this.cliPage.retryTimer = null;
            }
            this.cliPageStandDown('화면을 떠나서 진행 상태를 더 지켜볼 수 없습니다. 화면을 다시 열고 결과를 확인해주세요.');
            this.cliPageCloseSource();
        },

        // 이 화면이 더 이상 작업의 주인이 아닐 때 손을 뗀다 — 화면을 떠났거나(beforeDestroy),
        // 다른 탭이 같은 화면을 열어 명령권을 가져갔거나(superseded).
        //
        // 여기서 **살아 있다는 신호를 전부 끊는 것**이 핵심이다. 심장박동도 완료 대기도
        // 저쪽 타임아웃 시계를 다시 거는데, 주인이 아닌 화면이 그걸 계속 보내면
        // 그 작업은 영원히 끝나지 않는다(정본 §5 "영원히 남는 job 은 없다" 위반).
        // 탭을 두 개 열어두면 실제로 이렇게 된다.
        cliPageStandDown(reason) {
            this.cliPage.beatTimers.forEach(timer => clearInterval(timer));
            this.cliPage.beatTimers.clear();
            this.cliPage.lastProgressAt.clear();
            this.cliPage.stallMs.clear();
            this.cliPage.waitTimers.forEach((reject, timer) => {
                clearInterval(timer);
                try {
                    reject(new Error(reason));
                } catch (e) {
                    console.error('[AIRocketReg] 대기 정리 실패:', e.message);
                }
            });
            this.cliPage.waitTimers.clear();
        },

        // 대기 인터벌을 화면 수명에 묶는다. 화면이 닫히거나 명령권을 넘기면 같이 멈춘다.
        // 알림창(alert) 대신 쓰는 비차단 안내 — alert 는 사람이 누를 때까지 화면 JS 전체를 세워서
        // 에이전트가 시킨 작업(데몬 명령)과 살아있음 신호까지 멈춘다
        showNonBlockingNotice(message, title = '알림') {
            console.error('[AIRocketReg] 안내:', message);
            this.$bvToast.toast(String(message || ''), { title, variant: 'danger', solid: true, autoHideDelay: 15000, toaster: 'b-toaster-top-right' });
        },

        // 목록은 목록용(_light) 문서만 받는다 — 무거운 칸(coupangDoc 등)을 쓰기 전에 완전 문서로 받아
        // store 에서 다시 찾은 것을 돌려준다(들고 있던 참조는 버린다). 실패하면 안내하고 null(그 작업은 멈춘다).
        // throwOnError: CLI 경로처럼 실패를 호출자에게 그대로 올릴 때
        async ensureFullProducts(list, { throwOnError = false } = {}) {
            const arr = (Array.isArray(list) ? list : [list]).filter(Boolean);
            let result;
            try {
                // 돌려받은 완전 문서를 쓴다(store 에 없는 상품도 돌려받는다)
                const fulls = await this.$store.dispatch('ensureFullRocketProducts', arr.map(p => p._id).filter(Boolean));
                const byId = new Map((fulls || []).map(x => [String(x._id), x]));
                result = arr.map(p => (p._id && byId.get(String(p._id))) || p);
                // 그래도 목록용이면 반쪽 문서로 계속하지 않는다
                if (result.some(isLightDoc)) throw new Error(LIGHT_SAVE_ERROR);
            } catch (e) {
                if (throwOnError) throw e;
                this.showNonBlockingNotice(`상품 정보를 불러오지 못해 작업을 멈췄습니다: ${e.message}`, '오류');
                return null;
            }
            return result;
        },

        cliPageTrackWait(timer, reject) {
            this.cliPage.waitTimers.set(timer, reject);
        },

        cliPageClearWait(timer) {
            clearInterval(timer);
            this.cliPage.waitTimers.delete(timer);
        },

        async cliPageDeclareTools() {
            try {
                await axios.post(`${CLI_PAGE_BASE}/tools`, { screen: CLI_PAGE_SCREEN, tools: CLI_PAGE_TOOLS, ready: this.cliPage.listReady });
                console.log(`[AIRocketReg] 실행 가능한 작업 선언: ${CLI_PAGE_TOOLS.join(', ')} (목록 ${this.cliPage.listReady ? '준비됨' : '불러오는 중'})`);
            } catch (e) {
                console.error('[AIRocketReg] 실행 가능한 작업 선언 실패:', e.message);
            }
        },

        // 진행·완료 보고. 보고가 올 때마다 저쪽 타임아웃 시계가 다시 걸린다.
        // ⇒ 이 화면이 주인이 아니게 된 뒤에는 "진행 중"을 보내지 않는다 — 화면을 떠났거나
        //    다른 탭에 명령권을 넘겼을 때. 주인이 아닌 화면이 살아 있다고 말하면 그 작업은
        //    영원히 끝나지 않는다(정본 §5 "영원히 남는 job 은 없다" 를 깨뜨린다).
        //    끝(done·error)은 보낸다 — 타임아웃을 기다리게 하는 것보다 이유를 바로 알려주는 게 낫다.
        // subId 를 같이 보내는 이유: 탭이 여러 개면 누가 보낸 보고인지 저쪽이 알아야
        // 지금 명령을 받는 화면의 보고만 살아 있다는 증거로 칠 수 있다.
        async cliPageReport(jobId, payload) {
            if ((this.cliPage.stopped || this.cliPage.superseded) && payload && payload.status === 'running') {
                console.error(`[AIRocketReg] 이 탭은 더 이상 작업의 주인이 아니라 진행 보고를 보내지 않습니다 (${jobId}).`);
                return false;
            }
            try {
                await axios.post(`${CLI_PAGE_BASE}/result`, Object.assign({ jobId, subId: this.cliPage.subId }, payload));
                if (payload && payload.status === 'running') this.cliPage.rejoinTried.delete(jobId);
                return true;
            } catch (e) {
                console.error(`[AIRocketReg] 작업 보고 실패 (${jobId}):`, e.message);
                if (payload && payload.status === 'running' && e.response && e.response.status === 409) {
                    this.cliPageReportRejected(jobId, (e.response.data && e.response.data.error) || e.message);
                }
                return false;
            }
        },

        // 하던 작업의 진행 보고를 데몬이 409 로 거절함 — 이대로 두면 심장박동이 전부 버려지고 10분 뒤 「화면 무응답」으로 끝난다
        // (2026-10-20 윈 «작업개시 중 화면 무응답»). 처음엔 증명을 들고 다시 붙어 되찾고, 그래도 거절이면 보고를 멈추고 알린다.
        cliPageReportRejected(jobId, reason) {
            if (!this.cliPage.beatTimers.has(jobId)) return;
            if (!this.cliPage.rejoinTried.has(jobId)) {
                this.cliPage.rejoinTried.add(jobId);
                console.error(`[AIRocketReg] 진행 보고가 거절돼 다시 연결해 작업을 되찾습니다 (${jobId}): ${reason}`);
                this.cliPageCloseSource();
                this.cliPageConnect();
                return;
            }
            console.error(`[AIRocketReg] 다시 연결해도 진행 보고가 거절돼 보고를 멈춥니다 (${jobId}): ${reason}`);
            this.cliPageStopHeartbeat(jobId);
            this.$bvToast.toast(`로컬 에이전트가 이 작업의 진행 보고를 더 받지 않습니다(${reason}). 화면의 작업은 계속되니, 끝난 뒤 결과를 확인해주세요.`, {
                title: '진행 보고 멈춤',
                variant: 'warning',
                solid: true,
                autoHideDelay: 10000,
                toaster: 'b-toaster-bottom-right'
            });
        },

        cliPageStartHeartbeat(jobId) {
            if (this.cliPage.beatTimers.has(jobId)) return;
            const timer = setInterval(() => {
                // 진척 없이 30분이면 살려 두지 않는다 — 박동이 데몬 10분 시계를 계속 늘려 job 이 영원히 running 이던 길(10-20 윈 outbox 3255)
                if (!shouldBeat(this.cliPage.lastProgressAt.get(jobId), Date.now(), stallLimitMs(this.cliPage.stallMs.get(jobId)))) {
                    console.error(`[AIRocketReg] 진척 없이 한도가 지나 진행 보고를 멈춥니다 (${jobId}) — 로컬 에이전트가 이 작업을 무응답으로 끝냅니다.`);
                    this.cliPageStopHeartbeat(jobId);
                    return;
                }
                this.cliPageReport(jobId, { status: 'running' });
            }, CLI_PAGE_HEARTBEAT_MS);
            this.cliPage.beatTimers.set(jobId, timer);
        },

        cliPageStopHeartbeat(jobId) {
            const timer = this.cliPage.beatTimers.get(jobId);
            if (timer) {
                clearInterval(timer);
                this.cliPage.beatTimers.delete(jobId);
            }
            this.cliPage.lastProgressAt.delete(jobId);
            this.cliPage.stallMs.delete(jobId);
        },

        cliPageNotifyOrphaned(jobs) {
            if (!jobs.length) return;
            console.log(`[AIRocketReg] 새로고침으로 중단된 작업 ${jobs.length}건:`, jobs.map(j => j.tool).join(', '));
            this.$bvToast.toast(`화면을 새로 여는 사이에 중단된 자동 작업이 ${jobs.length}건 있습니다. 결과를 확인한 뒤 필요하면 다시 요청해주세요.`, {
                title: '중단된 작업',
                variant: 'warning',
                solid: true,
                autoHideDelay: 8000,
                toaster: 'b-toaster-bottom-right'
            });
        },

        async cliPageHandleJob(job) {
            if (!job || !job.jobId || !job.tool) return;
            if (this.cliPage.seenJobs.has(job.jobId)) return;
            this.cliPage.seenJobs.add(job.jobId);

            console.log(`[AIRocketReg] 자동 작업 수신: ${job.tool}`, job.params);
            const onProgress = ({ stallMs, ...progress }) => {
                this.cliPage.lastProgressAt.set(job.jobId, Date.now());
                this.cliPage.stallMs.set(job.jobId, stallMs);
                return this.cliPageReport(job.jobId, { status: 'running', progress });
            };

            // 실행 전 「내 것 맞나」 확인 — 시작 보고가 거절됐거나(다른 탭으로 넘어감·이미 없어짐)
            // 그 사이 명령권을 잃었으면 실행하지 않는다. 등록전송이 두 탭에서 두 번 나가는 길을 막는다.
            const started = await this.cliPageReport(job.jobId, { status: 'running', progress: { message: '작업을 시작합니다.' } });
            if (!started || this.cliPage.superseded || this.cliPage.stopped) {
                console.error(`[AIRocketReg] 이 탭의 작업이 아니라 실행하지 않습니다 (${job.tool} ${job.jobId}).`);
                return;
            }
            this.cliPage.lastProgressAt.set(job.jobId, Date.now());
            this.cliPageStartHeartbeat(job.jobId);
            try {
                const result = await this.cliPageRunTool(job, onProgress);
                // 항목 실패가 하나라도 있으면 「끝남(done)」이 아니다 — 결과를 그대로 싣고 partial 로 끝낸다.
                // 단계 번호만 보고 done 을 보내면 부르는 쪽이 실패를 못 보고 다음 단계로 간다(2026-10-15 묶음⑥).
                const partial = this.cliPagePartialSummary(job.tool, result);
                if (partial) {
                    await this.cliPageReport(job.jobId, { status: 'error', errorCode: 'partial', error: partial, result });
                } else {
                    await this.cliPageReport(job.jobId, { status: 'done', result: result === undefined ? null : result });
                }
            } catch (e) {
                console.error(`[AIRocketReg] 자동 작업 실패 (${job.tool}):`, e);
                await this.cliPageReport(job.jobId, Object.assign(
                    { status: 'error', error: e.message || '화면에서 작업을 끝내지 못했습니다.' },
                    e.cliErrorCode ? { errorCode: e.cliErrorCode } : {},
                    e.cliResult ? { result: e.cliResult } : {}
                ));
            } finally {
                this.cliPageStopHeartbeat(job.jobId);
                this.cliPage.rejoinTried.delete(job.jobId);
            }
        },

        // 작업개시가 든 긴 작업의 결과에 항목 실패가 있으면 사람 말 한 줄, 없으면 null
        cliPagePartialSummary(tool, result) {
            if (!result || typeof result !== 'object') return null;
            const name = String(tool || '').replace(/^rocket\.(sourcing\.)?/, '');
            if (name !== 'startQueue' && name !== 'runWork') return null;
            const failed = Array.isArray(result.failed) ? result.failed.length : 0;
            const workFailed = Array.isArray(result.workFailed) ? result.workFailed.length : 0;
            if (!failed && !workFailed) return null;
            if (name === 'runWork') {
                return `${result.total}건 중 ${result.succeeded}건만 끝났고 ${failed}건이 실패했습니다 — result.failed 의 등록ID·이유를 보고 그 건만 다시 돌리세요.`;
            }
            return result.message || `대기열 ${result.total}건 중 ${failed + workFailed}건이 끝나지 못했습니다 — result.failed·workFailed 를 보세요.`;
        },

        cliPageRunTool(job, onProgress) {
            const params = job.params || {};
            switch (job.tool) {
                case 'rocket.runWork':
                case 'rocket.sourcing.runWork': return this.cliPageRunWork(params, onProgress);
                case 'rocket.sourcing.setDetailImages': return this.cliPageSetDetailImages(params, onProgress);
                case 'rocket.setBundle':
                case 'rocket.sourcing.setBundle': return this.cliPageSetBundle(params);
                case 'rocket.setPrice':
                case 'rocket.sourcing.setPrice': return this.cliPageSetPrice(params);
                case 'rocket.submitRegistration':
                case 'rocket.sourcing.submitRegistration': return this.cliPageSubmitRegistration(params, onProgress);
                case 'rocket.startQueue':
                case 'rocket.sourcing.startQueue': return this.cliPageStartQueue(params, onProgress);
                case 'sourcing.categorySearch':
                case 'common.sourcing.categorySearch': return this.cliPageCategorySearch(params, onProgress);
                case 'sourcing.findCategory':
                case 'common.sourcing.findCategoryId': return this.cliPageFindCategory(params, onProgress);
                case 'rocket.checkSetup':
                case 'rocket.sourcing.checkSetup': return this.cliPageCheckSetup();
                default: return Promise.reject(new Error('이 화면이 처리할 수 없는 요청입니다. 화면을 새로고침한 뒤 다시 시도해주세요.'));
            }
        },

        // 대상 상품 고르기. registrationIds 를 주면 그것만, 안 주면 fallback 이 정한다.
        async cliPageTargetProducts(params, fallback) {
            // 등록ID를 줬든 안 줬든 먼저 쿠플러스 로그인부터 본다 — 화면 목록만 쓰는 길은 서버에 묻지 않아
            // 로그인이 풀린 채로 옛 목록을 돌리다 엉뚱한 곳에서 실패했다(PR261016-A3C581)
            await this.cliPageAssertSession();
            const ids = Array.isArray(params.registrationIds) ? params.registrationIds.map(id => String(id)) : null;
            if (ids && ids.length) {
                // 화면 목록은 조회 기간(기본 «오늘»)만 담는다 — 어제 만든 상품을 지정하면 늘 「목록에 없다」로 실패했다.
                // 에이전트는 기간을 바꿀 수 없으니, 목록에 없는 등록ID는 서버에서 직접 찾아 목록에 넣는다.
                await this.cliPageLoadMissingProducts(ids);
                const all = this.products || [];
                const missing = ids.filter(id => !all.some(p => String(p.registrationId) === id));
                if (missing.length) {
                    throw new Error(`이 계정에 없는 등록ID입니다: ${missing.join(', ')}. rocket.sourcing.listRegistrations 로 등록ID를 확인한 뒤 다시 부르세요.`);
                }
                // 작업·전송은 무거운 칸을 쓴다 — 완전 문서로 받고 store 것을 돌려준다(실패하면 그대로 올린다)
                return this.ensureFullProducts(all.filter(p => ids.includes(String(p.registrationId))), { throwOnError: true });
            }
            const all = this.products || [];
            if (typeof fallback !== 'function') {
                throw new Error('작업할 상품을 지정해주세요.');
            }
            return this.ensureFullProducts(fallback(all), { throwOnError: true });
        },

        // 쿠플러스 로그인 확인 — 목록 조회 API 를 결과 0건 조건(기간 0~0 · 한 칸)으로 가볍게 부른다
        async cliPageAssertSession() {
            const res = await axios.post('/api/aiRocketReg/getlist', { start: 0, end: 0, limit: 1, fields: ['registrationId'] });
            const data = res.data || {};
            if (data.code === 'session-expired') throw this.cliPageSessionExpiredError(data);
        },

        // 다시 불러도 같은 결과다 — 사람이 다시 로그인해야 풀린다. cliErrorCode 는 작업 결과 errorCode 로 실린다
        cliPageSessionExpiredError(data) {
            const expired = new Error((data.error || '쿠플러스 로그인이 풀렸습니다.') + ' 같은 요청을 다시 부르지 말고, 사용자에게 쿠플러스 재로그인을 요청하세요.');
            expired.cliErrorCode = 'session-expired';
            return expired;
        },

        // 화면 목록에 없는 등록ID를 기간 없이 서버에서 찾아 목록에 더한다(목록 조회와 같은 API · 등록ID 조건).
        async cliPageLoadMissingProducts(ids) {
            const have = new Set((this.products || []).map(p => String(p.registrationId)));
            const missing = ids.filter(id => !have.has(id));
            if (!missing.length) return;
            const res = await axios.post('/api/aiRocketReg/getlist', {
                start: 0, end: Date.now() + 24 * 60 * 60 * 1000, limit: 200,
                filter: { registrationId: { in: missing } }
            });
            const data = res.data || {};
            if (data.code === 'session-expired') throw this.cliPageSessionExpiredError(data);
            if (data['요청결과'] !== 'ok' || !Array.isArray(data.products)) {
                throw new Error(data.error || '화면 목록에 없는 상품을 서버에서 불러오지 못했습니다. 잠시 뒤 다시 시도해주세요.');
            }
            data.products.forEach(product => {
                // store searchRocketProducts 와 같은 가공 — 상세이미지 원본 칸
                product.originDetailImages = (product.detailImages || []).map(img => {
                    const url = typeof img === 'string' ? img : (img.img || img.url || '');
                    return { originalUrl: url, img: url };
                });
                this.$store.commit('ADD_ROCKET_PRODUCT', product);
            });
            console.log(`[AIRocketReg] 화면 목록에 없던 상품 ${data.products.length}/${missing.length}건을 불러왔습니다:`, missing.join(', '));
        },

        // 견적서가 멈춘 이유(processError) 한 줄 — runWork·startQueue 가 같은 꼴로 싣는다
        cliQuotationErrorText(product) {
            const pe = product && product.processError;
            return pe && typeof pe === 'object'
                ? [pe.message, (Array.isArray(pe.errors) ? pe.errors.slice(0, 5).join(' / ') : '')].filter(Boolean).join(' — ').slice(0, 600) || undefined
                : undefined;
        },

        // 작업개시 — 기존 workflowService.processProduct 를 그대로 부른다
        async cliPageRunWork(params, onProgress) {
            const tasks = Array.isArray(params.tasks) && params.tasks.length ? params.tasks : null;
            // 대상을 안 주면 **아직 쿠팡에 안 보낸 것**만 돈다. 옛 코드는 p.registrationStatus !== 'completed'
            // 였는데 최상위 registrationStatus 는 RocketReg 문서에 없는 필드라 늘 참 — 전체가 대상이 됐다.
            // 이미 보낸 상품을 다시 가공하면 쿠팡에 선 상품과 우리 기록이 어긋난다.
            const targets = await this.cliPageTargetProducts(params, all => all.filter(p => !this.isSentToCoupang(p)));
            if (!targets.length) {
                throw new Error('작업할 상품이 없습니다. 먼저 상품을 추가해주세요.');
            }

            // 화면 버튼과 달리 CLI 는 tasks 를 줘도 이미 완료된 작업은 뺀다 — 모르고 다시 돌리면 AI 가 또 불린다.
            // force 면 예전처럼 준 작업을 그대로 다시 돈다.
            const force = params.force === true && !!tasks;
            const ALL_TASKS = ['seo', 'pricing', 'mainImage', 'additionalImage', 'detailImage', 'koreanLabel', 'sizeChart', 'quotation'];

            // 견적서(quotation)가 상품을 분리하면 새 등록ID(_2, _3 …)가 생기는데 processProduct 는 그걸 돌려주지 않는다.
            // 분리 때 나가는 화면 이벤트에서 줍는다. 이벤트는 화면 전체에 나가 같은 탭 뒤에서 도는 startQueue 의 분리도 온다 —
            // 원본(splitProducts[0] · quotationService.finishSplit)이 지금 상품일 때만 줍는다(startQueue onSplit 과 같은 꼴).
            // (2026-10-21 윈 romirata PR261021-71A731: runWork(010001) 결과에 011001~ 가 섞였다)
            let current = null;
            const splitRegistrationIds = [];
            const onSplit = (e) => {
                const [orig, ...pieces] = (e && e.detail && e.detail.splitProducts) || [];
                if (!current || !orig || orig.registrationId !== current.registrationId) return;
                pieces.forEach(sp => {
                    const rid = sp && sp.registrationId;
                    if (rid && rid !== current.registrationId && !splitRegistrationIds.includes(rid)) {
                        splitRegistrationIds.push(rid);
                    }
                });
            };
            window.addEventListener('product-split-completed', onSplit);

            const failed = [];
            const skipped = [];
            const warnings = [];
            const seoWarnings = [];
            const detailClaimWarnings = [];
            let succeeded = 0;
            // 명령권을 잃은(다른 탭이 이어받음 · 화면 채널 꺼짐) 뒤 시작 못 한 상품 — 실패가 아니라 따로 싣는다
            let notStarted = [];
            try {
                for (let i = 0; i < targets.length; i++) {
                    // 명령권을 잃으면 데몬엔 보고가 안 가는데 고리는 말없이 저장을 계속했다 → 데몬은 timeout 으로 끝내고
                    // 에이전트가 다시 불러 두 번 돌았다(2026-10-21 윈 job_mvhokszc_2z). 상품 사이에서 멈춘다(startQueue stopQueueForTakeover 꼴)
                    if (this.cliPage.superseded || this.cliPage.stopped) {
                        notStarted = targets.slice(i).map(p => p.registrationId);
                        console.error(`[AIRocketReg] 명령권을 잃어 작업개시를 멈춥니다 — ${i}/${targets.length} 까지 함, 남은 ${notStarted.length}건은 시작 안 함`);
                        break;
                    }
                    const product = targets[i];
                    current = product;
                    const name = this.getDisplayProductName(product) || product.registrationId;
                    // stallMs = 이 상품 작업 한도 합 — 진척은 상품마다 한 번이라 큰 상품(대표이미지 옵션×2분)이 박동 멈춤으로 끊기지 않게
                    await onProgress({ current: i, total: targets.length, message: `${i + 1}/${targets.length} — ${name} 작업 중`,
                        stallMs: workflowService.productTimeoutMs(product, tasks || ALL_TASKS) });

                    const requested = tasks || ALL_TASKS;
                    const done = force ? [] : requested.filter(t => workflowService.isTaskCompleted(t, product));
                    const pending = requested.filter(t => !done.includes(t));
                    // 기본(전체) 모드에서 완료분을 빼는 건 원래 동작이라 굳이 적지 않는다 — 통째로 건너뛴 상품만 적는다.
                    if (done.length && (tasks || !pending.length)) {
                        skipped.push({ registrationId: product.registrationId, tasks: done });
                    }
                    if (!pending.length) continue;

                    // 옵션이 많은 상품은 한 건에 10분 가까이 걸린다. 「i/N — 작업 중」만 그대로면 부르는 쪽이
                    // 멈춘 줄 안다(BF36BD·AA4620·99DCAD) — 지금 도는 작업과 옵션 n/N 이 바뀔 때마다 문구에 붙인다.
                    // 진행이 없으면 문구가 그대로라 데몬의 멈춤 판정은 그대로 걸린다(formatWorkDetail 주석).
                    resetWorkProgress(product.registrationId);
                    const head = `${i + 1}/${targets.length} — ${name} 작업 중`;
                    let lastDetail = '';
                    const detailTimer = setInterval(() => {
                        const detail = formatWorkDetail(getWorkDetail(product.registrationId));
                        if (!detail || detail === lastDetail) return;
                        lastDetail = detail;
                        Promise.resolve(onProgress({ current: i, total: targets.length, message: `${head} · ${detail}` }))
                            .catch(e => console.error('[AIRocketReg] 작업 진행 보고 실패:', e));
                    }, RUN_WORK_DETAIL_TICK_MS);
                    try {
                        // 전체 모드는 null 그대로 넘긴다 — processProduct 가 고르는 방식을 바꾸지 않으려고.
                        await workflowService.processProduct(product, tasks ? pending : null);
                    } catch (e) {
                        console.error('[AIRocketReg] 상품 작업 실패:', product.registrationId, e);
                        failed.push({ registrationId: product.registrationId, reason: e.message || '알 수 없는 문제' });
                        continue;
                    } finally {
                        clearInterval(detailTimer);
                    }

                    // processProduct 는 작업 하나가 실패해도 상태만 'error' 로 찍고 true 를 돌려준다.
                    // 그래서 끝난 뒤 상태를 직접 읽어 실패 작업을 가려낸다.
                    const latest = this.$store.getters.getRocketProductById(product.registrationId) || product;
                    // '일부완료' — 끝나긴 했지만 빠진 것이 있다(예: 상세이미지 일부 번역 실패). 성공으로 세지 않고 경고로 싣는다
                    // 끝나지 않은 작업(processing 등)도 실패로 싣는다 — 'error' 만 보면 견적서가 processing 에 남은 건이 성공으로 셌다(2B2E83)
                    const { failed: failedTasks, partial: partialTasks, unfinished } = workOutcome(latest, pending);
                    if (partialTasks.length) {
                        warnings.push({
                            registrationId: product.registrationId,
                            partialTasks: partialTasks,
                            reason: (partialTasks.includes('detailImage') && latest.detailImageWarning && latest.detailImageWarning.message)
                                || `일부만 완료된 작업: ${partialTasks.join(', ')}`,
                            detailImageFailures: partialTasks.includes('detailImage') && latest.detailImageWarning
                                ? latest.detailImageWarning.failures : undefined
                        });
                    }
                    if (failedTasks.length || unfinished.length) {
                        // 견적서는 멈춘 이유(processError)를 같이 싣는다 — 「작업 실패: quotation」만으로는 무엇을 고칠지 모른다
                        const quotationError = failedTasks.includes('quotation') ? this.cliQuotationErrorText(latest) : undefined;
                        failed.push({
                            registrationId: product.registrationId,
                            reason: [failedTasks.length ? `작업 실패: ${failedTasks.join(', ')}` : '', unfinished.length ? `끝나지 않은 작업: ${unfinished.join(', ')}` : ''].filter(Boolean).join(' · ')
                                + (quotationError ? ` — 견적서가 멈춘 이유: ${quotationError}` : '') + (detailImageErrorText(latest) ? ` — 상세이미지가 멈춘 이유: ${detailImageErrorText(latest)}` : '') + (seoErrorText(latest) ? ` — SEO 가 멈춘 이유: ${seoErrorText(latest)}` : '') + (koreanLabelErrorText(latest) ? ` — 한글표시가 멈춘 이유: ${koreanLabelErrorText(latest)}` : ''),
                            failedTasks: failedTasks,
                            unfinishedTasks: unfinished,
                            quotationError: quotationError
                        });
                    } else if (!partialTasks.length) {
                        succeeded++;
                    }
                    // 자동 상품명에서 어린이용 낱말을 뺐다 — 성공은 그대로, 알림만 싣는다
                    if (pending.includes('seo') && latest.seoWarning && latest.seoWarning.message) {
                        seoWarnings.push({ registrationId: product.registrationId, removedWords: latest.seoWarning.removedWords, reason: latest.seoWarning.message });
                    }
                    // 상세이미지 번역 문구를 원문·1688 속성에 맞춰 고쳤다(소재·인증·최상급) — 성공은 그대로, 확인할 곳만 싣는다
                    if (pending.includes('detailImage') && latest.detailClaimWarning && latest.detailClaimWarning.message) {
                        detailClaimWarnings.push({ registrationId: product.registrationId, reason: latest.detailClaimWarning.message, items: latest.detailClaimWarning.items });
                    }
                }
            } finally {
                window.removeEventListener('product-split-completed', onSplit);
            }
            if (!notStarted.length) await onProgress({ current: targets.length, total: targets.length, message: '작업을 마쳤습니다.' });

            const result = {
                tasks: tasks || '완료되지 않은 전체 작업',
                total: targets.length,
                succeeded: succeeded,
                failed: failed
            };
            if (skipped.length) result.skipped = skipped;
            if (warnings.length) result.warnings = warnings;   // 일부완료 — 전송 전 다시 돌려야 한다
            if (seoWarnings.length) result.seoWarnings = seoWarnings;   // 상품명에서 어린이용 낱말을 뺐다 — 사용자에게 전한다
            if (detailClaimWarnings.length) result.detailClaimWarnings = detailClaimWarnings;   // 상세이미지 문구 정정 — 사용자에게 전한다
            if (splitRegistrationIds.length) result.splitRegistrationIds = splitRegistrationIds;
            if (notStarted.length) {
                // 끝남(done)이 아니다 — 남은 상품이 있다는 걸 결과와 같이 partial 로 싣는다(startQueue 이어받음과 같은 꼴)
                result.notStarted = notStarted;
                const err = new Error(`다른 탭이 이어받았거나 화면 연결이 꺼져 이 탭의 작업개시를 멈췄습니다 — ${targets.length - notStarted.length}/${targets.length} 상품까지 함. `
                    + `시작 안 한 ${notStarted.length}건(result.notStarted)만 남았습니다. 이미 한 상품은 다시 돌리지 마세요.`);
                err.cliErrorCode = 'partial';
                err.cliResult = result;
                throw err;
            }
            return result;
        },

        // 상세이미지 특정 장 빼기·바꾸기(PR261021-1B9947) — 쿠팡에 가는 것은 낱장을 이어 붙인 통합 이미지 1장이라
        // 낱장(processedDetailImages)을 고친 뒤 runWork 와 같은 HTML·convertHtmlToImage 로 다시 그려 올리고, 상세 편집기 «다른 건에 적용»과 같은 칸에 저장한다.
        // 보낸 건 거절은 이 화면 문 + 서버 updatePartial(상세이미지 칸 · tool-exec/rocketreg-sent-edit.js · DB 지금 값) 두 겹이다.
        async cliPageSetDetailImages(params, onProgress) {
            checkDetailImageEditInput(params);
            const [product] = await this.cliPageTargetProducts(params, null);
            if (this.isSentToCoupang(product)) {
                throw new Error(`이미 쿠팡에 보낸 상품은 상세이미지를 바꿀 수 없습니다: ${product.registrationId}`);
            }
            if (!hasDetailImageEdit(params)) {
                return { registrationId: product.registrationId, images: detailImageList(product), changed: false };
            }
            const edit = applyDetailImageEdit(product, params);
            if (onProgress) await onProgress({ current: 0, total: 1, message: `상세이미지 ${edit.images.length}장을 다시 그리는 중입니다.` });
            const settings = (this.$store.state.settings && this.$store.state.settings[0] && this.$store.state.settings[0].defaultSettings
                && this.$store.state.settings[0].defaultSettings.imageSettings) || {};
            let combinedUrl;
            try {
                combinedUrl = await detailImageService.convertHtmlToImage(
                    combinedDetailHtml(edit.images.map(x => x.url), settings), product.registrationId, { throwOnError: true });
            } catch (error) {
                console.error('상세이미지 통합 그림 실패:', error);
                throw new Error(detailUploadFailText(error));
            }
            await this.$store.dispatch('updateProductPartial', {
                productId: product._id,
                updateFields: detailEditUpdateFields(product, { images: edit.images, combinedUrl, claimWarning: buildClaimWarning(edit.images) })
            });
            return {
                registrationId: product.registrationId,
                changed: true,
                before: edit.before,
                after: edit.images.length,
                removed: edit.removed,
                replaced: edit.replaced,
                detailedImage: combinedUrl,
                images: detailImageList({ processedDetailImages: edit.images }),
                sentToCoupang: 0
            };
        },

        // 번들 구성 — 수량은 인자로 받거나, 안 주면 등록 때 실린 소싱 묶음 수량(sourcingBundleQuantity)을 쓴다
        async cliPageSetBundle(params) {
            const targets = await this.cliPageTargetProducts(params, null);

            // 이미 쿠팡에 보낸 상품은 묶음을 바꾸지 않는다 — 쿠팡에 선 상품과 우리 기록이 어긋난다(작업개시와 같은 기준).
            const sent = targets.filter(p => this.isSentToCoupang(p));
            if (sent.length) {
                throw new Error(`이미 쿠팡에 보낸 상품은 묶음을 바꿀 수 없습니다: ${sent.map(p => p.registrationId).join(', ')}`);
            }

            let fixed = params.bundleQuantity === undefined || params.bundleQuantity === null ? null : Number(params.bundleQuantity);
            if (fixed !== null && (!Number.isFinite(fixed) || fixed < 1)) {
                throw new Error('묶음 수량은 1 이상의 숫자여야 합니다.');
            }
            // 수량을 안 주면 소싱에서 정한 값을 쓴다. 그것도 없으면 거절한다 —
            // 자동 계산으로 빠지면 소싱 때 정한 원가 기준과 다른 묶음이 조용히 들어간다.
            const bundleSource = fixed === null ? 'sourcing' : 'argument';
            if (fixed === null) {
                const missing = targets.filter(p => !p.sourcingBundleQuantity);
                if (missing.length) {
                    throw new Error(`묶음 수량을 지정하지 않았는데, 소싱에서 정한 묶음 수량도 없는 상품입니다: ${missing.map(p => p.registrationId).join(', ')}. bundleQuantity 를 넣어 다시 불러주세요.`);
                }
                const distinct = [...new Set(targets.map(p => Number(p.sourcingBundleQuantity)))];
                if (distinct.length > 1) {
                    throw new Error(`소싱 묶음 수량이 상품마다 다릅니다(${distinct.join(', ')}). 상품별로 나눠 부르거나 bundleQuantity 를 지정해주세요.`);
                }
                fixed = distinct[0];
            }

            // 묶음 구성 방식. 'apply' = 기존 옵션의 묶음 수량을 바꾼다.
            // 'add' = 원본 옵션을 그대로 두고 '원본B수량' 묶음 옵션을 새로 추가한다.
            // 예전에는 mode 를 아예 안 읽어서 'add' 로 불러도 조용히 'apply' 처럼 동작했다
            // — 원본이 사라진 줄도 모르는 게 제일 나쁘다.
            const mode = params.mode === undefined ? 'apply' : String(params.mode);
            if (mode !== 'apply' && mode !== 'add') {
                throw new Error(`묶음 구성 방식 '${mode}' 는 지원하지 않습니다. add(묶음 옵션 추가) 또는 apply(원본을 묶음으로 대체) 만 가능합니다.`);
            }
            if (mode === 'add') {
                return this.cliPageAddBundleOptions(params, targets, fixed);
            }

            // 지정한 옵션만 묶는다. optionNumber 는 문자열이라 비교 전에 맞춰준다.
            // 예전에는 이 값을 안 읽어서, 4개만 지정해도 그 상품의 옵션 44개가 전부 묶였다 (2026-09-17 실측).
            const wantedOptionNumbers = Array.isArray(params.optionNumbers) && params.optionNumbers.length
                ? params.optionNumbers.map(n => String(n))
                : null;
            const matchedOptionNumbers = [];

            // 옵션과 등록서류의 짝이 이미 어긋나 있으면 옵션만 바뀌고 서류는 옛 가격으로 남는다.
            // 성공으로 돌려주면 옛 가격이 쿠팡에 등록된다 — 바꾸기 전에 실패시킨다.
            for (const product of targets) {
                const docs = (product.coupangDoc && product.coupangDoc.jsonDocument) || null;
                const optionCount = (product.options || []).length;
                if (docs && docs.length && docs.length !== optionCount) {
                    throw new Error(`${this.getDisplayProductName(product) || product.registrationId} 의 옵션(${optionCount}개)과 등록서류(${docs.length}개) 수가 맞지 않아 묶음 수량을 바꾸지 않았습니다. 가격 설정 화면에서 저장해 짝을 맞춘 뒤 다시 시도해주세요.`);
                }
            }

            // 목표 판매가가 고정된 상품(sourcingSellingPrice)은 묶음을 늘리면 매입가만 오른다.
            // 역마진이 되는 옵션이 있으면 어느 옵션도 바꾸기 전에 실패시킨다(사본으로 미리 계산).
            for (const product of targets.filter(p => p.sourcingSellingPrice)) {
                const settings = pricingPolicy.resolve(product, this.defaultSettings);
                for (const option of product.options || []) {
                    if (wantedOptionNumbers && !wantedOptionNumbers.includes(String(option.optionNumber))) continue;
                    this.updateOptionPricing({ ...option, bundleQuantity: fixed }, settings, true, product.sourcingSellingPrice, product.sourcingPurchaseCost, product.sourcingSupplyPrice, pricingPolicy.referenceCny(product.options), product.sourcingBundleQuantity || null);
                }
            }

            const applied = [];
            const overridden = [];
            const docSkipped = [];
            let docSyncedTotal = 0;
            for (const product of targets) {
                // 상품에 저장된 가격 정책이 화면 기본세팅보다 앞선다 — 묶음 수량도 가격 계산이라,
                // 여기서 화면 기본세팅만 보면 셀러가 넣은 환율과 다른 기준으로 묶음이 정해진다.
                const settings = pricingPolicy.resolve(product, this.defaultSettings);

                const options = product.options || [];
                const scoped = wantedOptionNumbers
                    ? options.filter(o => wantedOptionNumbers.includes(String(o.optionNumber)))
                    : options;
                if (!scoped.length) continue;
                for (const option of scoped) {
                    const quantity = fixed;
                    this.$set(option, 'bundleQuantity', quantity);
                    // 묶음 수량만 바꾸고 끝내면 공급가·판매가가 1개분 그대로라 팔릴 때마다 손해다.
                    // 묶음 기준으로 가격을 다시 계산한다.
                    const updated = this.updateOptionPricing(option, settings,
                        !!(product.sourcingBundleQuantity || product.sourcingSellingPrice), product.sourcingSellingPrice || null, product.sourcingPurchaseCost || null, product.sourcingSupplyPrice || null, pricingPolicy.referenceCny(product.options), product.sourcingBundleQuantity || null);
                    // 옵션명도 묶음 수에 맞춘다 — 화면 묶음 단추(PricingEdit)와 같은 함수(PR261021-C6B4A5: 수량만 바뀌고 이름은 1개분 그대로였다).
                    // 자동 번들이 수량을 덮었으면 실제 수(updated.bundleQuantity)로 맞춘다.
                    this.$set(option, 'korName', bundleOptionService.bundledOptionName(bundleOptionService.optionDisplayName(option), updated.bundleQuantity));
                    // 자동 번들이 켜진 상품은 계산이 요청 수량을 덮는다. 조용히 넘기지 않고 응답에 드러낸다.
                    if (Number(updated.bundleQuantity) !== quantity) {
                        overridden.push({
                            registrationId: product.registrationId,
                            optionNumber: updated.optionNumber,
                            requested: quantity,
                            actual: updated.bundleQuantity
                        });
                    }
                    matchedOptionNumbers.push(String(option.optionNumber));
                    applied.push({
                        registrationId: product.registrationId,
                        optionNumber: updated.optionNumber,
                        bundleQuantity: updated.bundleQuantity,
                        korName: option.korName,
                        purchasePrice: updated.purchasePrice,
                        supplyPrice: updated.supplyPrice,
                        sellingPrice: updated.sellingPrice
                    });
                }
                const saved = await this.updateProduct(product);
                if (!saved) throw new Error(`${this.getDisplayProductName(product) || product.registrationId} 의 묶음 수량을 저장하지 못했습니다.`);

                // 등록서류(쿠팡에 실제로 보내는 문서)의 가격까지 같이 맞춘다.
                // 묶음 수량을 바꾸면 공급가·판매가가 달라지는데 서류를 그대로 두면
                // 묶음 구성 → 등록전송 순서에서 **옛 가격이 쿠팡에 등록된다.**
                // 등록전송은 되돌릴 수 없어서 응답에 말로 알리는 것으로는 못 막는다(가격 수정과 같은 결함).
                //
                // apply 는 옵션 수를 바꾸지 않으므로(묶음 수량만 바꾼다) 옵션 ↔ 서류 짝은 그대로다.
                // 일부 옵션만 묶었더라도 서류는 상품 단위로 전부 맞춘다 — 안 묶은 옵션은
                // 값이 안 바뀌었으니 그대로 다시 써지고, 어긋나 있던 것만 제자리로 온다.
                const docResult = await this.cliPageSyncPricesToDoc(product, settings);
                docSyncedTotal += docResult.synced;
                if (docResult.reason) {
                    docSkipped.push({
                        label: this.getDisplayProductName(product) || product.registrationId,
                        reason: docResult.reason
                    });
                }
            }

            // 0건 처리를 성공으로 돌려주면 "성공처럼 보이는 실패" 가 된다. 명확히 알린다.
            if (!applied.length) {
                if (wantedOptionNumbers) {
                    throw new Error(`지정한 옵션번호를 찾지 못했습니다: ${wantedOptionNumbers.join(', ')}. 해당 상품에 있는 옵션번호인지 확인해주세요.`);
                }
                throw new Error('묶음 수량을 설정할 옵션이 없습니다.');
            }

            // 일부만 맞은 경우도 부르는 쪽이 알아야 한다.
            const notFound = wantedOptionNumbers ? wantedOptionNumbers.filter(n => !matchedOptionNumbers.includes(n)) : [];

            // 서류가 맞춰졌는지 사람 말로 돌려준다. 넓게 말하면 셀러가 "다 반영됐다"고 믿고
            // 옛 가격으로 등록전송을 눌러버린다.
            let notice = '묶음 수량에 맞춰 옵션의 매입가·공급가·판매가를 다시 계산해 저장했습니다.';
            if (docSyncedTotal) {
                notice += ` 쿠팡에 보내는 등록서류의 공급가·판매가·권장가도 같이 맞췄습니다(옵션 ${docSyncedTotal}개).`;
            }
            const docNotYet = docSkipped.filter(d => d.reason === 'noDoc').map(d => d.label);
            const docBroken = docSkipped.filter(d => d.reason !== 'noDoc').map(d => d.label);
            if (docNotYet.length) {
                notice += ` 아직 등록서류가 없는 상품(${docNotYet.join(', ')})은 작업개시 때 이 가격으로 서류가 만들어집니다.`;
            }
            if (docBroken.length) {
                notice += ` ${docBroken.join(', ')} 은 옵션과 등록서류의 짝이 맞지 않아 서류 가격을 맞추지 못했습니다`
                    + ' — 가격 설정 화면에서 저장해 확인해주세요.';
            }

            if (overridden.length) {
                notice += ` 옵션 ${overridden.length}개는 자동 번들 계산이 켜져 있어 요청한 ${fixed}개가 아닌 수량으로 저장됐습니다(overridden 참고).`;
            }

            return {
                total: applied.length,
                requestedBundleQuantity: fixed,
                bundleSource: bundleSource,
                options: applied,
                overridden: overridden,
                notFound: notFound,
                notice: notice
            };
        },

        // 묶음 옵션 추가 (mode: 'add') — 원본 옵션을 그대로 두고 '원본B수량' 옵션을 새로 만든다.
        //
        // 화면의 번들 추가 버튼(PricingEdit.addBundleOptions → savePricing)과 **같은 계산**을 쓴다
        // (bundleOptionService). 옵션 하나를 늘리려면 options 와 coupangDoc.jsonDocument 가
        // 같은 순서로 같이 늘어나야 한다 — 짝이 어긋나면 화면에 없는 SKU 가 쿠팡에만 선다.
        //
        // 저장은 배열을 통째로 덮는 updateProductPartial 로만 한다.
        // /api/rocketReg/updateFeature 는 DB 에 없는 새 옵션을 조용히 버리고 성공을 돌려준다.
        async cliPageAddBundleOptions(params, targets, fixed) {
            if (fixed === null) {
                throw new Error('묶음 옵션을 추가하려면 묶음 수량을 지정해주세요.');
            }
            if (fixed < 2) {
                throw new Error('묶음 옵션 추가는 묶음 수량 2 이상만 가능합니다. 묶음을 풀려면 apply 방식을 쓰세요.');
            }

            const wantedOptionNumbers = Array.isArray(params.optionNumbers) && params.optionNumbers.length
                ? params.optionNumbers.map(n => String(n))
                : null;
            const matchedOptionNumbers = [];

            // ========== 1단계: 먼저 전부 검사한다. 하나라도 걸리면 아무것도 바꾸지 않는다 ==========
            const plans = [];
            for (const product of targets) {
                const label = this.getDisplayProductName(product) || product.registrationId;
                const options = product.options || [];
                const docs = (product.coupangDoc && product.coupangDoc.jsonDocument) || null;

                if (!docs || !docs.length) {
                    throw new Error(`${label} 에 쿠팡 등록서류가 아직 없습니다. 작업개시를 먼저 끝내주세요.`);
                }
                // 이미 어긋나 있는 상태에서 뒤에 붙이면 잘못된 짝이 그대로 굳는다.
                if (docs.length !== options.length) {
                    throw new Error(`${label} 의 옵션(${options.length}개)과 등록서류(${docs.length}개) 수가 맞지 않습니다. 묶음 옵션을 추가하면 짝이 더 어긋나므로 중단합니다.`);
                }

                const scoped = wantedOptionNumbers
                    ? options.filter(o => wantedOptionNumbers.includes(String(o.optionNumber)))
                    : options;
                if (!scoped.length) continue;

                const settings = bundleOptionService.resolveBundleSettings(product, this.defaultSettings);
                const takenNumbers = options.map(o => String(o.optionNumber));
                const items = [];

                for (const option of scoped) {
                    if (option.isBundleOption) {
                        throw new Error(`${label} 의 ${option.optionNumber} 은 이미 묶음 옵션입니다. 묶음 옵션을 또 묶을 수는 없습니다.`);
                    }
                    const newOptionNumber = bundleOptionService.bundleOptionNumber(option.optionNumber, fixed);
                    if (takenNumbers.includes(newOptionNumber)) {
                        throw new Error(`${label} 에 ${newOptionNumber} 묶음 옵션이 이미 있습니다. 같은 옵션을 같은 수량으로 두 번 묶으면 옵션번호가 겹쳐 서류가 갱신되지 않습니다.`);
                    }
                    const originalIndex = options.indexOf(option);
                    const originalDoc = docs[originalIndex];
                    // 원본 서류를 못 찾으면 첫 번째 서류로 때우지 않는다 — 엉뚱한 상품 정보가 붙는 게 더 나쁘다.
                    if (!originalDoc) {
                        throw new Error(`${label} 의 ${option.optionNumber} 옵션에 해당하는 등록서류를 찾지 못했습니다.`);
                    }
                    takenNumbers.push(newOptionNumber);
                    matchedOptionNumbers.push(String(option.optionNumber));
                    items.push({ option: option, originalDoc: originalDoc });
                }

                plans.push({ product: product, label: label, settings: settings, items: items });
            }

            // 0건 처리를 성공으로 돌려주면 "성공처럼 보이는 실패" 가 된다. 명확히 알린다.
            if (!plans.length) {
                if (wantedOptionNumbers) {
                    throw new Error(`지정한 옵션번호를 찾지 못했습니다: ${wantedOptionNumbers.join(', ')}. 해당 상품에 있는 옵션번호인지 확인해주세요.`);
                }
                throw new Error('묶음 옵션을 추가할 옵션이 없습니다.');
            }

            // ========== 2단계: 배열을 같은 순서로 늘리고 한 번에 저장한다 ==========
            const added = [];
            for (const plan of plans) {
                const product = plan.product;
                const options = (product.options || []).slice();
                const jsonDocument = product.coupangDoc.jsonDocument.slice();
                const seoOptions = product.seo && Array.isArray(product.seo.options) ? product.seo.options.slice() : null;
                const pricingOptions = product.pricing && Array.isArray(product.pricing.options) ? product.pricing.options.slice() : null;
                const quotationOptions = product.quotation && Array.isArray(product.quotation.options) ? product.quotation.options.slice() : null;

                for (const item of plan.items) {
                    const originalOptionName = bundleOptionService.optionDisplayName(item.option);
                    const bundleOption = bundleOptionService.buildBundleOption(item.option, fixed, plan.settings, originalOptionName);
                    bundleOption.pricingStatus = 'completed';
                    const bundleDoc = bundleOptionService.buildBundleJsonDocument(item.originalDoc, bundleOption, originalOptionName, plan.settings, product && product.quotationUserEdits);
                    // 승계된 한글표시사항 라벨은 1개짜리다. 옵션 상태(buildBundleOption 이 내린다)만
                    // 비워두면 서류에는 그 라벨이 그대로 남아 전송 때 쿠팡으로 간다.
                    bundleOptionService.clearKoreanLabelImageInDoc(bundleDoc);

                    // 배열 끝에 붙인다. 중간에 끼우면 옵션 ↔ 서류 인덱스가 밀린다.
                    options.push(bundleOption);
                    jsonDocument.push(bundleDoc);

                    if (seoOptions) {
                        const originalSeo = seoOptions.find(o => String(o.optionNumber) === String(item.option.optionNumber));
                        seoOptions.push({
                            ...(originalSeo || {}),
                            optionNumber: bundleOption.optionNumber,
                            korName: bundleOption.korName
                        });
                    }
                    if (pricingOptions) {
                        // 길이가 어긋나면 가격 화면이 저장된 가격을 버리고 새로 계산한다 — 묶음 가격이 조용히 풀린다.
                        pricingOptions.push({
                            optionNumber: bundleOption.optionNumber,
                            optionName: originalOptionName,
                            korName: bundleOption.korName,
                            price: bundleOption.price,
                            stock: bundleOption.stock,
                            bundleQuantity: bundleOption.bundleQuantity,
                            purchasePrice: bundleOption.purchasePrice,
                            supplyPrice: bundleOption.supplyPrice,
                            sellingPrice: bundleOption.sellingPrice,
                            supplyMargin: bundleOption.supplyMargin,
                            sellingMargin: bundleOption.sellingMargin
                        });
                    }
                    if (quotationOptions) {
                        const originalQuotation = quotationOptions.find(q => String(q.optionNumber) === String(item.option.optionNumber));
                        const newQuotation = originalQuotation ? JSON.parse(JSON.stringify(originalQuotation)) : {};
                        newQuotation.optionNumber = bundleOption.optionNumber;
                        newQuotation.korName = bundleOption.korName;
                        quotationOptions.push(newQuotation);
                    }

                    added.push({
                        registrationId: product.registrationId,
                        optionNumber: bundleOption.optionNumber,
                        originalOptionNumber: bundleOption.originalOptionNumber,
                        bundleQuantity: bundleOption.bundleQuantity,
                        stock: bundleOption.stock,
                        purchasePrice: bundleOption.purchasePrice,
                        supplyPrice: bundleOption.supplyPrice,
                        sellingPrice: bundleOption.sellingPrice
                    });
                }

                if (options.length !== jsonDocument.length) {
                    throw new Error(`${plan.label} 의 옵션과 등록서류 수가 맞지 않아 저장하지 않았습니다 (옵션 ${options.length}개 / 서류 ${jsonDocument.length}개).`);
                }

                const updateFields = {
                    'options': options,
                    'coupangDoc.jsonDocument': jsonDocument,
                    // 상품 레벨도 같이 내린다. 등록전송의 완료 검사(cliPageSubmitRegistration 의 대상 고르기,
                    // submitProductsToCoupang 의 필수작업 검사)는
                    // 상품 레벨 koreanLabelStatus 만 보기 때문에, 옵션만 비우면 1개짜리 라벨을 단
                    // 상품이 여전히 전송 대상에 남는다.
                    // koreanLabels·koreanLabelImage 는 그대로 둔다 — 묶음이 아닌 옵션들의 라벨은 멀쩡하다.
                    'koreanLabelStatus': null,
                    'updatedAt': Date.now()
                };
                if (seoOptions) updateFields['seo.options'] = seoOptions;
                if (pricingOptions) updateFields['pricing.options'] = pricingOptions;
                if (quotationOptions) updateFields['quotation.options'] = quotationOptions;

                await this.$store.dispatch('updateProductPartial', {
                    productId: product._id,
                    updateFields: updateFields
                });
            }

            // ========== 3단계: 저장된 결과를 다시 읽어 짝이 맞는지 확인한다 ==========
            const byId = new Map((this.products || []).map(p => [String(p.registrationId), p]));
            for (const plan of plans) {
                const saved = byId.get(String(plan.product.registrationId));
                const savedOptions = (saved && saved.options) || [];
                const savedDocs = (saved && saved.coupangDoc && saved.coupangDoc.jsonDocument) || [];
                if (savedOptions.length !== savedDocs.length) {
                    throw new Error(`${plan.label} 저장 후 옵션(${savedOptions.length}개)과 등록서류(${savedDocs.length}개) 수가 맞지 않습니다. 화면을 새로고침해 확인해주세요.`);
                }
            }

            // 일부만 맞은 경우도 부르는 쪽이 알아야 한다.
            const notFound = wantedOptionNumbers ? wantedOptionNumbers.filter(n => !matchedOptionNumbers.includes(n)) : [];

            return {
                mode: 'add',
                total: added.length,
                options: added,
                notFound: notFound,
                notice: '옵션명의 "(N개묶음)" 표기는 상품명 작업(SEO)을 다시 돌려도 유지됩니다. 다만 묶음 구성은 작업개시를 끝낸 뒤에 하는 것이 안전합니다. 추가한 묶음 옵션의 한글표시사항은 1개 기준이라 그대로 쓸 수 없어 미완료로 되돌렸습니다 — 한글표시사항을 다시 만들어주세요.'
            };
        },

        // 가격 수정 — 기존 updateOptionPricing 을 그대로 부른다
        //
        // 정책은 상품마다 따로 푼다(pricingPolicy.resolve). 예전에는 this.defaultSettings 를
        // 통째로 갈아치우고 계산했는데, 그러면 화면에 띄워둔 다른 상품의 계산까지 이 정책으로 끌려갔다.
        // 그리고 그 정책이 상품에 남지 않으면 작업개시(가격 작업)가 화면 기본세팅으로 다시 계산해
        // 셀러가 넣은 환율을 조용히 덮는다 — 2026-09-19 실측(환율 210 → 매입 4,200 → 작업개시 후 7,000).
        async cliPageSetPrice(params) {
            const targets = await this.cliPageTargetProducts(params, null);

            const settingsPatch = (params.settings && typeof params.settings === 'object') ? params.settings : null;

            // 이미 쿠팡에 보낸 상품은 가격을 바꾸지 않는다 — 쿠팡에 선 가격과 우리 기록이 어긋난다(setBundle 과 같은 기준).
            const sent = targets.filter(p => this.isSentToCoupang(p));
            if (sent.length) {
                throw new Error(`이미 쿠팡에 보낸 상품은 가격을 바꿀 수 없습니다: ${sent.map(p => p.registrationId).join(', ')}`);
            }

            // 옵션과 등록서류의 짝이 어긋나 있으면 옵션만 바뀌고 서류는 옛 가격으로 남는다 — 바꾸기 전에 실패시킨다.
            for (const product of targets) {
                const docs = (product.coupangDoc && product.coupangDoc.jsonDocument) || null;
                const optionCount = (product.options || []).length;
                if (docs && docs.length && docs.length !== optionCount) {
                    throw new Error(`${this.getDisplayProductName(product) || product.registrationId} 의 옵션(${optionCount}개)과 등록서류(${docs.length}개) 수가 맞지 않아 가격을 바꾸지 않았습니다. 가격 설정 화면에서 저장해 짝을 맞춘 뒤 다시 시도해주세요.`);
                }
            }

            // 이 상품에 이미 저장된 정책 위에 보낸 항목만 얹는다.
            // 안 보낸 항목은 상품 설정 → 화면 기본세팅 순으로 채워지므로,
            // 환율 하나만 보내도 마진율이 회사 정책 그대로 남는다.
            const policyOf = product => (settingsPatch
                ? { ...pricingPolicy.resolve(product, this.defaultSettings), ...settingsPatch }
                : pricingPolicy.resolve(product, this.defaultSettings));

            // 목표 판매가가 고정된 상품(sourcingSellingPrice)은 환율·쿠팡마진율을 바꾸면 역마진이 될 수 있다.
            // 어느 상품도 저장하기 전에 사본으로 미리 계산해 역마진이면 실패시킨다.
            for (const product of targets.filter(p => p.sourcingSellingPrice)) {
                const policy = policyOf(product);
                (product.options || []).forEach(option => this.updateOptionPricing({ ...option }, policy, true, product.sourcingSellingPrice, product.sourcingPurchaseCost, product.sourcingSupplyPrice, pricingPolicy.referenceCny(product.options), product.sourcingBundleQuantity || null));
            }

            // 판매가가 고정된 상품에서는 판매가를 정하는 설정이 쓰이지 않는다. 받았으면 응답에 드러낸다.
            const fixedIgnoredKeys = ['marginRate', 'enableMinSupplyMargin', 'minSupplyMarginAmount', 'enableBundling', 'bundlingType', 'minMarginAmount', 'minCoupangMarginAmount'];
            const overridden = [];

            const applied = [];
            const docSkipped = [];
            let docSyncedTotal = 0;
            for (const product of targets) {
                const policy = policyOf(product);
                if (product.sourcingSellingPrice && settingsPatch) {
                    const ignoredSettings = Object.keys(settingsPatch).filter(k => fixedIgnoredKeys.includes(k));
                    if (ignoredSettings.length) {
                        overridden.push({
                            registrationId: product.registrationId,
                            fixedSellingPrice: Number(product.sourcingSellingPrice),
                            ignoredSettings: ignoredSettings
                        });
                    }
                }

                const options = product.options || [];
                for (const option of options) {
                    const updated = this.updateOptionPricing(option, policy,
                        !!(product.sourcingBundleQuantity || product.sourcingSellingPrice), product.sourcingSellingPrice || null, product.sourcingPurchaseCost || null, product.sourcingSupplyPrice || null, pricingPolicy.referenceCny(product.options), product.sourcingBundleQuantity || null);
                    applied.push({
                        registrationId: product.registrationId,
                        optionNumber: updated.optionNumber,
                        bundleQuantity: updated.bundleQuantity,
                        purchasePrice: updated.purchasePrice,
                        supplyPrice: updated.supplyPrice,
                        sellingPrice: updated.sellingPrice
                    });
                }
                const saved = await this.updateProduct(product);
                if (!saved) throw new Error(`${this.getDisplayProductName(product) || product.registrationId} 의 가격을 저장하지 못했습니다.`);

                // 바꾼 가격 정책을 상품에 남긴다. 이게 **다음 가격 작업의 정본**이다
                // (pricingService.getDefaultPricingInfo → pricingPolicy.resolve 가 이걸 먼저 읽는다).
                // 빠뜨리면 작업개시 때 화면 기본세팅으로 되돌아간다.
                //
                // 보낸 항목만 남긴다. 안 보낸 항목까지 지금 값으로 박으면 나중에 회사 기본세팅을
                // 바꿔도 이 상품만 옛 값에 묶인다 — pricingPolicy 가 기본세팅을 바닥에 깔아주므로
                // 여기에 전부 적어둘 필요가 없다.
                if (settingsPatch) {
                    const currentInfo = (product.pricing && product.pricing.info) ? product.pricing.info : {};
                    await this.$store.dispatch('updateProductPartial', {
                        productId: product._id,
                        updateFields: {
                            // pricing 을 통째로 덮으면 pricing.options 가 날아간다. info 만 점표기로 바꾼다.
                            'pricing.info': { ...currentInfo, ...settingsPatch },
                            // 상품 최상위에도 같은 값을 남긴다. 이 네 필드는 상품을 만들 때 한 번 찍히는
                            // 기록용이라 지금 코드가 계산에 쓰지는 않지만, 값이 다르면 DB 를 들여다보는
                            // 사람이 어느 쪽이 맞는지 알 수 없다 (실측: 최상위 350 / info 210).
                            // 정본은 pricing.info 고, 여기는 그 사본이다.
                            exchangeRate: policy.exchangeRate,
                            marginRate: policy.marginRate,
                            coupangMarginRate: policy.coupangMarginRate,
                            roundUnit: policy.roundUnit
                        }
                    });
                }

                // 등록서류(쿠팡에 실제로 보내는 문서)의 가격까지 같이 맞춘다.
                // 옵션만 다시 계산하고 서류를 두면 가격 수정 → 등록전송 순서에서 **옛 가격이 쿠팡에 등록된다.**
                // 등록전송은 되돌릴 수 없어서 응답에 말로 알리는 것으로는 못 막는다(2026-09-19 실측).
                const docResult = await this.cliPageSyncPricesToDoc(product, policy);
                docSyncedTotal += docResult.synced;
                if (docResult.reason) {
                    docSkipped.push({
                        label: this.getDisplayProductName(product) || product.registrationId,
                        reason: docResult.reason
                    });
                }
            }

            // 무엇이 맞춰졌고 무엇이 안 됐는지 사람 말로 돌려준다.
            // 넓게 말하면 셀러가 "다 반영됐다"고 믿고 옛 가격으로 등록한다.
            let notice = '이 설정으로 옵션의 매입가·공급가·판매가를 지금 다시 계산해 저장했습니다.'
                + ' 이 설정은 상품에 남아서 앞으로 돌리는 가격 작업에도 그대로 쓰입니다.';
            if (docSyncedTotal) {
                notice += ` 쿠팡에 보내는 등록서류의 공급가·판매가·권장가도 같이 맞췄습니다(옵션 ${docSyncedTotal}개).`;
            }
            const docNotYet = docSkipped.filter(s => s.reason === 'noDoc').map(s => s.label);
            const docBroken = docSkipped.filter(s => s.reason !== 'noDoc').map(s => s.label);
            if (docNotYet.length) {
                notice += ` 아직 등록서류가 없는 상품(${docNotYet.join(', ')})은 작업개시 때 이 가격으로 서류가 만들어집니다.`;
            }
            if (docBroken.length) {
                notice += ` ${docBroken.join(', ')} 은 옵션과 등록서류의 짝이 맞지 않아 서류 가격을 맞추지 못했습니다`
                    + ' — 가격 설정 화면에서 저장해 확인해주세요.';
            }
            if (overridden.length) {
                notice += ` 상품 ${overridden.length}개는 소싱에서 정한 목표 판매가로 고정돼 있어 판매가를 그대로 두고`
                    + ' 공급가만 쿠팡마진율로 다시 계산했습니다. 보낸 마진율 등은 이 상품 가격에 쓰이지 않았습니다(overridden 참고).';
            }

            return { total: applied.length, options: applied, overridden: overridden, notice: notice };
        },

        // 옵션 가격 → 등록서류(쿠팡에 실제로 보내는 문서) 반영.
        //
        // 서류에 가격 칸은 셋이다.
        //   purchasePrice    = 공급가 (우리가 쿠팡에 넘기는 값 = option.supplyPrice). 이름이 매입가처럼 보이지만 아니다
        //   coupangSalePrice = 판매가 (option.sellingPrice)
        //   msrp / osrp      = 권장소비자가 / 공식판매처가 = 판매가 × msrpMultiplier, 반올림
        // 매입가는 서류에 들어가지 않는다 — 묶음 매입가(단품 × 수량)는 공급가·판매가에 이미 녹아 있다.
        //
        // msrp 와 osrp 는 **서류에 이미 있는 칸만** 고치고 없는 칸은 만들지 않는다.
        // (화면은 서류에 있는 칸으로, 가격 작업은 스키마 필수 여부로 고르는데 두 규칙이 갈릴 수 있다.
        //  없는 칸은 쿠팡에 가지도 않으니, 있는 칸을 전부 맞추는 것이 옛 값이 남지 않는 유일한 방법이다.)
        //
        // 반올림·배수 계산은 묶음 서류를 만드는 곳과 같은 함수(bundleOptionService)를 쓴다.
        async cliPageSyncPricesToDoc(product, policy) {
            const options = product.options || [];
            const docs = (product.coupangDoc && product.coupangDoc.jsonDocument) || null;
            if (!docs || !docs.length) return { synced: 0, reason: 'noDoc' };
            // 옵션과 서류는 같은 순서의 짝이다(등록전송도 그 순서로 보낸다).
            // 수가 다르면 어느 서류가 어느 옵션인지 알 수 없다 — 엉뚱한 옵션에 가격을 붙이는 대신 멈춘다.
            if (docs.length !== options.length) return { synced: 0, reason: 'mismatch' };

            // msrp 는 상품 설정이 아니라 화면 기본세팅의 반올림 단위를 쓴다(화면·묶음과 같은 규칙).
            const settings = {
                ...policy,
                msrpRoundUnit: (this.defaultSettings && this.defaultSettings.roundUnit) || policy.roundUnit
            };

            const updateFields = { 'updatedAt': Date.now() };
            const pricingOptions = [];
            let synced = 0;

            options.forEach((option, index) => {
                pricingOptions.push({
                    optionNumber: option.optionNumber,
                    optionName: option.optionName || bundleOptionService.optionDisplayName(option),
                    korName: option.korName,
                    price: option.price,
                    stock: option.stock,
                    bundleQuantity: option.bundleQuantity,
                    purchasePrice: option.purchasePrice,
                    supplyPrice: option.supplyPrice,
                    sellingPrice: option.sellingPrice,
                    supplyMargin: option.supplyMargin,
                    sellingMargin: option.sellingMargin
                });

                const doc = docs[index];
                const commonAttributes = doc && doc.productPage && doc.productPage.commonAttributes;
                if (!commonAttributes) return;
                // 값이 숫자가 아니면 서류에 넣지 않는다. NaN 이 들어간 서류는 쿠팡이 받아도 우리가 못 읽는다.
                if (!Number.isFinite(Number(option.supplyPrice)) || !Number.isFinite(Number(option.sellingPrice))) return;

                const prefix = `coupangDoc.jsonDocument.${index}.productPage.commonAttributes`;
                updateFields[`${prefix}.purchasePrice`] = Number(Math.round(option.supplyPrice));
                updateFields[`${prefix}.coupangSalePrice`] = Number(Math.round(option.sellingPrice));

                const msrpValue = bundleOptionService.calculateMsrpValue(option.sellingPrice, settings);
                ['msrp', 'osrp'].forEach(field => {
                    if (Object.prototype.hasOwnProperty.call(commonAttributes, field)) {
                        updateFields[`${prefix}.${field}`] = msrpValue;
                    }
                });

                synced += 1;
            });

            if (!synced) return { synced: 0, reason: 'noPriceFields' };

            // 가격 화면은 pricing.options 가 옵션과 짝이 맞으면 **그 값을 그대로 쓴다**
            // (PricingEdit.initializeCalculatedOptions). 여기를 안 고치면 화면에는 옛 가격이 보이고,
            // 셀러가 그 화면에서 저장하는 순간 방금 계산한 가격이 옛 값으로 되돌아간다.
            updateFields['pricing.options'] = pricingOptions;

            await this.$store.dispatch('updateProductPartial', {
                productId: product._id,
                updateFields: updateFields
            });

            return { synced: synced, reason: null };
        },

        // 등록전송 — 기존 submitProductsToCoupang 를 그대로 부르고, **끝날 때까지 기다린 뒤 상품별 결과를 돌려준다.**
        //
        // 예전에는 submitProductsToCoupang 를 부르자마자 "진행했습니다" 를 돌려줬다. 그런데 그 함수는
        // 확장에 요청을 던지고 바로 돌아오고, 실제 전송은 확장 응답을 타고 이어진다.
        // 그래서 쿠팡 세션이 풀려 있으면 10초 만에 "보냈다"가 나오고 아무 일도 안 일어났다
        // (2026-09-16 실측). 되돌릴 수 없는 단계라 더 위험하다 — 끝을 보고 말한다.
        async cliPageSubmitRegistration(params, onProgress) {
            // 등록ID 없이 오면 보내지 않는다. 예전엔 «안 보낸 것 전부»를 골라 보냈는데, 사용자가 일부러 보류한 상품과
            // 서버가 막 보낸 상품까지 쿠팡으로 나갔다(2026-10-16 PR261016-3043EA, DUPLICATE_PRODUCT). 되돌릴 수 없다.
            const askedIds = Array.isArray(params.registrationIds) ? params.registrationIds.map(id => String(id || '').trim()).filter(Boolean) : [];
            if (!askedIds.length) {
                throw new Error('보낼 상품의 등록ID(registrationIds)를 지정해주세요. 등록전송은 되돌릴 수 없어 «아직 안 보낸 상품 전부»를 알아서 고르지 않습니다. rocket.sourcing.listRegistrations 로 등록ID를 확인한 뒤 다시 부르세요.');
            }
            const targets = await this.cliPageTargetProducts({ ...params, registrationIds: askedIds }, null);
            if (!targets.length) {
                throw new Error('등록전송할 수 있는 상품이 없습니다. 모든 작업이 완료되었는지 확인해주세요.');
            }

            // 등록ID를 직접 지정해 이미 보낸 상품이 섞이면 submitProductsToCoupang 가 "다시 전송하시겠습니까?"
            // 확인창을 띄운다. 부르는 쪽에는 그 창이 안 보이니 아무도 누르지 못하고 그대로 멈춘다.
            const already = targets.filter(p => this.isSentToCoupang(p));
            if (already.length) {
                const names = already.map(p => this.getDisplayProductName(p) || p.registrationId).join(', ');
                throw new Error(`이미 등록전송이 끝난 상품이 있습니다: ${names}. 다시 보내려면 화면에서 직접 전송해주세요.`);
            }
            if (this.isVerifying) {
                throw new Error('등록전송이 이미 진행 중입니다. 끝난 뒤에 다시 요청해주세요.');
            }

            const total = targets.length;
            const ids = targets.map(p => String(p.registrationId));
            await onProgress({ current: 0, total, message: `${total}개 상품 등록전송을 시작합니다.` });

            this.selectedItems = targets;
            const started = await this.submitProductsToCoupang({ registrationIds: ids });
            if (started && started.refused) throw new Error(started.refused);
            await this.cliPageWaitForSubmit(total, onProgress);

            // 상품 객체는 저장·AI 자동수정을 거치며 **새 객체로 바뀐다**(store 의 UPDATE_ROCKET_PRODUCT).
            // 들고 있던 참조가 아니라 등록ID로 화면 목록에서 다시 찾아 결과를 읽는다.
            const byId = new Map((this.products || []).map(p => [String(p.registrationId), p]));
            const products = ids.map(id => {
                const product = byId.get(id);
                if (!product) {
                    return { registrationId: id, submitted: false, reason: '전송 뒤 화면 목록에서 상품을 찾지 못했습니다.' };
                }
                const productName = this.getDisplayProductName(product) || id;
                const fixed = Array.isArray(product.originFix) && product.originFix.length ? { originFix: product.originFix } : {};   // 보내기 전에 고친 말(#240-2)
                if (product.registered === true) return { registrationId: id, productName, submitted: true, ...fixed };
                return { registrationId: id, productName, submitted: false, reason: this.cliPageSubmitFailReason(product), ...fixed };
            });
            const submitted = products.filter(p => p.submitted);
            const failed = products.filter(p => !p.submitted);

            await onProgress({ current: total, total, message: '등록전송을 마쳤습니다.' });

            // 한 건도 못 보냈으면 성공이 아니다. "진행했습니다" 로 뭉개지 않는다.
            if (!submitted.length) {
                throw new Error(`${total}개 상품 모두 등록전송에 실패했습니다. ${this.cliPageFailSummary(failed)}`);
            }
            return {
                total,
                submitted: submitted.length,
                failed: failed.length,
                products,
                message: failed.length
                    ? `${total}개 중 ${submitted.length}개를 쿠팡에 전송했고 ${failed.length}개는 실패했습니다. 쿠팡 심사 결과는 여기서 알 수 없습니다.`
                    : `${total}개 상품을 쿠팡에 전송했습니다. 쿠팡 심사 결과는 여기서 알 수 없습니다.`
            };
        },

        // 실패 사유를 사람 말로 한 줄. 상품 → 옵션 순으로 찾고, 아무것도 없으면 그렇다고 말한다.
        cliPageSubmitFailReason(product) {
            const detail = String(product.errorDetails || '').trim();
            if (detail) return detail;
            const optionDetail = (product.options || [])
                .map(option => String((option && option.errorDetails) || '').trim())
                .find(Boolean);
            if (optionDetail) return optionDetail;
            if (product.verified === true) return '검증은 끝났지만 등록완료로 바뀌지 않았습니다.';
            return '쿠팡이 등록을 받지 않았습니다. 화면의 등록상태에서 사유를 확인해주세요.';
        },

        // 실패가 많아도 문장이 길어지지 않게 앞 3건만 적는다.
        cliPageFailSummary(failed) {
            const head = failed.slice(0, 3)
                .map(f => `${f.productName || f.registrationId}: ${f.reason}`)
                .join(' / ');
            return failed.length > 3 ? `${head} 외 ${failed.length - 3}건` : head;
        },

        // 등록전송이 끝날 때까지 기다리며 진행 상황을 보고한다.
        // 보고가 갈 때마다 저쪽 타임아웃 시계가 다시 걸려서, 몇십 분짜리 전송도 끊기지 않는다.
        cliPageWaitForSubmit(total, onProgress) {
            return new Promise((resolve, reject) => {
                // 시작도 못 하고 끝난 경우(보낼 옵션이 없어 submitProductsToCoupang 가 되돌아온 경우).
                // 여기서 실패로 단정하지 않는다 — 부르는 쪽이 상품별 상태를 보고 판단한다.
                if (!this.isVerifying) {
                    resolve();
                    return;
                }
                let lastMark = '';
                let idleTicks = 0;
                let lastMovedAt = Date.now();
                const timer = setInterval(() => {
                    const left = this.verificationQueue ? this.verificationQueue.length : 0;
                    const done = Math.max(0, total - left);
                    // 대기열이 줄었거나 요청을 하나 더 보냈으면 살아 있는 것으로 본다.
                    const mark = `${left}|${this.processedOptionCount || 0}`;

                    if (mark !== lastMark) {
                        lastMark = mark;
                        lastMovedAt = Date.now();
                        idleTicks = 0;
                        onProgress({ current: done, total, message: `${done}/${total} 등록전송 중` });
                    } else if (++idleTicks >= QUEUE_WAIT_REPORT_TICKS) {
                        idleTicks = 0;
                        onProgress({ current: done, total, message: `${done}/${total} 진행 중` });
                    }

                    if (!this.isVerifying) {
                        this.cliPageClearWait(timer);
                        resolve();
                        return;
                    }

                    if (Date.now() - lastMovedAt > SUBMIT_WAIT_STALL_MS) {
                        this.cliPageClearWait(timer);
                        console.error(`[AIRocketReg] 등록전송이 ${done}/${total} 에서 더 진행되지 않습니다.`);
                        reject(new Error(`등록전송이 ${done}/${total} 에서 멈췄습니다. 쿠팡 판매자센터 탭이 열려 있고 로그인돼 있는지 확인해주세요.`));
                    }
                }, QUEUE_WAIT_TICK_MS);
                this.cliPageTrackWait(timer, reject);
            });
        },

        // 대기열 시작 — 화면의 "전체 시작" 버튼과 같은 길(startQueueProcessing)을 그대로 탄다.
        // 여기서 로직을 다시 쓰면 버튼과 도구가 갈라져서, 화면에서는 되는데 도구로는 안 되는 일이 생긴다.
        async cliPageStartQueue(params, onProgress) {
            if (this.queueProcessing) {
                throw new Error(this.sameTabQueueBusyMessage());
            }
            // 다른 탭의 같은 화면이 아직 대기열을 돌고 있으면 시작하지 않는다 — 대기열 파일이 하나라 같은 상품이 두 번 만들어진다
            const otherRun = this.otherTabQueueRun();
            if (otherRun) throw new Error(this.otherTabQueueRunMessage(otherRun));
            // 이 화면의 쿠플러스 로그인이 풀렸으면 모든 건이 「상품번호 확인」으로 실패한다 — 시작하지 않는다.
            if (!(await this.checkLoginBeforeQueue())) throw new Error(LOGIN_EXPIRED_MESSAGE);

            // 조회 기간을 오늘로 맞춘다(수동 addProduct 와 같은 기준). 탭을 어제 열어 둔 채면 저장 직후
            // search() 가 어제 기간 목록으로 덮어 새 상품이 목록에서 빠지고, 가격·이미지 작업이
            // 「제품을 찾을 수 없습니다」로 조용히 건너뛰어져 SEO 만 된 채 done 이 나갔다(PR261017-62FA8B).
            const today = this.getTodaywith();
            if (this.startdate !== today || this.enddate !== today) {
                this.startdate = today;
                this.enddate = today;
                await this.search();
            }

            // 화면이 아직 못 읽어온 대기열 항목이 있으면 먼저 읽어 온다.
            await this.loadCliRegistrationQueue();

            // 지정해 온 단계는 **화면 전역 기본값**을 바꾼다. 항목이 자기 단계를 싣고 있으면
            // 그 값이 이기므로(queueItemStepLevel) 여기서 4를 줘도 2로 들어온 항목은 2까지만 간다 —
            // 항목이 시킨 것보다 더 가지 않는 쪽이 안전하다. 그래서 이 인자는 단계를 싣지 않고
            // 들어온 항목(sourcing.sendToRocketReg 경로)에만 실제로 적용된다.
            const asked = params.stepLevel;
            if (asked !== undefined && asked !== null && asked !== '') {
                const level = this.normalizeQueueStepLevel(asked);
                if (level === null) {
                    throw new Error('어디까지 진행할지는 1(상품추가) 2(SEO+가격) 3(작업개시) 4(등록전송) 중 하나여야 합니다.');
                }
                this.queueStepLevel = level;
            }

            const ready = (this.productQueue || []).filter(q => q.link && q.keyword);
            if (!ready.length) {
                throw new Error((this.productQueue || []).length
                    ? '대기열에 1688 링크와 키워드가 모두 채워진 상품이 없습니다. 대기열 항목을 확인해주세요.'
                    : '대기열에 상품이 없습니다. 먼저 상품을 추가해주세요.');
            }

            // 응답의 stepLevel 키는 옛 모양 그대로 둔다(하위호환) — "모두 여기까지는 끝났다" 가
            // 참인 가장 낮은 단계다. 보고 문구는 이 값 하나로 고르지 않는다: 아래에서 실제로
            // 만들어진 항목의 단계별 개수(stepLevelCounts)로 나눠 말한다.
            // 항목에 4(등록 전송)가 실려 있어도 maxStepLevel 까지만 간다 — 아래 try 안에서 상한을 건다.
            const maxStep = this.normalizeQueueStepLevel(params.maxStepLevel);
            const stepLevel = Math.min(maxStep || 4, ...ready.map(q => this.queueItemStepLevel(q)));

            const total = ready.length;

            // 소싱 목표가가 실린 항목(탈환의깃발)은 소싱 관문과 같은 공식으로 계산돼야 한다.
            // 기본세팅이 적용환율이면 쿠패스 통합통관 환율로 켠다 — 켠 사실은 응답에 남긴다.
            let integratedRateSwitched = null;
            if (ready.some(q => this.normalizeQueueSellingPrice(q.targetSellingPrice))) {
                if (this.defaultSettings && this.defaultSettings.useIntegratedRate) {
                    await this.loadIntegratedRate();
                } else {
                    integratedRateSwitched = await this.enableIntegratedRateDefault();
                }
            }

            await onProgress({ current: 0, total, message: `대기열 ${total}건을 시작합니다.` });

            // 화면에서 사람이 체크해 둔 것이 있으면 그것만 도는데, 부르는 쪽은 그 체크를 모른다.
            // 무엇이 도는지 어긋나지 않게 대기열 전체를 대상으로 삼는다.
            this.queueSelectedItems = [];
            // 서버가 서플라이어허브에서 미리 받아 온 카테고리 양식({카테고리코드: 양식}) — 있으면 상품추가가
            // 확장·서플라이어허브 탭 없이 돈다(processNextQueueItem). 없는 카테고리는 예전처럼 확장에 묻는다.
            const info = params.rocketRegInfo;
            this._cliRocketRegInfo = info && typeof info === 'object' && !Array.isArray(info) ? info : null;
            // 서버가 서플라이어허브에서 «최하위 아님» 으로 확인한 카테고리({코드: 문구}) — 그 건은 확장으로 넘기지 않고 이 문구로 실패
            const bad = params.invalidCategories;
            this._cliInvalidCategories = bad && typeof bad === 'object' && !Array.isArray(bad) ? bad : null;
            // 작업개시 중 견적서가 상품을 나누면 새 등록ID 가 생기는데 대기열 기록(_queueCreated)엔 없다 — 분리 이벤트에서 줍는다
            // (quotationService.finishSplit · splitProducts[0] = 원본). 결과 splitInto = {원본 등록ID: [나뉜 등록ID]} (윈 3484 PR261021-022D37)
            const splitInto = {};
            const onSplit = (e) => {
                const [orig, ...pieces] = (e && e.detail && e.detail.splitProducts) || [];
                const key = orig && orig.registrationId;
                if (!key) return;
                const list = splitInto[key] || (splitInto[key] = []);
                pieces.forEach(sp => { const rid = sp && sp.registrationId; if (rid && rid !== key && !list.includes(rid)) list.push(rid); });
            };
            window.addEventListener('product-split-completed', onSplit);
            try {
                this._cliMaxStepLevel = maxStep;
                this.startQueueProcessing({ byAgent: true });
                if (!this.queueProcessing) {
                    throw new Error('대기열을 시작하지 못했습니다. 화면의 대기열 상태를 확인해주세요.');
                }

                try {
                    await this.cliPageWaitForQueue(total, onProgress);
                } catch (e) {
                    // 다른 탭이 이어받았으면 이 탭이 실제로 멈출 때까지 기다렸다가 보고한다 — 저장 중이던 건까지 세야
                    // 「N건까지 했다」가 맞고, 부르는 쪽이 이미 만든 건을 다시 돌리지 않는다.
                    if (this._queueAbortReason) await this.waitQueueStopped(QUEUE_TAKEOVER_STOP_WAIT_MS);
                    // 기다림이 중간에 끊겼다(화면을 떠남·다른 탭이 가져감·멈춤). 「어디까지 됐고 무엇이 남았나」를 같이 올린다.
                    throw this.cliPageQueueInterrupted(e, total);
                }
            } finally {
                window.removeEventListener('product-split-completed', onSplit);
                // 이번 회차 것만 쓴다 — 남겨 두면 사람이 누른 다음 회차가 낡은 양식을 탄다
                this._cliRocketRegInfo = null;
                this._cliInvalidCategories = null;
                this._cliMaxStepLevel = null;
            }
            // 목록은 화면 표시를 위해 맞춰 두지만 **만든 개수의 근거로는 쓰지 않는다.**
            // search() 는 화면의 조회 기간(startdate~enddate)으로만 조회하고 실패해도 던지지 않아서,
            // 기간이 오늘을 안 포함하면 상품이 실제로 만들어져도 created:0 으로 나왔다.
            // 도는 사이 자정을 넘겼을 수 있다 — 방금 만든 상품이 목록에서 빠지지 않게 기간을 오늘까지 늘린다(PR261016-1B97C6).
            this.ensureListRangeIncludesToday();
            await this.search();
            const searchError = this._lastSearchError || '';

            // 만든 것의 정본은 이번 회차 기록(_queueCreated)이다. 조회 결과에 기대지 않는다.
            // 같은 등록번호가 두 번 실리면 만든 개수가 부풀어 실제 중복 생성이 가려지므로 등록번호로 센다.
            const created = [];
            const createdSeen = new Set();
            for (const c of (Array.isArray(this._queueCreated) ? this._queueCreated : [])) {
                if (!c || !c.registrationId) continue;
                const id = String(c.registrationId);
                if (createdSeen.has(id)) continue;
                createdSeen.add(id);
                const lvl = this.normalizeQueueStepLevel(c.stepLevel);
                created.push({ registrationId: id, stepLevel: lvl === null ? this.queueStepLevel : lvl });
            }
            // 실패는 회차 기록이 정본이다. 행만 훑으면 대기열에서 빠진 실패가 통째로 사라져서,
            // 3건 넣고 2건 생긴 것을 사용자가 눈으로 찾아내야 한다.
            const recorded = this._queueFailures || [];
            const seen = new Set(recorded.map(f => f._queueId));
            // 실패한 항목은 대기열에 그대로 남는다. 부르는 쪽이 "이건 다시 해도 안 된다" 고 판단해서
            // 뺄 수 있으려면 어느 항목인지 가리킬 수 있어야 한다 — queueId 를 같이 올린다.
            const failed = recorded
                .concat((this.productQueue || [])
                    .filter(q => q._error && !seen.has(q._queueId))
                    .map(q => ({ _queueId: q._queueId, keyword: q.keyword, reason: q._error, failCount: Number(q.failCount) || 1 })))
                .map(f => ({ queueId: f._queueId, keyword: f.keyword, reason: f.reason, failCount: f.failCount || 1 }));
            // 로그인 풀림으로 건너뛴 건은 상품 탓이 아니다 — 「전에도 실패한 항목」으로 세지 않는다.
            const repeated = failed.filter(f => f.failCount > 1 && f.reason !== LOGIN_EXPIRED_MESSAGE);

            // 단계 서사("여기까지 끝났습니다")는 **실제로 만들어진 것이 있을 때만** 쓴다.
            // 하나도 안 만들어졌는데 그 문장을 돌려주면 부르는 쪽은 failed 를 안 보고 그대로
            // 다음 단계로 간다 — 이 레포가 여러 번 당한 "성공처럼 보이는 실패" 다.
            const createdCount = created.length;
            const none = createdCount === 0;
            const partial = createdCount > 0 && createdCount < total;

            // 실행은 항목마다 갈리는데(queueItemStepLevel) 보고는 가장 낮은 단계 하나로 뭉개고 있었다.
            // 2단계와 4단계가 섞이면 4단계 항목이 **이미 쿠팡에 나갔는데도** "쿠팡 등록 전송은 하지
            // 않았습니다" 라고 답했다 — 되돌릴 수 없는 일이 묻혔다. 단계별로 나눠 말한다.
            // 항목별 내역을 통째로 싣지는 않는다(1,000건이면 응답이 커진다) — 단계별 개수로 요약한다.
            // 작업개시(3단계 이상)를 시켰는데 끝나지 못한 상품. 단계 번호만 보고 「작업 개시까지 끝났습니다」라고
            // 말하면 남은 일이 묻힌다(2026-10-15 묶음⑥) — 이 상품들은 단계 서사에서 빼고 따로 말한다.
            const workFailed = (Array.isArray(this._queueWorkFailed) ? this._queueWorkFailed : [])
                .filter(f => f && createdSeen.has(String(f.registrationId)));
            const workFailedIds = new Set(workFailed.map(f => String(f.registrationId)));
            // 작업개시 기록에 안 잡혀도 상태가 'error' 인 작업이 있으면 같은 꼴로 싣는다(runWork 와 같은 기준) —
            // 견적서 분리(_2 …)로 생긴 조각도 본다. 안 보면 견적서가 멈췄는데 failed:[] 로 「다 됐다」가 된다(PR261016-9F5455).
            const workIds3 = new Set(created.filter(c => c.stepLevel >= 3).map(c => c.registrationId));
            const familyOf = id => String(id).replace(/(?:_\d+)+$/, '');
            (this.products || [])
                .filter(p => p && p.registrationId && workIds3.has(familyOf(p.registrationId)))
                .forEach(p => {
                    const id = String(p.registrationId);
                    if (workFailedIds.has(id)) return;
                    // 끝나지 않은 작업(processing 등)도 싣는다 — 'error' 만 보면 견적서가 processing 에 남은 건이 «다 됐다» 로 보였다(2B2E83)
                    const { failed: failedTasks, unfinished } = workOutcome(p, AUTO_WORK_TASKS);
                    if (!failedTasks.length && !unfinished.length) return;
                    const quotationError = failedTasks.includes('quotation') ? this.cliQuotationErrorText(p) : undefined;
                    workFailed.push({
                        registrationId: id,
                        reason: [failedTasks.length ? `작업 실패: ${failedTasks.join(', ')}` : '', unfinished.length ? `끝나지 않은 작업: ${unfinished.join(', ')}` : ''].filter(Boolean).join(' · ')
                            + (quotationError ? ` — 견적서가 멈춘 이유: ${quotationError}` : '') + (detailImageErrorText(p) ? ` — 상세이미지가 멈춘 이유: ${detailImageErrorText(p)}` : '') + (seoErrorText(p) ? ` — SEO 가 멈춘 이유: ${seoErrorText(p)}` : '') + (koreanLabelErrorText(p) ? ` — 한글표시가 멈춘 이유: ${koreanLabelErrorText(p)}` : ''),
                        failedTasks,
                        unfinishedTasks: unfinished,
                        quotationError
                    });
                    workFailedIds.add(id);
                });
            // 견적서 멈춤 — 사람이 견적서 화면에서 고쳐야 다시 돌릴 수 있는 것이 대부분이라 따로 센다
            const quotationStopped = workFailed.filter(f => Array.isArray(f.failedTasks) && f.failedTasks.includes('quotation')).length;
            const quotationStoppedNote = quotationStopped
                ? ` 견적서 멈춤 ${quotationStopped}건(workFailed 의 quotationError 에 이유).`
                : '';
            const workFailedNote = workFailed.length
                ? ` ⚠ ${workFailed.length}건은 작업개시가 끝나지 않았습니다(workFailed 에 등록ID·이유) — 등록 전송 대상이 아닙니다. 그 등록ID만 rocket.sourcing.runWork 로 다시 돌린 뒤 보내세요.` + quotationStoppedNote
                : '';
            const stepLevelCounts = {};
            // 분리 조각(_2 …)이 멈춰도 그 상품은 끝나지 않은 것이다 — 원래 등록ID 기준으로 뺀다
            const workFailedFamilies = new Set(Array.from(workFailedIds).map(familyOf));
            for (const c of created) {
                if (workFailedFamilies.has(familyOf(c.registrationId))) continue;
                stepLevelCounts[c.stepLevel] = (stepLevelCounts[c.stepLevel] || 0) + 1;
            }
            const levelsMade = Object.keys(stepLevelCounts).map(Number).sort((a, b) => a - b);
            const mixed = levelsMade.length > 1;

            // 되돌릴 수 없는 사실이라 맨 앞에 둔다 — 뒤에 붙이면 긴 문장에 묻힌다.
            // attempted = 쿠팡으로 보낸 것(되돌릴 수 없음) · submitted = 그중 쿠팡 접수(registered)가 확인된 것만
            const attempted = Array.isArray(this._queueSubmitted) ? this._queueSubmitted : [];
            const submitted = Array.isArray(this._queueSubmitConfirmed) ? this._queueSubmitConfirmed : [];
            const unconfirmed = attempted.filter(id => !submitted.includes(id));
            const submitBlocked = this._queueSubmitBlocked || '';
            const submittedNote = (submitted.length
                ? `⚠ 이 중 ${submitted.length}건은 쿠팡 등록 접수까지 확인됐습니다 — 되돌릴 수 없습니다. `
                : '')
                + (unconfirmed.length
                    ? `⚠ ${unconfirmed.length}건은 쿠팡으로 보냈지만 접수를 확인하지 못했습니다(submitUnconfirmed) — 화면 등록상태에서 확인하고 다시 보내지 마세요. `
                    : '');
            const blockedNote = submitBlocked ? `${submitBlocked} ` : '';

            // 4단계 문구는 "쿠팡 등록 전송까지 끝났다" 고 말한다. 전송이 보류됐는데 그대로 쓰면
            // 이번에 고치려는 것과 **반대 방향의 거짓말**이 된다 — 그때는 간 데까지만 말한다.
            const submitStopped = !!submitBlocked && !attempted.length;
            // 보냈지만 접수를 확인 못 한 건이 있으면 «전송까지 끝났다» 로 덮지 않는다(O7 · 앞 ⚠ 문장과 어긋남)
            const doneText = l => (l === 4 && submitStopped
                ? '상품 추가부터 작업 개시까지 끝났고, 쿠팡 등록 전송은 하지 못했습니다.'
                : l === 4 && unconfirmed.length
                    ? '상품 추가부터 쿠팡 등록 전송까지 했고, 일부는 쿠팡 접수를 확인하지 못했습니다(submitUnconfirmed).'
                    : QUEUE_STEP_DONE[l]);
            const nextText = l => (l === 4 && submitStopped
                ? '위 사유를 확인한 뒤 rocket.sourcing.submitRegistration 으로 직접 보내주세요.'
                : QUEUE_STEP_NEXT[l]);
            // 섞였을 때는 높은 단계(되돌릴 수 없는 쪽)를 먼저 말한다.
            // 하나도 안 만들어졌으면 단계 서사 자체를 쓰지 않는다(아래 none 분기). 빈 문자열로 둬서
            // undefined 가 문장에 섞여 들어가지 않게 한다.
            const doneByLevel = !levelsMade.length ? ''
                : mixed
                    ? levelsMade.slice().reverse().map(l => `${l}단계 ${stepLevelCounts[l]}건: ${doneText(l)}`).join(' ')
                    : doneText(levelsMade[0]);
            const nextByLevel = !levelsMade.length ? ''
                : mixed
                    ? levelsMade.map(l => `${l}단계 ${stepLevelCounts[l]}건: ${nextText(l)}`).join(' ')
                    : nextText(levelsMade[0]);

            // 작업개시가 '일부완료'로 끝난 상품(예: 상세이미지 일부 번역 실패) — 전송 대상에서 빠지므로 이유를 싣는다.
            // 조용히 넘어가면 "만들었는데 왜 안 보내지나" 가 된다.
            const warnings = [];
            for (const c of created) {
                const p = this.$store.getters.getRocketProductById(c.registrationId);
                const w = p && p.detailImageStatus === 'partially_completed' ? p.detailImageWarning : null;
                if (p && p.detailImageStatus === 'partially_completed') {
                    warnings.push({
                        registrationId: c.registrationId,
                        partialTasks: ['detailImage'],
                        reason: (w && w.message) || '상세이미지 일부 번역 실패 — 상세이미지 작업을 다시 돌려주세요',
                        detailImageFailures: w ? w.failures : undefined
                    });
                }
            }
            // 자동 상품명에서 어린이용 낱말을 뺀 상품 — 전송 대상은 그대로, 사용자에게 전할 알림만 싣는다
            const seoWarnings = [];
            for (const c of created) {
                const p = this.$store.getters.getRocketProductById(c.registrationId);
                if (p && p.seoWarning && p.seoWarning.message) {
                    seoWarnings.push({ registrationId: c.registrationId, removedWords: p.seoWarning.removedWords, reason: p.seoWarning.message });
                }
            }
            // 상세이미지 번역 문구를 원문·1688 속성에 맞춰 고친 상품 — 전송 대상은 그대로, 확인할 곳만 싣는다
            const detailClaimWarnings = [];
            for (const c of created) {
                const p = this.$store.getters.getRocketProductById(c.registrationId);
                if (p && p.detailClaimWarning && p.detailClaimWarning.message) {
                    detailClaimWarnings.push({ registrationId: c.registrationId, reason: p.detailClaimWarning.message, items: p.detailClaimWarning.items });
                }
            }
            // 1688 재고 0 이라 뺀 옵션·재고를 못 잰 옵션(202E64) — 전송 대상은 그대로, 사용자에게 전할 것만 싣는다
            const stockWarnings = [];
            for (const c of (Array.isArray(this._queueCreated) ? this._queueCreated : [])) {
                if (!c || !c.registrationId || !(c.soldOutOptions || c.stockUnknownOptions)) continue;
                if (stockWarnings.some(w => w.registrationId === String(c.registrationId))) continue;
                stockWarnings.push({ registrationId: String(c.registrationId), soldOutOptions: c.soldOutOptions || [], stockUnknownOptions: c.stockUnknownOptions || [] });
            }
            const soldOutCount = stockWarnings.reduce((n, w) => n + w.soldOutOptions.length, 0);
            const stockUnknownCount = stockWarnings.reduce((n, w) => n + w.stockUnknownOptions.length, 0);
            const stockNote = (soldOutCount ? ` 1688 재고 0 옵션 ${soldOutCount}개는 빼고 만들었습니다(stockWarnings.soldOutOptions).` : '')
                + (stockUnknownCount ? ` ⚠ 옵션 ${stockUnknownCount}개는 1688 재고를 못 재 그대로 넣었습니다(stockWarnings.stockUnknownOptions) — 판매자에게 재고를 확인하세요.` : '');
            const warningNote = warnings.length
                ? ` ⚠ ${warnings.length}건은 상세이미지 일부가 번역되지 않아 '일부완료'로 남았고 등록 전송 대상에서 빠집니다 — warnings 를 보고 rocket.sourcing.runWork(tasks:['detailImage'])로 다시 돌려주세요.`
                : '';

            const done = none
                ? `대기열 ${total}건 중 하나도 만들어지지 않았습니다. 상품이 생기지 않았으니 이어서 할 작업도 없습니다.`
                : submittedNote + blockedNote + (partial
                    ? `대기열 ${total}건 중 ${createdCount}건만 만들어졌습니다. 만들어진 ${createdCount}건은 ${doneByLevel}`
                    : doneByLevel) + workFailedNote;
            // 보류 사유는 done 에서 한 번 말했다. 여기서는 nextText(4) 가 "직접 보내라" 로 받는다.
            const nextStep = none
                ? 'failed 의 reason 을 사용자에게 그대로 전하세요. 대기열 항목을 고친 뒤 rocket.sourcing.startQueue 를 다시 부르는 것 말고는 이어서 부를 것이 없습니다.'
                : (workFailed.length
                    ? `먼저 workFailed 의 등록ID만 rocket.sourcing.runWork 로 다시 돌려 끝내세요(다른 건은 다시 돌리지 마세요).`
                        + (quotationStopped ? ` 견적서 멈춤 ${quotationStopped}건은 quotationError 의 이유(예: 필수 속성 누락)를 사용자에게 전해 견적서 화면에서 고친 뒤 runWork(tasks:['quotation'])로 다시 돌리세요.` : '') + ' '
                    : '') + (partial
                    ? `만들어진 ${createdCount}건(registrationIds)만 대상으로 하세요. ${nextByLevel}`
                    : nextByLevel);

            return {
                // 예전부터 있던 키다. 그대로 둔다(하위호환) — 다만 이건 **가장 낮은 단계 하나**라
                // 섞인 대기열을 설명하지 못한다. 실제 내역은 stepLevelCounts 를 본다.
                stepLevel,
                stepLevelCounts,
                maxStepLevel: levelsMade.length ? levelsMade[levelsMade.length - 1] : stepLevel,
                total,
                created: createdCount,
                registrationIds: created.map(c => c.registrationId),
                // 단계가 섞였을 때만 싣는다 — 안 섞였으면 registrationIds 와 같은 내용이라 두 배로 커질 뿐이다.
                ...(mixed
                    ? { registrationIdsByStep: levelsMade.reduce((acc, l) => {
                        acc[l] = created.filter(c => c.stepLevel === l).map(c => c.registrationId);
                        return acc;
                    }, {}) }
                    : {}),
                // 견적서가 나눈 상품 — 나뉜 새 등록ID 는 registrationIds 에 없다. 나뉜 게 없으면 키 없음
                ...(Object.keys(splitInto).some(k => splitInto[k].length) ? { splitInto } : {}),
                submitted: submitted.length,
                submittedRegistrationIds: submitted,
                ...(unconfirmed.length ? { submitUnconfirmed: unconfirmed } : {}),
                submitBlocked,
                ...(integratedRateSwitched
                    ? { settingsChanged: `기본세팅의 매입가 계산을 쿠패스 통합통관 환율(${integratedRateSwitched}원 + 포장검수 200원 + 바코드 100원, 관부가세 ×1.1)로 바꿨습니다. 이 계정의 다른 상품 가격 작업에도 적용됩니다 — 되돌리려면 화면 기본세팅에서 스위치를 끄세요.` }
                    : {}),
                // search() 는 실패해도 토스트만 띄운다. 조용히 넘어가면 화면이 안 맞는 이유를 아무도 모른다.
                listRefreshError: searchError,
                failed,
                // 작업개시를 시켰는데 끝나지 못한 상품(등록ID·이유) — 비어 있지 않으면 이 회차는 「다 끝남」이 아니다
                workFailed,
                // 시킨 단계까지 실제로 끝난 상품 수 / 실패(대기열 실패 + 작업개시 미완)
                succeeded: created.filter(c => !workFailedFamilies.has(familyOf(c.registrationId))).length,
                failedCount: failed.length + workFailed.length,
                ...(warnings.length ? { warnings } : {}),
                ...(seoWarnings.length ? { seoWarnings } : {}),
                ...(detailClaimWarnings.length ? { detailClaimWarnings } : {}),
                ...(stockWarnings.length ? { stockWarnings } : {}),
                done,
                nextStep,
                // done 에 이미 전송 경고가 앞에 붙어 있다. 실패 갈래는 done 을 안 쓰므로 여기서만 붙인다.
                message: (failed.length
                    ? submittedNote + blockedNote + (none
                        ? `대기열 ${total}건이 모두 실패해 하나도 만들어지지 않았습니다. `
                        : `대기열 ${total}건 중 ${createdCount}건을 만들고 ${failed.length}건이 실패했습니다. `
                          + `만들어진 ${createdCount}건은 ${doneByLevel} `)
                      + `실패한 항목은 대기열에 그대로 남아 다음에 다시 시도됩니다`
                      + (repeated.length ? ` — 그중 ${repeated.length}건은 전에도 실패한 항목입니다.` : '.')
                      + ' 다시 해도 소용없는 항목은 queueId 로 rocket.sourcing.removeQueueItems 를 불러 빼주세요.'
                    : none
                        ? `대기열 ${total}건을 돌렸지만 새로 만들어진 상품이 없습니다. 실패로 기록된 항목도 없으니 화면의 대기열 상태를 확인해주세요.`
                        : `대기열 ${total}건 중 ${createdCount}건을 만들었습니다. ${done}`)
                    + (searchError ? ` (화면 목록 새로고침은 실패했습니다: ${searchError} — 만든 개수는 이번 회차 기록으로 셌으니 위 숫자에는 영향이 없습니다.)` : '')
                    + warningNote
                    + stockNote
                    // 성공 갈래는 done 에 이미 붙어 있다 — 실패 갈래만 여기서 붙인다
                    + (failed.length ? workFailedNote : '')
            };
        },

        // 대기열 기다림이 끊겼을 때 — 지금까지 만든 것·실패·남은 것을 실패 결과에 싣는다(삼키지 않는다).
        // 남은 대기열 항목은 그대로 남아 있어 화면을 다시 열고 startQueue 를 부르면 남은 것부터 이어서 돈다.
        cliPageQueueInterrupted(cause, total) {
            const seen = new Set();
            const created = (Array.isArray(this._queueCreated) ? this._queueCreated : [])
                .map(c => c && c.registrationId && String(c.registrationId))
                .filter(id => id && !seen.has(id) && seen.add(id));
            const failed = (this._queueFailures || []).map(f => ({ queueId: f._queueId, keyword: f.keyword, reason: f.reason, failCount: f.failCount || 1 }));
            const remaining = (this.productQueue || []).filter(q => q.link && q.keyword && !q._error).length;
            const work = this.queueWorkProgress;
            const left = this.cliPage.stopped || this.cliPage.superseded;
            const where = work
                ? `상품 ${created.length}건을 만들었고 작업개시 ${work.k}/${work.n} 을 하던 중이었습니다`
                : `대기열 ${total}건 중 상품 ${created.length}건을 만들었습니다`;
            // 다른 탭이 이어받아 이 탭이 멈췄다 — 같은 대기열을 다시 돌리면 만든 건이 또 생긴다는 걸 맨 앞에 말한다
            const takeover = !!this._queueAbortReason;
            const stillRunning = takeover && this.queueProcessing;
            const head = takeover
                ? `다른 탭이 이어받음 — 이 탭은 ${created.length}건까지 하고 멈춤${stillRunning ? '(저장 중인 건이 남아 아직 멈추는 중)' : ''}. 이미 만든 ${created.length}건(result.registrationIds)은 다시 만들지 마세요.`
                : cause.message;
            const err = new Error(`${head} ${where}`
                + (failed.length ? `, ${failed.length}건은 실패했습니다` : '')
                + (remaining ? `. 남은 ${remaining}건은 대기열에 그대로 있어 화면을 다시 열고 rocket.sourcing.startQueue 를 부르면 이어서 진행합니다` : '')
                + (created.length ? '. 만들어진 등록ID(result.registrationIds)는 rocket.sourcing.listRegistrations 로 작업 상태를 확인한 뒤 끝나지 않은 것만 rocket.sourcing.runWork 로 이어가세요.' : '.'));
            err.cliErrorCode = left ? 'screen-left' : undefined;
            err.cliResult = { total, created: created.length, registrationIds: created, failed, remaining, interrupted: true, ...(work ? { workProgress: { current: work.k, total: work.n } } : {}),
                ...(takeover ? { takenOverByOtherTab: true, stillRunning, workFailed: Array.isArray(this._queueWorkFailed) ? this._queueWorkFailed : [] } : {}) };
            return err;
        },

        // 작업개시 진행 문구 — 「작업개시 1/2 (트렁크정리함) · 대표이미지 5/25 · 상세이미지 번역 6/18 · 11:43 시작」
        // 세부(작업 이름·이미지 장수)는 workProgress 가 들고 있다. 화면 값이 아니라 watch 가 안 걸리니 타이머 틱에서도 다시 읽는다(check).
        queueWorkMessage(work) {
            const head = `작업개시 ${work.k}/${work.n} (${work.name})`;
            const detail = formatWorkDetail(getWorkDetail(work.registrationId));
            return detail ? `${head} · ${detail}` : head;
        },

        // 대기열이 끝날 때까지 기다리며 진행 상황을 보고한다.
        // 보고가 갈 때마다 저쪽 타임아웃 시계가 다시 걸려서, 몇십 분짜리 대기열도 끊기지 않는다.
        // 진행·완료는 화면 값이 바뀌는 그 자리에서 안다(watch) — 창이 최소화·가려지면 타이머가 1분 간격까지 늘어
        // 완료 감지가 그만큼 늦었다. 타이머는 오래 변화가 없을 때의 진행 보고와 멈춤 판정에만 쓴다.
        cliPageWaitForQueue(total, onProgress) {
            return new Promise((resolve, reject) => {
                let lastCurrent = -1;
                let lastWorkMsg = '';
                let lastMovedAt = Date.now();
                let lastReportAt = Date.now();
                let timer = null;
                const unwatch = [];
                const stopWatching = () => { while (unwatch.length) unwatch.pop()(); };
                const report = (p) => { lastReportAt = Date.now(); onProgress(p); };
                // 작업개시 문구 — 상품 안에서 끝난 작업·도는 작업·대표이미지 옵션 수까지(store 상태 그대로).
                // 옵션 많은 상품은 한 건이 한 시간을 넘어 «작업개시 1/1» 만으로는 멈춘 줄 안다(10-20 43옵션).
                const workMessage = (work) => {
                    const product = (this.$store.state.rocketProducts || []).find(p => String(p.registrationId) === work.registrationId);
                    const detail = workProgressText(workProgress(product), t => workflowService.getWorkTypeName(`${t}Status`));
                    const msg = this.queueWorkMessage(work);
                    return detail ? `${msg} · ${detail}` : msg;
                };
                const check = () => {
                    // 화면을 떠나는 등으로 이 기다림이 밖에서 끝났으면(cliPage.waitTimers 에서 빠짐) 더 보지 않는다
                    if (timer !== null && !this.cliPage.waitTimers.has(timer)) { stopWatching(); return; }
                    const current = (this.queueProgress && this.queueProgress.current) || 0;
                    const work = this.queueWorkProgress;
                    const workMsg = work ? workMessage(work) : '';
                    if (work && workMsg !== lastWorkMsg) {
                        // 상품추가가 끝나고 작업개시를 도는 구간 — 숫자는 그대로 두고 문구로 몇 번째 상품·어느 작업·이미지 몇 장째인지 알린다
                        lastWorkMsg = workMsg;
                        report({ current, total, phase: 'work', message: workMsg });
                    } else if (current !== lastCurrent) {
                        lastCurrent = current;
                        lastMovedAt = Date.now();
                        report({ current, total, message: `${current}/${total} 상품 추가 중` });
                    }
                    if (!this.queueProcessing) {
                        stopWatching();
                        this.cliPageClearWait(timer);
                        onProgress({ current: total, total, message: '대기열 처리를 마쳤습니다.' });
                        resolve();
                    }
                };
                timer = setInterval(() => {
                    if (!this.cliPage.waitTimers.has(timer)) { stopWatching(); return; }
                    const current = (this.queueProgress && this.queueProgress.current) || 0;
                    const work = this.queueWorkProgress;
                    if (Date.now() - lastReportAt >= QUEUE_WAIT_TICK_MS * QUEUE_WAIT_REPORT_TICKS) {
                        report(work
                            ? { current, total, phase: 'work', message: workMessage(work) }
                            : { current, total, message: `${current}/${total} 진행 중` });
                    }
                    // 상품추가 구간에서 아주 오래 한 건도 안 늘면 멈춘 것으로 본다.
                    // 숫자가 다 찬 뒤(작업개시·등록전송)는 원래 오래 걸리는 구간이라 건드리지 않는다.
                    if (current < total && Date.now() - lastMovedAt > QUEUE_WAIT_STALL_MS) {
                        stopWatching();
                        this.cliPageClearWait(timer);
                        console.error(`[AIRocketReg] 대기열이 ${current}/${total} 에서 더 진행되지 않습니다.`);
                        reject(new Error(`대기열이 ${current}/${total} 에서 더 진행되지 않습니다. 화면은 아직 처리 중일 수 있으니 상태를 확인해주세요.`));
                        return;
                    }
                    check();
                }, QUEUE_WAIT_TICK_MS);
                this.cliPageTrackWait(timer, reject);
                unwatch.push(
                    this.$watch('queueProcessing', check),
                    this.$watch(() => this.queueProgress && this.queueProgress.current, check),
                    this.$watch('queueWorkProgress', check, { deep: true }),
                );
                check();
            });
        },

        // ───────────────────────────────────────────────────────────────
        // 카테고리 수집 — 확장에 시키고 결과를 받아 온다
        //
        // 쿠팡 카테고리 페이지는 브라우저 밖에서는 읽히지 않는다(챌린지). 확장만 읽을 수
        // 있는데 에이전트는 확장을 직접 못 부른다 ⇒ 열려 있는 이 화면이 다리 역할을 한다.
        // ───────────────────────────────────────────────────────────────

        // 가격 조건 하나를 숫자로 다듬는다. 안 준 것과 잘못 준 것을 갈라서 본다.
        cliPageCategoryPrice(value, label) {
            if (value === undefined || value === null || value === '') return null;
            const num = Number(value);
            if (!Number.isFinite(num) || num < 0) {
                throw new Error(`${label}는 0 이상의 숫자여야 합니다.`);
            }
            return Math.round(num);
        },

        // 입력을 먼저 다 따져 본다. 확장을 부르기 전에 걸러야 쓸데없이 쿠팡을 때리지 않는다.
        async cliPageCategorySearch(params, onProgress) {
            const categoryId = String(params.categoryId === undefined || params.categoryId === null ? '' : params.categoryId).trim();
            if (!/^\d+$/.test(categoryId)) {
                throw new Error('카테고리 번호를 숫자로 알려주세요. 쿠팡 카테고리 주소(www.coupang.com/np/categories/12345)의 마지막 숫자입니다.');
            }

            const sorter = params.sorter === undefined || params.sorter === null || params.sorter === ''
                ? 'saleCountDesc'
                : String(params.sorter);
            if (!CATEGORY_SEARCH_SORTERS.includes(sorter)) {
                throw new Error(`'${sorter}' 정렬은 지원하지 않습니다. ${CATEGORY_SEARCH_SORTERS.join(' · ')} 중에서 골라주세요.`);
            }

            const pages = params.pages === undefined || params.pages === null || params.pages === '' ? 1 : Number(params.pages);
            if (!Number.isInteger(pages) || pages < 1) {
                throw new Error('읽을 페이지 수는 1 이상의 정수여야 합니다.');
            }
            // 넘치면 조용히 잘라 주지 않고 거절한다 — 사람이 몇 페이지를 받았는지 알아야 한다.
            if (pages > CATEGORY_SEARCH_MAX_PAGES) {
                throw new Error(`한 번에 ${CATEGORY_SEARCH_MAX_PAGES}페이지까지만 읽을 수 있습니다. 더 읽으면 쿠팡이 자동 수집으로 보고 한동안 쿠팡 검색 자체를 막습니다.`);
            }

            const minPrice = this.cliPageCategoryPrice(params.minPrice, '최저가');
            const maxPrice = this.cliPageCategoryPrice(params.maxPrice, '최고가');
            if (minPrice !== null && maxPrice !== null && minPrice > maxPrice) {
                throw new Error('최저가가 최고가보다 큽니다. 가격 범위를 다시 확인해주세요.');
            }

            if (this.cliPage.categoryBusy) {
                throw new Error('카테고리 수집이 이미 진행 중입니다. 끝난 뒤에 다시 요청해주세요. 동시에 읽으면 쿠팡이 한동안 검색을 막습니다.');
            }

            const request = {
                categoryId,
                sorter,
                minPrice,
                maxPrice,
                rocketOnly: params.rocketOnly === true || params.rocketOnly === 'true',
                pages
            };

            this.cliPage.categoryBusy = true;
            try {
                const done = await this.cliPageCollectCategory(request, onProgress);
                return this.cliPageCategoryResult(request, done);
            } finally {
                this.cliPage.categoryBusy = false;
            }
        },

        // 확장에 요청을 던지고 COLLECT_CATEGORY_DONE 을 기다린다.
        // requestId 로 짝을 맞춘다 — 이 화면에는 다른 확장 응답도 계속 흘러서,
        // 짝을 안 맞추면 남의 응답을 내 결과로 착각한다.
        cliPageCollectCategory(request, onProgress) {
            return new Promise((resolve, reject) => {
                const requestId = `catsearch_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
                let settled = false;
                let answered = false;          // 확장이 한 번이라도 대답했나
                let lastBeatAt = Date.now();
                let timer = null;

                const finish = (err, value) => {
                    if (settled) return;
                    settled = true;
                    window.removeEventListener('message', handler);
                    this.cliPageClearWait(timer);
                    if (err) reject(err); else resolve(value);
                };

                const handler = (event) => {
                    const data = event && event.data;
                    if (!data || data.requestId !== requestId) return;

                    if (data.response === 'COLLECT_CATEGORY_PROGRESS') {
                        answered = true;
                        lastBeatAt = Date.now();
                        const current = Number(data.current) || 0;
                        const total = Number(data.total) || request.pages;
                        // 진행을 올려야 저쪽 타임아웃 시계가 다시 걸린다.
                        onProgress({ current, total, message: data.message || `${current}/${total} 페이지를 읽었습니다.` });
                        return;
                    }

                    if (data.response === 'COLLECT_CATEGORY_DONE') {
                        answered = true;
                        finish(null, data);
                    }
                };

                window.addEventListener('message', handler);

                // 확장이 그냥 입을 다무는 경우가 있다(미설치·옛 버전·쿠팡 탭이 닫힘).
                // 그때 영원히 매달리지 않도록 지켜본다.
                timer = setInterval(() => {
                    const idle = Date.now() - lastBeatAt;
                    if (idle < (answered ? CATEGORY_SEARCH_IDLE_MS : CATEGORY_SEARCH_FIRST_MS)) return;
                    console.error(`[AIRocketReg] 카테고리 수집 응답이 ${Math.round(idle / 1000)}초째 없습니다 (${requestId}).`);
                    finish(new Error(answered
                        ? '카테고리를 읽는 도중 쿠플러스 확장 프로그램이 응답을 멈췄습니다. 화면을 새로고침한 뒤 다시 시도해주세요.'
                        : EXT_NO_ANSWER));
                }, CATEGORY_SEARCH_TICK_MS);
                // 화면을 떠나거나 다른 탭에 명령권을 넘기면 이 기다림도 같이 끝난다.
                this.cliPageTrackWait(timer, (e) => {
                    if (settled) return;
                    settled = true;
                    window.removeEventListener('message', handler);
                    reject(e);
                });

                window.postMessage({
                    joke: 'collectCategory',
                    requestId,
                    categoryId: request.categoryId,
                    sorter: request.sorter,
                    minPrice: request.minPrice,
                    maxPrice: request.maxPrice,
                    rocketOnly: request.rocketOnly,
                    pages: request.pages
                }, '*');
                onProgress({ current: 0, total: request.pages, message: `카테고리 ${request.categoryId} 의 ${request.pages}개 페이지를 읽습니다.` });
            });
        },

        // 확장이 준 결과를 정리한다. 여기서 "성공처럼 보이는 실패" 를 걸러낸다.
        cliPageCategoryResult(request, data) {
            const raw = Array.isArray(data.products) ? data.products : [];

            // 광고 상품이 페이지마다 다시 나와서 같은 상품이 여러 번 들어온다. 상품번호로 한 번만 남긴다.
            const seen = new Set();
            const products = [];
            for (const item of raw) {
                const id = item && item.productId !== undefined && item.productId !== null ? String(item.productId) : '';
                if (id) {
                    if (seen.has(id)) continue;
                    seen.add(id);
                }
                products.push(item);
            }

            const pagesRead = Number(data.pagesRead) || 0;
            const blocked = !!data.blocked;
            const blockedReason = data.blockedReason || '쿠팡이 자동 수집으로 보고 요청을 막았습니다.';
            // 차단이 아닌데 0건일 때 확장이 붙여주는 사유. 옛 확장은 안 준다(아래에서 그때를 따로 본다).
            const emptyKind = data.emptyKind || null;
            const emptyReason = data.emptyReason || null;

            // 차단은 예외로 던지지 않는다. 한 건도 못 건졌어도 결과로 돌려준다 —
            // 부르는 쪽(데몬)이 blocked 를 보고 예산을 닫아야(markBlocked) 다음 호출이
            // 쿠팡을 또 때리지 않는다. 예외로 던지면 그 장부가 안 닫힌다.
            // 대신 blocked·사유·읽은 페이지 수를 결과에 그대로 실어 성공으로 읽히지 않게 한다.
            //
            // 차단이 아닌데 0건인 것은 다른 이야기다. 확장이 왜 비었는지까지 같이 준다 —
            // 「그 조건에 상품이 없다」와 「있는데 못 읽었다」는 다른 사건이라 다르게 다룬다.
            //   · unreadable   = 페이지엔 상품이 있는데 못 읽었다 → 실패로 던진다(성공처럼 보이는 실패 금지)
            //   · no-match / rocket-filtered = 정상 200 인데 그 조건에 상품이 없다 → 결과로 돌려준다
            // 후자를 실패나 차단으로 올리면 안 된다. 2026-09-19 에 카테고리 번호를 잘못 친 조회가
            // 정상 200(본문 223KB·상품 0개·챌린지 마커 없음)으로 돌아왔는데 이걸 차단으로 읽어
            // 쿠팡 예산을 83분 닫았고, 그동안 셀러가 자기 크롬에서도 쿠팡 검색을 못 했다.
            // 사유가 아예 없으면(옛 확장) 판단 근거가 없으니 예전처럼 실패로 본다.
            if (!blocked && !products.length && (!emptyKind || emptyKind === 'unreadable')) {
                throw new Error(emptyReason || `카테고리 ${request.categoryId} 에서 상품을 한 건도 찾지 못했습니다. 카테고리 번호와 가격 조건을 확인해주세요.`);
            }
            // 여기까지 왔는데 0건이면 「없다」가 확인된 것이다. 조용한 성공으로 만들지 않고 사유를 실어 올린다.
            const isEmpty = !blocked && !products.length;

            return {
                categoryId: request.categoryId,
                sorter: request.sorter,
                minPrice: request.minPrice,
                maxPrice: request.maxPrice,
                rocketOnly: request.rocketOnly,
                pagesAsked: request.pages,
                pagesRead,
                total: products.length,
                duplicatesRemoved: raw.length - products.length,
                // 일부만 읽고 막힌 경우 — 건진 것은 주되, 막혔다는 사실을 그대로 올린다.
                blocked,
                blockedReason: blocked ? blockedReason : null,
                // 차단이 아닌 0건. 부르는 쪽이 이걸 차단으로 읽어 예산을 닫으면 안 된다.
                empty: isEmpty,
                emptyReason: isEmpty ? emptyReason : null,
                products,
                message: blocked
                    ? `${blockedReason} ${pagesRead}페이지까지만 읽어 ${products.length}건을 가져왔습니다. 한두 시간 뒤에 다시 시도해주세요 — 바로 다시 시도하면 쿠팡 검색이 더 오래 막힙니다.`
                    : isEmpty
                        ? `카테고리 ${request.categoryId} 에서 상품을 찾지 못했습니다. ${emptyReason} (쿠팡이 막은 것은 아닙니다)`
                        : `카테고리 ${request.categoryId} 에서 ${pagesRead}페이지를 읽어 ${products.length}건을 가져왔습니다.`
            };
        },

        // ───────────────────────────────────────────────────────────────
        // 카테고리 트리 가져오기 — 쿠팡 홈 카테고리 메뉴를 통째로 한 번 긁는다
        //
        // 셀러는 번호가 아니라 말로 카테고리를 찾는다. 그 말을 번호로 바꾸려면 트리가 있어야
        // 하는데, 트리는 브라우저 밖에서는 안 읽힌다 — 확장이 쿠팡 탭 안에서 읽고 이 화면이
        // 다리 역할을 한다. 한 번 긁으면 로컬 에이전트가 캐시하므로 자주 불리지 않는다.
        // ───────────────────────────────────────────────────────────────
        async cliPageFindCategory(params, onProgress) {
            if (this.cliPage.findCategoryBusy || this.cliPage.categoryBusy) {
                throw new Error('쿠팡 조회가 이미 진행 중입니다. 끝난 뒤에 다시 요청해주세요. 동시에 읽으면 쿠팡이 한동안 조회를 막습니다.');
            }
            this.cliPage.findCategoryBusy = true;
            try {
                const done = await this.cliPageCollectCategoryTree(onProgress);
                return this.cliPageCategoryTreeResult(done);
            } finally {
                this.cliPage.findCategoryBusy = false;
            }
        },

        // 세팅 점검(rocket.sourcing.checkSetup) — 상품추가·작업개시는 확장이 서플라이어허브 탭 안에서 돈다.
        // 그 탭이 열려 있는지·로그인 화면인지 확장에 묻는다(탭을 열거나 쿠팡을 부르지 않는다).
        // 답이 없으면(옛 확장·확장 꺼짐) 'unknown' — 없다고 단정하지 않는다.
        // 이 탭을 크롬 자동 버림에서 뺀다(on)/되돌린다(off) — 확장이 보낸 탭만 바꾼다.
        // 옛 확장은 답이 없다: 막지 않고 경고 한 줄만 남긴다(작업은 그대로 돈다).
        keepTabAlive(on) {
            const requestId = `keeptab_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
            let timer = null;
            const handler = (event) => {
                const data = event && event.data;
                if (event.source !== window || !data || data.res !== 'keepTabAliveResult' || data.requestId !== requestId) return;
                window.removeEventListener('message', handler);
                clearTimeout(timer);
                if (!data.ok) console.error(`[AIRocketReg] 탭 자동 버림 ${on ? '제외' : '되돌림'} 실패: ${data.error || '알 수 없음'}`);
            };
            window.addEventListener('message', handler);
            timer = setTimeout(() => {
                window.removeEventListener('message', handler);
                console.warn(`[AIRocketReg] 탭 자동 버림 ${on ? '제외' : '되돌림'} — 확장 응답 없음(옛 확장일 수 있음 · 작업은 계속)`);
            }, CLI_PAGE_TAB_CHECK_MS);
            window.postMessage({ greeting: 'keepTabAlive', on: !!on, requestId }, window.location.origin);
        },

        // 세팅 점검 — 서플라이어허브 탭과 이 화면의 쿠플러스 로그인을 같이 본다.
        // CLI 세션이 살아 있어도 화면 로그인이 풀리면 대기열이 0건으로 끝난다(PR261021-62ACE5) — 옛 서버는 couplusSession 을 모른다(무시)
        async cliPageCheckSetup() {
            const [tab, couplusSession] = await Promise.all([this.cliPageCheckSupplierTab(), this.readScreenLoginStatus()]);
            return { ...tab, couplusSession };
        },

        cliPageCheckSupplierTab() {
            return new Promise((resolve) => {
                const requestId = `suptab_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
                let timer = null;
                const finish = (supplierTab) => {
                    window.removeEventListener('message', handler);
                    clearTimeout(timer);
                    resolve({ supplierTab });
                };
                const handler = (event) => {
                    const data = event && event.data;
                    if (event.source !== window || !data || data.res !== 'supplierTabStatus' || data.requestId !== requestId) return;
                    // 탭이 로그인 화면이면 작업개시가 판매자코드를 못 읽는다 — 옛 확장은 loggedOut 을 안 보낸다(ok 로 둔다)
                    if (data.open === true) finish(data.loggedOut === true ? 'loggedOut' : 'ok');
                    else finish(data.open === false ? 'missing' : 'unknown');
                };
                window.addEventListener('message', handler);
                timer = setTimeout(() => {
                    console.error('[AIRocketReg] 서플라이어허브 탭 확인 — 확장 응답 없음(모름으로 둔다)');
                    finish('unknown');
                }, CLI_PAGE_TAB_CHECK_MS);
                window.postMessage({ greeting: 'checkSupplierTab', requestId }, window.location.origin);
            });
        },

        // 확장에 요청을 던지고 COLLECT_CATEGORY_TREE_DONE 을 기다린다.
        // 기다리는 규칙은 카테고리 수집과 같다 — 같은 확장, 같은 탭이다.
        cliPageCollectCategoryTree(onProgress) {
            return new Promise((resolve, reject) => {
                const requestId = `cattree_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
                let settled = false;
                let answered = false;
                let lastBeatAt = Date.now();
                let timer = null;

                const finish = (err, value) => {
                    if (settled) return;
                    settled = true;
                    window.removeEventListener('message', handler);
                    this.cliPageClearWait(timer);
                    if (err) reject(err); else resolve(value);
                };

                const handler = (event) => {
                    const data = event && event.data;
                    if (!data || data.requestId !== requestId) return;

                    if (data.response === 'COLLECT_CATEGORY_TREE_PROGRESS') {
                        answered = true;
                        lastBeatAt = Date.now();
                        onProgress({ current: Number(data.current) || 0, total: 1, message: data.message || '쿠팡 카테고리 목록을 가져옵니다.' });
                        return;
                    }

                    if (data.response === 'COLLECT_CATEGORY_TREE_DONE') {
                        answered = true;
                        finish(null, data);
                    }
                };

                window.addEventListener('message', handler);

                timer = setInterval(() => {
                    const idle = Date.now() - lastBeatAt;
                    if (idle < (answered ? CATEGORY_SEARCH_IDLE_MS : CATEGORY_SEARCH_FIRST_MS)) return;
                    console.error(`[AIRocketReg] 카테고리 목록 응답이 ${Math.round(idle / 1000)}초째 없습니다 (${requestId}).`);
                    finish(new Error(answered
                        ? '카테고리 목록을 가져오는 도중 쿠플러스 확장 프로그램이 응답을 멈췄습니다. 화면을 새로고침한 뒤 다시 시도해주세요.'
                        : EXT_NO_ANSWER));
                }, CATEGORY_SEARCH_TICK_MS);
                this.cliPageTrackWait(timer, (e) => {
                    if (settled) return;
                    settled = true;
                    window.removeEventListener('message', handler);
                    reject(e);
                });

                window.postMessage({ joke: 'collectCategoryTree', requestId }, '*');
                onProgress({ current: 0, total: 1, message: '쿠팡 카테고리 목록을 가져옵니다.' });
            });
        },

        // 확장이 준 결과를 정리한다. 세 가지를 **서로 다른 사건으로** 갈라 올린다.
        //   · blocked      = 쿠팡이 막았다 → 결과로 돌려준다. 부르는 쪽이 이걸 보고 예산을 닫아야
        //                    다음 호출이 또 때리지 않는다. 예외로 던지면 그 장부가 안 닫힌다
        //   · failedReason = 우리가 못 읽었다(쿠팡이 목록 형식을 바꿈) → 실패. 차단이 아니다
        //   · 0건          = 조용한 성공으로 만들지 않는다. 쿠팡 카테고리는 비어 있을 수가 없다
        cliPageCategoryTreeResult(data) {
            if (data.blocked) {
                return {
                    rows: [],
                    total: 0,
                    blocked: true,
                    blockedReason: data.blockedReason || '쿠팡이 자동 수집으로 보고 요청을 막았습니다.',
                    message: `${data.blockedReason || '쿠팡이 요청을 막았습니다.'} 한두 시간 뒤에 다시 시도해주세요.`
                };
            }
            if (data.failedReason) throw new Error(data.failedReason);

            const rows = Array.isArray(data.rows) ? data.rows.filter(r => r && r.categoryId && r.name) : [];
            if (!rows.length) {
                throw new Error('쿠팡에서 카테고리 목록을 한 건도 읽지 못했습니다. 잠시 뒤에 다시 시도해주세요.');
            }
            return {
                rows,
                total: rows.length,
                blocked: false,
                blockedReason: null,
                message: `쿠팡 카테고리 ${rows.length}개를 가져왔습니다.`
            };
        },

        // CLI 대기열은 쿠플러스 계정(companyid)별 파일이다 — 이 화면 회사의 대기열을 읽고 고친다(옛 CLI 는 이 값을 무시한다)
        cliQueueCompany() {
            return (this.$store.state.user && this.$store.state.user.companyid) || null;
        },

        // CLI 대기열에서 처리 완료/삭제된 항목 제거
        // 항목을 읽어 온 회사(없으면 지금 화면 회사) — 읽은 뒤 계정을 바꿔도 그 회사 대기열 파일을 고치게
        cliQueueCompanyOf(queueId) {
            const byId = this._cliQueueCompanyById || {};
            return Object.prototype.hasOwnProperty.call(byId, queueId) ? byId[queueId] : this.cliQueueCompany();
        },

        async syncRemoveFromCliQueue(queueIds) {
            if (!CLI_DAEMON_ENABLED) return;
            const byCompany = new Map();
            (queueIds || []).forEach(id => {
                const c = this.cliQueueCompanyOf(id);
                if (!byCompany.has(c)) byCompany.set(c, []);
                byCompany.get(c).push(id);
            });
            for (const [companyid, ids] of byCompany) {
                try {
                    await axios.post(cliDaemonUrl('/api/cli/registration/remove'), { queueIds: ids, companyid });
                    if (this._cliQueueCompanyById) ids.forEach(id => { delete this._cliQueueCompanyById[id]; });
                } catch (e) {
                    // CLI 서버 꺼져있으면 무시 (로컬 추가 항목은 CLI에 없으므로)
                }
            }
        },

        // CLI 대기열 항목에 실패 사실을 남긴다 (빼지는 않는다)
        async syncFailToCliQueue(queueId, reason) {
            if (!queueId || !CLI_DAEMON_ENABLED) return;
            try {
                await axios.post(cliDaemonUrl('/api/cli/registration/fail'), { queueId, reason, companyid: this.cliQueueCompanyOf(queueId) });
            } catch (e) {
                // CLI 서버 꺼져있으면 무시 (화면에서 직접 추가한 항목은 CLI 파일에 없다)
            }
        },

        // 선택된 대기열 항목 일괄 삭제
        removeSelectedQueueItems() {
            const ids = this.queueSelectedItems.map(q => q._queueId);
            this.productQueue = this.productQueue.filter(q => !ids.includes(q._queueId));
            this.syncRemoveFromCliQueue(ids);
            this.queueSelectedItems = [];
        },

        // 대기열 모달: 상품 추가 (카테고리 선택 → 행 추가)
        addQueueItem() {
            this.queueAddMode = true;
            this.queueAddLoading = true; // 카테고리 조회 완료/실패 시 해제
            this.$refs.categorySelect.open();
        },

        // 카테고리 조회 응답이 왔다(성공·실패) — 로딩 표시를 푼다
        handleCategoryResponded() {
            this.extensionRequestPending = false;
            this.showspinner1 = false;
            this.queueAddLoading = false;
        },

        // 카테고리를 골랐다(CategorySelectModal) — 대기열 행 추가, 아니면 상품 추가 모달
        handleCategorySelected({ categoryCode, categoryPath, categoryPathString }) {
            this.newProduct.categoryCode = categoryCode;
            this.newProduct.categoryPath = categoryPath;
            this.newProduct.categoryPathString = categoryPathString;

            // 대기열 모드: 행 추가 후 대기열 모달로 복귀
            if (this.queueAddMode) {
                this.productQueue.push({
                    _queueId: Date.now() + '_' + Math.random().toString(36).substr(2, 5),
                    categoryCode: this.newProduct.categoryCode,
                    categoryPath: this.newProduct.categoryPath,
                    categoryPathString: categoryPathString,
                    link: '',
                    productFeature: '',
                    keyword: ''
                });
                this.queueAddMode = false;
                return;
            }

            // 기존 흐름: 상품 추가 모달 열기
            this.actionAddProduct();
        },

        // 대기열 모달: 행 복사
        duplicateQueueItem(item) {
            const copy = {
                ...item,
                _queueId: Date.now() + '_' + Math.random().toString(36).substr(2, 5),
                // 복사본은 CLI 파일에 없다. 표식을 물려받으면 "파일에서 빠진 CLI 행"으로 보여 다음 로드 때 지워진다.
                _fromCli: false,
                // 실패 이력은 복사본이 물려받지 않는다. 물려받으면 새 행이 실패한 적도 없이
                // 빨갛게 뜨고, _error 때문에 처리에서 통째로 건너뛰어진다.
                _error: undefined,
                failCount: 0,
                lastError: '',
                lastFailedAt: ''
            };
            const idx = this.productQueue.findIndex(q => q._queueId === item._queueId);
            this.productQueue.splice(idx + 1, 0, copy);
        },

        // 대기열 모달: 행 삭제 (개별)
        removeQueueItem(item) {
            this.productQueue = this.productQueue.filter(q => q._queueId !== item._queueId);
            this.syncRemoveFromCliQueue([item._queueId]);
        },

        // 대기열 시작 전 로그인 확인 — 「전체 시작」 버튼과 rocket.sourcing.startQueue 가 같이 쓴다.
        // 로그인 확인은 화면이 처음 열릴 때 쓰는 것(/api/loginstatus)을 그대로 쓴다. 확인 자체가 실패하면 그대로 진행.
        async checkLoginBeforeQueue() {
            if ((await this.readScreenLoginStatus()) === 'loggedOut') {
                this.$bvModal.msgBoxOk(LOGIN_EXPIRED_MESSAGE, { title: '로그인이 필요합니다', okVariant: 'danger', centered: true });
                return false;
            }
            return true;
        },

        // 이 화면의 쿠플러스 로그인 — 'ok' | 'loggedOut' | 'unknown'(확인 실패). 읽기만 한다(대기열 시작 전·세팅 점검이 같이 쓴다)
        async readScreenLoginStatus() {
            try {
                const login = await axios.post('/api/loginstatus');
                return login.data && login.data.loginstatus === '로그인 해주세요' ? 'loggedOut' : 'ok';
            } catch (e) {
                console.error('[AIRocketReg] 로그인 상태 확인 실패(모름으로 둔다):', e);
                return 'unknown';
            }
        },

        // 대기열: 순차 실행 시작 (선택 항목 or 전체)
        startQueueProcessing(opts = {}) {
            this.queueWorkProgress = null;
            // 선택된 항목이 있으면 선택만, 없으면 전체
            const targetItems = this.queueSelectedItems.length > 0
                ? this.queueSelectedItems
                : this.productQueue;

            // 유효한 항목만 (링크+키워드 있는 것)
            const validItems = targetItems.filter(q => q.link && q.keyword);
            if (validItems.length === 0) {
                this.$bvToast.toast('1688 링크와 키워드가 입력된 상품이 없습니다.', {
                    title: '알림', variant: 'warning', solid: true, toaster: 'b-toaster-bottom-right'
                });
                return;
            }
            // 다른 탭이 같은 대기열을 돌고 있으면 시작하지 않는다(버튼·도구 공통) — 같은 상품이 두 번 만들어진다
            const otherRun = this.otherTabQueueRun();
            if (otherRun) {
                this.showNonBlockingNotice(this.otherTabQueueRunMessage(otherRun), '대기열 시작 안 함');
                return;
            }
            // 화면을 자정 전에 열어 두면 조회 기간이 어제에 머문다 — 이번 회차에 만들 상품이 목록에서 빠지지 않게 오늘까지 늘린다
            this.ensureListRangeIncludesToday();

            // 새 회차는 지난 회차에 실패한 항목도 다시 시도한다. _error 는 **이번 회차 안에서**
            // 같은 항목을 또 집지 않게 하는 표식인데, 회차가 바뀌어도 남아 있어서 실패 항목이
            // 화면을 새로고침하기 전까지 영원히 건너뛰어졌다(run 4·19 — 「다음에 다시 시도됩니다」와 달랐다).
            // 실패 이력(failCount·lastError)은 그대로 둔다.
            validItems.forEach(q => { if (q._error) this.$set(q, '_error', undefined); });

            // 선택 모드: 선택 안 된 항목은 대기열에서 임시 제외 (처리 대상만 남김)
            if (this.queueSelectedItems.length > 0) {
                const selectedIds = new Set(validItems.map(q => q._queueId));
                this._queueExcluded = this.productQueue.filter(q => !selectedIds.has(q._queueId));
                this.productQueue = validItems;
            } else {
                this._queueExcluded = [];
            }

            this.queueProcessing = true;
            this.queueProgress = { current: 0, total: validItems.length };
            // skipInitialProcessing 은 항목마다 다시 정한다(processNextQueueItem) — 여기서 한 번에
            // 정하면 단계가 섞인 대기열에서 1단계 항목과 2단계 항목이 같은 취급을 받는다.
            // 이번 회차에 무엇을 어느 단계로 만들었는지. 뒤 단계(작업개시·등록전송)의 대상이 된다.
            this._queueCreated = [];
            // 이번 회차에 **실제로 쿠팡으로 나간 것**과, 나가지 못하게 막은 이유. 되돌릴 수 없는
            // 사실이라 회차 기록에 남겨야 응답이 "전송 안 했다"고 말하는 일이 없다.
            this._queueSubmitted = [];
            // 그중 쿠팡 접수(registered)까지 확인된 것 — 결과의 «보낸 수»는 이것만 센다(O7)
            this._queueSubmitConfirmed = [];
            this._queueSubmitBlocked = '';
            // 이번 회차 작업개시에서 끝나지 못한 상품(실패·남은 작업). 「작업개시까지 끝났다」의 근거다.
            this._queueWorkFailed = [];
            this.queueSelectedItems = [];
            // 한 번에 한 건만 돈다는 표식. 이걸 안 두면 예약이 두 갈래로 겹칠 때
            // 아직 대기열에 남아 있는 같은 항목을 또 집어서 같은 상품이 두 번 만들어진다.
            this._queueBusy = false;
            // 이번 회차의 실패 기록. 행이 사라져도 실패는 여기 남아 결과에 실린다.
            this._queueFailures = [];
            this._queueStoppedForLogin = false;
            this._queueStoppedForCap = false;
            // 다른 탭이 이어받아 멈추는 중이면 그 이유(superseded 때 채운다). 비어 있으면 평소대로 돈다.
            this._queueAbortReason = '';
            // 에이전트(rocket.sourcing.startQueue)가 시킨 회차인지 — 다른 탭이 이어받으면 이것만 멈춘다(사람이 누른 회차는 그대로 끝까지)
            this._queueStartedByAgent = opts.byAgent === true;
            this.markQueueRun(true);
            this.$bvModal.hide('productQueueModal');
            this.processNextQueueItem();
        },

        // 다른 탭이 명령권을 가져갔다 — 지금 건은 마치고 다음 상품 사이에서 멈춘다(processNextQueueItem 첫머리).
        // 남은 항목은 실패로 남기지 않는다: 대기열 파일에 그대로 있어 이어받은 탭이 이어서 돈다.
        stopQueueForTakeover() {
            if (this._queueAbortReason) return;
            this._queueAbortReason = '다른 탭이 이어받음';
            console.error(`[Queue] 다른 탭이 이어받아 대기열을 멈춥니다 — 지금까지 ${(this._queueCreated || []).length}건 만듦, 저장 중인 건은 마칩니다.`);
            this.showNonBlockingNotice('다른 탭에서 로켓등록 화면이 이어받아, 이 탭의 대기열은 지금 상품까지만 하고 멈춥니다.', '대기열 멈춤');
        },

        // 멈추는 중인 대기열이 실제로 끝날 때까지 기다린다(최대 ms). 끝났으면 true.
        waitQueueStopped(ms) {
            if (!this.queueProcessing) return Promise.resolve(true);
            return new Promise(resolve => {
                let unwatch = null;
                const timer = setTimeout(() => { if (unwatch) unwatch(); resolve(false); }, ms);
                unwatch = this.$watch('queueProcessing', v => {
                    if (v) return;
                    clearTimeout(timer);
                    unwatch();
                    resolve(true);
                });
            });
        },

        // 조회 기간이 오늘을 포함하게 늘린다(시작일은 그대로 둔다 — 어제 것도 계속 보인다). 바꿨으면 true.
        ensureListRangeIncludesToday() {
            const { startdate, enddate, changed } = listRangeIncludingToday(this.startdate, this.enddate, this.getTodaywith());
            this.startdate = startdate;
            this.enddate = enddate;
            if (changed) console.log(`[Queue] 조회 기간을 오늘까지 늘렸습니다: ${this.startdate} ~ ${this.enddate}`);
            return changed;
        },

        // ── 탭 사이 대기열 표식 ──
        // 대기열 진행 상태는 그 탭 메모리에만 있고 대기열 파일은 탭들이 같이 쓴다. 다른 탭이 돌고 있는지 알 길이
        // 같은 브라우저의 저장소뿐이라 여기에 「어느 탭이 언제까지 돌고 있었나」를 남긴다(오래되면 무시).
        queueRunTabId() {
            if (!this._queueTabId) this._queueTabId = `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 8)}`;
            return this._queueTabId;
        },

        markQueueRun(on) {
            if (this._queueRunBeat) { clearInterval(this._queueRunBeat); this._queueRunBeat = null; }
            const write = () => {
                try {
                    const p = this.queueProgress || {};
                    localStorage.setItem(QUEUE_RUN_KEY, JSON.stringify({ tab: this.queueRunTabId(), at: Date.now(), current: p.current || 0, total: p.total || 0 }));
                } catch (e) {
                    console.error('[Queue] 탭 사이 대기열 표식 저장 실패:', e.message);
                }
            };
            if (on) {
                write();
                this._queueRunBeat = setInterval(() => {
                    if (!this.queueProcessing) { this.markQueueRun(false); return; }
                    write();
                }, QUEUE_RUN_BEAT_MS);
                return;
            }
            try {
                const cur = JSON.parse(localStorage.getItem(QUEUE_RUN_KEY) || 'null');
                if (cur && cur.tab === this.queueRunTabId()) localStorage.removeItem(QUEUE_RUN_KEY);
            } catch (e) {
                console.error('[Queue] 탭 사이 대기열 표식 정리 실패:', e.message);
            }
        },

        // 다른 탭이 지금 대기열을 돌고 있으면 그 표식, 아니면 null
        otherTabQueueRun() {
            try {
                const cur = JSON.parse(localStorage.getItem(QUEUE_RUN_KEY) || 'null');
                if (!cur || cur.tab === this.queueRunTabId()) return null;
                return Date.now() - Number(cur.at || 0) <= QUEUE_RUN_STALE_MS ? cur : null;
            } catch (e) {
                console.error('[Queue] 탭 사이 대기열 표식 읽기 실패:', e.message);
                return null;
            }
        },

        // 이 탭의 대기열이 아직 돌고 있을 때(앞 job 이 타임아웃으로 끝났어도 화면은 계속 돈다) — 어디까지 왔는지와 다음 할 일을 같이 말한다
        sameTabQueueBusyMessage() {
            const p = this.queueProgress || {};
            const work = this.queueWorkProgress;
            const parts = [];
            if (p.total) parts.push(`현재 ${p.current || 0}/${p.total}`);
            if (work) parts.push(this.queueWorkMessage(work));
            const where = parts.length ? `(${parts.join(' · ')})` : '';
            return `앞 대기열이 아직 돌고 있습니다${where}. common.sourcing.getJob(이전 jobId)·rocket.sourcing.listRegistrations 로 된 것을 확인하고 끝난 뒤 남은 것만 다시 시작하세요. 진행이 오래 안 바뀌면 사람에게 로켓등록 화면 새로고침을 부탁하세요.`;
        },

        otherTabQueueRunMessage(run) {
            const where = run.total ? ` (${run.current}/${run.total})` : '';
            return `다른 탭의 로켓등록 화면이 아직 대기열을 돌고 있습니다${where}. 그 탭이 멈춘 뒤 다시 시작하세요 — 지금 시작하면 같은 상품이 두 번 만들어집니다. rocket.sourcing.getQueue 로 남은 항목을 확인한 뒤 1~2분 뒤 다시 부르세요.`;
        },

        // 대기열 한 건의 실패를 남긴다. 행에도 표시하고 회차 기록에도 넣는다 —
        // 행만 쓰면 그 행이 대기열에서 빠지는 순간 실패가 통째로 사라진다.
        recordQueueFailure(item, reason) {
            const text = reason || '알 수 없는 이유로 실패했습니다.';
            const failCount = (Number(item && item.failCount) || 0) + 1;
            if (item) {
                this.$set(item, '_error', text);
                this.$set(item, 'failCount', failCount);
                this.$set(item, 'lastError', text);
                this.$set(item, 'lastFailedAt', new Date().toISOString());
            }
            if (!Array.isArray(this._queueFailures)) this._queueFailures = [];
            const queueId = item ? item._queueId : this._currentQueueId;
            const keyword = (item && item.keyword) || '';
            if (!this._queueFailures.some(f => f._queueId === queueId)) {
                this._queueFailures.push({ _queueId: queueId, keyword: keyword, reason: text, failCount: failCount });
            }
            // 실패했다고 대기열에서 빼지는 않는다 — 없는 상품번호인지 잠깐 끊긴 것인지 여기서는 모른다.
            // 대신 실패 사실을 파일에 남겨서 다음에 읽는 쪽이 보고 정하게 한다.
            this.syncFailToCliQueue(queueId, text);
            console.error(`[Queue] 대기열 항목 실패 (${keyword || queueId}) ${failCount}번째: ${text}`);
        },

        // 쿠플러스 로그인이 풀려 대기열을 멈춘다. 남은 건은 요청을 보내지 않고 이번 회차에서만 건너뛴다 —
        // 상품 탓이 아니므로 실패 횟수(failCount)·CLI 실패 기록은 올리지 않는다(_error 는 다음 회차 시작 때 지워진다).
        // 안내는 한 번만 크게 띄운다. 마무리(queueProcessing 끄기·제외 항목 복원)는 평소 끝나는 길을 탄다.
        stopQueueForLoginExpired() {
            console.error('[Queue] 쿠플러스 로그인이 풀려 대기열을 멈춥니다.');
            this.queueAutoMode = false;
            this._queueStoppedForLogin = true;
            if (!Array.isArray(this._queueFailures)) this._queueFailures = [];
            (this.productQueue || [])
                .filter(q => q.link && q.keyword && !q._error)
                .forEach(q => {
                    this.$set(q, '_error', LOGIN_EXPIRED_MESSAGE);
                    this._queueFailures.push({ _queueId: q._queueId, keyword: q.keyword || '', reason: LOGIN_EXPIRED_MESSAGE, failCount: Number(q.failCount) || 0 });
                });
            this._queueBusy = false;
            this.$bvModal.msgBoxOk(LOGIN_EXPIRED_MESSAGE, { title: '로그인이 필요합니다', okVariant: 'danger', centered: true });
            this.processNextQueueItem();
        },

        // 오늘(KST) 남은 등록 칸 — 서버 saveItems·도구 readSlot(tool-exec/rocket-setup.js)과 같은 셈: 분리 조각(«_») 뺌.
        // { maxSlot, used, left } · 칸 값이 없거나 0 이면 left 0 · 목록을 못 읽었으면 null(막지 않는다).
        async queueSlotLeft() {
            const maxSlot = Number(this.$store.state.user.rocketRegSlot) || 0;
            if (!Number.isFinite(maxSlot) || maxSlot <= 0) return { maxSlot: 0, used: null, left: 0 };
            const DAY = 24 * 60 * 60 * 1000, KST = 9 * 60 * 60 * 1000;
            const start = Math.floor((Date.now() + KST) / DAY) * DAY - KST;
            try {
                let used = 0;
                for (let offset = 0, more = true, i = 0; more && i < 10; i++) {
                    const res = await axios.post('/api/aiRocketReg/getlist', { start, end: start + DAY - 1, filter: {}, fields: ['registrationId'], sort: 'registrationId', limit: 200, offset });
                    const data = (res && res.data) || {};
                    if (data['요청결과'] !== 'ok') throw new Error(data.error || '등록 목록 조회 실패');
                    const rows = data.products || [];
                    used += rows.filter(r => r && r.registrationId && !String(r.registrationId).includes('_')).length;
                    offset += rows.length;
                    more = !!data.hasMore && rows.length > 0;
                }
                return { maxSlot, used, left: Math.max(maxSlot - used, 0) };
            } catch (e) {
                console.error('[Queue] 오늘 등록 칸을 세지 못했습니다:', e && e.message);
                return null;
            }
        },

        // 오늘 등록 칸을 다 써 대기열을 멈춘다. 남은 건은 요청을 보내지 않고 이번 회차에서만 건너뛴다 — 상품 탓이 아니므로
        // 실패 횟수(failCount)·CLI 실패 기록은 올리지 않는다(_error 는 다음 회차 시작 때 지워진다 · 대기열 파일엔 그대로).
        // 마무리(만든 상품의 뒤 단계·queueProcessing 끄기·제외 항목 복원)는 평소 끝나는 길을 탄다(stopQueueForLoginExpired 와 같은 꼴).
        stopQueueForDailyCap(maxSlot, used) {
            const message = maxSlot > 0
                ? `오늘 등록 한도(${maxSlot}개)를 다 써(오늘 ${used}개) 대기열을 멈췄습니다. 남은 상품은 대기열에 그대로 있어 내일 다시 시작하면 이어서 돕니다.`
                : '오늘 추가 가능한 상품 한도가 없어 대기열을 멈췄습니다. 이용 중인 요금제나 한도를 확인해주세요.';
            console.error(`[Queue] ${message}`);
            this.queueAutoMode = false;
            this._queueStoppedForCap = true;
            if (!Array.isArray(this._queueFailures)) this._queueFailures = [];
            (this.productQueue || [])
                .filter(q => q.link && q.keyword && !q._error)
                .forEach(q => {
                    this.$set(q, '_error', message);
                    this._queueFailures.push({ _queueId: q._queueId, keyword: q.keyword || '', reason: message, failCount: Number(q.failCount) || 0 });
                });
            this._queueBusy = false;
            this.showNonBlockingNotice(message, '오늘 등록 한도');
            this.processNextQueueItem();
        },

        // 확장 응답을 기다리던 중에 끊긴 경우. 실패를 남기고 다음 건으로 넘어간다.
        // 여기서 그냥 돌아가면 대기열이 그 자리에 멈춰 서고, 아무도 이유를 모른다.
        failCurrentQueueItem(reason) {
            if (!this.queueAutoMode) return false;
            this.queueAutoMode = false;
            this.extensionRequestPending = false;
            this.extensionRequestId = null;
            this.pendingProductData = null;
            const item = (this.productQueue || []).find(q => q._queueId === this._currentQueueId);
            this.recordQueueFailure(item, reason);
            this._queueBusy = false;
            setTimeout(() => this.processNextQueueItem(), 1000);
            return true;
        },

        // 대기열: 다음 건 처리
        async processNextQueueItem() {
            // 처리 중인 건이 끝나야 다음 건을 집는다. 처리 중인 항목은 끝날 때까지 대기열에
            // 그대로 남아 있어서, 겹쳐 들어오면 같은 항목을 또 집어 상품이 두 번 만들어진다.
            if (this._queueBusy) {
                console.error('[Queue] 이미 한 건을 처리하는 중이라 중복 호출을 무시합니다.');
                return;
            }
            // 다른 탭이 이어받았다 — 다음 건을 집지 않고, 작업개시·등록전송도 걸지 않고 여기서 끝낸다(안전한 자리).
            // 남은 항목은 대기열 파일에 그대로 있어 이어받은 탭이 돈다.
            if (this._queueAbortReason) {
                console.error(`[Queue] ${this._queueAbortReason} — 상품 ${(this._queueCreated || []).length}건까지 하고 대기열을 멈춥니다.`);
                this.skipInitialProcessing = false;
                this.queueWorkProgress = null;
                this.queueProcessing = false;
                if (this._queueExcluded && this._queueExcluded.length > 0) {
                    this.productQueue.push(...this._queueExcluded);
                    this._queueExcluded = [];
                }
                return;
            }
            // 유효한 항목 찾기
            const idx = this.productQueue.findIndex(q => q.link && q.keyword && !q._error);
            if (idx === -1) {
                // 상품추가 단계 완료
                this.skipInitialProcessing = false;
                // 로그인 풀림으로 멈췄으면 「완료」를 띄우지 않는다 — 안내 창이 이미 떠 있다.
                if (!this._queueStoppedForLogin && !this._queueStoppedForCap) {
                    this.$bvToast.toast(`대기열 상품추가 완료 (${this.queueProgress.current}/${this.queueProgress.total}건)`, {
                        title: '완료', variant: 'success', solid: true, toaster: 'b-toaster-bottom-right'
                    });
                }

                // 뒤 단계는 **그 단계를 시킨 항목이 만든 상품에만** 건다. 대기열 전체를 한 단계로
                // 묶으면 2단계로 넣은 항목까지 딸려가 시키지 않은 등록전송이 나간다.
                const createdByLevel = Array.isArray(this._queueCreated) ? this._queueCreated : [];

                // 스텝 3 이상: 작업개시 (큐 경로에선 등록전송은 아래 스텝 4 블록에서 별도 처리)
                const workIds = createdByLevel.filter(c => c.stepLevel >= 3).map(c => String(c.registrationId));
                if (workIds.length > 0) {
                    // 작업개시는 건당 보통 2~5분, 옵션 20개 넘으면 10~15분이다(2026-10-16 실측). 진행 보고가 「N/N 상품 추가 중」에 멈춰 있으면
                    // 부르는 쪽이 멈춘 줄 안다 — 몇 번째 상품을 도는지 남긴다(cliPageWaitForQueue 가 읽는다).
                    const work = await this.autoFullProcess({
                        skipVerify: true,
                        registrationIds: workIds,
                        // 다른 탭이 이어받으면 다음 상품으로 넘어가기 전에 멈춘다(돌던 상품은 마친다)
                        shouldStop: () => !!this._queueAbortReason,
                        onItem: (k, n, product) => {
                            const name = String(this.getDisplayProductName(product) || product.registrationId || '').slice(0, 20);
                            resetWorkProgress(product.registrationId);
                            this.queueWorkProgress = { k, n, name, registrationId: String(product.registrationId || '') };
                        }
                    });
                    this.queueWorkProgress = null;
                    const workFailed = (work && work.failed) || [];
                    // 시킨 상품이 다 돌았는지 등록ID로 맞춘다 — 목록에서 빠졌거나 도중에 멈춰 안 돈 상품을
                    // 조용히 넘기면 「작업 개시까지 끝났습니다」가 된다(PR261016-1B97C6: 5건 만들고 0건 돌았는데 done).
                    const touched = new Set(((work && work.processed) || []).concat(workFailed.map(f => String(f.registrationId))));
                    workIds.filter(id => !touched.has(id)).forEach(id => workFailed.push({
                        registrationId: id,
                        reason: this._queueAbortReason
                            ? `${this._queueAbortReason} — 이 탭은 작업개시를 여기서 멈췄습니다`
                            : (work && work.error ? `작업개시가 중간에 멈췄습니다: ${work.error}` : '작업개시 대상인데 돌지 않았습니다(화면 목록에서 찾지 못함)')
                    }));
                    if (workFailed.length) console.error(`[Queue] 작업개시 ${workIds.length}건 중 ${workFailed.length}건이 끝나지 않았습니다:`, workFailed.map(f => f.registrationId).join(', '));
                    this._queueWorkFailed = workFailed;
                }
                // 작업개시 도중 다른 탭이 이어받았으면 등록전송(되돌릴 수 없음)은 하지 않는다
                if (this._queueAbortReason) {
                    this.processNextQueueItem();
                    return;
                }
                // 스텝 4: 등록전송 — 이번 회차에 4단계로 들어온 항목이 만든 상품 중 완료된 것만.
                // 목록 전체에서 고르면 시키지 않은 상품까지 쿠팡으로 나간다 — 되돌릴 수 없다.
                const submitIds = new Set(createdByLevel.filter(c => c.stepLevel >= 4).map(c => String(c.registrationId)));
                if (submitIds.size > 0) {
                    // 아래 판정이 coupangDoc.jsonDocument 를 본다 — 목록용 문서면 먼저 완전 문서로 받는다
                    const fullOk = await this.ensureFullProducts(this.products.filter(p => submitIds.has(String(p.registrationId))));
                    const readyProducts = !fullOk ? [] : this.products.filter(p => {
                        if (!submitIds.has(String(p.registrationId))) return false;
                        const tasks = ['seoStatus', 'mainImageStatus', 'additionalImageStatus', 'detailImageStatus', 'koreanLabelStatus', 'quotationStatus'];
                        return tasks.every(t => p[t] === 'completed') && p.coupangDoc && p.coupangDoc.jsonDocument;
                    });

                    // 작업개시(견적서 상품분리)는 옵션을 갈라 **등록건을 새로 만든다** — 등록ID 뒤에
                    // _2 · _3 이 붙는다. 그 조각은 위 submitIds 에 없어서 원본만 나가고, 나머지 옵션은
                    // 쿠팡에 접수되지 않는다(2026-09-17 실측: 옵션 6개 중 3개만 접수).
                    // rocket.sourcing.submitRegistration 은 같은 상황을 보내기 전에 거절하는데 이 경로만 그냥
                    // 보내고 있었다 — 같은 전송이다. 되돌릴 수 없으니 여기서도 보내지 않고 알린다.
                    const familyBase = id => String(id).replace(/(?:_\d+)+$/, '');
                    const submitBases = new Set(Array.from(submitIds).map(familyBase));
                    const missingSiblings = this.products
                        .filter(p => {
                            const id = String(p.registrationId);
                            if (submitIds.has(id)) return false;
                            if (!submitBases.has(familyBase(id))) return false;
                            return !this.isSentToCoupang(p);   // 이미 보낸 조각은 다시 보낼 것이 아니다
                        })
                        .map(p => String(p.registrationId));

                    if (missingSiblings.length > 0) {
                        this._queueSubmitBlocked = `작업 개시 때 옵션이 여러 등록건으로 나뉘어 담겼습니다(${missingSiblings.join(', ')}). `
                            + '일부만 보내면 나머지 옵션은 쿠팡에 접수되지 않고 되돌릴 수 없어, 자동 등록 전송을 하지 않았습니다. '
                            + '나뉜 등록건을 함께 지정해 rocket.sourcing.submitRegistration 으로 보내주세요.';
                        console.error('[Queue] 나뉘어 담긴 등록건이 있어 등록 전송을 하지 않았습니다:', missingSiblings.join(', '));
                        this.$bvToast.toast(this._queueSubmitBlocked, {
                            title: '등록 전송 보류', variant: 'warning', solid: true, autoHideDelay: 10000, toaster: 'b-toaster-bottom-right'
                        });
                    } else if (!fullOk) {
                        this._queueSubmitBlocked = '상품 정보를 불러오지 못해 등록 전송을 하지 않았습니다. 잠시 뒤 다시 시도해주세요.';
                    } else if (readyProducts.length > 0) {
                        this.selectedItems = readyProducts;
                        // 전송을 시작했다는 사실을 먼저 남긴다. submitProductsToCoupang 는 확장에 요청만 던지고
                        // 돌아오므로, 여기서 안 남기면 "나갔는지"를 뒤에서 알 길이 없다.
                        this._queueSubmitted = readyProducts.map(p => String(p.registrationId));
                        const started = await this.submitProductsToCoupang({ registrationIds: this._queueSubmitted });
                        if (started && started.refused) {
                            this._queueSubmitted = [];
                            this._queueSubmitBlocked = `자동 등록 전송 실패 — ${started.refused}`;
                        } else {
                            // submitProductsToCoupang 는 첫 요청만 던지고 돌아온다 — 끝날 때까지 기다린 뒤
                            // 쿠팡이 받은 것(registered)만 «보냄»으로 센다. 안 기다리면 «보내려고 한 수»가 «보낸 수»로 나간다(O7)
                            try {
                                await this.cliPageWaitForSubmit(this._queueSubmitted.length, () => {});
                            } catch (e) {
                                console.error('[Queue] 등록 전송 끝을 기다리지 못했습니다:', e.message);
                            }
                            const byId = new Map((this.products || []).map(p => [String(p.registrationId), p]));
                            this._queueSubmitConfirmed = this._queueSubmitted.filter(id => byId.get(id) && byId.get(id).registered === true);
                        }
                    } else {
                        this._queueSubmitBlocked = '등록 전송할 수 있는 상품이 없습니다. 모든 작업이 완료되었는지 확인해주세요.';
                        this.$bvToast.toast(this._queueSubmitBlocked, {
                            title: '알림', variant: 'warning', solid: true, toaster: 'b-toaster-bottom-right'
                        });
                    }
                }

                this.queueProcessing = false;
                // 선택 모드에서 제외했던 항목 복원
                if (this._queueExcluded && this._queueExcluded.length > 0) {
                    this.productQueue.push(...this._queueExcluded);
                    this._queueExcluded = [];
                }
                return;
            }

            const item = this.productQueue[idx];
            this._queueBusy = true;
            // 오늘 등록 칸 — 항목마다 본다(PR261020-4B5BC8 · 칸 25 에 대기열 50 이 다 돌아 47 등록). 다 썼으면 남은 건은
            // 이번 회차에서 건너뛰고 평소 끝 길(만든 상품의 작업개시 등)을 탄다. 못 셌으면 막지 않는다(서버 saveItems 가 마지막 문)
            const slot = await this.queueSlotLeft();
            if (slot && slot.left <= 0) {
                this.stopQueueForDailyCap(slot.maxSlot, slot.used);
                return;
            }
            this.queueProgress.current++;
            // 이 항목이 시킨 단계만큼만 간다. 이 값이 이 건의 SEO+가격 실행 여부(1단계면 건너뜀)와
            // 대기열이 끝난 뒤 작업개시·등록전송 대상이 되는지를 함께 정한다.
            this._currentQueueStepLevel = this.queueItemStepLevel(item);
            this._currentQueueBundleQuantity = this.normalizeQueueBundleQuantity(item.bundleQuantity);
            this._currentQueueSellingPrice = this.normalizeQueueSellingPrice(item.targetSellingPrice);
            this._currentQueuePurchaseCost = this.normalizeQueuePurchaseCost(item.purchaseCost);
            this._currentQueueSupplyPrice = this.normalizeQueuePurchaseCost(item.supplyPrice);
            this._currentQueueKeepSkuIds = this.normalizeQueueKeepSkuIds(item.keepSkuIds);
            this._currentQueueStock = null;
            this._currentQueueBenchmarkVendorItemId = item.benchmarkVendorItemId || null;
            this.skipInitialProcessing = this._currentQueueStepLevel < 2;

            try {
                this.$bvToast.toast(`[${this.queueProgress.current}/${this.queueProgress.total}] "${item.keyword}" 상품 추가 중...`, {
                    title: '대기열', variant: 'info', solid: true, toaster: 'b-toaster-bottom-right'
                });

                // newProduct에 대기열 항목 세팅
                this.newProduct.link = item.link;
                this.newProduct.keyword = item.keyword;
                this.newProduct.productFeature = item.productFeature || '';
                this.newProduct.categoryCode = item.categoryCode;
                this.newProduct.categoryPath = item.categoryPath;
                this.newProduct.categoryPathString = item.categoryPathString;

                // 1688 상품정보 가져오기
                const productNo = item.link.slice(
                    item.link.search('offer/') + 6,
                    item.link.search('.html')
                );
                const res = await axios.post('/api/aiPage/getProductInfo', [{ productId: parseInt(productNo) }]);
                // 로그인이 풀렸으면 남은 건도 전부 같은 답이다 — 같은 요청을 반복하지 않고 여기서 멈춘다.
                if (res.data && (res.data.loginRequired || res.data.error === '로그인실패')) {
                    this.stopQueueForLoginExpired();
                    return;
                }
                // 서버가 이유를 실어 거절했으면(1688 응답 오류 등) 그 이유를 그대로 남긴다 — 상품번호 탓이 아니다.
                if (res.data && res.data['요청결과'] === '실패') {
                    const reason = res.data.reason || (typeof res.data.error === 'string' && res.data.error) || '';
                    if (reason) throw new Error(`1688에서 상품 정보를 가져오지 못했습니다 (${reason}). 잠시 뒤 다시 시도해주세요.`);
                }
                // 없는 상품번호면 여기서 빈 응답이 온다. 그대로 넘기면 아무 일도 안 일어난 채
                // 대기열이 그 자리에 멈춰 서고, 사용자는 몇 건이 빠졌는지 눈으로 찾아야 한다.
                const first = res.data && Array.isArray(res.data.result) ? res.data.result[0] : null;
                const data = first && first.result ? first.result.result : null;
                if (!data) {
                    throw new Error('1688에서 상품 정보를 가져오지 못했습니다. 상품번호가 맞는지 확인해주세요.');
                }
                // 남길 옵션 = 남길 목록(없으면 1688 옵션 전부) − 뺀 옵션 — 여기서 한 번 풀어 두면 상품의 sourcingSkuIds 표식이
                // 초기화·계열 나누기에서도 그 옵션만 지킨다(판 #443 ① 뺀 옵션은 그 상품에서 지운다).
                const resolved = resolveKeepSkuIds(data.productSkuInfos, this._currentQueueKeepSkuIds, this.normalizeQueueExcludedSkuIds(item.excludedSkus));
                if (resolved.missing.length) console.error('[AIRocketReg] 남길·뺀 옵션 중 1688 상품에 없는 번호:', resolved.missing);
                this._currentQueueKeepSkuIds = resolved.ids;
                // 남길 옵션이 하나도 없으면 쿠팡 쪽을 건드리기 전에 멈춘다(전부 등록하지 않는다).
                if (resolved.ids && !resolved.ids.length) {
                    throw new Error(KEEP_NONE_MESSAGE);
                }
                // 1688 실시간 재고 0 옵션은 뺀다 — 선택 옵션 재고만 보고 재고 0 옵션까지 올렸다(202E64).
                // 재고를 못 잰 옵션은 0 으로 세지 않고 남긴 채 결과(stockWarnings)에 따로 싣는다.
                const stock = dropSoldOutSkus(data.productSkuInfos, this._currentQueueKeepSkuIds);
                this._currentQueueKeepSkuIds = stock.ids;
                this._currentQueueStock = stock.soldOut.length || stock.unknown.length
                    ? { soldOutOptions: stock.soldOut, stockUnknownOptions: stock.unknown }
                    : null;
                if (stock.ids && !stock.ids.length) {
                    throw new Error(STOCK_NONE_MESSAGE);
                }

                // 상태 초기화 후 Extension 요청
                console.log(`[Q-DEBUG] processNextQueueItem ${this.queueProgress.current}/${this.queueProgress.total} — keyword: ${item.keyword}, extensionRequestPending: ${this.extensionRequestPending}, pendingProductData: ${!!this.pendingProductData}`);
                this.extensionRequestPending = false; // 이전 건의 잔여 상태 초기화
                this.pendingProductData = null; // 이전 건 데이터 초기화
                this.queueAutoMode = true;
                this._currentQueueId = item._queueId;
                const invalidCategory = this._cliInvalidCategories && item.categoryCode
                    ? this._cliInvalidCategories[String(item.categoryCode)]
                    : null;
                if (invalidCategory) throw new Error(invalidCategory);
                const serverInfo = this._cliRocketRegInfo && item.categoryCode
                    ? this._cliRocketRegInfo[String(item.categoryCode)]
                    : null;
                if (serverInfo) {
                    // 서버가 미리 받은 양식이 있으면 확장(서플라이어허브 탭)을 거치지 않는다 — 판매자코드 대조도 서버가 했다
                    this.answerProductInfoFromServer(data, serverInfo);
                } else {
                    // await 를 빼면 여기서 난 오류가 아무 데도 안 잡혀 조용히 사라진다.
                    await this.requestProductInfoFromExtension(data, item.keyword);
                }
                if (!this.extensionRequestPending) {
                    throw new Error('쿠팡 카테고리 정보를 요청하지 못했습니다. 잠시 뒤 다시 시도해주세요.');
                }

            } catch (error) {
                this.queueAutoMode = false;
                this.extensionRequestPending = false;
                this.pendingProductData = null;
                this.extensionRequestId = null;
                this.recordQueueFailure(item, error.message);
                this._queueBusy = false;
                // 실패해도 다음 건 진행
                setTimeout(() => this.processNextQueueItem(), 1000);
            }
        },

        // actionAddProduct 메서드 수정
        actionAddProduct() {
            // 브랜드명 처리 - 쉼표로 구분된 경우 첫 번째 브랜드만 사용
            const getFirstBrandName = (brandName) => {
                if (brandName && brandName.includes(',')) {
                    const firstBrand = brandName.split(',')[0].trim();
                    console.log('새 상품 추가 시 쉼표로 구분된 브랜드명에서 첫 번째 값만 사용:', firstBrand);
                    return firstBrand;
                }
                return brandName;
            };

            if (!this.newProduct) {

                this.newProduct = {
                    link: '',
                    keyword: '',
                    brand: getFirstBrandName(this.defaultSettings.brand),
                    categoryPath: '',
                    categoryCode: '',
                    categoryPathString: ''
                };
            } else {
                // 기존 카테고리 정보 유지
                const categoryPath = this.newProduct.categoryPath || '';
                const categoryCode = this.newProduct.categoryCode || '';
                const categoryPathString = this.newProduct.categoryPathString || '';

                // 브랜드명은 항상 첫 번째 값만 사용
                this.newProduct = {
                    link: '',
                    keyword: '',
                    brand: getFirstBrandName(this.defaultSettings.brand),
                    categoryPath: categoryPath,
                    categoryCode: categoryCode,
                    categoryPathString: categoryPathString
                };
            }

            this.selectdate = 'today';
            this.search();

            this.$bvModal.show('addProductModal');
        },

        // Enter 키로 추가 버튼 트리거
        triggerAddProduct() {
            // 모달의 OK 버튼 클릭 이벤트 트리거
            this.$bvModal.hide('addProductModal');
            this.$nextTick(() => {
                // 가짜 이벤트 객체 생성
                const fakeEvent = {
                    preventDefault: () => {}
                };
                this.handleAddProduct(fakeEvent);
            });
        },

        // 수정: handleAddProduct 메서드
        async handleAddProduct(bvModalEvent) {
            bvModalEvent.preventDefault();

            if (!this.newProduct.link) {
                this.linkError = '1688 상품 링크를 입력해주세요.';
                return;
            }

            if (!this.newProduct.keyword) {
                this.$bvToast.toast('타겟 키워드를 입력해주세요.', {
                    title: '알림',
                    variant: 'warning',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
                return;
            }

            try {
                // 로딩 표시
                this.$bvToast.toast('상품 정보를 가져오는 중입니다...', {
                    title: '진행 중',
                    variant: 'info',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });

                // 1688 상품정보 가져오기
                const productNo = this.newProduct.link.slice(
                    this.newProduct.link.search('offer/') + 6,
                    this.newProduct.link.search('.html')
                );
                console.log(productNo)

                const res = await axios.post('/api/aiPage/getProductInfo', [{ productId: parseInt(productNo) }]);
                if (res.data && res.data.loginRequired) throw new Error(LOGIN_EXPIRED_MESSAGE);
                const data = res.data.result[0].result.result;
                console.log(data)

                // 추가: 키워드를 기반으로 쿠팡 카테고리 및 상품등록필요정보 수집 시작
                this.requestProductInfoFromExtension(data, this.newProduct.keyword);

            } catch (error) {
                console.error('상품 추가 실패:', error);
                this.$bvToast.toast('상품 추가 중 오류가 발생했습니다. ' + error.message, {
                    title: '오류',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
            }
        },

        // 수정된 코드 - requestProductInfoFromExtension 메서드
        async requestProductInfoFromExtension(productData, keyword) {
            console.log(`[Q-DEBUG] requestProductInfoFromExtension 진입 — keyword: ${keyword}, extensionRequestPending: ${this.extensionRequestPending}, queueAutoMode: ${this.queueAutoMode}`);
            // 이미 요청 중인 경우 중복 요청 방지
            if (this.extensionRequestPending) {
                console.warn('[Q-DEBUG] ⛔ extensionRequestPending=true → 요청 스킵됨!');
                return;
            }

            // 옵션 정보 확인 - 옵션 유무와 관계없이 단일 요청으로 처리
            // 옵션이 있는 경우에도 첫 번째 옵션에 대해서만 요청을 보내고 나머지는 재사용
            this.pendingProductData = productData;
            this.extensionRequestPending = true;

            // 요청 ID 생성
            this.extensionRequestId = 'product_info_' + Date.now();

            // 로딩 메시지 업데이트
            this.loadingtext = '쿠팡 카테고리 및 상품 등록 정보 수집 중...';
            this.showspinner1 = true;

            // 확장 프로그램에 메시지 전송 - 상품 레벨에서 한 번만 요청
            const message = {
                type: 'GET_PRODUCT_INFO',
                id: this.extensionRequestId,
                data: {
                    keyword: keyword,
                    productName: productData.subject,
                    productNameTrans: productData.subjectTrans,
                    productFeature: this.newProduct.productFeature,
                    supplierCode: this.$store.state.user.suppliercode,
                    categoryCode: this.newProduct.categoryCode,
                    categoryPathString: this.newProduct.categoryPathString,
                    isOption: false // 옵션 아님 - 상품 레벨 요청
                }
            };

            // 옵션 정보가 있는 경우 로딩 메시지에 표시
            if (productData.productSkuInfos && productData.productSkuInfos.length > 0) {
                this.loadingtext = `쿠팡 카테고리 및 상품 등록 정보 수집 중... (옵션 ${productData.productSkuInfos.length}개)`;
            }

            console.log('상품 정보 요청 (통합):', message);
            window.postMessage(message, '*');
        },

        // 서버가 미리 받은 카테고리 양식으로 상품 정보 응답을 만든다(rocket.sourcing.startQueue 경로).
        // 확장 GET_PRODUCT_INFO 의 응답(PRODUCT_INFO_RESPONSE)과 같은 모양으로 같은 처리부에 넘긴다 —
        // 상품 만들기·대기열 다음 건 진행이 확장 경로와 갈라지지 않게.
        answerProductInfoFromServer(productData, serverInfo) {
            // 같은 카테고리 항목이 한 양식을 나눠 쓴다 — 확장처럼 건마다 새 객체로 넘긴다(처리부가 고쳐 써도 다음 건에 안 번지게)
            const rocketRegInfo = JSON.parse(JSON.stringify(serverInfo));
            this.pendingProductData = productData;
            this.extensionRequestPending = true;
            this.extensionRequestId = 'product_info_' + Date.now();
            const categoryPath = `${String(this.newProduct.categoryPathString || '').replace(/ /g, '')} (${this.newProduct.categoryCode})`;
            // 확장(getProductInfoFromCoupang)이 만들던 초기 문서 틀과 같다 — 문서 생성은 검증 단계에서 한다
            const createResult = {
                docId: null,
                productName: productData.subjectTrans,
                categoryPath: categoryPath,
                categoryId: rocketRegInfo.kanCategoryId,
                displayCategoryCode: this.newProduct.categoryCode,
                jsonDocument: [{ startPage: { productName: productData.subjectTrans, categoryPath: categoryPath } }],
                scope: rocketRegInfo.scopeType,
                productNoticeNumber: rocketRegInfo.noticeNumber,
                version: rocketRegInfo.version
            };
            this.handleExtensionMessage({
                data: {
                    type: 'PRODUCT_INFO_RESPONSE',
                    id: this.extensionRequestId,
                    data: { optionIndex: undefined },
                    rocketRegInfo: rocketRegInfo,
                    createResult: createResult
                }
            }).catch(e => console.error('[AIRocketReg] 서버 양식으로 상품 정보 처리 실패:', e));
        },

        // 상품 분리 완료 이벤트 핸들러
        handleProductSplitCompleted(event) {
            console.log('🔍 상품 분리 완료 이벤트 수신:', event.detail);

            try {
                const { originalProductId, splitProducts, totalProducts, message } = event.detail;

                // 원본 상품 인덱스 찾기
                const originalIndex = this.products.findIndex(p => p._id === originalProductId);

                if (originalIndex >= 0 && splitProducts && splitProducts.length > 0) {
                    console.log(`📊 상품 분리 처리: 원본 인덱스 ${originalIndex}, 분리된 상품 수 ${splitProducts.length}`);

                    // 원본 상품을 업데이트된 상품으로 교체
                    this.$set(this.products, originalIndex, splitProducts[0]);
                    console.log(`✅ 원본 상품 업데이트: ${splitProducts[0].registrationId}`);

                    // 새로 생성된 상품들을 원본 상품 바로 뒤에 추가
                    if (splitProducts.length > 1) {
                        const newProducts = splitProducts.slice(1); // 첫 번째는 원본이므로 제외

                        // 원본 상품 바로 뒤에 새 상품들 삽입
                        newProducts.reverse().forEach(newProduct => {
                            this.products.splice(originalIndex + 1, 0, newProduct);
                            console.log(`✅ 새 상품 추가: ${newProduct.registrationId}`);
                        });
                    }

                    // 성공 메시지 표시
                    this.$bvToast.toast(message || `상품이 ${totalProducts}개로 분리되었습니다.`, {
                        title: '상품 분리 완료',
                        variant: 'success',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });

                    console.log(`✅ 상품 분리 처리 완료: 총 ${this.products.length}개 상품`);
                } else {
                    console.warn('⚠️ 원본 상품을 찾을 수 없거나 분리된 상품 데이터가 없습니다.');
                }
            } catch (error) {
                console.error('❌ 상품 분리 이벤트 처리 중 오류:', error);

                // 오류 발생 시 검색으로 폴백
                this.search().then(() => {
                    console.log('✅ 폴백 검색 완료');
                }).catch(searchError => {
                    console.error('❌ 폴백 검색 실패:', searchError);
                });
            }
        },

        // errorDetails를 텍스트로 변환하는 헬퍼 함수
        convertErrorDetailsToText(errorDetails) {
            if (!errorDetails) return '';

            // 이미 문자열인 경우 그대로 반환
            if (typeof errorDetails === 'string') {
                return errorDetails;
            }

            // 객체나 배열인 경우 JSON 문자열로 변환
            try {
                return JSON.stringify(errorDetails, null, 2);
            } catch (e) {
                console.error('errorDetails 변환 중 오류:', e);
                return String(errorDetails);
            }
        },

        // 추가: 확장 프로그램 메시지 핸들러
        async handleExtensionMessage(event) {
            console.log(event.data);

            // 메시지 형식 확인
            if (!event.data || typeof event.data !== 'object') return;

            if (event.data.msg == 'CoupangRegAlert') {
                // 허브 재확인(읽기만) 중에 온 알림은 그쪽 기다림(requestHubInspection)이 받는다 — 전송·대기열이 안 도는 때만 돌므로 남의 것이 아니다
                if (this.hubRecheck.inFlight && !this.isVerifying && !this.rocketRegWorking) return;
                this.extensionRequestPending = false;
                this.extensionRequestId = null;
                this.showspinner1 = false;
                this.queueAddLoading = false;
                console.error('[AIRocketReg] 확장 알림:', event.data.res);
                if (this.isVerifying) this.logSubmitAbort('확장 알림', event.data.res);
                // 대기열 중이면 알림창으로 막아 세우지 않는다 — 실패로 남기고 다음 건으로 간다.
                if (!this.failCurrentQueueItem(event.data.res)) {
                    this.showNonBlockingNotice(event.data.res);
                }
                return;
            }


            // 수정된 PRODUCT_INFO_RESPONSE 처리 부분
            if (event.data.type === 'PRODUCT_INFO_RESPONSE') {
                // 응답 데이터 저장
                console.log('확장 프로그램 응답 수신:', event.data);

                // 요청 하나에 응답 하나만 받는다. 같은 응답이 두 번 들어오면 남아 있던
                // 직전 데이터로 상품이 한 번 더 만들어진다 — 등록전송까지 가면 쿠팡에 두 번 올라간다.
                if (!this.extensionRequestId) {
                    console.error('[AIRocketReg] 기다리고 있지 않은 상품정보 응답이라 무시합니다:', event.data.id);
                    return;
                }
                if (event.data.id && event.data.id !== this.extensionRequestId) {
                    console.error(`[AIRocketReg] 지난 요청의 상품정보 응답이라 무시합니다 (받은 ${event.data.id} / 기다린 ${this.extensionRequestId}).`);
                    return;
                }

                // 응답 데이터에 createResult가 있는지 확인
                if (!event.data.createResult) {
                    console.error('⚠️ 응답에 createResult가 없습니다!', event.data);
                    this.extensionRequestPending = false;
                    this.extensionRequestId = null;
                    this.showspinner1 = false;
                    // 대기열 중이면 알림창으로 막아 세우지 않는다 — 실패로 남기고 다음 건으로 간다.
                    if (!this.failCurrentQueueItem('쿠팡 상품등록 정보를 가져오지 못했습니다. 쿠팡 판매자센터 탭을 새로고침한 뒤 다시 시도해주세요.')) {
                        this.showNonBlockingNotice('쿠팡 판매자센터 탭을 새로고침한 뒤 다시 시도해주세요.');
                    }
                    return;
                } else {
                    console.log(`createResult.docId: ${event.data.createResult.docId}`);
                }

                if (!event.data.rocketRegInfo || !event.data.rocketRegInfo.schemaString) {
                    console.error('⚠️ 응답에 rocketRegInfo.schemaString이 없습니다!', event.data);
                    this.extensionRequestPending = false;
                    this.extensionRequestId = null;
                    this.showspinner1 = false;
                    if (!this.failCurrentQueueItem('쿠팡 카테고리 양식을 가져오지 못했습니다. 쿠팡 판매자센터 탭을 새로고침한 뒤 다시 시도해주세요.')) {
                        this.showNonBlockingNotice('쿠팡 판매자센터 탭을 새로고침한 뒤 다시 시도해주세요.');
                    }
                    return;
                }

                // 응답 데이터 저장
                this.extensionResponseData = event.data;

                // rocketRegInfo 저장
                if (event.data.rocketRegInfo) {
                    this.savedRocketRegInfo = event.data.rocketRegInfo;
                }

                // 이 응답은 여기서 소비한다. 들고 있으면 뒤에 같은 응답이 한 번 더 왔을 때
                // 같은 데이터로 상품이 또 만들어진다.
                const answeredProductData = this.pendingProductData;
                const answeredResetProduct = this.resetPendingProduct;
                this.extensionRequestId = null;
                this.pendingProductData = null;
                this.resetPendingProduct = null;

                // 초기화 모드인 경우: 기존 상품 업데이트
                if (answeredResetProduct && answeredProductData) {
                    this.updateProductWithResetData(answeredResetProduct, answeredProductData, this.extensionResponseData)
                        .then(() => {
                            this.extensionRequestPending = false;
                            this.showspinner1 = false;
                            this.resetPendingProduct = null;
                            this.pendingProductData = null;

                            this.$bvToast.toast('상품이 초기화되었습니다.', {
                                title: '초기화 완료',
                                variant: 'success',
                                solid: true,
                                toaster: 'b-toaster-bottom-right'
                            });

                            // 목록 새로고침
                            this.$nextTick(() => {
                                this.search();
                            });
                        })
                        .catch(error => {
                            console.error('상품 초기화 실패:', error);
                            this.$bvToast.toast('상품 초기화 중 오류가 발생했습니다: ' + error.message, {
                                title: '오류',
                                variant: 'danger',
                                solid: true,
                                toaster: 'b-toaster-bottom-right'
                            });

                            this.extensionRequestPending = false;
                            this.showspinner1 = false;
                            this.resetPendingProduct = null;
                            this.pendingProductData = null;
                        });
                }
                // 상품 추가 모드: 새 상품 생성
                else if (answeredProductData) {
                    this.createProductObject(answeredProductData, this.extensionResponseData)
                        .then(() => {
                            // 요청 상태 초기화
                            console.log('[Q-DEBUG] createProductObject .then() — extensionRequestPending=false 설정');
                            this.extensionRequestPending = false;
                            this.showspinner1 = false;

                            // 완료 메시지 표시
                            this.$bvToast.toast('상품 추가가 완료되었습니다.', {
                                title: '성공',
                                variant: 'success',
                                solid: true,
                                toaster: 'b-toaster-bottom-right'
                            });

                            // 모달 닫기
                            this.$bvModal.hide('addProductModal');
                        })
                        .catch(error => {
                            console.error('상품 생성 실패:', error);
                            this.$bvToast.toast('상품 추가 중 오류가 발생했습니다: ' + error.message, {
                                title: '오류',
                                variant: 'danger',
                                solid: true,
                                toaster: 'b-toaster-bottom-right'
                            });

                            // 요청 상태 초기화
                            this.extensionRequestPending = false;
                            this.showspinner1 = false;
                        });
                } else {
                    console.error('pendingProductData가 없습니다!');
                    this.extensionRequestPending = false;
                    this.showspinner1 = false;
                }
            }

            // 검증 응답 처리 - 두 가지 응답 형식 모두 처리
            if (event.data.type === 'VERIFY_ROCKET_REG_DOC_RESPONSE' ||
                (event.data.response === true && event.data.data && event.data.data.type === 'UPDATE_ROCKET_REG_RESPONSE')) {

                console.log('검증 응답 수신 (조건 1):', event.data);
                console.log('조건 체크:', {
                    'event.data.type === VERIFY_ROCKET_REG_DOC_RESPONSE': event.data.type === 'VERIFY_ROCKET_REG_DOC_RESPONSE',
                    'event.data.response === true': event.data.response === true,
                    'event.data.data 존재': !!event.data.data,
                    'event.data.data.type === UPDATE_ROCKET_REG_RESPONSE': event.data.data && event.data.data.type === 'UPDATE_ROCKET_REG_RESPONSE'
                });

                // 요청 ID 추출 (두 가지 형식 모두 처리)
                const requestId = event.data.id || event.data.requestId;
                console.log('추출된 요청 ID:', requestId);

                if (!requestId) {
                    console.error('응답에 요청 ID가 없습니다', event.data);
                    if (this.isVerifying) this.logSubmitAbort('확장 응답(요청 ID 없음)', (event.data.data && (event.data.data.result || event.data.data.text)) || event.data.error || '요청 ID 없는 응답');
                    return;
                }

                // 요청 ID로 대기 중인 검증 요청 찾기
                console.log(`요청 ID ${requestId}에 대한 대기 중인 검증 요청 확인`,
                    this.pendingVerifications ?
                        `(현재 ${this.pendingVerifications.size}개 대기 중)` :
                        '(pendingVerifications가 초기화되지 않음)');

                if (this.pendingVerifications && this.pendingVerifications.has(requestId)) {
                    console.log(`요청 ID ${requestId}에 대한 검증 정보 찾음`);
                    const verificationInfo = this.pendingVerifications.get(requestId);
                    console.log('검증 정보:', verificationInfo);

                    const { product } = verificationInfo;
                    console.log(`상품 ID: ${product.registrationId}`);

                    // 성공 여부 확인 (두 가지 형식 모두 처리)
                    const isSuccess = event.data.success ||
                        (event.data.data && event.data.data.success === true);

                    // 오류 메시지 확인 (두 가지 형식 모두 처리)
                    const errorMessage = event.data.error ||
                        (event.data.data && (event.data.data.result || event.data.data.errorDetails)) ||
                        '알 수 없는 오류';

                    // docId 추출 (두 가지 형식 모두 처리)
                    const docId = event.data.docId ||
                        (event.data.data && event.data.data.docId);

                    // 응답 결과에 따라 상태 업데이트
                    if (isSuccess) {
                        console.log(`🟢 상품 ${product.registrationId} 검증 및 등록 성공, docId: ${docId}`);

                        // 확장 프로그램 응답 로깅
                        console.log(`💾 확장 프로그램 응답 데이터:`, {
                            requestId,
                            docId,
                            success: isSuccess,
                            productId: product.registrationId,
                            hasCoupangDoc: !!product.coupangDoc
                        });

                        // 확장 «완료» = 허브 제출 버튼 뒤 완료 글뿐(WIMS 실제 줄 확인 0) — 등록됨 아님, «전송됨·확인 전»으로(판 #378)
                        if (!docId) console.warn(`⚠️ 상품 ${product.registrationId} 전송 성공 응답에 docId 가 없습니다!`);
                        markSentUnconfirmed(product, docId, (o, k, v) => this.$set(o, k, v), Date.now(), event.data.qvtRequestId || (event.data.data && event.data.data.qvtRequestId));

                        // 상품 정보 업데이트 (Vuex 스토어)
                        console.log(`💾 Vuex 스토어에 상품 ${product.registrationId} 업데이트 시작`);
                        this.$store.dispatch('updateRocketProduct', product);

                        // 성공 메시지 표시
                        this.$bvToast.toast(`상품 ${product.registrationId} 쿠팡에 전송했습니다 — 서플라이어허브 확인 전(확인되면 «등록됨»으로 바뀝니다).`, {
                            title: '전송됨·확인 전',
                            variant: 'success',
                            solid: true,
                            toaster: 'b-toaster-bottom-right'
                        });
                    } else {
                        console.error(`상품 ${product.registrationId} 검증 실패:`, errorMessage);

                        // ✅ AI 수정 가능한 에러인지 확인
                        const fullErrorData = event.data.data?.fullErrorData;

                        if (fullErrorData && fullErrorData.errors && fullErrorData.errors.length > 0) {
                            // AI 자동 수정 시도
                            console.log(`🤖 상품 ${product.registrationId}의 에러를 AI로 수정 시도합니다.`);

                            // 재시도 카운터 확인 (무한 루프 방지)
                            if (!product.aiFixRetryCount) {
                                product.aiFixRetryCount = 0;
                            }

                            if (product.aiFixRetryCount >= 2) {
                                // 최대 재시도 횟수 초과
                                console.warn(`⚠️ 상품 ${product.registrationId}는 2회 AI 수정 후에도 실패했습니다.`);

                                // 상품 상태 업데이트
                                this.$set(product, 'verified', false);
                                this.$set(product, 'registered', false);
                                this.$set(product, 'errorDetails', this.convertErrorDetailsToText(errorMessage));
                                this.$set(product, 'aiFixRetryCount', 0); // 카운터 리셋

                                // 상품 정보 업데이트 (Vuex 스토어)
                                this.$store.dispatch('updateRocketProduct', product);

                                // 실패 메시지 표시
                                this.$bvToast.toast(`상품 ${product.registrationId}는 2회 수정 후에도 실패했습니다. 수동 수정이 필요합니다.`, {
                                    title: '등록 실패',
                                    variant: 'danger',
                                    solid: true,
                                    toaster: 'b-toaster-bottom-right'
                                });

                                // 처리된 요청 정보 삭제
                                this.pendingVerifications.delete(requestId);

                                // 대기열에서 처리된 항목 제거
                                this.verificationQueue.shift();

                                // 다음 상품으로 계속 진행
                                this.processNextVerification();

                                return;
                            }

                            try {
                                // AI 수정 요청
                                product.aiFixRetryCount++;
                                console.log(`🔄 AI 수정 시도 ${product.aiFixRetryCount}/2`);

                                const fixedProduct = await workflowService.fixRegistrationErrors(
                                    product,
                                    fullErrorData
                                );

                                // 수정된 상품 저장
                                await this.$store.dispatch('updateRocketProduct', fixedProduct);

                                // 토스트 메시지
                                this.$bvToast.toast(`상품 ${product.registrationId}의 에러를 AI가 수정했습니다. 재검증을 시작합니다. (${product.aiFixRetryCount}/2)`, {
                                    title: 'AI 자동 수정',
                                    variant: 'info',
                                    solid: true,
                                    toaster: 'b-toaster-bottom-right'
                                });

                                // 처리된 요청 정보 삭제
                                this.pendingVerifications.delete(requestId);

                                // 대기열에서 처리된 항목 제거
                                this.verificationQueue.shift();

                                // 재검증 요청 (대기열 맨 앞에 추가)
                                this.verificationQueue.unshift({ product: fixedProduct, index: product.registrationId });

                                // 다음 항목 처리 (재검증)
                                this.processNextVerification();

                                return;

                            } catch (aiError) {
                                console.error('❌ AI 수정 실패:', aiError);

                                // AI 수정 실패 시 기존 로직대로 처리
                                this.$set(product, 'verified', false);
                                this.$set(product, 'registered', false);
                                this.$set(product, 'errorDetails', this.convertErrorDetailsToText(errorMessage));
                                this.$set(product, 'aiFixRetryCount', 0); // 카운터 리셋

                                // 상품 정보 업데이트 (Vuex 스토어)
                                this.$store.dispatch('updateRocketProduct', product);

                                this.$bvToast.toast(`상품 ${product.registrationId} AI 수정 실패. 수동 수정이 필요합니다.`, {
                                    title: '등록 실패',
                                    variant: 'danger',
                                    solid: true,
                                    toaster: 'b-toaster-bottom-right'
                                });

                                // 처리된 요청 정보 삭제
                                this.pendingVerifications.delete(requestId);

                                // 대기열에서 처리된 항목 제거
                                this.verificationQueue.shift();

                                // 다음 상품으로 계속 진행
                                this.processNextVerification();

                                return;
                            }

                        } else {
                            // AI 수정 불가능한 에러 (기존 로직)
                            console.log('ℹ️ AI 수정 불가능한 에러입니다. 수동 수정이 필요합니다.');

                            // 상품 상태 업데이트
                            this.$set(product, 'verified', false);
                            this.$set(product, 'registered', false);
                            this.$set(product, 'errorDetails', this.convertErrorDetailsToText(errorMessage));

                            // 상품 정보 업데이트 (Vuex 스토어)
                            this.$store.dispatch('updateRocketProduct', product);

                            // 실패 메시지 표시
                            this.$bvToast.toast(`상품 ${product.registrationId} 등록 실패: ${errorMessage}`, {
                                title: '등록 실패',
                                variant: 'danger',
                                solid: true,
                                toaster: 'b-toaster-bottom-right'
                            });

                            // 처리된 요청 정보 삭제
                            this.pendingVerifications.delete(requestId);

                            // 대기열에서 처리된 항목 제거
                            this.verificationQueue.shift();

                            // ✅ 다음 상품으로 계속 진행 (전체 프로세스 중단하지 않음)
                            this.processNextVerification();

                            return;
                        }
                    }

                    // 처리된 요청 정보 삭제
                    this.pendingVerifications.delete(requestId);

                    // 대기열에서 처리된 항목 제거
                    this.verificationQueue.shift();

                    // 다음 항목 처리
                    this.processNextVerification();
                } else {
                    console.warn(`검증 응답을 처리할 요청 정보를 찾을 수 없습니다. 요청 ID: ${requestId}`);
                }

                return;
            }

            // UPDATE_ROCKET_REG_RESPONSE 처리 (백그라운드에서 전달되는 메시지)
            if (event.data.type == 'UPDATE_ROCKET_REG_RESPONSE') {
                console.log('UPDATE_ROCKET_REG_RESPONSE 메시지 수신:', event.data);
                console.log('pendingVerifications:', this.pendingVerifications ?
                    `${this.pendingVerifications.size}개 항목 있음` : 'undefined');

                // 요청 ID가 있는 경우 직접 처리
                if (event.data.requestId && this.pendingVerifications.has(event.data.requestId)) {
                    console.log(`🟢 요청 ID ${event.data.requestId}에 대한 UPDATE_ROCKET_REG_RESPONSE 응답 처리`);

                    // 응답 데이터 로깅
                    console.log(`💾 UPDATE_ROCKET_REG_RESPONSE 응답 데이터:`, {
                        requestId: event.data.requestId,
                        docId: event.data.docId,
                        success: event.data.success,
                        result: event.data.result || event.data.errorDetails
                    });

                    // 요청 정보 가져오기
                    const requestInfo = this.pendingVerifications.get(event.data.requestId);

                    // 요청 정보 로깅
                    console.log(`💾 요청 정보:`, {
                        productId: requestInfo.product.registrationId,
                        hasCoupangDoc: !!requestInfo.product.coupangDoc,
                        currentDocId: requestInfo.product.coupangDoc?.docId
                    });

                    // docId 업데이트
                    if (requestInfo.product && event.data.docId) {
                        if (!requestInfo.product.coupangDoc) {
                            this.$set(requestInfo.product, 'coupangDoc', {
                                docId: event.data.docId,
                                jsonDocument: []
                            });
                            console.log(`💾 상품 ${requestInfo.product.registrationId}에 coupangDoc 생성 및 docId 설정: ${event.data.docId}`);
                        } else {
                            this.$set(requestInfo.product.coupangDoc, 'docId', event.data.docId);
                            console.log(`💾 상품 ${requestInfo.product.registrationId}의 coupangDoc.docId 업데이트: ${event.data.docId}`);
                        }
                    } else if (requestInfo.product && !event.data.docId) {
                        console.warn(`⚠️ 상품 ${requestInfo.product.registrationId} 등록 성공했지만 docId가 없습니다!`);
                    }

                    if (!event.data.success) {
                        const errorMessage = event.data.result || event.data.errorDetails || '알 수 없는 오류';
                        const product = requestInfo.product;

                        console.error(`상품 ${product.registrationId} 검증 실패:`, errorMessage);

                        // ✅ AI 수정 가능한 에러인지 확인
                        const fullErrorData = event.data.fullErrorData;

                        if (fullErrorData && fullErrorData.errors && fullErrorData.errors.length > 0) {
                            // AI 자동 수정 시도
                            console.log(`🤖 상품 ${product.registrationId}의 에러를 AI로 수정 시도합니다.`);

                            // 재시도 카운터 확인 (무한 루프 방지)
                            if (!product.aiFixRetryCount) {
                                product.aiFixRetryCount = 0;
                            }

                            if (product.aiFixRetryCount >= 2) {
                                // 최대 재시도 횟수 초과
                                console.warn(`⚠️ 상품 ${product.registrationId}는 2회 AI 수정 후에도 실패했습니다.`);

                                // 상품 상태 업데이트
                                this.$set(product, 'verified', false);
                                this.$set(product, 'registered', false);
                                this.$set(product, 'errorDetails', this.convertErrorDetailsToText(errorMessage));
                                this.$set(product, 'aiFixRetryCount', 0); // 카운터 리셋

                                // 상품 정보 업데이트 (Vuex 스토어)
                                this.$store.dispatch('updateRocketProduct', product);

                                // 처리된 요청 정보 삭제
                                this.pendingVerifications.delete(event.data.requestId);

                                // 대기열에서 처리된 항목 제거
                                this.verificationQueue.shift();

                                // 실패 메시지 표시
                                this.$bvToast.toast(`상품 ${product.registrationId}는 2회 수정 후에도 실패했습니다. 수동 수정이 필요합니다.`, {
                                    title: '등록 실패',
                                    variant: 'danger',
                                    solid: true,
                                    toaster: 'b-toaster-bottom-right'
                                });

                                // 다음 상품으로 계속 진행
                                this.processNextVerification();

                                return;
                            }

                            try {
                                // AI 수정 요청
                                product.aiFixRetryCount++;
                                console.log(`🔄 AI 수정 시도 ${product.aiFixRetryCount}/2`);

                                const fixedProduct = await workflowService.fixRegistrationErrors(
                                    product,
                                    fullErrorData
                                );

                                // 수정된 상품 저장
                                await this.$store.dispatch('updateRocketProduct', fixedProduct);

                                // 토스트 메시지
                                this.$bvToast.toast(`상품 ${product.registrationId}의 에러를 AI가 수정했습니다. 재검증을 시작합니다. (${product.aiFixRetryCount}/2)`, {
                                    title: 'AI 자동 수정',
                                    variant: 'info',
                                    solid: true,
                                    toaster: 'b-toaster-bottom-right'
                                });

                                // 처리된 요청 정보 삭제
                                this.pendingVerifications.delete(event.data.requestId);

                                // 대기열에서 처리된 항목 제거
                                this.verificationQueue.shift();

                                // 재검증 요청 (대기열 맨 앞에 추가)
                                this.verificationQueue.unshift({ product: fixedProduct, index: product.registrationId });

                                // 다음 항목 처리 (재검증)
                                this.processNextVerification();

                                return;

                            } catch (aiError) {
                                console.error('❌ AI 수정 실패:', aiError);

                                // ✅ Gemini API 에러인 경우 전체 프로세스 중단
                                if (aiError.message && aiError.message.startsWith('GEMINI_API_ERROR:')) {
                                    console.error('🚨 Gemini API 오류로 인해 전체 등록 프로세스를 중단합니다.');

                                    // 큐에 남아있는 모든 요청 취소
                                    workflowService.clearQueue();

                                    // 상품 상태 업데이트
                                    this.$set(product, 'verified', false);
                                    this.$set(product, 'registered', false);
                                    this.$set(product, 'errorDetails', aiError.message);
                                    this.$set(product, 'aiFixRetryCount', 0);

                                    // 상품 정보 업데이트
                                    this.$store.dispatch('updateRocketProduct', product);

                                    // 전체 프로세스 중단
                                    this.stopVerificationProcess(
                                        `Gemini API 오류가 발생했습니다: ${aiError.message.replace('GEMINI_API_ERROR:', '')}. API 상태를 확인한 후 다시 시도해주세요.`,
                                        'danger'
                                    );

                                    return;
                                }

                                // ✅ 일반 에러 - 다음 상품으로 계속 진행
                                console.log('ℹ️ 일반 AI 수정 에러 - 다음 상품으로 진행합니다.');

                                // 상품 상태 업데이트
                                this.$set(product, 'verified', false);
                                this.$set(product, 'registered', false);
                                this.$set(product, 'errorDetails', this.convertErrorDetailsToText(errorMessage));
                                this.$set(product, 'aiFixRetryCount', 0); // 카운터 리셋

                                // 상품 정보 업데이트 (Vuex 스토어)
                                this.$store.dispatch('updateRocketProduct', product);

                                // 처리된 요청 정보 삭제
                                this.pendingVerifications.delete(event.data.requestId);

                                // 대기열에서 처리된 항목 제거
                                this.verificationQueue.shift();

                                this.$bvToast.toast(`상품 ${product.registrationId} AI 수정 실패. 수동 수정이 필요합니다.`, {
                                    title: '등록 실패',
                                    variant: 'danger',
                                    solid: true,
                                    toaster: 'b-toaster-bottom-right'
                                });

                                // 다음 상품으로 계속 진행
                                this.processNextVerification();

                                return;
                            }

                        } else {
                            // AI 수정 불가능한 에러 (기존 로직)
                            console.log('ℹ️ AI 수정 불가능한 에러입니다. 수동 수정이 필요합니다.');

                            // 상품 상태 업데이트
                            this.$set(product, 'verified', false);
                            this.$set(product, 'registered', false);
                            this.$set(product, 'errorDetails', this.convertErrorDetailsToText(errorMessage));

                            // 상품 정보 업데이트 (Vuex 스토어)
                            this.$store.dispatch('updateRocketProduct', product);

                            // 처리된 요청 정보 삭제
                            this.pendingVerifications.delete(event.data.requestId);

                            // 대기열에서 처리된 항목 제거
                            this.verificationQueue.shift();

                            // 실패 메시지 표시
                            this.$bvToast.toast(`상품 ${product.registrationId} 등록 실패: ${errorMessage}`, {
                                title: '등록 실패',
                                variant: 'danger',
                                solid: true,
                                toaster: 'b-toaster-bottom-right'
                            });

                            // ✅ 다음 상품으로 계속 진행 (전체 프로세스 중단하지 않음)
                            this.processNextVerification();

                            return;
                        }
                    } else {
                        // 확장 «완료» 만으로 등록됨 아님 — «전송됨·확인 전»(판 #378)
                        markSentUnconfirmed(requestInfo.product, event.data.docId, (o, k, v) => this.$set(o, k, v), Date.now(), event.data.qvtRequestId);

                        // 상품 정보 업데이트 (Vuex 스토어)
                        console.log(`💾 Vuex 스토어에 상품 ${requestInfo.product.registrationId} 업데이트 시작`);
                        this.$store.dispatch('updateRocketProduct', requestInfo.product);

                        // 처리된 요청 정보 삭제
                        this.pendingVerifications.delete(event.data.requestId);

                        // 대기열에서 처리된 항목 제거
                        this.verificationQueue.shift();

                        // 다음 항목 처리
                        this.processNextVerification();
                    }
                    return;
                }

                // 이전 방식으로 fallback (요청 ID가 없는 경우 docId로 매칭)
                let matchingRequestId = null;
                if (this.pendingVerifications && this.pendingVerifications.size > 0) {
                    for (const [reqId, info] of this.pendingVerifications.entries()) {
                        console.log(`요청 ID ${reqId} 검사 중: `,
                            info.product && info.product.coupangDoc ?
                                `상품 coupangDoc.docId=${info.product.coupangDoc.docId}` :
                                '상품 coupangDoc 없음');

                        if (info.product && info.product.coupangDoc &&
                            String(info.product.coupangDoc.docId) === String(event.data.docId)) {
                            matchingRequestId = reqId;
                            console.log(`docId ${event.data.docId}와 일치하는 요청 ID 찾음: ${reqId}`);
                            break;
                        }
                    }
                }

                // 일치하는 요청 ID가 있으면 해당 요청으로 처리
                if (matchingRequestId) {
                    console.log(`일치하는 요청 ID ${matchingRequestId}로 이벤트 재구성`);
                    // 이벤트 객체 재구성해서 검증 응답 처리로 전달
                    const newEvent = {
                        data: {
                            type: 'VERIFY_ROCKET_REG_DOC_RESPONSE',
                            id: matchingRequestId,
                            success: event.data.success,
                            error: event.data.result,
                            docId: event.data.docId
                        }
                    };

                    // 재귀적으로 handleExtensionMessage 호출
                    console.log('재구성된 이벤트로 처리:', newEvent);
                    this.handleExtensionMessage(newEvent);
                    return;
                }

                // 일치하는 요청 ID가 없는 경우 - 이는 통신 문제나 처리 오류 징후
                console.log('요청 ID 매칭 실패 - 프로세스에 문제가 있습니다.');
                console.log('현재 대기열 상태:', {
                    '대기열 길이': this.verificationQueue ? this.verificationQueue.length : 'undefined',
                    '다음 항목': this.verificationQueue && this.verificationQueue.length > 0 ?
                        `상품 ${this.verificationQueue[0].product.registrationId}, 옵션 ${this.verificationQueue[0].option?.optionNumber}` : 'none'
                });
                console.log('대기중인 검증 요청:', this.pendingVerifications ?
                    Array.from(this.pendingVerifications.entries()).map(([id, info]) =>
                        `[${id}] 상품 ${info.product.registrationId}, 옵션 ${info.option?.optionNumber}`) :
                    'none');

                // 응답에서 필요한 정보 추출
                const docId = event.data.docId;  // 문서 ID
                const success = event.data.success;
                const errorDetails = event.data.result || '알 수 없는 오류';

                // 요청 ID 매칭 실패는 통신 문제로 간주하고 프로세스 중단
                if (this.verificationQueue && this.verificationQueue.length > 0) {
                    const firstItem = this.verificationQueue[0];
                    console.log(`requestId 매칭 실패 - 프로세스 중단: 옵션 ${firstItem.option?.optionNumber}`);

                    // 오류 정보 기록
                    if (firstItem.option) {
                        this.$set(firstItem.option, 'errorDetails',
                            this.convertErrorDetailsToText('요청 ID 매칭 실패. 통신 문제 또는 처리 오류가 발생했습니다. 다시 시도해주세요.'));
                    }

                    // 프로세스 중단 및 큐 초기화
                    this.stopVerificationProcess(
                        `옵션 등록 중 통신 문제가 발생했습니다. 요청과 응답이 정확히 매칭되지 않았습니다. 다시 시도해주세요.`,
                        'warning'
                    );
                    return;
                }

                console.log('독립적인 문서 처리 시작: docId=', docId, '타입=', typeof docId);

                // 아래 두 반복은 this.products 를 고쳐 통째 저장한다 — 해당 상품이 목록용이면 먼저 완전 문서로 받는다
                const touched = this.products.filter(p => p.selected || (docId && p.coupangDoc && String(p.coupangDoc.docId) === String(docId)));
                if (touched.some(isLightDoc) && !(await this.ensureFullProducts(touched))) return;

                // 새로운 docId 확인 후 업데이트 (중요: 이 로직 추가)
                if (docId) {
                    // 모든 상품의 coupangDoc을 검사하여 업데이트해야 하는 내용이 있는지 확인
                    for (const product of this.products) {
                        if (product.selected) {
                            // 상품 레벨 coupangDoc 업데이트
                            if (!product.coupangDoc) {
                                this.$set(product, 'coupangDoc', {
                                    docId,
                                    jsonDocument: []
                                });
                                console.log(`상품(${product.registrationId})에 coupangDoc 생성 및 docId 설정: ${docId}`);
                            } else if (product.coupangDoc.docId !== docId) {
                                console.log(`상품(${product.registrationId})의 docId 업데이트: ${product.coupangDoc.docId} -> ${docId}`);
                                this.$set(product.coupangDoc, 'docId', docId);
                            }
                        }
                    }
                }

                // 모든 상품 검사
                for (const product of this.products) {
                    let productUpdated = false;
                    let hasError = false;
                    let errorMessages = [];

                    // 상품에 직접 연결된 문서인지 확인 (타입 안전하게 확인)
                    if (product.coupangDoc && String(product.coupangDoc.docId) === String(docId)) {
                        console.log(`상품 ${product.registrationId}의 문서 ID 일치: ${product.coupangDoc.docId} === ${docId}`);
                        if (!success) {
                            product.verified = false;
                            product.errorDetails = this.convertErrorDetailsToText(errorDetails);
                            hasError = true;
                            errorMessages.push(`상품: ${this.convertErrorDetailsToText(errorDetails)}`);
                        } else {
                            // 확장 «완료» 만으로 등록됨 아님 — «전송됨·확인 전»(판 #378)
                            markSentUnconfirmed(product, docId, (o, k, v) => this.$set(o, k, v), Date.now(), event.data.qvtRequestId);
                        }
                        productUpdated = true;
                    }

                    // 모든 옵션의 상태 업데이트
                    if (product.options && product.options.length > 0 && productUpdated) {
                        if (!success) {
                            // 오류 발생 시 모든 옵션에 오류 상태 설정
                            product.options.forEach(option => {
                                option.verified = false;
                                option.registered = false;
                                option.errorDetails = this.convertErrorDetailsToText(errorDetails);
                            });
                        }   // 성공이면 옵션 칸은 markSentUnconfirmed 가 이미 적음(pending)
                    }

                    // 상품 정보가 업데이트 되었으면 저장
                    if (productUpdated) {
                        console.log(`상품 ${product.registrationId} 업데이트 필요 (hasError=${hasError}): `, product.errorDetails);

                        // 변경된 상품 서버 저장
                        this.updateRocketProduct(product).catch(error => {
                            console.error('상품 검증 상태 업데이트 실패:', error);
                        });

                        // Toast 메시지로 결과 표시 (hasError 사용)
                        if (!hasError) {
                            // 상품명 표시 (SEO > 영문 > 원본)
                            const displayName = this.getDisplayProductName(product);

                            this.$bvToast.toast(`상품 "${displayName}" ${event.data.text || '등록 완료'}`, {
                                title: '정상',
                                variant: 'success',
                                solid: true,
                                toaster: 'b-toaster-bottom-right'
                            });
                        } else {
                            // 상품명 표시 (SEO > 영문 > 원본)
                            const displayName = this.getDisplayProductName(product);

                            this.$bvToast.toast(`상품 "${displayName}" 등록 중 오류: ${errorMessages.join(', ')}`, {
                                title: '오류',
                                variant: 'danger',
                                solid: true,
                                toaster: 'b-toaster-bottom-right'
                            });
                        }
                    }
                }

                // 매칭되는 상품/옵션이 없는 경우 일반 알림만 표시
                if (!success) {
                    console.log('검증 오류 발생으로 큐 처리 중단');
                    // 검증 중단 (모든 상태 초기화)
                    this.verificationQueue = [];
                    this.pendingVerifications.clear();
                    this.isVerifying = false;
                    this.showspinner1 = false;
                    this.loadingtext = '';

                    // 오류 알림
                    this.$bvToast.toast('검증 중 오류가 발생하여 프로세스가 중단되었습니다. 확인 후 다시 시도해주세요.', {
                        title: '검증 중단',
                        variant: 'warning',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                }

                // 성공 시 다음 항목 처리
                else if (this.verificationQueue && this.verificationQueue.length > 0) {
                    this.processNextVerification();
                } else {
                    this.isVerifying = false;
                    this.showspinner1 = false;
                    this.loadingtext = '';
                }
            }
        },

        // 옵션별 상품 생성 메서드
        async createMultipleOptionProduct(productData, optionsWithResponses) {
            try {
                const now = new Date().getTime();

                // 등록번호 생성
                const newRegistrationId = await this.generateRegistrationId(now);

                // 브랜드명 설정
                const brandName = this.newProduct.brand || this.defaultSettings.brand;

                // 가격 결정 로직 개선 - 모든 SKU의 가격이 동일한지 확인
                const allSkus = optionsWithResponses.map(opt => opt.sku);
                const skuPrices = allSkus.map(sku =>
                    parseFloat((sku.fenxiaoPriceInfo && sku.fenxiaoPriceInfo.offerPrice)
                        ? sku.fenxiaoPriceInfo.offerPrice
                        : sku.consignPrice)
                );

                const allSamePrices = skuPrices.every(price => price === skuPrices[0]);
                const basePrice = parseFloat(productData.productSaleInfo.priceRangeList[0].price);
                const shouldUseBasePrice = allSamePrices;

                console.log(`createMultipleOptionProduct 가격 결정: 모든 SKU 가격 동일(${allSamePrices}) -> ${shouldUseBasePrice ? `기본가격 ${basePrice} 사용` : 'SKU별 가격 사용'}`);

                // 모든 옵션 정보 처리
                const allOptions = [];

                for (const optionWithResponse of optionsWithResponses) {
                    console.log(`===== 옵션 처리 시작 =====`);
                    console.log(`옵션 인덱스: ${optionWithResponse.index}`);
                    console.log(`옵션 응답 데이터 유무: ${!!optionWithResponse.responseData}`);

                    const { sku, optionName, optionProductName, responseData } = optionWithResponse;

                    // responseData가 없으면 자세히 로깅processOptions
                    if (!responseData) {
                        console.error(`옵션 ${optionWithResponse.index} responseData가 없음!`);
                        console.log(`optionWithResponse 전체 구조:`, JSON.stringify(optionWithResponse));
                        continue; // 이 옵션은 건너뛰기
                    }

                    // 응답의 createResult 확인
                    if (!responseData.createResult) {
                        console.error(`옵션 ${optionWithResponse.index} responseData에 createResult가 없음!`);
                        console.log(`responseData 구조:`, JSON.stringify(responseData));
                    } else {
                        console.log(`createResult docId: ${responseData.createResult.docId || '없음'}`);
                    }

                    // 가격 정보 - 개선된 로직
                    const price = shouldUseBasePrice
                        ? basePrice
                        : parseFloat((sku.fenxiaoPriceInfo && sku.fenxiaoPriceInfo.offerPrice)
                            ? sku.fenxiaoPriceInfo.offerPrice
                            : sku.consignPrice);

                    // 옵션 번호 형식
                    const optionNumber = `${newRegistrationId.substring(0, 9)}${String(optionWithResponse.index + 1).padStart(3, '0')}`;
                    console.log(`생성된 옵션 번호: ${optionNumber}`);

                    // 옵션 이미지 결정
                    const optionImage = sku.skuAttributes[0].skuImageUrl
                        || (sku.skuAttributes[1] && sku.skuAttributes[1].skuImageUrl)
                        || productData.productImage.images[0];

                    console.log(`coupangDoc 초기화 시작 - 옵션 인덱스: ${optionWithResponse.index}`);

                    // 옵션별 coupangDoc 생성은 더 이상 여기서 하지 않음
                    // 대신 모든 옵션 정보를 수집한 후 product 레벨에서 통합 coupangDoc 생성

                    // 옵션 정보 생성
                    const option = {
                        id: sku.skuId,
                        optionNumber,
                        option1: {
                            name: sku.skuAttributes[0].value,
                            nameTrans: sku.skuAttributes[0].valueTrans,
                            imageUrl: sku.skuAttributes[0].skuImageUrl || ''
                        },
                        option2: sku.skuAttributes[1] ? {
                            name: sku.skuAttributes[1].value,
                            nameTrans: sku.skuAttributes[1].valueTrans,
                            imageUrl: sku.skuAttributes[1].skuImageUrl || ''
                        } : null,
                        korName: optionName,
                        fullProductName: optionProductName,
                        stock: sku.amountOnSale,
                        price: price,
                        // coupangDoc은 더 이상 옵션별로 설정하지 않음
                        mainImageStatus: {
                            status: 'pending',
                            image: optionImage,
                            processedImage: null,
                            textRemoved: false,
                            dimensions: '', // 아직 그림 안 받음 — 못 잼 = 빈 칸(지어낸 기본 크기 0)
                            filesize: ''
                        },
                        additionalImageStatus: {
                            status: 'pending',
                            images: productData.productImage.images
                        },
                        detailImageStatus: {
                            status: 'pending',
                            images: productData.description ? this.getDetailImagesWithTopBottom(this.extractDetailImages(productData.description)) : []
                        },
                        koreanLabelStatus: 'pending',
                        pricingStatus: 'pending',
                        seoStatus: 'pending',
                        sizeChartStatus: 'pending',
                        quotationStatus: 'pending'
                    };

                    // 가격 계산 및 업데이트
                    const processedOption = this.updateOptionPricing(option);
                    allOptions.push(processedOption);
                }

                // 새 상품 객체 생성
                const newProductObj = {
                    createdAt: now,
                    registrationId: newRegistrationId,
                    productImage: productData.productImage.images[0],
                    productName: productData.subject,
                    productNameTrans: productData.subjectTrans,
                    categoryPath: this.newProduct.categoryPath || optionsWithResponses[0].responseData.categoryPath,
                    categoryCode: this.newProduct.categoryCode || optionsWithResponses[0].responseData.categoryCode,
                    rocketRegInfo: optionsWithResponses[0].responseData.rocketRegInfo,
                    // coupangDoc은 product 레벨에서 통합 문서로 생성
                    mainImageStatus: 'pending',
                    additionalImageStatus: 'pending',
                    detailImageStatus: 'pending',
                    koreanLabelStatus: 'pending',
                    pricingStatus: 'pending',
                    seoStatus: 'pending',
                    sizeChartStatus: 'pending',
                    quotationStatus: 'pending',
                    targetKeyword: this.newProduct.keyword,
                    brand: brandName,
                    productFeature: this.newProduct.productFeature,
                    구매링크: this.newProduct.link.split('?')[0],
                    options: allOptions,
                    // 추가 정보
                    originalPrice: productData.productSaleInfo.priceRangeList[0].price,
                    minOrderQuantity: productData.minOrderQuantity,
                    attributes: productData.productAttribute,
                    mainImages: productData.productImage.images,
                    detailImages: this.getDetailImagesWithTopBottom(this.extractDetailImages(productData.description)),
                    // 등록 정보 복사
                    manufacturer: this.defaultSettings.manufacturer,
                    transactionType: this.defaultSettings.transactionType,
                    importStatus: this.defaultSettings.importStatus,
                    asInfo: this.defaultSettings.asInfo,
                    exchangeRate: this.defaultSettings.exchangeRate,
                    marginRate: this.defaultSettings.marginRate,
                    coupangMarginRate: this.defaultSettings.coupangMarginRate,
                    roundUnit: this.defaultSettings.roundUnit,
                    createDate: now,
                    updateDate: now
                };

                // 통합 coupangDoc 생성 및 설정
                // 첫 번째 옵션의 responseData.createResult 사용
                if (optionsWithResponses.length > 0 && optionsWithResponses[0].responseData && optionsWithResponses[0].responseData.createResult) {
                    newProductObj.coupangDoc = this.initializeCoupangDoc(
                        optionsWithResponses[0].responseData.createResult,
                        this.defaultSettings,
                        optionsWithResponses[0].responseData.rocketRegInfo,
                        allOptions // 모든 옵션 정보 전달
                    );
                    console.log('통합 coupangDoc 생성 완료:', newProductObj.coupangDoc.docId, '문서 항목 수:', newProductObj.coupangDoc.jsonDocument.length);
                } else {
                    console.error('통합 coupangDoc 생성 실패: 필요한 데이터가 없습니다.');
                }

                console.log('생성된 상품 객체:', newProductObj);

                // 서버에 저장
                assertNotLight(newProductObj); // 목록용 문서 저장 금지
                const saveRes = await axios.post('/api/rocketReg/saveItems', [newProductObj]);
                if (saveRes.data.res !== 'success') {
                    throw new Error(saveRes.data.alert || 'rocketReg/saveItems API 호출 실패');
                }

                // 서버 응답으로부터 저장된 상품 정보 반영
                let savedProductObj = newProductObj;
                if (saveRes.data.savedItems && saveRes.data.savedItems.length > 0) {
                    savedProductObj = saveRes.data.savedItems[0];
                }

                // 로컬 목록에 반영
                this.products.push(savedProductObj);

                this.$bvModal.hide('addProductModal');
                this.$bvToast.toast('상품이 추가되었습니다.', {
                    title: '성공',
                    variant: 'success',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });

                // 성공 후 목록 새로고침
                this.$nextTick(() => {
                    this.search();
                });

                return savedProductObj;
            } catch (error) {
                console.error('상품 객체 생성 실패:', error);
                throw error;
            }
        },
        isSizeChartEnabled(product) {
            if (!product) return false;
            return this.isSizeChartRequired(product);
        },
        async createProductObject(data, extensionData) {
            console.log(`[Q-DEBUG] createProductObject 시작 — queueAutoMode: ${this.queueAutoMode}, skipInitialProcessing: ${this.skipInitialProcessing}`);
            try {
                const newProductObj = await this.buildRocketRegProduct(data, extensionData);

                console.log('생성된 상품 객체:', newProductObj);

                // 서버에 저장
                assertNotLight(newProductObj); // 목록용 문서 저장 금지
                const saveRes = await axios.post('/api/rocketReg/saveItems', [newProductObj]);
                if (saveRes.data.res !== 'success') {
                    throw new Error(saveRes.data.alert || 'rocketReg/saveItems API 호출 실패');
                }

                // 서버 응답으로부터 저장된 상품 정보 반영
                let savedProductObj = newProductObj;
                if (saveRes.data.savedItems && saveRes.data.savedItems.length > 0) {
                    savedProductObj = saveRes.data.savedItems[0];
                }

                // 로컬 목록에 반영 - 중요: skipUpdate 플래그 추가
                savedProductObj.skipUpdate = true; // 초기 추가 시 업데이트 스킵 플래그
                this.products.push(savedProductObj);

                this.$bvModal.hide('addProductModal');
                this.$bvToast.toast('상품이 추가되었습니다.', {
                    title: '성공',
                    variant: 'success',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });

                // 초기 상품 추가 후 skipUpdate 플래그 제거 (일정 시간 후)
                setTimeout(() => {
                    const addedProduct = this.products.find(p => p.registrationId === savedProductObj.registrationId);
                    if (addedProduct) {
                        delete addedProduct.skipUpdate;
                    }
                }, 3000); // 3초 후 플래그 제거

                // 성공 후 목록 새로고침
                this.$nextTick(() => {
                    this.search();
                });

                // ========== 자동 SEO + Pricing 실행 ==========
                console.log(`[Q-DEBUG] SEO+가격 분기 — skipInitialProcessing: ${this.skipInitialProcessing}, queueAutoMode: ${this.queueAutoMode}`);
                if (!this.skipInitialProcessing) {
                    if (this.queueAutoMode) {
                        console.log('[Q-DEBUG] runInitialProcessing await 시작');
                        await this.runInitialProcessing(savedProductObj);
                        console.log('[Q-DEBUG] runInitialProcessing await 완료');
                    } else {
                        this.runInitialProcessing(savedProductObj);
                    }
                } else {
                    this.$bvToast.toast('상품이 추가되었습니다. 작업개시로 SEO·이미지·가격을 일괄 처리할 수 있습니다.', {
                        title: '바로추가 완료',
                        variant: 'info',
                        solid: true,
                        autoHideDelay: 4000,
                        toaster: 'b-toaster-bottom-right'
                    });
                }
                // 자동 모드가 아닐 때만 리셋 (대기열/소싱은 전체 완료 후 리셋)
                if (!this.queueAutoMode && !this.sourcingAutoMode) {
                    this.skipInitialProcessing = false;
                }

                // 소싱 자동 모드: 다음 건 처리
                if (this.sourcingAutoMode) {
                    this.sourcingAutoMode = false;
                    setTimeout(() => this.processNextSourcingItem(), 2000);
                }

                // 대기열 자동 모드: 완료된 행 제거 → CLI 동기화 → 다음 건
                if (this.queueAutoMode) {
                    this.queueAutoMode = false;
                    // 이 상품이 어느 단계를 시킨 항목에서 나왔는지 남긴다. 이게 없으면 대기열이
                    // 끝난 뒤 작업개시·등록전송을 어디까지 걸어야 하는지 알 길이 없다.
                    if (!Array.isArray(this._queueCreated)) this._queueCreated = [];
                    this._queueCreated.push({
                        registrationId: savedProductObj.registrationId,
                        stepLevel: this._currentQueueStepLevel || this.queueStepLevel,
                        ...(this._currentQueueStock || {})
                    });
                    this.syncRemoveFromCliQueue([this._currentQueueId]);
                    this.productQueue = this.productQueue.filter(q => q._queueId !== this._currentQueueId);
                    console.log(`[Q-DEBUG] 대기열 다음 건 예약 — 남은 큐: ${this.productQueue.length}건, extensionRequestPending: ${this.extensionRequestPending}, 2초 후 시작`);
                    this._queueBusy = false;
                    setTimeout(() => this.processNextQueueItem(), 2000);
                }

                return savedProductObj;
            } catch (error) {
                console.error('상품 객체 생성 실패:', error);
                // 소싱 자동 모드에서 실패 시에도 다음 건 진행
                if (this.sourcingAutoMode) {
                    this.sourcingAutoMode = false;
                    setTimeout(() => this.processNextSourcingItem(), 1000);
                }
                // 대기열 자동 모드에서 실패 시에도 다음 건 진행
                if (this.queueAutoMode) {
                    this.queueAutoMode = false;
                    // 실패한 행에 에러 표시 (제거하지 않음) + 회차 기록에도 남긴다
                    const failedItem = this.productQueue.find(q => q._queueId === this._currentQueueId);
                    this.recordQueueFailure(failedItem, error.message);
                    this._queueBusy = false;
                    setTimeout(() => this.processNextQueueItem(), 1000);
                }
                throw error;
            }
        },

        /**
         * 상품 추가 후 자동 SEO + Pricing 실행
         * 세련된 로딩 UI와 함께 진행
         */
        async runInitialProcessing(product) {
            try {
                // 로딩 오버레이 표시
                this.isInitialProcessing = true;
                this.initialProcessingStep = 1;
                this.initialProcessingProgress = 10;
                this.initialProcessingTitle = '상품 초기화 중...';
                this.initialProcessingMessage = '상품이 저장되었습니다. SEO 최적화를 시작합니다.';

                console.log('🚀 자동 SEO + Pricing 시작:', product.registrationId);

                // Step 2: SEO 처리
                await new Promise(resolve => setTimeout(resolve, 500)); // 애니메이션을 위한 짧은 딜레이
                this.initialProcessingStep = 2;
                this.initialProcessingProgress = 30;
                this.initialProcessingTitle = 'SEO 최적화 중...';
                this.initialProcessingMessage = 'AI가 상품명과 키워드를 분석하고 있습니다.';

                // 목록용 문서면 완전 문서로 받고 (실패하면 아래 catch 가 알린다)
                await this.ensureFullProducts(product, { throwOnError: true });

                // 최신 상품 정보 가져오기
                let currentProduct = this.$store.state.rocketProducts.find(p =>
                    p.registrationId === product.registrationId
                ) || product;

                await workflowService.executeSingleTask(currentProduct, 'seo', {
                    'seo': 'seoStatus',
                    'pricing': 'pricingStatus',
                }, false);

                this.initialProcessingProgress = 60;
                this.initialProcessingMessage = 'SEO 최적화 완료! 가격 설정을 시작합니다.';

                // Step 3: Pricing 처리
                await new Promise(resolve => setTimeout(resolve, 300));
                this.initialProcessingStep = 3;
                this.initialProcessingProgress = 70;
                this.initialProcessingTitle = '가격 설정 중...';
                this.initialProcessingMessage = 'AI가 최적 가격을 계산하고 있습니다.';

                // 최신 상품 정보 다시 가져오기
                currentProduct = this.$store.state.rocketProducts.find(p =>
                    p.registrationId === product.registrationId
                ) || currentProduct;

                await workflowService.executeSingleTask(currentProduct, 'pricing', {
                    'seo': 'seoStatus',
                    'pricing': 'pricingStatus',
                }, false);

                this.initialProcessingProgress = 100;
                this.initialProcessingMessage = '초기화 완료!';

                console.log('✅ 자동 SEO + Pricing 완료:', product.registrationId);

                // 완료 후 잠시 대기 후 오버레이 닫기
                await new Promise(resolve => setTimeout(resolve, 800));

                // 목록 새로고침
                await this.search();

                // 완료 토스트
                this.$bvToast.toast('SEO 최적화와 가격 설정이 완료되었습니다. 이제 "전체 작업"으로 나머지 작업을 진행하세요.', {
                    title: '초기화 완료',
                    variant: 'success',
                    solid: true,
                    autoHideDelay: 5000,
                    toaster: 'b-toaster-bottom-right'
                });

            } catch (error) {
                console.error('자동 SEO + Pricing 실패:', error);
                this.$bvToast.toast(`초기 처리 중 오류: ${error.message}`, {
                    title: '오류',
                    variant: 'warning',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
            } finally {
                // 오버레이 닫기
                this.isInitialProcessing = false;
                this.initialProcessingStep = 0;
                this.initialProcessingProgress = 0;
            }
        },

        // --- AI소싱 → AIRocketReg 자동 상품추가 (레거시 — 쓰지 않는다) ---
        processSourcingItems() {
            // 레거시 자동 처리 비활성화
        },

        async processNextSourcingItem() {
            if (this.sourcingQueue.length === 0) {
                this.isSourcingProcessing = false;
                this.$bvToast.toast(`소싱 상품 ${this.sourcingProgress.total}건 등록 완료!`, {
                    title: 'AI 소싱 완료',
                    variant: 'success',
                    solid: true,
                    toaster: 'b-toaster-bottom-right',
                });

                return;
            }

            const item = this.sourcingQueue.shift();
            this.sourcingProgress.current++;

            try {
                // 1688 상품정보 가져오기
                this.$bvToast.toast(`[${this.sourcingProgress.current}/${this.sourcingProgress.total}] "${item.keyword}" 상품 정보 수집 중...`, {
                    title: 'AI 소싱',
                    variant: 'info',
                    solid: true,
                    toaster: 'b-toaster-bottom-right',
                });

                const res = await axios.post('/api/aiPage/getProductInfo', [{ productId: parseInt(item.offerId) }]);
                if (res.data && res.data.loginRequired) throw new Error(LOGIN_EXPIRED_MESSAGE);
                const data = res.data.result[0].result.result;

                // newProduct 설정
                this.newProduct.link = item.link;
                this.newProduct.keyword = item.keyword;

                // Extension에 상품정보 요청 (기존 플로우 활용)
                // sourcingAutoMode 플래그로 완료 후 다음 건 자동 진행
                this.sourcingAutoMode = true;
                this.requestProductInfoFromExtension(data, item.keyword);

            } catch (error) {
                console.error(`[Sourcing] 상품 처리 실패 (${item.offerId}):`, error.message);
                this.$bvToast.toast(`상품 처리 실패: ${item.keyword} - ${error.message}`, {
                    title: '오류',
                    variant: 'warning',
                    solid: true,
                    toaster: 'b-toaster-bottom-right',
                });
                // 실패해도 다음 건 진행
                setTimeout(() => this.processNextSourcingItem(), 1000);
            }
        },

        async autoFullProcess(options = {}) {
            const skipVerify = options.skipVerify === true;
            // 대상을 지정해 오면 그것만 돈다. 대기열은 항목마다 단계가 달라서, 여기서 목록 전체를
            // 돌면 작업개시를 시키지 않은 상품까지 같이 가공된다. (안 주면 기존대로 전체)
            const only = Array.isArray(options.registrationIds) && options.registrationIds.length
                ? new Set(options.registrationIds.map(String))
                : null;
            // 항목별 결과. 부르는 쪽(대기열)이 「작업개시까지 끝났다」를 이걸로 판정한다
            // processed = 실제로 돌린 등록ID(부르는 쪽이 시킨 것과 맞춰 안 돈 것을 찾는다)
            const work = { total: 0, succeeded: 0, failed: [], processed: [] };
            try {
                // 화면 목록은 조회 기간만 담는다 — 자정 직후 대기열이 상품을 추가하고 search() 가 전날 기간으로
                // 목록을 갈아끼우면 방금 만든 상품이 빠져 0건 도는데 done 이 됐다. 없는 등록ID는 서버에서 불러오고,
                // 그래도 없으면 실패로 남겨 partial 로 끝나게 한다.
                if (only) {
                    try {
                        await this.cliPageLoadMissingProducts(Array.from(only));
                    } catch (e) {
                        console.error('[AIRocketReg] 목록에 없는 상품 불러오기 실패:', e);
                    }
                    const have = new Set((this.products || []).map(p => String(p.registrationId)));
                    only.forEach(id => {
                        if (!have.has(id)) work.failed.push({ registrationId: id, reason: '화면 목록에 없음 — 서버에서도 불러오지 못해 작업개시를 돌리지 못했습니다' });
                    });
                }
                // Step 1: 전체 작업 실행
                // 위 cliPageRunWork 과 같은 기준 — 최상위 registrationStatus 는 없는 필드라 늘 참이었다.
                // 여기는 Step 2 가 등록전송이라 더 위험하다: 이미 보낸 건을 다시 가공해 또 보내게 된다.
                const listed = this.products.filter(p => !this.isSentToCoupang(p)
                    && (!only || only.has(String(p.registrationId))));
                // 가공은 무거운 칸을 쓴다 — 완전 문서로 받고 store 것을 쓴다(실패하면 안내 후 멈춤)
                const products = await this.ensureFullProducts(listed);
                if (!products) return;
                for (let i = 0; i < products.length; i++) {
                    // 상품 사이가 안전한 멈춤 자리다 — 돌던 상품의 저장 도중에는 끊지 않는다
                    if (typeof options.shouldStop === 'function' && options.shouldStop()) {
                        console.error(`[AIRocketReg] 작업개시를 ${i}/${products.length} 에서 멈춥니다(남은 건은 이 탭에서 돌리지 않음).`);
                        work.stopped = true;
                        break;
                    }
                    const product = products[i];
                    work.processed.push(String(product.registrationId));
                    if (typeof options.onItem === 'function') options.onItem(i + 1, products.length, product);
                    try {
                        await workflowService.processProduct(product, null);
                    } catch (e) {
                        // 한 건이 실패해도 나머지는 계속 처리한다 (기존 동작 유지) — 단 실패는 결과에 남긴다
                        console.error('[AIRocketReg] 상품 작업 실패 — 다음 건으로 진행:', product.keyword || '', e);
                        work.failed.push({ registrationId: String(product.registrationId), reason: e.message || '알 수 없는 문제' });
                        continue;
                    }
                    // processProduct 는 작업 하나가 실패해도 상태만 'error' 로 찍고 끝난다(cliPageRunWork 와 같은 사정).
                    // 끝난 뒤 상태를 직접 읽어, 등록 전송 조건(아래 AUTO_WORK_TASKS 전부 완료)에 못 미친 것을 가려낸다.
                    const latest = this.$store.getters.getRocketProductById(product.registrationId) || product;
                    // 일부완료(partially_completed)는 warnings 로 따로 알린다 — 여기서는 실패·끝나지 않은 것만(runWork·startQueue 와 같은 기준 workOutcome)
                    const { failed: failedTasks, unfinished } = workOutcome(latest, AUTO_WORK_TASKS);
                    if (failedTasks.length || unfinished.length) {
                        // 견적서가 멈춘 이유를 같이 싣는다(cliPageRunWork 와 같은 꼴)
                        const quotationError = failedTasks.includes('quotation') ? this.cliQuotationErrorText(latest) : undefined;
                        work.failed.push({
                            registrationId: String(product.registrationId),
                            reason: [failedTasks.length ? `작업 실패: ${failedTasks.join(', ')}` : '', unfinished.length ? `끝나지 않은 작업: ${unfinished.join(', ')}` : ''].filter(Boolean).join(' · ')
                                + (quotationError ? ` — 견적서가 멈춘 이유: ${quotationError}` : '') + (detailImageErrorText(latest) ? ` — 상세이미지가 멈춘 이유: ${detailImageErrorText(latest)}` : '') + (seoErrorText(latest) ? ` — SEO 가 멈춘 이유: ${seoErrorText(latest)}` : '') + (koreanLabelErrorText(latest) ? ` — 한글표시가 멈춘 이유: ${koreanLabelErrorText(latest)}` : ''),
                            failedTasks,
                            unfinishedTasks: unfinished,
                            quotationError
                        });
                    } else {
                        work.succeeded++;
                    }
                }
                work.total = products.length;

                if (skipVerify) return work; // 호출자가 별도로 submitProductsToCoupang 를 처리할 예정


                // Step 2: 등록전송 — 여기서는 대상을 고르지 않는다(«안 보낸 것 전부»를 보내지 않는다). 등록ID 없이 부르므로
                // 전송 함수가 거절하고, 그 까닭을 결과(work.error)에 싣는다 — 조용히 안 보내고 끝내지 않는다
                const started = await this.submitProductsToCoupang();
                if (started && started.refused) work.error = `등록 전송 실패 — ${started.refused}`;
            } catch (error) {
                console.error('[AIRocketReg] 전체작업 처리 실패:', error);
                work.error = error.message || '전체작업 처리 실패';
            }
            return work;
        },

        // 옵션 및 모달 관련 메서드
        async toggleOptions(product) {
            if (!product || !product.registrationId) {
                console.error("유효하지 않은 제품 정보입니다.");
                return;
            }
            // 모달은 옵션 coupangDoc 을 쓴다 — 완전 문서로 받고 연다
            const full = await this.ensureFullProducts(product);
            if (!full) return;
            product = full[0];

            // Vuex로 선택된 상품 저장
            this.SET_SELECTED_ROCKET_PRODUCT(product);

            // 모달 표시
            this.showOptionsModal = true;
        },

        // 상품 편집
        async editProduct(product) {
            const full = await this.ensureFullProducts(product);
            if (!full) return;
            product = full[0];
            this.selectedProduct = product;
            this.showOptionsModal = true;

            // 여기에 Wizard를 열지 않도록!
        },

        // 상품 초기화 (1688에서 다시 가져와서 SEO/가격설정부터 다시 시작)
        async resetProduct(product) {
            if (!product || !product.registrationId) {
                console.error("유효하지 않은 제품 정보입니다.");
                return;
            }

            if (!product.구매링크) {
                this.$bvToast.toast('구매링크가 없어 초기화할 수 없습니다.', {
                    title: '오류',
                    variant: 'danger',
                    solid: true
                });
                return;
            }

            const confirmMessage = `'${product.productName}' 상품을 초기화하시겠습니까?\n\n1688에서 상품 정보를 다시 가져오고, SEO/가격설정부터 다시 진행합니다.\n모든 작업 결과(이미지, 한글라벨, 견적서)가 초기화됩니다.`;

            if (!(await this.confirmInPage(confirmMessage))) {
                return;
            }

            try {
                // 초기화는 rocketRegInfo 를 읽고 상품을 통째 저장한다 — 완전 문서로 받고 시작
                const full = await this.ensureFullProducts(product);
                if (!full) return;
                await this.resetProductToInitialState(full[0]);
            } catch (error) {
                console.error('상품 초기화 실패:', error);
                this.$bvToast.toast(`상품 초기화 중 오류가 발생했습니다: ${error.message}`, {
                    title: '오류',
                    variant: 'danger',
                    solid: true
                });
                this.showspinner1 = false;
                this.resetPendingProduct = null;
            }
        },

        // 상품을 초기 상태로 리셋하는 핵심 로직 (1688 재수집 + Extension 요청)
        async resetProductToInitialState(product) {
            console.log('resetProductToInitialState 호출됨:', product.registrationId);

            // 1. Spinner 표시
            this.loadingtext = '1688에서 상품 정보를 다시 가져오는 중...';
            this.showspinner1 = true;

            // 2. 구매링크에서 productNo 추출
            const productNo = product.구매링크.slice(
                product.구매링크.search('offer/') + 6,
                product.구매링크.search('.html')
            );

            if (!productNo || isNaN(parseInt(productNo))) {
                throw new Error('구매링크에서 상품번호를 추출할 수 없습니다.');
            }

            // 3. 1688 API 호출
            const res = await axios.post('/api/aiPage/getProductInfo', [{ productId: parseInt(productNo) }]);
            if (res.data && res.data.loginRequired) throw new Error(LOGIN_EXPIRED_MESSAGE);
            const data = res.data.result[0].result.result;

            if (!data) {
                throw new Error('1688에서 상품 정보를 가져올 수 없습니다.');
            }

            console.log('1688 상품 정보 재수집 완료:', data.subject);

            // 4. 초기화 모드 설정 및 Extension 요청
            this.resetPendingProduct = product; // 초기화 모드임을 표시
            this.pendingProductData = data;     // 1688 데이터 저장
            this.extensionRequestPending = true;

            // 요청 ID 생성
            this.extensionRequestId = 'reset_product_' + Date.now();

            // 로딩 메시지 업데이트
            this.loadingtext = '쿠팡 카테고리 및 상품 등록 정보 수집 중...';

            // 옵션 수 표시
            if (data.productSkuInfos && data.productSkuInfos.length > 0) {
                this.loadingtext = `쿠팡 카테고리 및 상품 등록 정보 수집 중... (옵션 ${data.productSkuInfos.length}개)`;
            }

            // 5. Extension에 GET_PRODUCT_INFO 요청 (상품추가와 동일)
            const message = {
                type: 'GET_PRODUCT_INFO',
                id: this.extensionRequestId,
                data: {
                    keyword: product.targetKeyword || product.productName,
                    productName: data.subject,
                    productNameTrans: data.subjectTrans,
                    productFeature: product.productFeature || '',
                    supplierCode: this.$store.state.user.suppliercode,
                    categoryCode: product.rocketRegInfo?.categoryCode || this.newProduct.categoryCode,
                    categoryPathString: product.rocketRegInfo?.categoryPath || this.newProduct.categoryPathString,
                    isOption: false
                }
            };

            console.log('초기화용 상품 정보 요청:', message);
            window.postMessage(message, '*');

            // Extension 응답은 PRODUCT_INFO_RESPONSE 핸들러에서 처리됨
            // 핸들러에서 resetPendingProduct가 있으면 초기화 모드로 처리
        },

        // 초기화 모드: 기존 상품을 1688 데이터와 Extension 응답으로 업데이트
        async updateProductWithResetData(existingProduct, productData, extensionData) {
            console.log('updateProductWithResetData 호출됨:', existingProduct.registrationId);

            const regId = existingProduct.registrationId;

            // 1. 1688 데이터로 옵션 재생성
            // 소싱에서 남긴 옵션이 있는 상품은 옵션을 다시 만들어도 그 옵션만 남긴다.
            const processedOptions = this.processOptions(productData, regId, existingProduct.sourcingSkuIds || null);
            console.log('재생성된 옵션 수:', processedOptions.length);
            // 소싱 묶음 수량이 있는 상품은 옵션을 다시 만들어도 그 수량을 지킨다.
            if (existingProduct.sourcingBundleQuantity) {
                this.applySourcingBundleQuantity(processedOptions, Number(existingProduct.sourcingBundleQuantity));
            }
            // 소싱 목표 판매가가 있는 상품도 판매가를 지킨다.
            if (existingProduct.sourcingSellingPrice) {
                this.applySourcingSellingPrice(processedOptions, Number(existingProduct.sourcingSellingPrice), existingProduct.sourcingPurchaseCost || null, null, existingProduct.sourcingSupplyPrice || null, existingProduct.sourcingBundleQuantity || null);
            }

            // 2. 기존 상품 업데이트
            // 기본 정보 업데이트 (1688에서 가져온 정보)
            existingProduct.productName = productData.subject;
            existingProduct.productNameTrans = productData.subjectTrans;
            existingProduct.mainImages = productData.productImage.images;
            existingProduct.detailImages = productData.description
                ? this.getDetailImagesWithTopBottom(this.extractDetailImages(productData.description))
                : [];

            // 3. 옵션 교체
            existingProduct.options = processedOptions;

            // 4. rocketRegInfo 업데이트
            if (extensionData.rocketRegInfo) {
                existingProduct.rocketRegInfo = extensionData.rocketRegInfo;
            }

            // 5. coupangDoc 재초기화
            existingProduct.coupangDoc = this.initializeCoupangDoc(
                extensionData.createResult,
                this.defaultSettings,
                extensionData.rocketRegInfo,
                processedOptions
            );

            // 6. SEO 정보 적용
            if (extensionData.seoData) {
                existingProduct.productNameSeo = extensionData.seoData.productName;
                existingProduct.keywordSeo = extensionData.seoData.keywords;
            }

            // 7. 상태값 초기화 (SEO/가격설정은 completed로 설정)
            existingProduct.seoStatus = 'completed';
            existingProduct.pricingStatus = 'completed';
            existingProduct.mainImageStatus = 'pending';
            existingProduct.additionalImageStatus = 'pending';
            existingProduct.detailImageStatus = 'pending';
            existingProduct.koreanLabelStatus = 'pending';
            existingProduct.quotationStatus = 'pending';
            existingProduct.sizeChartStatus = 'pending';

            // 8. 작업 결과물 삭제 (MongoDB $unset용)
            this.$delete(existingProduct, 'detailImageStatusObj');
            this.$delete(existingProduct, 'koreanLabelImage');
            this.$delete(existingProduct, 'koreanLabels');
            this.$delete(existingProduct, 'detailHtml');
            this.$delete(existingProduct, 'processedDetailImages');

            existingProduct._unsetFields = [
                'detailImageStatusObj',
                'koreanLabelImage',
                'koreanLabels',
                'detailHtml',
                'processedDetailImages'
            ];

            // 9. 업데이트 시간 갱신
            existingProduct.updateDate = Date.now();

            // 10. 서버에 저장
            assertNotLight(existingProduct); // 목록용 문서 저장 금지(resetProduct 가 완전 문서로 받아 온다)
            const saveRes = await axios.post('/api/rocketReg/saveItems', [existingProduct]);
            if (saveRes.data.res !== 'success') {
                throw new Error(saveRes.data.alert || 'rocketReg/saveItems API 호출 실패');
            }

            console.log('상품 초기화 저장 완료:', existingProduct.registrationId);

            // 11. 로컬 목록에서 해당 상품 업데이트
            const index = this.products.findIndex(p => p.registrationId === existingProduct.registrationId);
            if (index !== -1) {
                this.$set(this.products, index, existingProduct);
            }
        },

        // coupangDoc의 노출속성 값들을 초기 상태로 리셋
        resetCoupangDocAttributes(product) {
            if (!product.coupangDoc || !product.coupangDoc.jsonDocument) {
                return;
            }

            product.coupangDoc.jsonDocument.forEach(doc => {
                if (doc.productPage && doc.productPage.commonAttributes) {
                    // 노출속성 값 초기화 (attributeName은 유지, attributeValue만 "해당사항없음"으로)
                    if (doc.productPage.commonAttributes.exposedAttributes) {
                        doc.productPage.commonAttributes.exposedAttributes.forEach(attr => {
                            attr.attributeValue = '해당사항없음';
                        });
                    }
                    // 비노출속성 값 초기화 (attributeValue를 null로)
                    if (doc.productPage.unexposedAttributes) {
                        doc.productPage.unexposedAttributes.forEach(attr => {
                            attr.attributeValue = null;
                        });
                    }
                }
                // 이미지 관련 필드 초기화
                if (doc.imagesPage) {
                    doc.imagesPage.images = [];
                }
                if (doc.logisticsPage) {
                    // 물류 정보는 유지 (가격 정보 포함)
                }
            });

            // productName은 SEO 처리된 상품명 유지
            console.log('coupangDoc 속성 초기화 완료');
        },

        // 쿠팡에 이미 보낸 상품인지 — 서버 거절 조건과 같은 판단이다.
        // 상품 레벨이든 옵션 하나든 보낸 표식이 있으면 보낸 것으로 본다.
        // coupangDoc.docId 는 전송 전에도 생기므로 표식으로 쓰지 않는다.
        // 전송됨·확인 전 — 등록전송 뒤 허브 상태 조회로 아직 확인 못 한 것(tool-exec/rocket-submit.js 가 옵션에 'pending')
        isPendingConfirm(item) {
            if (!item || item.registered === true) return false;
            return (item.options || []).some(option => option && option.registrationStatus === 'pending');
        },

        // 반려 — 보냈는데 서플라이어허브가 «상품 검수 반려»로 보여 준 것(registerConfirm.status 'rejected'). 등록완료 아님
        isRejectedConfirm(item) {
            if (!item || item.registered === true) return false;
            return !!(item.registerConfirm && item.registerConfirm.status === 'rejected');
        },

        isSentToCoupang(item) {
            if (!item) return false;
            if (item.registered === true) return true;
            // registerConfirm.status 는 전송 뒤에만 적힌다(화면 markSentUnconfirmed · 도구 saveSent) — 옵션 없는 상품의 유일한 «보냄» 표식(도구 isSent 와 같은 잣대)
            if (item.registerConfirm && item.registerConfirm.status) return true;
            return (item.options || []).some(
                option => option && (option.registered === true || option.registrationStatus === 'registered' || option.registrationStatus === 'pending')
            );
        },

        // 전송은 됐는데 쿠팡 접수를 확인 못 한 건(서버 등록전송이 남김 — tool-exec/rocket-submit.js). 경고 표시만 — 잠금 아님
        isConfirmPending(item) {
            return !!(item && item.registerConfirm && ['not_found', 'check_failed'].includes(item.registerConfirm.status));
        },

        // 전송이 끝난 뒤 한 번 — 쿠팡 반영을 잠깐 기다렸다가 방금 보낸 건(간격 무시)을 허브에서 확인
        scheduleHubRecheckSoon() {
            clearTimeout(this.hubRecheck.soonTimer);
            this.hubRecheck.soonTimer = setTimeout(() => this.autoRecheckHubConfirm({ minGapMs: 0 }), HUB_SOON_MS);
        },

        // 자동 재확인 — 화면이 보이고, 전송·작업이 안 돌고, 때가 된 «접수 미확인» 건이 있을 때만. 조회 실패 뒤엔 쉰다(과도 호출 막기)
        async autoRecheckHubConfirm({ minGapMs = HUB_AUTO_MIN_GAP_MS } = {}) {
            const now = Date.now();
            if (this.hubRecheck.inFlight || this.isVerifying || this.rocketRegWorking) return;
            if (typeof document !== 'undefined' && document.visibilityState === 'hidden') return;
            if (minGapMs > 0 && now < this.hubRecheck.nextAutoAt) return;
            // 대상은 화면 목록(기본 오늘)이 아니라 기간과 따로 받은 «접수 미확인» 목록 — 어제·그 전에 보낸 밀린 건이 빠지던 것(딩톡 #46 · cpl-x3-reg46recheck-1)
            const pending = await this.fetchPendingRecheck(now, minGapMs);
            if (!pending || !pending.length) return;
            if (this.hubRecheck.inFlight || this.isVerifying || this.rocketRegWorking) return;   // 목록 받는 사이 전송·작업이 시작됐으면 다음 바퀴
            // 초안 번호만 아는 건(딩톡 #46)은 서버 재확인 길(CLI 데몬)이 있을 때만 — 최근 것부터 한 묶음씩
            const due = pickAutoRecheck(pending, now, minGapMs, { byDoc: CLI_DAEMON_ENABLED });
            if (!due.length) return;
            this.recheckHubConfirm(due, { manual: false });
        },

        // «접수 미확인» 목록 한 묶음 — 서버 getlist view:'pending'(기간과 따로 · 최근부터 · before 보다 전에 본 건만 · 상한 = 서버 재확인 한 묶음).
        // 화면 표에 같은 건이 있으면 그 줄을 써서 결과가 표에도 보이게 한다(표에 새 줄은 안 섞는다). 못 받으면 크게 알리고 쉰다 — 화면 목록으로 대신하지 않는다.
        async fetchPendingRecheck(now, minGapMs) {
            if (this.hubRecheck.loadingPending) return null;
            this.hubRecheck.loadingPending = true;
            try {
                const res = await axios.post('/api/aiRocketReg/getlist', { view: 'pending', before: now - minGapMs, limit: AUTO_SERVER_RECHECK_MAX });
                const body = (res && res.data) || {};
                if (body.요청결과 !== 'ok' || !Array.isArray(body.products)) throw new Error(body.error || '접수 미확인 목록 응답 꼴이 다릅니다');
                return body.products.map(p => this.products.find(x => x && String(x._id) === String(p._id)) || p);
            } catch (e) {
                console.error('[AIRocketReg] 접수 미확인 목록을 못 받음 — 자동 재확인 30분 쉼:', e && e.message);
                this.hubRecheck.nextAutoAt = Date.now() + HUB_AUTO_BACKOFF_MS;
                return null;
            } finally {
                this.hubRecheck.loadingPending = false;
            }
        },

        // 확장에 서플라이어허브 등록 상태 목록 한 쪽을 묻는다(GET_REGISTRATION_INSPECTION — 등록 심사 상태 화면과 같은 읽기 전용 길).
        // 응답에 요청 번호가 없어 한 번에 하나만 묻는다(hubRecheck.inFlight). → { ok, items, totalPages, error }
        requestHubInspection({ startDate, endDate, page }) {
            return new Promise((resolve) => {
                let timer = null;
                const finish = (out) => {
                    window.removeEventListener('message', handler);
                    clearTimeout(timer);
                    resolve(out);
                };
                const handler = (event) => {
                    const data = event && event.data;
                    if (event.source !== window || !data || typeof data !== 'object') return;
                    if (data.msg === 'CoupangRegAlert') return finish({ ok: false, error: data.res || '쿠팡 서플라이어허브 연결을 확인해주세요.' });
                    if (data.type !== 'REGISTRATION_INSPECTION_RESPONSE') return;
                    if (data.success !== true) return finish({ ok: false, error: data.error || '등록 상태를 가져오지 못했습니다.' });
                    const nav = data.pageNavigator || {};
                    finish({ ok: true, items: Array.isArray(data.items) ? data.items : [], totalPages: typeof nav.totalPages === 'number' ? nav.totalPages : 1 });
                };
                window.addEventListener('message', handler);
                timer = setTimeout(() => finish({ ok: false, error: '쿠플러스 확장 프로그램이 응답하지 않습니다' }), HUB_RESPONSE_TIMEOUT_MS);
                window.postMessage({
                    type: 'GET_REGISTRATION_INSPECTION',
                    data: { suppliercode: this.$store.state.user.suppliercode, startDate, endDate, state: '', progress: '', productName: '', page, sizePerPage: HUB_PAGE_SIZE },
                }, '*');
            });
        },

        // «접수 미확인» 다시 확인 — 서플라이어허브 등록 상태 목록에서 quotationId(CID-+qvtRequestId)로 찾기만 한다. **전송 없음.**
        // 찾으면 등록됨(반려면 반려), 끝 쪽까지 봐도 없으면 그대로(not_found), 조회 실패면 check_failed — 도구 재확인과 같은 칸(utils/hubRecheck)
        async recheckHubConfirm(list, { manual = false } = {}) {
            if (this.hubRecheck.inFlight) return;
            if (this.isVerifying || this.rocketRegWorking) {
                if (manual) this.showNonBlockingNotice('등록 전송·작업이 끝난 뒤에 다시 눌러주세요.', '접수 다시 확인');
                return;
            }
            let targets = (Array.isArray(list) ? list : [list]).filter(p => needsHubRecheck(p));
            if (!targets.length) return;
            if (!this.$store.state.user.suppliercode) {
                if (manual) this.showNonBlockingNotice('판매자코드가 없어 서플라이어허브에서 확인할 수 없습니다.', '접수 다시 확인');
                return;
            }
            this.hubRecheck.inFlight = true;
            const now = Date.now();
            let failed = null;
            try {
                // 목록용 문서엔 견적 번호(coupangDoc.qvtRequestId)가 없을 수 있다 — 직접 누를 때만 완전 문서로 받아 읽는다
                if (manual && targets.some(p => !quotationIdOf(p) && p._light)) {
                    const fulls = await this.ensureFullProducts(targets);
                    if (fulls) targets = fulls.filter(p => needsHubRecheck(p));
                }
                const withQ = targets.filter(p => quotationIdOf(p));
                // 견적 번호 없이 초안 번호(docId)만 있는 건(화면 전송 건 — 딩톡 #46)은 서버가 접수 목록에서 docId 로 견적 번호를 받아 확인한다(직접 누를 때 + 자동)
                const byDoc = CLI_DAEMON_ENABLED ? targets.filter(p => needsServerRecheck(p)) : [];
                const noQ = targets.length - withQ.length - byDoc.length;
                const byQ = new Map();
                let reachedEnd = false;
                if (withQ.length) {
                    const startDate = hubStartMs(withQ, now);
                    const endDate = now + 24 * 60 * 60 * 1000;
                    const want = new Set(withQ.map(p => quotationIdOf(p)));
                    for (let page = 1; page <= HUB_MAX_PAGES; page++) {
                        const r = await this.requestHubInspection({ startDate, endDate, page });
                        if (!r.ok) { failed = r.error; break; }
                        for (const it of r.items) {
                            const q = it && it.quotationId ? String(it.quotationId) : '';
                            if (q && want.has(q) && !byQ.has(q)) byQ.set(q, it);
                        }
                        if ([...want].every(q => byQ.has(q)) || page >= (r.totalPages || 1)) { reachedEnd = true; break; }
                    }
                    if (!failed && !reachedEnd) failed = `서플라이어허브 등록 상태를 ${HUB_MAX_PAGES}쪽까지만 봤습니다`;
                }
                const count = { found: 0, rejected: 0, not_found: 0, check_failed: 0, save_failed: 0 };
                for (const p of withQ) {
                    const hit = byQ.get(quotationIdOf(p));
                    const fields = applyHubResult(p, hit ? { hit } : (failed ? { error: failed } : { notFound: true }), (o, k, v) => this.$set(o, k, v), now);
                    count[p.registerConfirm.status]++;
                    try {
                        await apiService.updateRocketProductPartial(p._id, fields);
                    } catch (e) {
                        console.error(`[AIRocketReg] ${p.registrationId} 접수 확인 결과 저장 실패:`, e);
                    }
                }
                if (byDoc.length) {
                    const r = await this.recheckViaServer(byDoc);
                    for (const p of byDoc) {
                        // 판정·저장은 서버가 했다 — 화면은 결과만 보여 준다(서버가 이 건에 결과를 안 주면 그대로 두고 조회 실패로 센다)
                        const st = r.rows ? applyServerRecheck(p, r.rows.get(String(p.registrationId)), (o, k, v) => this.$set(o, k, v), now) : null;
                        count[st || 'check_failed']++;
                        // 결과를 못 적은 건도 이번에 본 것으로 시각만 화면에 남긴다(저장 안 함) — 안 그러면 자동 재확인이 같은 묶음만 계속 고른다
                        if ((!st || st === SERVER_SAVE_FAILED) && p.registerConfirm) this.$set(p.registerConfirm, 'at', now);
                    }
                    if (r.error) failed = failed ? `${failed} / ${r.error}` : r.error;
                }
                if (failed) this.hubRecheck.nextAutoAt = Date.now() + HUB_AUTO_BACKOFF_MS;
                if (count.found || count.rejected || manual) {
                    const parts = [count.found && `등록 확인 ${count.found}건`, count.rejected && `반려 ${count.rejected}건`,
                        count.not_found && `아직 못 찾음 ${count.not_found}건`, count.check_failed && `조회 실패 ${count.check_failed}건`,
                        count.save_failed && `저장 실패 ${count.save_failed}건 — 다시 확인`,
                        noQ && `견적 번호 없어 확인 못 함 ${noQ}건`].filter(Boolean);
                    this.$bvToast.toast(`${parts.join(' · ') || '확인할 건이 없습니다'}${failed ? ` — ${failed}` : ''}`, {
                        title: '접수 다시 확인', variant: failed || count.save_failed ? 'warning' : 'info', solid: true, autoHideDelay: 8000, toaster: 'b-toaster-bottom-right'
                    });
                }
            } catch (e) {
                console.error('[AIRocketReg] 접수 다시 확인 실패:', e);
                this.hubRecheck.nextAutoAt = Date.now() + HUB_AUTO_BACKOFF_MS;
                if (manual) this.showNonBlockingNotice(`접수 확인 중 오류가 났습니다: ${e.message}`, '접수 다시 확인');
            } finally {
                this.hubRecheck.inFlight = false;
            }
        },

        // 초안 번호만 아는 건의 허브 재확인 — CLI 데몬으로 서버 도구 rocket.sourcing.submitRegistration 을 recheckOnly 로 부른다(보내지 않음).
        // 서버가 접수 목록(register-requested)에서 docId 가 같은 줄의 견적 번호만 받아 허브 상태로 등록완료/반려를 확정·저장한다(도구 재확인과 같은 길).
        // → { rows: Map(registrationId → 결과 줄) | null, error }
        async recheckViaServer(list) {
            const rows = new Map();
            const errors = [];
            const ids = list.map(p => String(p.registrationId));
            for (let i = 0; i < ids.length; i += HUB_SERVER_RECHECK_CHUNK) {
                try {
                    const res = await axios.post(cliDaemonUrl('/api/cli/tool/rocket.sourcing.submitRegistration'), {
                        params: { registrationIds: ids.slice(i, i + HUB_SERVER_RECHECK_CHUNK), recheckOnly: true, account: this.$store.state.user.suppliercode },
                    });
                    const body = res.data || {};
                    if (!body.success) throw new Error(body.error || '서버 재확인 실패');
                    for (const row of ((body.result && body.result.products) || [])) if (row && row.registrationId) rows.set(String(row.registrationId), row);
                } catch (e) {
                    // 응답이 아예 없으면 데몬(쿠플러스 CLI)이 꺼져 있다 — «Network Error» 대신 할 일을 말한다
                    const msg = e.response ? ((e.response.data && e.response.data.error) || e.message) : '쿠플러스 CLI 가 꺼져 있어 확인하지 못했습니다(CLI 를 켠 뒤 다시 누르세요)';
                    console.error('[AIRocketReg] 서버 접수 재확인 실패:', msg);
                    errors.push(msg);
                }
            }
            return { rows, error: errors.length ? `초안 번호로 확인 실패: ${errors[0]}` : null };
        },

        // 상품 삭제
        async deleteProduct(product) {
            if (!product || !product.registrationId) {
                console.error("유효하지 않은 제품 정보입니다.");
                return;
            }

            // 전송된 건은 여기서 먼저 끊는다. 아래에서 쿠팡 문서 삭제를 확장에 먼저 보내기 때문에,
            // 서버 거절만 믿으면 쿠팡 문서는 이미 지워진 뒤가 된다.
            if (this.isSentToCoupang(product)) {
                console.error(`상품 ${product.registrationId}: 쿠팡에 전송된 건이라 삭제하지 않습니다.`);
                this.$bvToast.toast('쿠팡에 이미 전송된 상품이라 삭제할 수 없습니다. 쿠팡에서 먼저 처리한 뒤 다시 시도해주세요.', {
                    title: '삭제할 수 없습니다',
                    variant: 'warning',
                    solid: true,
                    toaster: 'b-toaster-bottom-right',
                    autoHideDelay: 6000
                });
                return;
            }

            // 상품에 coupangDoc이 있는지 확인
            const hasCoupangDoc = product.coupangDoc && product.coupangDoc.docId;

            const confirmMessage = hasCoupangDoc ?
                `'${product.productName}' 상품과 관련된 쿠팡 문서를 삭제하시겠습니까?` :
                `'${product.productName}' 상품을 삭제하시겠습니까?`;

            if (!(await this.confirmInPage(confirmMessage))) {
                return;
            }

            try {
                // 상품 레벨 coupangDoc 삭제 요청
                if (hasCoupangDoc) {
                    // 확장 프로그램에 문서 삭제 요청 메시지 전송
                    window.postMessage({
                        type: 'DELETE_ROCKET_REG_DOC',
                        id: `delete_product_${product.registrationId}_${Date.now()}`,
                        data: {
                            docId: product.coupangDoc.docId,
                            suppliercode: this.$store.state.user.suppliercode
                        }
                    }, '*');

                    console.log(`상품 ${product.registrationId}의 쿠팡 문서 삭제 요청 (docId: ${product.coupangDoc.docId})`);

                    // 연속 요청 시 확장 프로그램에 부하가 가지 않도록 짧은 딜레이 추가
                    await new Promise(resolve => setTimeout(resolve, 100));
                }
                // 이전 코드에서 이미 처리했으므로 이 부분은 제거

                // API 호출 - 서버 데이터베이스에서 상품 삭제
                const res = await axios.post('/api/rocketReg/deleteItem', product);

                if (res.data.res === 'success') {
                    // 목록에서 제거
                    const index = this.products.findIndex(p => p.registrationId === product.registrationId);
                    if (index !== -1) {
                        this.products.splice(index, 1);
                    }

                    // 선택된 상품 목록에서도 제거
                    const selectedIndex = this.selectedItems.findIndex(p => p.registrationId === product.registrationId);
                    if (selectedIndex !== -1) {
                        this.selectedItems.splice(selectedIndex, 1);
                    }

                    this.$bvToast.toast('상품이 삭제되었습니다.', {
                        title: '성공',
                        variant: 'success',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                } else {
                    // 서버가 왜 못 지우는지 알려준다(전송된 건 등). 삼키면 "눌렀는데 아무 일도 없음"이 된다.
                    console.error('상품 삭제 거절:', res.data.alert);
                    this.$bvToast.toast(res.data.alert || '상품 삭제에 실패하였습니다.', {
                        title: '삭제할 수 없습니다',
                        variant: 'warning',
                        solid: true,
                        toaster: 'b-toaster-bottom-right',
                        autoHideDelay: 6000
                    });
                }
            } catch (error) {
                console.error('상품 삭제 오류', error);
                this.$bvToast.toast('상품 삭제에 실패하였습니다.', {
                    title: '실패',
                    variant: 'warning',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
            }
        },

        // 옵션 삭제 처리
        handleOptionDeleted(product) {
            // 상품 업데이트 처리
            this.updateProduct(product);
        },

        // 상품 업데이트
        async updateProduct(product) {
            try {
                // Vuex 액션 호출
                await this.updateRocketProduct(product);
                return true;
            } catch (error) {
                console.error('상품 정보 업데이트 중 오류:', error);
                this.$bvToast.toast(`상품 정보 업데이트 실패: ${error.message}`, {
                    title: '실패',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
                return false;
            }
        },

        // 마법사 모달 닫힘 처리
        handleWizardClosed() {
            console.log("위자드 모달 닫힘");

            try {
                // 선택된 상품이 있으면
                if (this.selectedProduct) {
                    // 테이블 UI 강제 갱신을 위한 코드
                    const index = this.products.findIndex(p => p.registrationId === this.selectedProduct.registrationId);
                    if (index !== -1) {
                        // Vuex 상태에서 최신 상품 정보 가져오기
                        const updatedProduct = JSON.parse(JSON.stringify(this.selectedProduct));

                        // Vue의 반응성을 보장하기 위해 $set 사용
                        this.$set(this.products, index, updatedProduct);

                        // 🔧 QuotationEdit에서 pending 변경사항이 이미 저장되었으므로
                        // 추가적인 전체 상품 저장은 필요 없음 (중복 저장 방지)
                        console.log("💾 QuotationEdit에서 이미 변경사항이 저장되었으므로 추가 저장 생략");
                    }

                    // 옵션 모달이 열려있는 경우 선택된 상품도 동기화 업데이트
                    if (this.showOptionsModal) {
                        // 최신 제품 정보 가져오기
                        const latestProduct = this.products.find(p =>
                            p.registrationId === this.selectedProduct.registrationId
                        );

                        if (latestProduct) {
                            // 갱신된 정보로 Vuex 상태 업데이트
                            this.SET_SELECTED_ROCKET_PRODUCT(JSON.parse(JSON.stringify(latestProduct)));
                        }
                    }
                }

                // 선택된 작업 초기화 (옵션 유지)
                this.SET_SELECTED_WORK_TYPE("");
            } catch (error) {
                console.error("위자드 닫힘 처리 중 오류:", error);
            }
        },
        // 검증 상태 배지 색상 결정
        getVerificationStatusVariant(product) {
            if (this.isConfirmPending(product)) return 'warning';   // 접수 미확인
            // 상품 자체가 registered 플래그를 가지고 있는지 확인
            if (product.registered === true) {
                return 'success'; // 등록 완료
            }

            // 서플라이어허브 반려 — 등록 완료로 세지 않는다
            if (this.isRejectedConfirm(product)) {
                return 'danger';
            }

            // 모든 옵션에 대한 상태 확인
            if (product.options && product.options.length > 0) {
                // 등록 완료된 옵션 수
                const registeredCount = product.options.filter(opt => opt.registrationStatus === 'registered').length;
                // 전송됨·확인 전 옵션 수 — 등록 완료와 따로 센다
                const pendingCount = product.options.filter(opt => opt && opt.registrationStatus === 'pending').length;
                // docId가 있는 옵션 수 (실제 등록된 옵션)
                const docIdCount = product.options.filter(opt => opt.coupangDoc && opt.coupangDoc.docId).length;
                // 검증 완료된 옵션 수
                const verifiedCount = product.options.filter(opt => opt.verified === true).length;

                // 전체 옵션 수
                const totalOptions = product.options.length;

                // 보냈지만 허브에서 아직 확인 전 — docId·verified 가 있어도 등록 완료 아님
                if (pendingCount > 0 && registeredCount < totalOptions) {
                    return 'info';
                }
                // docId가 있는 옵션이 전체인 경우 (실제 등록 완료)
                if (docIdCount === totalOptions && docIdCount > 0) {
                    return 'success'; // 등록 완료
                }
                // registrationStatus가 'registered'인 옵션이 전체인 경우
                else if (registeredCount === totalOptions && registeredCount > 0) {
                    return 'success'; // 등록 완료
                }
                // 전체 옵션이 검증 완료된 경우
                else if (verifiedCount === totalOptions && verifiedCount > 0) {
                    return 'success'; // 등록 완료
                }
            }

            if (product.verified) {
                return 'secondary'; // 검증 완료
            }

            // 검증 오류가 있는지 확인
            if (this.hasVerificationErrors(product)) {
                return 'danger'; // 검증 오류
            }

            return 'secondary'; // 검증 필요
        },

        // 검증 오류 여부 확인
        hasVerificationErrors(product) {
            // 상품 자체에 오류 정보가 있는 경우
            if (product.errorDetails) {
                return true;
            }

            // 옵션에 오류 정보가 있는지 확인
            if (product.options && product.options.length > 0) {
                return product.options.some(option => option.errorDetails);
            }

            return false;
        },

        // 작업 타입을 한국어 이름으로 변환
        getWorkTypeName(workType) {
            const workTypeNames = {
                'seoStatus': 'SEO 설정',
                'mainImageStatus': '대표 이미지',
                'additionalImageStatus': '추가 이미지',
                'detailImageStatus': '상세 이미지',
                'sizeChartStatus': '사이즈표',
                'koreanLabelStatus': '한글표시사항',
                'quotationStatus': '가격 설정'
            };
            return workTypeNames[workType] || workType;
        },

        // 검증 상태 툴팁 메시지 생성
        getVerificationStatusTooltip(product) {
            if (this.isConfirmPending(product)) {
                const rc = product.registerConfirm || {};
                const head = rc.status === 'check_failed'
                    ? `쿠팡에 보냈지만 서플라이어허브 등록 상태를 조회하지 못했습니다${rc.error ? `(${rc.error})` : ''}`
                    : '쿠팡에 보냈지만 서플라이어허브 등록 상태 목록에서 아직 찾지 못했습니다(쿠팡 반영까지 몇 분 걸릴 수 있고, 검수가 끝난 건은 목록에서 빠집니다)';
                const how = quotationIdOf(product)
                    ? " — 화면이 열려 있으면 자동으로 다시 확인합니다. 바로 보려면 '접수 다시 확인'을 누르세요"
                    : needsServerRecheck(product)
                        ? (CLI_DAEMON_ENABLED
                            ? " — 화면이 열려 있으면 초안 번호로 쿠팡 접수 목록에서 찾아 자동으로 다시 확인합니다(쿠플러스 CLI 가 켜져 있어야 합니다). 바로 보려면 '접수 다시 확인'을 누르세요"
                            : " — 견적 번호가 없고 이 화면엔 쿠플러스 CLI 연결이 없어 확인할 수 없습니다. 서플라이어허브 '상품 등록 상태 확인'에서 확인하세요")
                        : " — 견적 번호·초안 번호가 없어 자동 확인을 못 합니다. 서플라이어허브 '상품 등록 상태 확인'에서 확인하세요";
                return `${head}${how}. 다시 전송하지 마세요(중복 접수 위험)`;
            }
            // 상품 자체가 registered 플래그를 가지고 있는지 확인
            if (product.registered === true) {
                return '등록이 성공적으로 완료되었습니다';
            }

            if (this.isRejectedConfirm(product)) {
                const rc = product.registerConfirm || {};
                return `쿠팡에 전송했지만 서플라이어허브에서 반려됐습니다${rc.hubState ? ` (${rc.hubState})` : ''}${rc.rejectReason ? ` — 사유: ${rc.rejectReason}` : ''}. 다시 보내지 말고 쿠팡 서플라이어허브에서 사유를 보고 새로 등록하세요`;
            }

            // 모든 옵션에 대한 상태 확인
            if (product.options && product.options.length > 0) {
                // 등록 완료된 옵션 수
                const registeredCount = product.options.filter(opt => opt.registrationStatus === 'registered').length;
                // 전송됨·확인 전 옵션 수 — 등록 완료와 따로 센다
                const pendingCount = product.options.filter(opt => opt && opt.registrationStatus === 'pending').length;
                // docId가 있는 옵션 수 (실제 등록된 옵션)
                const docIdCount = product.options.filter(opt => opt.coupangDoc && opt.coupangDoc.docId).length;
                // 검증 완료된 옵션 수
                const verifiedCount = product.options.filter(opt => opt.verified === true).length;

                // 전체 옵션 수
                const totalOptions = product.options.length;

                if (pendingCount > 0 && registeredCount < totalOptions) {
                    return `전송됨·확인 전 (옵션 ${pendingCount}/${totalOptions}) — 쿠팡에 전송함 · 서플라이어허브에서 아직 확인 전입니다. 다시 보내지 마세요`;
                }
                // docId가 있는 옵션이 전체인 경우 (실제 등록 완료)
                if (docIdCount === totalOptions && docIdCount > 0) {
                    return '등록이 성공적으로 완료되었습니다';
                }
                // registrationStatus가 'registered'인 옵션이 전체인 경우
                else if (registeredCount === totalOptions && registeredCount > 0) {
                    return '등록이 성공적으로 완료되었습니다';
                }
                // 전체 옵션이 검증 완료된 경우
                else if (verifiedCount === totalOptions && verifiedCount > 0) {
                    return '등록이 성공적으로 완료되었습니다';
                }
            }

            // 모든 오류 메시지 수집 (상품 + 옵션)
            const allErrors = [];

            // 상품 자체의 오류 메시지
            if (product.errorDetails) {
                console.log(product.errorDetails);

                // errorDetails가 object인 경우 텍스트로 변환
                const errorText = this.convertErrorDetailsToText(product.errorDetails);

                // 상품 오류가 이미 옵션 오류의 집합인 경우는 그대로 반환
                if (typeof errorText === 'string' && errorText.includes('옵션 ')) {
                    return errorText.replace(/\n\n/g, ' | ').replace(/\n/g, ' - ');
                }
                allErrors.push(errorText);
            }

            // 옵션별 오류 메시지 수집
            if (product.options && product.options.length > 0) {
                product.options.forEach((option, index) => {
                    if (option.errorDetails) {
                        // errorDetails가 object인 경우 텍스트로 변환
                        const errorText = this.convertErrorDetailsToText(option.errorDetails);
                        allErrors.push(`옵션 ${index + 1} - ${errorText}`);
                    }
                });
            }

            // 오류가 하나라도 있으면 표시
            if (allErrors.length > 0) {
                return allErrors.join(' | ');
            }

            // 오류가 없고 검증 완료된 경우
            if (product.verified) {
                return '등록이 성공적으로 완료되었습니다'; // 검증이 성공적으로 완료되었습니다 -> 등록이 성공적으로 완료되었습니다
            }

            // 기본 메시지
            return '검증이 필요한 상태입니다';
        },

        // 목록 칸 「처리중 12/50」 — 옵션이 많은 상품은 한 작업이 몇 분씩 걸려 칸만 보면 멈춘 줄 안다(99DCAD)
        stepCountText(product, task) {
            void this.workProgressTick; // workProgress 는 Vue 가 모르는 값이라 이것으로 다시 그린다
            if (!product || this.getWorkStatus(product, `${task}Status`) !== 'processing') return '';
            return formatStepCount(product.registrationId, task);
        },

        // AIRocketReg.vue의 getWorkStatus 메서드 수정
        getWorkStatus(product, workType) {
            if (workType === 'sizeChartStatus') {
                // 사이즈표가 필요 없는 경우 'disabled' 반환
                if (!this.isSizeChartRequired(product)) {
                    return 'disabled';
                }
            }
            if (product[workType] && product[workType] !== 'pending') {
                return product[workType];
            }
            // 1. 상품 자체의 상태 확인
            if (product[workType]) {
                // 상태가 객체인 경우 (예: { status: 'completed' })
                if (typeof product[workType] === 'object' && product[workType].status) {
                    return product[workType].status;
                }
                // 상태가 문자열인 경우
                if (typeof product[workType] === 'string') {
                    return product[workType];
                }
            }

            // 2. 옵션이 없으면 'disabled' 반환
            if (!product.options || product.options.length === 0) return 'disabled';

            const totalOptions = product.options.length;

            // 옵션별 상태를 집계
            const statuses = product.options.map(option => {
                // 객체 형태인 경우 (예: mainImageStatus: { status: 'completed' })
                if (option[workType] && typeof option[workType] === 'object') {
                    return option[workType].status || 'pending';
                }
                // 문자열 형태인 경우 (예: mainImageStatus: 'completed')
                return option[workType] || 'pending';
            });

            // 모든 옵션이 완료되었는지 확인
            const completedCount = statuses.filter(status => status === 'completed').length;

            // 처리 중인 옵션이 있는지 확인
            const processingCount = statuses.filter(status => status === 'processing').length;

            // 오류가 있는 옵션 수
            const errorCount = statuses.filter(status => status === 'error').length;

            // 상태 결정 로직
            if (completedCount === totalOptions) {
                return 'completed'; // 모든 옵션 완료
            } else if (completedCount > 0) {
                return 'partially_completed'; // 일부 옵션만 완료
            } else if (processingCount > 0) {
                return 'processing'; // 처리 중인 옵션 있음
            } else if (errorCount > 0) {
                return 'error'; // 오류 발생한 옵션 있음
            } else {
                return 'pending'; // 대기 상태
            }
        },
        // 수정 후 코드
        async startProcessing() {
            if (!this.hasSelectedProducts) {
                this.$bvToast.toast('처리할 상품을 선택해주세요.', {
                    title: '알림',
                    variant: 'warning',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
                return;
            }

            // if (!this.$store.state.settings[0]?.geminiAPIKey) {
            //     this.$bvToast.toast('계정관리 > 설정 > Gemini API 설정 에서 Gemini API Key를 먼저 설정해 주세요', {
            //         title: '설정 필요',
            //         variant: 'warning',
            //         solid: true,
            //         toaster: 'b-toaster-bottom-right'
            //     });
            //     return;
            // }

            this.isProcessing = true;
            try {
                // 선택된 작업 유형에 따라 처리할 작업 목록 설정
                // 'all'인 경우 null을 전달하면 workflowService에서 완료 안된 작업만 자동 필터링
                let tasksToProcess = null;

                if (this.selectedWorkType === 'all') {
                    // null 전달 → workflowService에서 완료 안된 작업만 병렬 처리
                    tasksToProcess = null;
                    console.log('작업 개시: 전체 작업 (완료 안된 작업만 병렬 처리)');
                } else {
                    // 개별 작업 선택 시
                    tasksToProcess = [this.selectedWorkType];
                    console.log(`작업 개시: ${this.selectedWorkType}`);
                }

                // 가공은 무거운 칸을 쓴다 — 선택 전부를 완전 문서로 받고 store 것을 쓴다(실패하면 안내 후 멈춤)
                const fullItems = await this.ensureFullProducts(this.selectedItems);
                if (!fullItems) return;

                // 선택된 상품들 처리
                let needsRefresh = false;
                let hasErrors = false;
                for (const product of fullItems) {
                    try {
                        console.log(`상품 ${product.registrationId} 처리 시작`);

                        // 선택된 작업만 처리
                        const result = await workflowService.processProduct(product, tasksToProcess);
                        console.log(`상품 ${product.registrationId} 처리 결과:`, result);

                        // 상품 분리가 발생한 경우 새로고침 플래그 설정
                        if (result && result.needsRefresh) {
                            needsRefresh = true;
                            console.log('상품 분리 감지됨. 검색 새로고침이 필요합니다.');
                        }

                        // 처리 후 상태 확인
                        const updatedProduct = this.products.find(p => p.registrationId === product.registrationId);
                        if (updatedProduct) {
                            console.log(`처리 후 상품 상태:`, {
                                mainImageStatus: updatedProduct.mainImageStatus,
                                optionsStatus: updatedProduct.options.map(o => ({
                                    optionNumber: o.optionNumber,
                                    mainImageStatus: o.mainImageStatus?.status || o.mainImageStatus
                                }))
                            });

                            // SEO 작업이 포함되었고 완료된 경우, 여기서는 쿠팡 문서 업데이트를 건너뜁니다.
                            // 실제 문서 업데이트는 '등록 전송' 버튼을 통해 진행하게 됩니다.
                        }
                    } catch (productError) {
                        hasErrors = true;
                        console.error(`상품 ${product.registrationId} 처리 중 오류:`, productError);

                        // 에러가 발생한 작업의 상태를 'error'로 업데이트
                        const updatedProduct = this.$store.getters.getRocketProductById(product.registrationId);
                        if (updatedProduct) {
                            // 처리 중이던 작업들의 상태를 'error'로 변경
                            for (const task of tasksToProcess) {
                                const statusField = `${task}Status`;
                                if (updatedProduct[statusField]) {
                                    if (typeof updatedProduct[statusField] === 'object') {
                                        updatedProduct[statusField].status = 'error';
                                    } else {
                                        updatedProduct[statusField] = 'error';
                                    }
                                }
                            }

                            // 상품 업데이트
                            await this.$store.dispatch('updateRocketProduct', updatedProduct);
                        }

                        // Gemini API 에러인 경우 전체 프로세스 중단
                        if (productError.message && productError.message.startsWith('GEMINI_API_ERROR:')) {
                            console.error('Gemini API 오류로 인해 전체 프로세스를 중단합니다.');
                            // 큐에 남아있는 모든 요청 취소
                            workflowService.clearQueue();
                            break;
                        }
                    }
                }

                // 상품 분리가 발생한 경우 검색 새로고침
                if (needsRefresh) {
                    console.log('🔄 상품 분리로 인한 검색 새로고침 실행');
                    await this.search();
                    this.$bvToast.toast('상품 분리가 완료되어 목록을 새로고침했습니다.', {
                        title: '상품 분리 완료',
                        variant: 'success',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                }

                // 완료 메시지 표시
                if (hasErrors) {
                    this.$bvToast.toast('일부 상품 처리 중 오류가 발생했습니다.', {
                        title: '일부 완료',
                        variant: 'warning',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                } else {
                    this.$bvToast.toast('선택한 상품의 작업이 완료되었습니다.', {
                        title: '성공',
                        variant: 'success',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                }
            } catch (error) {
                console.error('작업 처리 중 오류:', error);
                this.$bvToast.toast('작업 처리 중 오류가 발생했습니다.', {
                    title: '오류',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
            } finally {
                this.isProcessing = false;
            }
        },

        // AI 테스트 요청
        async testRequestExtension() {
            // 선택된 상품이 있는지 확인
            if (this.selectedItems.length === 0) {
                this.$bvToast.toast('테스트할 상품을 먼저 선택해주세요', {
                    title: '알림',
                    variant: 'warning',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
                return;
            }

            // API 키 확인
            if (!this.$store.state.settings[0]?.hasGeminiKey) {
                this.$bvToast.toast('계정관리 > 설정 > Gemini API 설정 에서 Gemini API Key를 먼저 설정해 주세요', {
                    title: '설정 필요',
                    variant: 'warning',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
                return;
            }

            // 테스트할 상품 선택 (목록용이면 완전 문서로 받아 store 것을 쓴다)
            const fullTest = await this.ensureFullProducts(this.selectedItems[0]);
            if (!fullTest) return;
            const testProduct = fullTest[0];

            // Vuex 액션 호출
            try {
                await this.testRequestExtension(testProduct);
            } catch (error) {
                console.error('AI 테스트 중 오류:', error);
                this.$bvToast.toast(`AI 테스트 중 오류가 발생했습니다: ${error.message}`, {
                    title: '오류',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
            }
        },

        // 쿠팡 등록전송 — 확인만 하는 함수가 아니다. 확장(VERIFY_ROCKET_REG_DOC)이 초안 생성→저장→검증→**등록**까지 한 번에 한다.
        // 확인 전용 경로는 없다(체크·준비 확인은 cliPageCheckSupplierTab 등 별도). 옛 이름 verifyProducts 가 확인용으로 읽혀 이름을 바꿨다.
        // opts.byClick = 화면 «등록 전송» 버튼(사람). 그 밖의 호출(CLI 화면 작업·대기열)은 opts.registrationIds 필수 —
        // 체크된 행(selectedItems)을 그대로 믿지 않는다(2026-10-16 PR261016-3043EA: 보류한 상품까지 나갔다).
        async submitProductsToCoupang(opts = {}) {
            console.log('submitProductsToCoupang() 시작');
            // 전송 중에 또 들어오면(버튼 두 번·자동 전송 겹침) 대기열이 새로 깔려 같은 행이 두 번 나간다 — 받지 않는다
            if (this.isVerifying) {
                const why = '등록 전송이 이미 진행 중이라 새 전송을 시작하지 않았습니다. 끝난 뒤에 다시 보내주세요.';
                console.error('[AIRocketReg] ' + why);
                this.$bvToast.toast(why, {
                    title: '등록 전송 보류', variant: 'warning', solid: true, toaster: 'b-toaster-bottom-right'
                });
                return { refused: why };
            }
            const byClick = !!(opts && opts.byClick === true);
            if (!byClick) {
                const ids = new Set((Array.isArray(opts && opts.registrationIds) ? opts.registrationIds : []).map(String).filter(Boolean));
                if (!ids.size) {
                    const why = '보낼 등록ID 없이 자동 등록 전송이 요청돼 보내지 않았습니다. 등록ID를 지정해 rocket.sourcing.submitRegistration 으로 보내주세요.';
                    console.error('[AIRocketReg] ' + why);
                    this.$bvToast.toast(why, {
                        title: '등록 전송 보류', variant: 'warning', solid: true, autoHideDelay: 10000, toaster: 'b-toaster-bottom-right'
                    });
                    return { refused: why };
                }
                this.selectedItems = this.selectedItems.filter(p => ids.has(String(p.registrationId)));
            }

            if (this.selectedItems.length === 0) {
                console.log('선택된 상품 없음');
                this.$bvToast.toast('검증할 상품을 먼저 선택해주세요', {
                    title: '알림',
                    variant: 'warning',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
                return;
            }

            // 반려 — 서플라이어허브가 받지 않은 건. 다시 보내지 않고 쿠팡에서 사유를 보고 새로 등록하게 안내한다(재접수를 받는지 모름)
            const rejectedProducts = this.selectedItems.filter(product => this.isRejectedConfirm(product));
            if (rejectedProducts.length > 0) {
                const lines = rejectedProducts.map(product => {
                    const rc = product.registerConfirm || {};
                    return `${this.getDisplayProductName(product)}${rc.rejectReason ? ` — 사유: ${rc.rejectReason}` : ''}`;
                }).join('\n');
                await this.$bvModal.msgBoxOk(
                    `다음 상품은 쿠팡 서플라이어허브에서 반려됐습니다:\n\n${lines}\n\n다시 보내지 않았습니다. 쿠팡 서플라이어허브에서 반려 사유를 보고 새로 등록해주세요.`,
                    { title: '반려된 상품', size: 'lg', buttonSize: 'sm', okTitle: '확인', footerClass: 'p-2', centered: true }
                );
                return;
            }

            // 전송됨·확인 전(옵션 pending) — 쿠팡에 이미 접수됐을 수 있어 다시 보내면 두 번 접수된다. 재전송 확인창 없이 막는다
            const pendingProducts = this.selectedItems.filter(product => this.isPendingConfirm(product));
            if (pendingProducts.length > 0) {
                const pendingNames = pendingProducts.map(product => this.getDisplayProductName(product)).join(', ');
                await this.$bvModal.msgBoxOk(
                    `다음 상품은 이미 쿠팡에 전송됐고 아직 접수 확인 전입니다:\n\n${pendingNames}\n\n다시 보내면 쿠팡에 두 번 접수될 수 있어 보내지 않았습니다. 지금 서플라이어허브 등록 상태를 다시 확인해 등록완료·반려(사유)로 바꿔 드립니다.`,
                    { title: '전송됨·확인 전 상품', size: 'lg', buttonSize: 'sm', okTitle: '확인', footerClass: 'p-2', centered: true }
                );
                // 막고 끝내지 않는다 — 창을 닫으면 그 건들로 바로 허브 확인(읽기만, 전송 없음 · 딩톡 #46 · #3145 에 있던 것이 #3156 뒤 빠졌다)
                this.recheckHubConfirm(pendingProducts, { manual: true });
                return;
            }

            // 보내기 직전 서버 문서를 다시 읽는다 — 화면이 모르는 사이 서버(도구)가 이미 보낸 건을 또 보내면
            // 쿠팡이 DUPLICATE_PRODUCT 로 거절한다. 화면도 «보냄»으로 아는 건(사람 클릭)은 아래 재전송 확인에 맡긴다.
            let serverSent;
            try {
                serverSent = await this.fetchServerSentIds(this.selectedItems.map(p => String(p.registrationId)));
            } catch (e) {
                console.error('[AIRocketReg] 등록전송 전 서버 상태 확인 실패:', e);
                const why = '서버에서 상품의 최신 전송 상태를 확인하지 못해 등록 전송을 하지 않았습니다. 잠시 뒤 다시 시도해주세요.';
                this.$bvToast.toast(why, {
                    title: '등록 전송 보류', variant: 'warning', solid: true, toaster: 'b-toaster-bottom-right'
                });
                return { refused: why };
            }
            if (this._serverBlockSubmit) {
                const why = `시험 가드(COUPLUS_E2E_BLOCK_SUBMIT): 서버가 등록 전송을 막는 판이라 쿠팡으로 보내지 않았습니다(${this.selectedItems.length}건).`;
                console.error('[guard] COUPLUS_E2E_BLOCK_SUBMIT — 확장 등록전송(VERIFY_ROCKET_REG_DOC) 안 보냄', this.selectedItems.map(p => p.registrationId).join(', '));
                this.$bvToast.toast(why, { title: '시험 가드: 쿠팡 전송 막음', variant: 'danger', solid: true, autoHideDelay: 15000, toaster: 'b-toaster-bottom-right' });
                return { refused: why, guard: 'e2e-block-submit' };
            }
            // 1688 상품의 «국산» 원산지 주장·근거 없는 «여아» 대상 말 — 고쳐 저장한 뒤 보낸다(#240-2 · PR261017-2A7068).
            // 도구 전송(tool-exec/rocket-submit.js)과 같은 파일(submitOriginFix)로 고친다. 이름이 안 남아 못 고치는 건만 보류
            const originHeld = [];
            for (const p of this.selectedItems) {
                const fix = fixOriginForSubmit(p);
                if (fix.invalid) { this.$set(p, 'errorDetails', fix.invalid); originHeld.push(p); continue; }
                if (!Object.keys(fix.patch).length) continue;
                try {
                    await apiService.updateRocketProductPartial(p._id, fix.patch);
                } catch (e) {
                    console.error('[AIRocketReg] 원산지 말 고쳐 저장 실패:', p.registrationId, e);
                    this.$set(p, 'errorDetails', `원산지 표기(국산) 말을 고쳐 저장하지 못해 보내지 않았습니다(${fix.changes.join(' / ')}). 잠시 뒤 다시 전송하세요.`);
                    originHeld.push(p);
                    continue;
                }
                Object.keys(fix.patch).forEach(key => {
                    const keys = key.split('.');
                    let obj = p;
                    for (let i = 0; i < keys.length - 1; i++) {
                        if (obj[keys[i]] == null) this.$set(obj, keys[i], {});
                        obj = obj[keys[i]];
                    }
                    this.$set(obj, keys[keys.length - 1], fix.patch[key]);
                });
                this.$set(p, 'originFix', fix.changes);
                console.warn('[AIRocketReg] 원산지·대상 말 고쳐 보냄:', p.registrationId, fix.changes.join(' / '));
                this.$bvToast.toast(`${this.getDisplayProductName(p) || p.registrationId}: ${fix.changes.join(' / ')}`, {
                    title: '등록 전송 전 말 고침', variant: 'info', solid: true, autoHideDelay: 10000, toaster: 'b-toaster-bottom-right'
                });
            }
            if (originHeld.length) {
                const names = originHeld.map(p => this.getDisplayProductName(p) || p.registrationId).join(', ');
                this.$bvToast.toast(`보내지 않음: ${names} — ${originHeld[0].errorDetails}`, {
                    title: '등록 전송 보류(원산지)', variant: 'danger', solid: true, autoHideDelay: 15000, toaster: 'b-toaster-bottom-right'
                });
                const heldIds = new Set(originHeld.map(p => String(p.registrationId)));
                this.selectedItems = this.selectedItems.filter(p => !heldIds.has(String(p.registrationId)));
                if (!this.selectedItems.length) return { refused: `원산지 표기(국산)로 보내지 않았습니다: ${names}. ${originHeld[0].errorDetails}` };
            }
            // 상세이미지 780×500px 미달이면 허브가 반려한다(002 · PR261021-C2CA3A). 도구 전송(tool-exec/rocket-submit.js)과 같은 잣대·말(detailImageMin).
            // 그림을 불러 실제 크기를 잰다 — 못 읽으면(불러오기 실패·시간 넘김) 보내지 않는다(지어낸 크기 0). 같은 주소는 한 번만
            const sizeUrls = [...new Set(this.selectedItems.flatMap(p => detailImageUrls(p.coupangDoc)))];
            const sizeOf = new Map(await Promise.all(sizeUrls.map(async u => [u, await measureImage(Image, u)])));
            const sizeHeld = [];
            for (const p of this.selectedItems) {
                const urls = detailImageUrls(p.coupangDoc);
                const why = urls.map((u, i) => detailSizeReason(i, u, sizeOf.get(u))).find(Boolean);
                if (why) { this.$set(p, 'errorDetails', why); sizeHeld.push(p); }
            }
            if (sizeHeld.length) {
                const names = sizeHeld.map(p => this.getDisplayProductName(p) || p.registrationId).join(', ');
                console.error('[AIRocketReg] 상세이미지 크기로 등록 전송 보류:', sizeHeld.map(p => `${p.registrationId} ${p.errorDetails}`).join(' | '));
                this.$bvToast.toast(`보내지 않음: ${names} — ${sizeHeld[0].errorDetails}`, {
                    title: '등록 전송 보류(상세이미지)', variant: 'danger', solid: true, autoHideDelay: 15000, toaster: 'b-toaster-bottom-right'
                });
                const heldIds = new Set(sizeHeld.map(p => String(p.registrationId)));
                this.selectedItems = this.selectedItems.filter(p => !heldIds.has(String(p.registrationId)));
                if (!this.selectedItems.length) return { refused: `상세이미지 크기로 보내지 않았습니다: ${names}. ${sizeHeld[0].errorDetails}` };
            }
            const skipped = this.selectedItems.filter(p => serverSent.has(String(p.registrationId)) && !(byClick && this.isSentToCoupang(p)));
            if (skipped.length) {
                const names = skipped.map(p => this.getDisplayProductName(p) || p.registrationId).join(', ');
                console.error('[AIRocketReg] 이미 쿠팡에 전송된 상품이라 건너뜁니다:', skipped.map(p => p.registrationId).join(', '));
                this.$bvToast.toast(`이미 쿠팡에 전송된 상품이라 건너뛰었습니다: ${names}. 새로고침하면 전송완료로 보입니다.`, {
                    title: '이미 전송됨', variant: 'warning', solid: true, autoHideDelay: 10000, toaster: 'b-toaster-bottom-right'
                });
                const skipIds = new Set(skipped.map(p => String(p.registrationId)));
                this.selectedItems = this.selectedItems.filter(p => !skipIds.has(String(p.registrationId)));
                if (!this.selectedItems.length) return { refused: `이미 쿠팡에 전송된 상품이라 보내지 않았습니다: ${names}.` };
            }

            // 이미 등록완료된 상품이 있는지 확인
            const registeredProducts = this.selectedItems.filter(product => product.registered === true);
            if (registeredProducts.length > 0) {
                const productNames = registeredProducts.map(product => this.getDisplayProductName(product)).join(', ');
                const confirmed = await this.$bvModal.msgBoxConfirm(
                    `다음 상품들은 이미 등록전송이 완료된 상품입니다:\n\n${productNames}\n\n다시 전송하시겠습니까?`,
                    {
                        title: '등록완료 상품 재전송 확인',
                        size: 'lg',
                        buttonSize: 'sm',
                        okVariant: 'danger',
                        okTitle: '재전송',
                        cancelTitle: '취소',
                        footerClass: 'p-2',
                        hideHeaderClose: false,
                        centered: true
                    }
                );

                if (!confirmed) {
                    console.log('사용자가 재전송을 취소했습니다.');
                    return;
                }
                console.log('사용자가 재전송을 확인했습니다.');
            }

            console.log(`선택된 상품 수: ${this.selectedItems.length}`);

            // 전송은 coupangDoc 을 쓴다 — 선택 전부를 완전 문서로 받고 store 것을 쓴다(실패하면 안내 후 멈춤)
            const fullSelected = await this.ensureFullProducts(this.selectedItems);
            if (!fullSelected) return;

            // 각 상품의 오류 플래그 초기화
            for (const product of fullSelected) {
                if (product.options && product.options.length > 0) {
                    for (const option of product.options) {
                        // 오류 플래그 초기화
                        this.$set(option, 'error', false);
                        this.$set(option, 'errorDetails', '');

                        // 이미 등록된 상품이 아닌 경우에만 상태 초기화
                        if (option.registrationStatus !== 'registered' && !option.registered) {
                            this.$set(option, 'verificationStatus', '');
                            this.$set(option, 'registrationStatus', '');
                        }

                        console.log(`옵션 ${option.optionNumber}의 오류 플래그 초기화 완료`);
                    }
                }

                // 상품 레벨 오류 플래그 초기화
                this.$set(product, 'error', false);
                this.$set(product, 'errorDetails', '');
            }

            console.log('등록 전송 시작 전 오류 플래그 초기화 완료');

            // 필수 정보 확인
            const selectedProducts = fullSelected;
            this.isVerifying = true;

            try {
                // 옵션 처리 추적을 위한 상태 관리 변수 추가
                this.pendingVerifications = new Map(); // 처리 중인 검증 요청을 추적하기 위한 맵
                this.verificationQueue = []; // 검증 대기열
                this.processedOptionCount = 0; // 처리된 옵션 수를 추적

                // 진행 상황 추적을 위한 변수 초기화
                this.initialQueueSize = 0;

                // 모든 상품을 대기열에 추가
                for (const product of selectedProducts) {
                    // 이미 등록 완료된 상품은 사용자 확인 후 처리
                    // (위에서 이미 확인받았으므로 여기서는 건너뛰지 않음)

                    // 모든 필수 작업이 완료되었는지 확인
                    const requiredTasks = ['seoStatus', 'mainImageStatus', 'additionalImageStatus', 'detailImageStatus', 'koreanLabelStatus', 'quotationStatus'];
                    const incompleteTasks = [];

                    for (const task of requiredTasks) {
                        // 사이즈표는 카테고리에 따라 필요 여부가 다름
                        if (task === 'sizeChartStatus' && !this.isSizeChartRequired(product)) {
                            continue;
                        }

                        const status = product[task];
                        const isCompleted = status === 'completed';

                        if (!isCompleted) {
                            incompleteTasks.push(this.getWorkTypeName(task));
                        }
                    }

                    if (incompleteTasks.length > 0) {
                        // 상품명 표시 (SEO > 영문 > 원본)
                        const displayName = this.getDisplayProductName(product);

                        this.$bvToast.toast(`상품 "${displayName}"의 다음 항목이 완료되지 않았습니다: ${incompleteTasks.join(', ')}`, {
                            title: '검증 실패',
                            variant: 'warning',
                            solid: true,
                            toaster: 'b-toaster-bottom-right'
                        });
                        continue;
                    }

                    // 상품 레벨 coupangDoc 확인
                    if (!product.coupangDoc || !product.coupangDoc.jsonDocument) {
                        console.error(`상품 ${product.registrationId}에 필요한 문서가 없습니다.`);
                        this.$bvToast.toast(`상품 "${this.getDisplayProductName(product)}"에 필요한 문서가 없습니다. 정보를 모두 입력한 후 다시 시도해주세요.`, {
                            title: '검증 실패',
                            variant: 'warning',
                            solid: true,
                            toaster: 'b-toaster-bottom-right'
                        });
                        continue;
                    }

                    // 모든 옵션에 대한 jsonDocument 항목이 있는지 확인
                    if (product.options && product.options.length > 0) {
                        if (product.coupangDoc.jsonDocument.length < product.options.length) {
                            console.error(`상품 ${product.registrationId}의 일부 옵션에 해당하는 문서 항목이 없습니다.`);
                            this.$bvToast.toast(`상품 "${this.getDisplayProductName(product)}"의 일부 옵션에 해당하는 문서 항목이 없습니다. 정보를 모두 입력한 후 다시 시도해주세요.`, {
                                title: '검증 실패',
                                variant: 'warning',
                                solid: true,
                                toaster: 'b-toaster-bottom-right'
                            });
                            continue;
                        }
                    }

                    // 모든 검사를 통과한 경우 대기열에 추가
                    console.log(`상품 ${product.registrationId} 대기열에 추가됨`);
                    this.verificationQueue.push({
                        product,
                        index: product.registrationId
                    });
                }

                // 프로세스가 이미 중단되었는지 확인
                if (!this.isVerifying) {
                    console.log('대기열 구성 중 프로세스가 중단되었습니다.');
                    return;
                }

                // 대기열에 아이템이 있으면 처리 시작
                if (this.verificationQueue.length > 0) {
                    // 총 대기열 크기 저장
                    this.initialQueueSize = this.verificationQueue.length;

                    this.$bvToast.toast(`총 ${this.verificationQueue.length}개 옵션을 순차적으로 검증합니다.`, {
                        title: '검증 시작',
                        variant: 'info',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });

                    // 첫 번째 옵션 검증 시작
                    this.processNextVerification();
                } else {
                    this.isVerifying = false;
                    this.$bvToast.toast('검증할 유효한 옵션이 없습니다.', {
                        title: '알림',
                        variant: 'warning',
                        solid: true,
                        toaster: 'b-toaster-bottom-right'
                    });
                }
            } catch (error) {
                console.error('검증 중 오류 발생:', error);
                this.stopVerificationProcess(`검증 중 오류가 발생했습니다: ${error.message}. 문제를 해결한 후 다시 시도해주세요.`, 'danger');
            }
        },

        // 순차적 검증 처리를 위한 새로운 메서드
        // 검증 프로세스를 중단하고 상태를 초기화하는 메서드
        // 모델번호가 비어 있으면 상품명으로 채운다 — 보내기 직전 마지막 관문.
        //
        // 비어 있으면 쿠팡 validate-step 2 가 「모델 번호는 필수 항목입니다」로 막고 등록이 거기서 끝난다.
        // 견적서 생성 경로(quotationService:691)는 채우지만, 그 경로를 안 탄 옛 문서는 빈 채로 남아 있고
        // **AI 자동수정도 이 필드는 못 채운다**(상품명·SEO 만 고친다). 실측 2026-09-15 rubycoco.
        //
        // 상품명을 쓰는 건 쿠팡 안내 그대로다 — 견적서 화면 도움말: "모델명이 없는 경우, 상품명과
        // 동일하게 입력해주세요." 값이 이미 있으면 절대 덮지 않는다.
        fillMissingModelNumber(coupangDoc) {
            try {
                const docs = coupangDoc && coupangDoc.jsonDocument;
                if (!Array.isArray(docs)) return;
                docs.forEach(d => {
                    if (!d || !d.productPage) return;
                    if (String(d.productPage.modelNumber || '').trim()) return;
                    const name = (d.startPage && d.startPage.productName) || coupangDoc.productName || '';
                    if (!String(name).trim()) return;
                    d.productPage.modelNumber = String(name).slice(0, 50);
                    console.log('모델번호가 비어 있어 상품명으로 채움:', d.productPage.modelNumber);
                });
            } catch (e) {
                console.error('모델번호 보정 실패:', e);
            }
        },
        // 서버 문서 기준으로 이미 쿠팡에 보낸 등록ID 집합 — 서버 등록전송(tool-exec/rocket-submit.js)이 남기는 표식,
        // isSentToCoupang 과 같은 판단 + 접수 확인 기록. 못 읽으면 던진다(보내지 않는 쪽으로).
        async fetchServerSentIds(ids) {
            if (!ids.length) return new Set();
            const res = await axios.post('/api/aiRocketReg/getlist', {
                start: 0, end: Date.now() + 24 * 60 * 60 * 1000, limit: 200,
                filter: { registrationId: { in: ids } },
                fields: ['registrationId', 'registered', 'options.registered', 'options.registrationStatus', 'registerConfirm.status']
            });
            const data = (res && res.data) || {};
            if (data['요청결과'] !== 'ok' || !Array.isArray(data.products)) {
                throw new Error(data.error || '상품 목록 응답을 읽지 못했습니다.');
            }
            // 서버 시험 가드(COUPLUS_E2E_BLOCK_SUBMIT) 표식 — 한 번 보면 이 화면 동안 켠 채 둔다(안전한 쪽)
            if (data.e2eBlockSubmit === true) this._serverBlockSubmit = true;
            const sent = new Set();
            data.products.forEach(doc => {
                if (this.isSentToCoupang(doc) || (doc.registerConfirm && doc.registerConfirm.status)) sent.add(String(doc.registrationId));
            });
            return sent;
        },
        // 화면 등록전송이 상품별 결과 없이 끝난 경우(확장 알림·요청 ID 없는 실패·중단)를 서버 로그(service_error_logs)에 남긴다.
        // 상품별 성공·실패는 상품 문서(registered·errorDetails)에 남지만 이 경우는 아무 데도 안 남았다(2026-10-08 DITCO 10:09).
        logSubmitAbort(stage, message) {
            const ids = (this.verificationQueue || []).map(x => x && x.product && x.product.registrationId).filter(Boolean);
            logServiceError('AIRocketReg', 'verifyProducts', String(message || '알 수 없는 오류'), {
                errorType: ERROR_TYPES.VALIDATION_FAILED,
                productId: ids[0] || null,
                additional: { stage, registrationIds: ids }
            });
        },
        stopVerificationProcess(message, variant = 'warning') {
            console.log('검증 프로세스 중단:', message);
            this.logSubmitAbort('등록전송 중단', message);

            // 상태 초기화
            this.isVerifying = false;
            this.showspinner1 = false;
            this.loadingtext = '';

            // 대기열 및 대기 중인 검증 요청 초기화
            this.verificationQueue = [];
            if (this.pendingVerifications) {
                this.pendingVerifications.clear();
            }

            // 모든 요청 카운터 초기화
            this.processedOptionCount = 0;
            this.initialQueueSize = 0;

            // 사용자에게 메시지 표시
            this.$bvToast.toast(message, {
                title: variant === 'error' ? '등록 오류' : '등록 중단',
                variant: variant,
                solid: true,
                toaster: 'b-toaster-bottom-right'
            });

            return false; // 프로세스 중단 결과 반환
        },

        processNextVerification() {
            console.log('processNextVerification 호출됨, 대기열 상태:', {
                '대기열 길이': this.verificationQueue ? this.verificationQueue.length : 'undefined',
                '처리된 요청 수': this.pendingVerifications ? this.pendingVerifications.size : 0,
                '처리 대기중 항목': this.verificationQueue ?
                    this.verificationQueue.map(item => `${item.product.registrationId}`) : []
            });

            // 대기열이 비어있으면 완료
            if (!this.verificationQueue || this.verificationQueue.length === 0) {
                console.log('모든 검증 완료, 상태 초기화');

                // 검증 통과(verified)만으로 등록됨으로 올리지 않는다 — 전송 응답 자리에서 이미 «전송됨·확인 전»으로 적었다(판 #378)

                this.isVerifying = false;
                this.showspinner1 = false;
                this.loadingtext = '';
                this.$bvToast.toast('전송을 마쳤습니다 — 서플라이어허브에서 확인된 상품만 «등록됨»으로 바뀝니다.', {
                    title: '전송 끝',
                    variant: 'success',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });
                return;
            }

            // 대기열에서 다음 항목 가져오기
            const current = this.verificationQueue[0];
            const { product } = current;

            // 전송·저장은 완전 문서로만 — 목록용이면 받아서 바꿔 끼우고 다시 돈다(verifyProducts 가 미리 받지만 안전망)
            if (isLightDoc(product)) {
                this.ensureFullProducts(product).then(full => {
                    if (!full) {
                        this.stopVerificationProcess(`상품 ${product.registrationId} 정보를 불러오지 못해 등록을 중단합니다. 잠시 뒤 다시 시도해주세요.`, 'warning');
                        return;
                    }
                    current.product = full[0];
                    this.processNextVerification();
                });
                return;
            }

            // 이미 검증되었지만 등록완료되지 않은 상품만 건너뛰기
            // 등록완료된 상품은 사용자가 재전송을 확인했으므로 처리 진행
            if (product.verified === true && product.registered !== true) {
                console.log(`상품 ${product.registrationId}는 이미 검증되었습니다. 다음 항목으로 이동합니다.`);
                this.verificationQueue.shift(); // 현재 항목 제거
                this.processNextVerification(); // 다음 항목으로 재귀적 진행
                return;
            }

            // 상품 레벨 coupangDoc 확인
            if (!product.coupangDoc || !product.coupangDoc.jsonDocument) {
                console.error(`상품 ${product.registrationId}에 필요한 문서가 없습니다.`);
                this.stopVerificationProcess(`상품 ${product.registrationId}에 필요한 문서가 없어 등록을 중단합니다. 필요한 정보를 모두 입력한 후 다시 시도해주세요.`, 'warning');
                return;
            }

            // 모든 옵션에 대한 jsonDocument 항목이 있는지 확인
            if (product.options && product.options.length > 0) {
                if (product.coupangDoc.jsonDocument.length < product.options.length) {
                    console.error(`상품 ${product.registrationId}의 일부 옵션에 해당하는 문서 항목이 없습니다.`);
                    this.stopVerificationProcess(`상품 ${product.registrationId}의 일부 옵션에 해당하는 문서 항목이 없어 등록을 중단합니다. 필요한 정보를 모두 입력한 후 다시 시도해주세요.`, 'warning');
                    return;
                }
            }

            // 로딩 상태 업데이트
            this.showspinner1 = true;
            const displayName = this.getDisplayProductName(product);

            // 진행 상황을 표시하는 loadingtext 업데이트
            // 전체 대기열 길이와 현재 처리 중인 항목의 위치 계산
            const totalItems = this.initialQueueSize || this.verificationQueue.length;
            const processedItems = (this.initialQueueSize || 0) - this.verificationQueue.length;
            const currentIndex = processedItems + 1;
            const progressPercent = Math.round((processedItems / totalItems) * 100);

            this.loadingtext = `상품 ${displayName} 등록 중... (${currentIndex}/${totalItems}, ${progressPercent}%)`;

            try {
                // 등록완료된 상품을 재전송하는 경우 상태 초기화
                if (product.registered === true) {
                    console.log(`등록완료된 상품 ${product.registrationId}을 재전송합니다. 상태를 초기화합니다.`);
                    // 상품 상태 초기화
                    this.$set(product, 'verified', false);
                    this.$set(product, 'registered', false);
                    this.$set(product, 'errorDetails', '');
                    this.$set(product, 'registerConfirm', null);

                    // 옵션 상태도 초기화
                    if (product.options && product.options.length > 0) {
                        product.options.forEach(option => {
                            this.$set(option, 'verified', false);
                            this.$set(option, 'registrationStatus', '');   // 'pending' 은 «보냄·확인 전» 이라 쓰지 않는다
                        });
                    }
                }

                // 검증 요청 ID 생성
                const requestId = `verify_${product.registrationId}_${Date.now()}`;

                // 요청 ID와 현재 항목을 매핑하여 저장
                this.pendingVerifications.set(requestId, {
                    product,
                    timestamp: Date.now()
                });

                // 확장 프로그램에 검증 요청 전송
                // 이미 처리된 상품이 있는지 확인 (첫 번째 상품인지 아닌지 체크)
                const isFirstProduct = this.pendingVerifications.size <= 1 &&
                    (!this.processedOptionCount || this.processedOptionCount === 0);

                // 처리 여부 추적을 위한 카운터 증가
                this.processedOptionCount = (this.processedOptionCount || 0) + 1;

                console.log(`상품 ${product.registrationId} 검증 요청: ${isFirstProduct ? '첫 번째 상품' : '후속 상품'}, shouldRedirect=${isFirstProduct}`);

                // 모델 번호 길이 검증 및 수정 (모든 jsonDocument 항목 확인)
                if (product.coupangDoc.jsonDocument && product.coupangDoc.jsonDocument.length > 0) {
                    for (let i = 0; i < product.coupangDoc.jsonDocument.length; i++) {
                        const docItem = product.coupangDoc.jsonDocument[i];
                        if (docItem.productPage && docItem.productPage.modelNumber) {
                            const modelNumber = docItem.productPage.modelNumber;
                            if (modelNumber.length > 50) {
                                console.log(`문서 항목 ${i+1}의 모델번호 길이(${modelNumber.length})가 50자를 초과합니다. 50자로 자릅니다.`);
                                docItem.productPage.modelNumber = modelNumber.substring(0, 50);
                            }
                        }
                    }
                }

                // productName 일치 여부 확인 및 동기화
                if (product.coupangDoc.jsonDocument && product.coupangDoc.jsonDocument.length > 0) {
                    const firstDocProductName = product.coupangDoc.jsonDocument[0]?.startPage?.productName;
                    const coupangDocProductName = product.coupangDoc.productName;

                    if (firstDocProductName && firstDocProductName !== coupangDocProductName) {
                        console.log(`⚠️ productName 불일치 감지 - 동기화 진행`);
                        console.log(`   기존 coupangDoc.productName: ${coupangDocProductName}`);
                        console.log(`   jsonDocument[0].startPage.productName: ${firstDocProductName}`);

                        // coupangDoc.productName 업데이트
                        this.$set(product.coupangDoc, 'productName', firstDocProductName);

                        // product.productNameSeo 업데이트
                        this.$set(product, 'productNameSeo', firstDocProductName);

                        console.log(`✅ productName 동기화 완료: ${firstDocProductName}`);
                    }
                }

                this.fillMissingModelNumber(product.coupangDoc);

                // 출구 바로 앞 두 번째 문 — 1차 문(submitProductsToCoupang)을 지나친 길이 생겨도 쿠팡으로 안 나간다
                if (this._serverBlockSubmit) {
                    console.error('[guard] COUPLUS_E2E_BLOCK_SUBMIT — 출구 앞에서 확장 등록전송을 멈춤', product.registrationId);
                    this.stopVerificationProcess();
                    return;
                }
                window.postMessage({
                    type: 'VERIFY_ROCKET_REG_DOC',
                    id: requestId,
                    requestId: requestId, // 요청 ID 중복 추가 (두 가지 형식 지원)
                    data: {
                        docId: product.coupangDoc?.docId || null,
                        // 쿠플러스 안 표시(logisticsPage.packageSource 'ai-guess' · 판 #733 ②)는 쿠팡에 안 보낸다 — 사본에서만 뺀다
                        body: coupangDocForSend(product.coupangDoc),
                        suppliercode: this.$store.state.user.suppliercode,
                        delay: this.delay,
                        shouldRedirect: isFirstProduct // 첫 번째 상품만 true, 나머지는 false
                    }
                }, '*');

                console.log(`상품 검증 요청: ${product.registrationId}, requestId: ${requestId}`);

                // 타임아웃 로직 제거 - 첫 번째 검증이 완료된 후 다음 상품 검증이 진행되도록 함
            } catch (error) {
                console.error(`상품 ${product.registrationId} 검증 중 오류:`, error);

                // 상품 상태 업데이트
                this.$set(product, 'verified', false);
                this.$set(product, 'registered', false);
                this.$set(product, 'errorDetails', error.message);

                // 상품 정보 업데이트 (Vuex 스토어)
                this.$store.dispatch('updateRocketProduct', product);

                // 실패 메시지 표시
                this.$bvToast.toast(`상품 ${product.registrationId} 검증 중 오류: ${error.message}`, {
                    title: '검증 오류',
                    variant: 'danger',
                    solid: true,
                    toaster: 'b-toaster-bottom-right'
                });

                // 대기열에서 처리된 항목 제거
                this.verificationQueue.shift();

                // ✅ 다음 상품으로 계속 진행 (전체 프로세스 중단하지 않음)
                this.processNextVerification();
            }
        },

        // 등록 상태 표시 텍스트 반환
        getRegistrationStatusText(item) {
            if (!item) return '등록 대기';
            if (this.isConfirmPending(item)) return '접수 미확인';

            // 상품 레벨의 등록 상태 확인 (우선순위 1)
            if (item.registered === true) {
                return '등록완료';
            }

            // 보냈는데 허브가 반려로 보여 준 것 — 확인 전보다 앞에서 따로
            if (this.isRejectedConfirm(item)) {
                return '반려';
            }

            // 보냈지만 쿠팡 허브에서 아직 확인 못 한 것 — docId 가 있어도 «등록완료» 가 아니다
            if (this.isPendingConfirm(item)) {
                return '전송됨·확인 전';
            }

            // 상품 레벨의 오류 상태 확인 (우선순위 2)
            if (item.errorDetails) {
                return '등록실패';
            }

            // 상품 레벨의 검증 상태 확인 (우선순위 3)
            if (item.verified === true) {
                return '등록완료';
            }

            // 상품에 coupangDoc이 있는지 확인 (우선순위 4)
            if (item.coupangDoc && item.coupangDoc.docId) {
                return '등록완료';
            }

            // 옵션이 없거나 기본 상태
            if (this.hasVerificationErrors(item)) {
                return '검증필요';
            }

            return '등록대기';
        },

    }
};
</script>

<style scoped>
/* 머리 버튼 줄 — 폰 폭에서 줄이 넘치면 버튼째 다음 줄로(글자가 한 자씩 세로로 꺾이던 것 · 10-19 390 실측) */
.rr-head-btns {
    row-gap: 8px;
}
.rr-head-btns .btn {
    white-space: nowrap;
}
.rr-thumb-empty {
    width: 50px;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #eef0f3;
    color: #8a929c;
    font-size: 0.7rem;
    white-space: nowrap;
}
.detail-claim-flag {
    font-size: 0.75rem;
    color: #b8860b;
    white-space: nowrap;
    cursor: help;
}
.talhwan-guide-video {
    display: block;
    width: 100%;
    max-height: 70vh;
    background: #000;
}

/* AIRocketReg.vue의 <style> 섹션에 추가 */
@keyframes pulse {
    0% {
        opacity: 1;
    }

    50% {
        opacity: 0.2;
    }

    100% {
        opacity: 1;
    }
}

.pulsating {
    animation: pulse 1.5s infinite ease-in-out;
}

.rocket-delete-disabled {
    opacity: 0.45;
    cursor: not-allowed;
}

.rocket-badge-pill.badge-primary {
    position: relative;
}

.rocket-badge-pill.badge-primary.pulsating::before {
    content: '';
    position: absolute;
    width: 100%;
    height: 100%;
    background: inherit;
    border-radius: inherit;
    z-index: -1;
    animation: pulse-shadow 1.5s infinite;
}

@keyframes pulse-shadow {
    0% {
        transform: scale(1);
        opacity: 0.8;
    }

    50% {
        transform: scale(1.05);
        opacity: 0.2;
    }

    100% {
        transform: scale(1);
        opacity: 0.8;
    }
}

.cursor-pointer {
    cursor: pointer;
}

/* ========== 세련된 초기화 로딩 오버레이 스타일 ========== */
.initial-processing-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(15, 23, 42, 0.85);
    backdrop-filter: blur(8px);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeIn 0.3s ease-out;
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

.processing-card {
    background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
    border-radius: 24px;
    padding: 48px 56px;
    text-align: center;
    box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(255, 255, 255, 0.1);
    animation: slideUp 0.4s ease-out;
    max-width: 420px;
    width: 90%;
}

@keyframes slideUp {
    from {
        opacity: 0;
        transform: translateY(30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.processing-spinner {
    width: 80px;
    height: 80px;
    margin: 0 auto 28px;
    position: relative;
}

.spinner-ring {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    border: 3px solid transparent;
    animation: spinRing 1.5s linear infinite;
}

.spinner-ring:nth-child(1) {
    border-top-color: #3b82f6;
    animation-delay: 0s;
}

.spinner-ring:nth-child(2) {
    border-right-color: #8b5cf6;
    animation-delay: 0.15s;
    width: 70%;
    height: 70%;
    top: 15%;
    left: 15%;
}

.spinner-ring:nth-child(3) {
    border-bottom-color: #06b6d4;
    animation-delay: 0.3s;
    width: 40%;
    height: 40%;
    top: 30%;
    left: 30%;
}

.spinner-dot {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 12px;
    height: 12px;
    margin: -6px 0 0 -6px;
    background: linear-gradient(135deg, #3b82f6, #8b5cf6);
    border-radius: 50%;
    animation: pulse 1s ease-in-out infinite;
}

@keyframes spinRing {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

@keyframes pulse {
    0%, 100% { transform: scale(1); opacity: 1; }
    50% { transform: scale(1.3); opacity: 0.7; }
}

.processing-title {
    color: #f1f5f9;
    font-size: 1.5rem;
    font-weight: 600;
    margin-bottom: 8px;
}

.processing-message {
    color: #94a3b8;
    font-size: 0.95rem;
    margin-bottom: 24px;
}

.processing-progress {
    height: 6px;
    background: rgba(255, 255, 255, 0.1);
    border-radius: 3px;
    overflow: hidden;
    margin-bottom: 28px;
}

.processing-progress .progress-bar {
    height: 100%;
    background: linear-gradient(90deg, #3b82f6, #8b5cf6, #06b6d4);
    background-size: 200% 100%;
    border-radius: 3px;
    transition: width 0.5s ease-out;
    animation: shimmer 2s infinite;
}

@keyframes shimmer {
    0% { background-position: 200% 0; }
    100% { background-position: -200% 0; }
}

.processing-steps {
    display: flex;
    justify-content: center;
    gap: 32px;
}

.processing-steps .step {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    opacity: 0.4;
    transition: all 0.3s ease;
}

.processing-steps .step.active {
    opacity: 1;
}

.processing-steps .step.completed {
    opacity: 1;
}

.processing-steps .step.completed .step-icon {
    background: linear-gradient(135deg, #22c55e, #16a34a);
}

.processing-steps .step-icon {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #e2e8f0;
    font-weight: 600;
    font-size: 0.9rem;
    transition: all 0.3s ease;
}

.processing-steps .step.active .step-icon {
    background: linear-gradient(135deg, #3b82f6, #8b5cf6);
    box-shadow: 0 0 20px rgba(59, 130, 246, 0.5);
}

.processing-steps .step-text {
    color: #94a3b8;
    font-size: 0.8rem;
    white-space: nowrap;
}

.processing-steps .step.active .step-text {
    color: #e2e8f0;
}
</style>